/**
 *  https://developer.dji.com/doc/cloud-api-tutorial/en/error-code.html
 */

export class CONSTANT_DJI_ERROR {
  static dji_error = {
    "0x11000002" : {
      "en": "Aircraft power distribution board 1 overheated. Return to home or land promptly",
      "zh": "飞行器分电板1温度过高，请尽快返航或降落",
      "fr": ""
    },
    "0x11000003" : {
      "en": "Aircraft power distribution board 2 overheated. Return to home or land promptly",
      "zh": "飞行器分电板2温度过高，请尽快返航或降落",
      "fr": ""
    },
    "0x11000020" : {
      "en": "Gimbal %index payload voltage too high",
      "zh": "%index号云台位负载电压过高",
      "fr": ""
    },
    "0x11000021" : {
      "en": "Gimbal %index payload voltage too low",
      "zh": "%index号云台位负载电压过低",
      "fr": ""
    },
    "0x11000022" : {
      "en": "Gimbal %index battery module overheated",
      "zh": "%index号云台位电源温度过高",
      "fr": ""
    },
    "0x11000023" : {
      "en": "Gimbal %index battery module temperature too low",
      "zh": "%index号云台位电源温度过低",
      "fr": ""
    },
    "0x11000024" : {
      "en": "Total payload power too high",
      "zh": "负载总功率过载",
      "fr": ""
    },
    "0x11000025" : {
      "en": "Gimbal %index payload transmission error",
      "zh": "%index号云台负载链路异常",
      "fr": ""
    },
    "0x11000029" : {
      "en": "PSDK voltage too high",
      "zh": "PSDK 设备电压过高",
      "fr": ""
    },
    "0x1100002A" : {
      "en": "PSDK voltage too low",
      "zh": "PSDK 设备电压过低",
      "fr": ""
    },
    "0x1100002B" : {
      "en": "PSDK battery module overheated",
      "zh": "PSDK电源温度过高",
      "fr": ""
    },
    "0x1100002C" : {
      "en": "PSDK battery module temperature too low",
      "zh": "PSDK电源温度过低",
      "fr": ""
    },
    "0x1100002D" : {
      "en": "PSDK device rated power exceeded. Restarting...",
      "zh": "PSDK 设备功率过载，重启中",
      "fr": ""
    },
    "0x1100002E" : {
      "en": "PSDK device rated power exceeded. Failed to restart",
      "zh": "PSDK 设备功率过载，重启失败",
      "fr": ""
    },
    "0x11000034" : {
      "en": "Landing gear motor power supply error. Restart aircraft",
      "zh": "起落架舵机供电异常，请尝试重启飞行器",
      "fr": ""
    },
    "0x11000035" : {
      "en": "Radar power supply error. Restarting radar recommended",
      "zh": "雷达供电异常，请尝试重启雷达",
      "fr": ""
    },
    "0x11000036" : {
      "en": "4G module power supply error. Remove and insert module again",
      "zh": "4G 模块供电异常，请尝试拔插",
      "fr": ""
    },
    "0x11000037" : {
      "en": "Gimbal power supply error. Detach and remount gimbal",
      "zh": "云台供电异常，请尝试拔插云台",
      "fr": ""
    },
    "0x11000038" : {
      "en": "Left battery connector overheated. Return to home or land promptly",
      "zh": "左电池连接器温度过高，请尽快返航或降落",
      "fr": ""
    },
    "0x11000039" : {
      "en": "Right battery connector overheated. Return to home or land promptly",
      "zh": "右电池连接器温度过高，请尽快返航或降落",
      "fr": ""
    },
    "0x1100003A" : {
      "en": "Left battery not properly installed. Remove and reinstall battery",
      "zh": "左电池安装不到位，请重新安装电池",
      "fr": ""
    },
    "0x1100003B" : {
      "en": "Right battery not properly installed. Remove and reinstall battery",
      "zh": "右电池安装不到位，请重新安装电池",
      "fr": ""
    },
    "0x1100003C" : {
      "en": "Gimbal not properly installed. Detach and remount gimbal",
      "zh": "云台安装不到位，请重新安装云台",
      "fr": ""
    },
    "0x1100003D" : {
      "en": "Aircraft center board overheated. Return to home or land promptly",
      "zh": "飞行器中心板温度过高，请尽快返航或降落",
      "fr": ""
    },
    "0x1100003E" : {
      "en": "Radar disconnected. Fly with caution and return to home or land promptly",
      "zh": "雷达连接断开，请谨慎飞行并尽快返航或降落",
      "fr": ""
    },
    "0x1100003F" : {
      "en": "Downward infrared sensing system connection error. Restart aircraft",
      "zh": "飞行器TOF模块连接异常，请尝试重启飞行器",
      "fr": ""
    },
    "0x11000040" : {
      "en": "Landing gear motor communication error. Restart aircraft",
      "zh": "起落架舵机通信异常，请尝试重启飞行器",
      "fr": ""
    },
    "0x11000041" : {
      "en": "Landing gear motor stalled. Make sure motor is clear of obstacles and restart aircraft",
      "zh": "起落架舵机堵转，请检查是否有异物并重启飞行器",
      "fr": ""
    },
    "0x11000042" : {
      "en": "Large current difference between batteries. Maintain smooth flight and land promptly",
      "zh": "电池电流差异大，请保持平稳飞行并尽快降落",
      "fr": ""
    },
    "0x11000043" : {
      "en": "Motor overheated. Do not transform aircraft frequently",
      "zh": "舵机温度高，请避免频繁变形",
      "fr": ""
    },
    "0x11000044" : {
      "en": "Motor overheated. Transforming aircraft stopped. Wait until motor cools down",
      "zh": "舵机温度过高，已经停止变形，请等待舵机温度降低",
      "fr": ""
    },
    "0x11000045" : {
      "en": "Temperature too low. Landing gear stuck",
      "zh": "温度过低起落架运动受阻",
      "fr": ""
    },
    "0x11000046" : {
      "en": "Aircraft screw rod reaching maximum life span. To ensure flight safety, contact DJI Support and send aircraft back to DJI for maintenance",
      "zh": "飞行器丝杆即将达到设计使用寿命，为确保飞行安全，请您及时联系 DJI 技术支持并寄回处理",
      "fr": ""
    },
    "0x11000047" : {
      "en": "Aircraft screw rod exceeded maximum life span. To ensure flight safety, contact DJI Support immediately and send aircraft back to DJI for maintenance. You are responsible for the maintenance cost for the flight accident caused by continued use of the aircraft",
      "zh": "飞行器丝杆已超出设计使用寿命，为确保飞行安全，请您立刻联系 DJI 技术支持并寄回处理，继续使用导致的飞行事故，需要您承担维修费用",
      "fr": ""
    },
    "0x11000048" : {
      "en": "Landing gear error. Obstacle avoidance performance degraded. Fly with caution. Pay attention to lens when aircraft is landing. Contact DJI Support",
      "zh": "起落架异常，避障性能降低，请谨慎飞行，注意降落镜头保护，请联系售后",
      "fr": ""
    },
    "0x11020030" : {
      "en": "%battery_index battery cover temperature error. Switched to single-battery flight. Return to home or land promptly",
      "zh": "%battery_index电池上盖温度异常，转为单电池飞行，请尽快返航或降落",
      "fr": ""
    },
    "0x11020031" : {
      "en": "%battery_index battery connector temperature error. Switched to single-battery flight. Return to home or land promptly",
      "zh": "%battery_index电池连接器温度异常，转为单电池飞行，请尽快返航或降落",
      "fr": ""
    },
    "0x11020032" : {
      "en": "%battery_index battery temperature error. Switched to single-battery flight. Return to home or land promptly",
      "zh": "%battery_index电池温度异常，转为单电池飞行，请尽快返航或降落",
      "fr": ""
    },
    "0x11020033" : {
      "en": "%battery_index battery error. Switched to single-battery flight. Return to home or land promptly",
      "zh": "%battery_index电池异常，转为单电池飞行，请尽快返航或降落",
      "fr": ""
    },
    "0x110B0001" : {
      "en": "%battery_index Battery overcurrent when discharging. Maintain smooth flight and check if aircraft is overloaded",
      "zh": "%battery_index电池放电过流，请保持平稳飞行并检查是否有负重",
      "fr": ""
    },
    "0x110B0002" : {
      "en": "%battery_index Battery overheated. Return to home promptly and wait until battery cools down",
      "zh": "%battery_index电池温度过高，请尽快返航，待电池冷却到常温再使用",
      "fr": ""
    },
    "0x110B0003" : {
      "en": "%battery_index Battery temperature too low. Warm up battery to 5°C or higher",
      "zh": "%battery_index电池温度过低，请预热电池至5摄氏度以上",
      "fr": ""
    },
    "0x110B0004" : {
      "en": "%battery_index Battery short-circuited during discharge. Replace battery",
      "zh": "%battery_index电池放电出现短路，请更换电池",
      "fr": ""
    },
    "0x110B0005" : {
      "en": "Battery %index cell voltage low. Replace battery",
      "zh": "电芯%index欠压，请更换电池",
      "fr": ""
    },
    "0x110B0006" : {
      "en": "%battery_index Battery cell damaged. Stop using battery and contact DJI Support",
      "zh": "%battery_index电池电芯损坏，请停止使用该电池，并联系售后服务",
      "fr": ""
    },
    "0x110B0007" : {
      "en": "%battery_index Battery auto-check failed. Stop using battery and contact DJI Support",
      "zh": "%battery_index电池自检失败，请更换电池，并联系售后服务",
      "fr": ""
    },
    "0x110B0008" : {
      "en": "%battery_index Battery auto-check failed. Stop using battery and contact DJI Support",
      "zh": "%battery_index电池自检失败，请更换电池，并联系售后服务",
      "fr": ""
    },
    "0x110B0009" : {
      "en": "%battery_index Battery auto-check failed. Stop using battery and contact DJI Support",
      "zh": "%battery_index电池自检失败，请更换电池，并联系售后服务",
      "fr": ""
    },
    "0x110B000A" : {
      "en": "%battery_index Battery auto-check failed. Stop using battery and contact DJI Support",
      "zh": "%battery_index电池自检失败，请更换电池，并联系售后服务",
      "fr": ""
    },
    "0x110B000B" : {
      "en": "%battery_index Battery damaged. Stop using battery and contact DJI Support",
      "zh": "%battery_index电池已损坏，请停止使用该电池，并联系售后服务",
      "fr": ""
    },
    "0x110B000C" : {
      "en": "%battery_index Battery maintenance required",
      "zh": "%battery_index电池需要保养",
      "fr": ""
    },
    "0x110B000D" : {
      "en": "%battery_index Battery damaged. Stop using battery and contact DJI Support",
      "zh": "%battery_index电池已损坏，请停止使用该电池，并联系售后服务",
      "fr": ""
    },
    "0x110B000E" : {
      "en": "Battery %index self-discharged during storage",
      "zh": "%index电池发生存储自放电",
      "fr": ""
    },
    "0x110B000F" : {
      "en": "%battery_index Battery capacity significantly reduced. Continue using battery may cause safety risks",
      "zh": "%battery_index电池性能严重下降，继续使用有安全风险",
      "fr": ""
    },
    "0x110B0010" : {
      "en": "Safety requirements not met. Dispose of %battery_index Battery properly",
      "zh": "超出安全条件使用，请报废%battery_index电池",
      "fr": ""
    },
    "0x110B0011" : {
      "en": "%battery_index Battery data communication error. Reinstall battery. Replace battery if issue persists",
      "zh": "%battery_index电池数据通信异常，请重新安装电池，如果未解决请更换电池",
      "fr": ""
    },
    "0x110B0012" : {
      "en": "%battery_index Battery maintenance required",
      "zh": "%battery_index电池需要保养",
      "fr": ""
    },
    "0x110B0013" : {
      "en": "Battery not detected in %battery_index Battery slot. Insert or replace battery",
      "zh": "%battery_index电池槽没有电池，请插入电池或者更换电池",
      "fr": ""
    },
    "0x110B0013_in_the_sky" : {
      "en": "Battery not detected in %battery_index Battery slot. Return to home or land promptly",
      "zh": "%battery_index电池槽检测不到电池，请尽快返航或降落",
      "fr": ""
    },
    "0x110B0014" : {
      "en": "%battery_index Battery self-heating",
      "zh": "%battery_index电池在自加热",
      "fr": ""
    },
    "0x110B0015" : {
      "en": "%battery_index Battery maintenance required to ensure flight safety",
      "zh": "%battery_index电池需要保养才能正常飞行",
      "fr": ""
    },
    "0x110B0016" : {
      "en": "%battery_index Battery maintenance required to ensure flight safety",
      "zh": "%battery_index电池需要保养才能正常飞行",
      "fr": ""
    },
    "0x110B0017" : {
      "en": "%battery_index Battery maintenance required to ensure flight safety",
      "zh": "%battery_index电池需要保养才能正常飞行",
      "fr": ""
    },
    "0x110B0018" : {
      "en": "%battery_index Battery maintenance required to ensure flight safety",
      "zh": "%battery_index电池需要保养才能正常飞行",
      "fr": ""
    },
    "0x110B0019" : {
      "en": "%battery_index Battery maintenance required to ensure flight safety",
      "zh": "%battery_index电池需要保养才能正常飞行",
      "fr": ""
    },
    "0x110B001A" : {
      "en": "%battery_index Battery maintenance required to ensure flight safety",
      "zh": "%battery_index电池需要保养才能正常飞行",
      "fr": ""
    },
    "0x110B001B" : {
      "en": "%battery_index Battery maintenance required to ensure flight safety",
      "zh": "%battery_index电池需要保养才能正常飞行",
      "fr": ""
    },
    "0x110B001C" : {
      "en": "Batteries do not match. Replace with matching batteries",
      "zh": "电池不匹配，建议更换匹配电池",
      "fr": ""
    },
    "0x110B001D" : {
      "en": "%battery_index Battery discharge error. Return to home or land promptly",
      "zh": "电池槽%battery_index电池放电异常，请尽快返航或降落",
      "fr": ""
    },
    "0x110b001e" : {
      "en": "%battery_index Battery connection error. Return to home or land promptly",
      "zh": "电池槽%battery_index电池接触不良，请尽快返航或降落",
      "fr": ""
    },
    "0x110B001E" : {
      "en": "%battery_index Battery connection error. Return to home or land promptly",
      "zh": "电池槽%battery_index电池接触不良，请尽快返航或降落",
      "fr": ""
    },
    "0x110B007" : {
      "en": "Battery %d% auto check failed. Replace battery and contact DJI Support",
      "zh": "电池%d%自检失败，请更换电池，并联系售后服务",
      "fr": ""
    },
    "0x110B0403" : {
      "en": "Incompatible battery firmware versions. Update firmware",
      "zh": "双电池版本不一致，请更新电池固件版本",
      "fr": ""
    },
    "0x12000000" : {
      "en": "Battery Station not activated",
      "zh": "电池箱未激活",
      "fr": ""
    },
    "0x12000001" : {
      "en": "Battery Station auto check error",
      "zh": "电池箱自检异常",
      "fr": ""
    },
    "0x12000002" : {
      "en": "Battery Station expansion card communication error",
      "zh": "电池箱拓展板通信异常",
      "fr": ""
    },
    "0x12010000" : {
      "en": "Power Supply Module Not Recognized",
      "zh": "电源模块无法识别",
      "fr": ""
    },
    "0x12010001" : {
      "en": "Battery module input voltage too high",
      "zh": "电源模块输入电压过高",
      "fr": ""
    },
    "0x12010002" : {
      "en": "Battery module input voltage too low",
      "zh": "电源模块输入电压过低",
      "fr": ""
    },
    "0x12010003" : {
      "en": "Battery module output voltage error",
      "zh": "电源模块输出电压异常",
      "fr": ""
    },
    "0x12010004" : {
      "en": "Battery module output current error",
      "zh": "电源模块输出电流异常",
      "fr": ""
    },
    "0x12010005" : {
      "en": "Battery module short-circuited",
      "zh": "电源模块发生短路",
      "fr": ""
    },
    "0x12010006" : {
      "en": "Battery module communication error",
      "zh": "电源模块通信异常",
      "fr": ""
    },
    "0x12010007" : {
      "en": "Battery module fan malfunctioned",
      "zh": "电源模块风扇故障",
      "fr": ""
    },
    "0x12010008" : {
      "en": "Battery module temperature too high",
      "zh": "电源模块温度过高",
      "fr": ""
    },
    "0x12020000" : {
      "en": "Battery port %index battery communication error",
      "zh": "%index槽位电池通讯异常",
      "fr": ""
    },
    "0x12020001" : {
      "en": "Battery port %index battery temperature too low",
      "zh": "%index槽位电池温度过低",
      "fr": ""
    },
    "0x12020002" : {
      "en": "Battery port %index battery overheated",
      "zh": "%index槽位电池温度过高",
      "fr": ""
    },
    "0x12020003" : {
      "en": "Battery port %index battery cell voltage too high",
      "zh": "%index槽位电池电芯过压",
      "fr": ""
    },
    "0x12020004" : {
      "en": "Battery port %index battery system error",
      "zh": "%index槽位电池系统异常",
      "fr": ""
    },
    "0x12020005" : {
      "en": "Battery port %index battery overcurrent during charging",
      "zh": "%index槽位电池充电过流",
      "fr": ""
    },
    "0x12020006" : {
      "en": "Battery port %index battery voltage too high",
      "zh": "%index槽位电池电压过高",
      "fr": ""
    },
    "0x12020007" : {
      "en": "Battery port %index battery voltage too high during charging",
      "zh": "%index槽位电池充电过压",
      "fr": ""
    },
    "0x12020008" : {
      "en": "Battery port %index battery voltage too low during charging",
      "zh": "%index槽位电池充电欠压",
      "fr": ""
    },
    "0x12020009" : {
      "en": "Battery port %index battery permanently damaged",
      "zh": "%index槽位电池永久损坏",
      "fr": ""
    },
    "0x1202000A" : {
      "en": "Battery port %index battery short-circuited",
      "zh": "%index槽位电池短路",
      "fr": ""
    },
    "0x1202000B" : {
      "en": "Battery port %index battery charging taking too long",
      "zh": "%index槽位电池充电时间过长",
      "fr": ""
    },
    "0x1202000C" : {
      "en": "No current detected for battery port %index battery during charging",
      "zh": "%index槽位电池无充电电流",
      "fr": ""
    },
    "0x1202000D" : {
      "en": "Battery port %index battery type not recognized",
      "zh": "%index槽位电池类型无法识别",
      "fr": ""
    },
    "0x12030000" : {
      "en": "Battery Station motherboard overheated",
      "zh": "电池箱主板温度过高",
      "fr": ""
    },
    "0x12030001" : {
      "en": "Battery Station motherboard voltage too high",
      "zh": "电池箱主板电压过高",
      "fr": ""
    },
    "0x12030002" : {
      "en": "Battery Station motherboard voltage too low",
      "zh": "电池箱主板电压过低",
      "fr": ""
    },
    "0x12030003" : {
      "en": "Battery Station port %index error",
      "zh": "电池箱%index槽位充电通道异常",
      "fr": ""
    },
    "0x12030004" : {
      "en": "AC Input Voltage Drop Too Large",
      "zh": "交流输入压降过大",
      "fr": ""
    },
    "0x12030005" : {
      "en": "Oil Maintenance Tips",
      "zh": "机油保养提示",
      "fr": ""
    },
    "0x12030006" : {
      "en": "Charging Device Controller Board Output Voltage Error",
      "zh": "管家板输出电压异常",
      "fr": ""
    },
    "0x12030007" : {
      "en": "Controller Board of Charging Device Input Voltage Error",
      "zh": "管家板输入电压异常",
      "fr": ""
    },
    "0x12040000" : {
      "en": "Dock RTK device disconnected",
      "zh": "机场RTK设备断连",
      "fr": ""
    },
    "0x12040001" : {
      "en": "Dock moved",
      "zh": "机场位置被移动",
      "fr": ""
    },
    "0x12040002" : {
      "en": "Dock RTK error",
      "zh": "机场RTK工作异常",
      "fr": ""
    },
    "0x12040003" : {
      "en": "Location calibrated by RTK device far from current dock location",
      "zh": "机场RTK标定位置距离机场位置过远",
      "fr": ""
    },
    "0x12040004" : {
      "en": "Dock RTK initialization error",
      "zh": "机场RTK初始化收敛失败",
      "fr": ""
    },
    "0x12120000" : {
      "en": "Battery port %index remote controller battery communication error",
      "zh": "%index槽位遥控器电池通信异常",
      "fr": ""
    },
    "0x12120001" : {
      "en": "Battery port %index remote controller battery temperature error",
      "zh": "%index槽位遥控器电池温度异常",
      "fr": ""
    },
    "0x12120002" : {
      "en": "Battery port %index remote controller battery charging error",
      "zh": "%index槽位遥控器电池充电异常",
      "fr": ""
    },
    "0x14010031" : {
      "en": "Payload infusion data error. Restart payload",
      "zh": "负载融合数据异常，请重启负载",
      "fr": ""
    },
    "0x14010032" : {
      "en": "Unable to converge payload infusion data",
      "zh": "负载融合数据未收敛",
      "fr": ""
    },
    "0x14010033" : {
      "en": "Payload system time error. Restart aircraft",
      "zh": "负载系统时间异常，请重启飞行器",
      "fr": ""
    },
    "0x14010034" : {
      "en": "Payload tachometer data invalid. Restart payload",
      "zh": "负载角速度计数据非法，请重启负载",
      "fr": ""
    },
    "0x14010035" : {
      "en": "Payload tachometer data not updated. Restart payload",
      "zh": "负载角速度计数据卡死，请重启负载",
      "fr": ""
    },
    "0x14010036" : {
      "en": "No payload tachometer data. Restart payload",
      "zh": "负载无角速度计数据，请重启负载",
      "fr": ""
    },
    "0x14010037" : {
      "en": "Payload tachometer data exceeds limit. Restart payload",
      "zh": "负载角速度计数据超限，请重启负载",
      "fr": ""
    },
    "0x14010038" : {
      "en": "Payload tachometer data error. Restart payload",
      "zh": "负载角速度计数据异常，请重启负载",
      "fr": ""
    },
    "0x14010039" : {
      "en": "Payload accelerometer data invalid. Restart payload",
      "zh": "负载加速度计数据非法，请重启负载",
      "fr": ""
    },
    "0x1401003A" : {
      "en": "Payload accelerometer data not updated. Restart payload",
      "zh": "负载加速度计数据卡死，请重启负载",
      "fr": ""
    },
    "0x1401003B" : {
      "en": "No payload accelerometer data. Restart payload",
      "zh": "负载无加速度计数据，请重启负载",
      "fr": ""
    },
    "0x1401003C" : {
      "en": "Payload accelerometer data exceeds limit. Restart payload",
      "zh": "负载加速度计数据超限，请重启负载",
      "fr": ""
    },
    "0x1401003D" : {
      "en": "Payload accelerometer data error. Restart payload",
      "zh": "负载加速度计数据异常，请重启负载",
      "fr": ""
    },
    "0x1401003E" : {
      "en": "Payload RTK data calculation error. Restart aircraft",
      "zh": "负载RTK数据解算异常，请重启飞行器",
      "fr": ""
    },
    "0x1401003F" : {
      "en": "Payload direction data error. Check satellite signal",
      "zh": "负载测向数据异常，请确认飞机搜星质量",
      "fr": ""
    },
    "0x14010040" : {
      "en": "Payload RTK data error. Restart aircraft",
      "zh": "负载RTK数据异常，请重启飞行器",
      "fr": ""
    },
    "0x14010041" : {
      "en": "Payload RTK time error. Restart aircraft",
      "zh": "负载RTK时间异常，请重启飞行器",
      "fr": ""
    },
    "0x14010042" : {
      "en": "Payload RTK data invalid. Restart aircraft",
      "zh": "负载RTK数据无效，请重启飞行器",
      "fr": ""
    },
    "0x14010042_in_the_sky" : {
      "en": "Payload RTK data invalid. Make sure satellite signal searching is normal and wait until RTK is fixed",
      "zh": "负载RTK数据无效，请确认搜星情况良好，等待恢复",
      "fr": ""
    },
    "0x14010043" : {
      "en": "Payload IMU warming up. Wait until IMU finished warming up to continue",
      "zh": "请等待负载惯导预热完成",
      "fr": ""
    },
    "0x14010044" : {
      "en": "Payload IMU temperature control processor error. Restart payload",
      "zh": "负载惯导温控异常，请重启负载",
      "fr": ""
    },
    "0x14010045" : {
      "en": "Payload IMU overheated. Restart payload",
      "zh": "负载惯导温度过高，请重启负载",
      "fr": ""
    },
    "0x14010046" : {
      "en": "Payload IMU temperature too low. Restart payload",
      "zh": "负载惯导温度过低，请重启负载",
      "fr": ""
    },
    "0x14010047" : {
      "en": "Payload processor overheated. Return to home or land promptly. Remove payload and wait for it to cool down before use",
      "zh": "负载芯片温度过高，请尽快返航或降落，移除负载等待冷却后重启使用",
      "fr": ""
    },
    "0x14010047_in_the_sky" : {
      "en": "Payload processor overheated. Return to home or land promptly. Remove payload and wait for it to cool down before use",
      "zh": "负载芯片温度过高，请尽快返航或降落，移除负载等待冷却后重启使用",
      "fr": ""
    },
    "0x14010048" : {
      "en": "Payload fan error. Check whether the fan is stalled",
      "zh": "负载风扇异常，请检查负载风扇是否有堵转",
      "fr": ""
    },
    "0x14010048_in_the_sky" : {
      "en": "Payload fan error. Return to home or land and check whether the fan is stalled",
      "zh": "负载风扇异常，请返航或降落，检查负载风扇是否有堵转",
      "fr": ""
    },
    "0x14010049" : {
      "en": "Payload PPS Data Error",
      "zh": "负载PPS数据异常",
      "fr": ""
    },
    "0x1401004A" : {
      "en": "Payload UTC Time Error",
      "zh": "负载UTC时间异常",
      "fr": ""
    },
    "0x14020000" : {
      "en": "ASIC芯片温度异常",
      "zh": "ASIC芯片温度异常",
      "fr": ""
    },
    "0x14020001" : {
      "en": "主控芯片温度异常",
      "zh": "主控芯片温度异常",
      "fr": ""
    },
    "0x14020002" : {
      "en": "看门狗超时",
      "zh": "看门狗超时",
      "fr": ""
    },
    "0x14020003" : {
      "en": "ASIC芯片错误",
      "zh": "ASIC芯片错误",
      "fr": ""
    },
    "0x14020004" : {
      "en": "栈溢出",
      "zh": "栈溢出",
      "fr": ""
    },
    "0x14020005" : {
      "en": "MIPI故障",
      "zh": "MIPI故障",
      "fr": ""
    },
    "0x14020007" : {
      "en": "脏污预警",
      "zh": "脏污预警",
      "fr": ""
    },
    "0x14020031" : {
      "en": "Payload infusion data error. Restart payload",
      "zh": "负载融合数据异常，请重启负载",
      "fr": ""
    },
    "0x14020032" : {
      "en": "Unable to converge payload infusion data",
      "zh": "负载融合数据未收敛",
      "fr": ""
    },
    "0x14020033" : {
      "en": "Payload system time error. Restart aircraft",
      "zh": "负载系统时间异常，请重启飞行器",
      "fr": ""
    },
    "0x14020034" : {
      "en": "Payload tachometer data invalid. Restart payload",
      "zh": "负载角速度计数据非法，请重启负载",
      "fr": ""
    },
    "0x14020035" : {
      "en": "Payload tachometer data not updated. Restart payload",
      "zh": "负载角速度计数据卡死，请重启负载",
      "fr": ""
    },
    "0x14020036" : {
      "en": "No payload tachometer data. Restart payload",
      "zh": "负载无角速度计数据，请重启负载",
      "fr": ""
    },
    "0x14020037" : {
      "en": "Payload tachometer data exceeds limit. Restart payload",
      "zh": "负载角速度计数据超限，请重启负载",
      "fr": ""
    },
    "0x14020038" : {
      "en": "Payload tachometer data error. Restart payload",
      "zh": "负载角速度计数据异常，请重启负载",
      "fr": ""
    },
    "0x14020039" : {
      "en": "Payload accelerometer data invalid. Restart payload",
      "zh": "负载加速度计数据非法，请重启负载",
      "fr": ""
    },
    "0x1402003A" : {
      "en": "Payload accelerometer data not updated. Restart payload",
      "zh": "负载加速度计数据卡死，请重启负载",
      "fr": ""
    },
    "0x1402003B" : {
      "en": "No payload accelerometer data. Restart payload",
      "zh": "负载无加速度计数据，请重启负载",
      "fr": ""
    },
    "0x1402003C" : {
      "en": "Payload accelerometer data exceeds limit. Restart payload",
      "zh": "负载加速度计数据超限，请重启负载",
      "fr": ""
    },
    "0x1402003D" : {
      "en": "Payload accelerometer data error. Restart payload",
      "zh": "负载加速度计数据异常，请重启负载",
      "fr": ""
    },
    "0x1402003E" : {
      "en": "Payload RTK data calculation error. Restart aircraft",
      "zh": "负载RTK数据解算异常，请重启飞行器",
      "fr": ""
    },
    "0x14020040" : {
      "en": "Payload RTK data error. Restart aircraft",
      "zh": "负载RTK数据异常，请重启飞行器",
      "fr": ""
    },
    "0x14020041" : {
      "en": "Payload RTK time error. Restart aircraft",
      "zh": "负载RTK时间异常，请重启飞行器",
      "fr": ""
    },
    "0x14020042" : {
      "en": "Payload RTK data invalid. Restart aircraft",
      "zh": "负载RTK数据无效，请重启飞行器",
      "fr": ""
    },
    "0x14020042_in_the_sky" : {
      "en": "Payload RTK data invalid. Make sure satellite signal searching is normal and wait until RTK is fixed",
      "zh": "负载RTK数据无效，请确认搜星情况良好，等待恢复",
      "fr": ""
    },
    "0x14030000" : {
      "en": "扫描模块温度异常",
      "zh": "扫描模块温度异常",
      "fr": ""
    },
    "0x14030001" : {
      "en": "扫描模块电流异常",
      "zh": "扫描模块电流异常",
      "fr": ""
    },
    "0x14030002" : {
      "en": "Rotation speed error of LiDAR scanning module. Restart aircraft",
      "zh": "激光雷达扫描模块转速异常，请重启飞行器",
      "fr": ""
    },
    "0x14030003" : {
      "en": "Auto Check error of LiDAR scanning module. Restart aircraft",
      "zh": "激光雷达扫描模块自检异常，请重启飞行器",
      "fr": ""
    },
    "0x1403000B" : {
      "en": "Calibrating LiDAR scanning module. Do not move aircraft",
      "zh": "激光雷达扫描模块校准中，请勿移动飞行器",
      "fr": ""
    },
    "0x14040000" : {
      "en": "接收器高压异常",
      "zh": "接收器高压异常",
      "fr": ""
    },
    "0x14040001" : {
      "en": "接收器温度异常",
      "zh": "接收器温度异常",
      "fr": ""
    },
    "0x14040002" : {
      "en": "激光器温度异常",
      "zh": "激光器温度异常",
      "fr": ""
    },
    "0x14050000" : {
      "en": "PPS同步异常",
      "zh": "PPS同步异常",
      "fr": ""
    },
    "0x14050002" : {
      "en": "PPS同步异常",
      "zh": "PPS同步异常",
      "fr": ""
    },
    "0x14050003" : {
      "en": "时间同步精度低",
      "zh": "时间同步精度低",
      "fr": ""
    },
    "0x14060000" : {
      "en": "NIR Illumination power error and disabled. Re-enable this function or contact DJI Support",
      "zh": "近红外补光功率异常并关闭，请重启或联系售后客服",
      "fr": ""
    },
    "0x14810040" : {
      "en": "LiDAR temperature too high/low",
      "zh": "激光雷达温度过高/过低",
      "fr": ""
    },
    "0x14810080" : {
      "en": "LiDAR voltage too high/low",
      "zh": "激光雷达电压过高/过低",
      "fr": ""
    },
    "0x148100c0" : {
      "en": "LiDAR motor error",
      "zh": "激光雷达电机异常",
      "fr": ""
    },
    "0x148100C0" : {
      "en": "",
      "zh": "",
      "fr": ""
    },
    "0x14810100" : {
      "en": "LiDAR lifecycle warning",
      "zh": "激光雷达寿命预警",
      "fr": ""
    },
    "0x14810140" : {
      "en": "LiDAR system error",
      "zh": "激光雷达系统异常",
      "fr": ""
    },
    "0x15000020" : {
      "en": "Millimeter-wave radar temperature too low. Check if ambient temperature is too low",
      "zh": "毫米波雷达温度过低，请确认工作环境温度是否过低",
      "fr": ""
    },
    "0x15000021" : {
      "en": "Millimeter-wave radar overheated. Check if ambient temperature is too high",
      "zh": "毫米波雷达温度过高，请确认工作环境温度是否过高",
      "fr": ""
    },
    "0x15010020" : {
      "en": "Millimeter-wave radar internal power supply error. Restart radar",
      "zh": "毫米波雷达内部供电异常，请重启雷达负载",
      "fr": ""
    },
    "0x15010021" : {
      "en": "Millimeter-wave radar internal power supply error. Restart radar",
      "zh": "毫米波雷达内部供电异常，请重启雷达负载",
      "fr": ""
    },
    "0x15010022" : {
      "en": "Millimeter-wave radar internal power supply error. Restart radar",
      "zh": "毫米波雷达内部供电异常，请重启雷达负载",
      "fr": ""
    },
    "0x15010023" : {
      "en": "Millimeter-wave radar internal power supply error. Restart radar",
      "zh": "毫米波雷达内部供电异常，请重启雷达负载",
      "fr": ""
    },
    "0x15020020" : {
      "en": "Millimeter-wave radar motor error. Check whether radar is stalled",
      "zh": "毫米波雷达电机异常，请检查雷达是否卡转",
      "fr": ""
    },
    "0x15020021" : {
      "en": "Millimeter-wave radar motor error. Check whether radar is stalled",
      "zh": "毫米波雷达电机异常，请检查雷达是否卡转",
      "fr": ""
    },
    "0x15020022" : {
      "en": "Millimeter-wave radar motor error. Check whether radar is stalled",
      "zh": "毫米波雷达电机异常，请检查雷达是否卡转",
      "fr": ""
    },
    "0x15020023" : {
      "en": "Millimeter-wave radar sensing error. Check firmware version",
      "zh": "毫米波雷达感知功能异常，请检查固件版本",
      "fr": ""
    },
    "0x15030020" : {
      "en": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15030021" : {
      "en": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15030022" : {
      "en": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15030023" : {
      "en": "Starting millimeter-wave radar timed out. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达启动超时，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15030024" : {
      "en": "Millimeter-wave radar communication link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达通信链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15030025" : {
      "en": "Millimeter-wave radar communication link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达通信链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15030026" : {
      "en": "Millimeter-wave radar communication link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达通信链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15030028" : {
      "en": "%index radar cable error. Obstacle avoidance and altitude stabilization unavailable",
      "zh": "%index雷达线材异常，避障定高功能失效",
      "fr": ""
    },
    "0x15040020" : {
      "en": "Millimeter-wave radar motor error. Check whether radar is stalled",
      "zh": "毫米波雷达电机异常，请检查雷达是否卡转",
      "fr": ""
    },
    "0x15040021" : {
      "en": "Millimeter-wave radar motor error. Check whether radar is stalled",
      "zh": "毫米波雷达电机异常，请检查雷达是否卡转",
      "fr": ""
    },
    "0x15060020" : {
      "en": "Millimeter-wave radar motor error. Check whether radar is stalled",
      "zh": "毫米波雷达电机异常，请检查雷达是否卡转",
      "fr": ""
    },
    "0x15070020" : {
      "en": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达通信链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15080020" : {
      "en": "Millimeter-wave radar overheated. Check if ambient temperature is too high",
      "zh": "毫米波雷达温度过高，请确认工作环境温度是否过高",
      "fr": ""
    },
    "0x15080021" : {
      "en": "Millimeter-wave radar processor overheated. Obstacle avoidance and altitude stabilization affected",
      "zh": "毫米波雷达芯片温度过高，避障定高性能衰退",
      "fr": ""
    },
    "0x15080022" : {
      "en": "Millimeter-wave radar processor overheated. Obstacle avoidance and altitude stabilization affected",
      "zh": "毫米波雷达芯片温度过高，避障定高性能衰退",
      "fr": ""
    },
    "0x15090020" : {
      "en": "Millimeter-wave radar overheated. Check if ambient temperature is too high",
      "zh": "毫米波雷达温度过高，请确认工作环境温度是否过高",
      "fr": ""
    },
    "0x15090021" : {
      "en": "Millimeter-wave radar error. Obstacle sensing unavailable",
      "zh": "毫米波雷达功能异常，避障功能失效",
      "fr": ""
    },
    "0x15100020" : {
      "en": "Millimeter-wave radar communication link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达通信链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15100021" : {
      "en": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达通信链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15100022" : {
      "en": "Millimeter-wave radar link unstable. Check if there is strong interference in the surrounding area",
      "zh": "毫米波雷达通信链路不稳定，请检查周边是否存在强力干扰",
      "fr": ""
    },
    "0x15110020" : {
      "en": "Millimeter-wave radar motor error. Check whether radar is stalled",
      "zh": "毫米波雷达电机异常，请检查雷达是否卡转",
      "fr": ""
    },
    "0x15130021" : {
      "en": "Millimeter-wave radar sensing error. Check firmware version",
      "zh": "毫米波雷达感知功能异常，请检查固件版本",
      "fr": ""
    },
    "0x15140020" : {
      "en": "Millimeter-wave radar RF clock error. Return to home promptly and check radar",
      "zh": "毫米波雷达射频时钟异常，请立即返航并检查雷达负载",
      "fr": ""
    },
    "0x15220020" : {
      "en": "Backward and downward radar disconnected. Restart aircraft or check and replace radar",
      "zh": "后下雷达断连，请重启或检查更换",
      "fr": ""
    },
    "0x15300020" : {
      "en": "Millimeter-wave radar sensing error. Check firmware version",
      "zh": "毫米波雷达感知功能异常，请检查固件版本",
      "fr": ""
    },
    "0x15300021" : {
      "en": "Millimeter-wave radar sensing error. Check firmware version",
      "zh": "毫米波雷达感知功能异常，请检查固件版本",
      "fr": ""
    },
    "0x15300022" : {
      "en": "Millimeter-wave radar sensing error. Check firmware version",
      "zh": "毫米波雷达感知功能异常，请检查固件版本",
      "fr": ""
    },
    "0x16000001" : {
      "en": "Flight controller overloaded. Unable to take off. Restart aircraft",
      "zh": "无法起飞：飞控系统负载高，请重启飞行器",
      "fr": ""
    },
    "0x16000001_in_the_sky" : {
      "en": "Flight controller overloaded. If the issue persists, land aircraft promptly",
      "zh": "飞控系统负载高，如若持续存在请尽快降落",
      "fr": ""
    },
    "0x16000002" : {
      "en": "Flight data recording error. Contact your local dealer or DJI Support",
      "zh": "飞行数据记录异常，请尽快联系就近代理商或大疆售后服务。",
      "fr": ""
    },
    "0x16000002_in_the_sky" : {
      "en": "Flight data record abnorma.If the warning persists, contact your local dealer or DJI Support.",
      "zh": "飞行数据记录异常，请尽快联系就近代理商或大疆售后服务。",
      "fr": ""
    },
    "0x16010001" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010001_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010005" : {
      "en": "Sensor system initializing. Wait for initialization to complete",
      "zh": "传感器系统初始化中，请等待初始化完成",
      "fr": ""
    },
    "0x16010005_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010007" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010007_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x1601000A" : {
      "en": "Sensor system initializing. Wait for initialization to complete",
      "zh": "传感器系统初始化中，请等待初始化完成",
      "fr": ""
    },
    "0x1601000A_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x1601000D" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1601000D_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010010" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010010_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010013" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010013_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010016" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010016_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010019" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010019_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x1601001C" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1601001C_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x1601001F" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1601001F_in_the_sky" : {
      "en": "Not Applicable. This string has been deleted",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010022" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010022_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010025" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010025_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010026" : {
      "en": "Unable to take off. Non-DJI RTK module detected",
      "zh": "无法起飞：检测到非官方RTK模块",
      "fr": ""
    },
    "0x16010026_in_the_sky" : {
      "en": "Non-DJI RTK module detected",
      "zh": "检测到非官方RTK模块",
      "fr": ""
    },
    "0x16010028" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010028_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x1601002B" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1601002B_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x1601002F" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1601002F_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010032" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010032_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010033" : {
      "en": "Vision positioning detection poor. Fly with caution",
      "zh": "视觉定位观测较差，请注意飞行安全",
      "fr": ""
    },
    "0x16010034" : {
      "en": "GNSS detection poor. Fly with caution",
      "zh": "卫星定位观测较差，请注意飞行安全",
      "fr": ""
    },
    "0x16010035" : {
      "en": "Positioning quality poor. Fly with caution",
      "zh": "定位质量较差，请注意飞行安全",
      "fr": ""
    },
    "0x16010036" : {
      "en": "Vision positioning detection poor. Fly with caution",
      "zh": "视觉定位观测不佳，请注意飞行安全",
      "fr": ""
    },
    "0x16010037" : {
      "en": "GNSS detection poor. Fly with caution",
      "zh": "卫星定位观测不佳，请注意飞行安全",
      "fr": ""
    },
    "0x16010038" : {
      "en": "Positioning quality poor. Fly with caution",
      "zh": "定位质量不佳，请注意飞行安全",
      "fr": ""
    },
    "0x16010039" : {
      "en": "No GNSS available. Wait for searching satellite signal. Fly with caution",
      "zh": "无卫星定位，请等待搜星，注意飞行安全",
      "fr": ""
    },
    "0x16010041" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16010041_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16010042" : {
      "en": "Severe error in aircraft positioning system. Aircraft will automatically land soon. Fly aircraft to open area promptly",
      "zh": "飞行器定位系统严重故障，即将强制降落，请尽快选择空旷地区降落",
      "fr": ""
    },
    "0x16010050" : {
      "en": "",
      "zh": "当前仅使用雷达定位，请勿在狭窄走廊、隧道等环境飞行",
      "fr": ""
    },
    "0x16020001" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16020001_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x16020004" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16020004_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x16020007" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16020007_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x1602000A" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x1602000A_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x1602000D" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x1602000D_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x16020016" : {
      "en": "IMU bias too large. Calibrate IMU",
      "zh": "IMU偏差过大，请校准 IMU",
      "fr": ""
    },
    "0x16020016_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x16020027" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16020027_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x1602002A" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x1602002A_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x1602002B" : {
      "en": "IMU constant temperature system error. Restart aircraft",
      "zh": "IMU恒温系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16020620" : {
      "en": "RTH canceled. Control stick pushed down",
      "zh": "返航中断：检测到反向杆量",
      "fr": ""
    },
    "0x16020621" : {
      "en": "RTH canceled. Obstacle detected",
      "zh": "返航中断：检测到障碍物",
      "fr": ""
    },
    "0x16020622" : {
      "en": "RTH canceled. Strong wind or aircraft approaching GEO Zone",
      "zh": "返航中断：风速过大或有限飞区",
      "fr": ""
    },
    "0x16020623" : {
      "en": "GNSS error. RTH canceled",
      "zh": "返航中断：卫星定位异常",
      "fr": ""
    },
    "0x16030001" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16030001_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x16030004" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16030004_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x16030007" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16030007_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x1603000A" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x1603000A_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x1603000D" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x1603000D_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x16030010" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16030010_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x16030013" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16030013_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x16030016" : {
      "en": "IMU bias too large. Calibrate IMU",
      "zh": "IMU偏差过大，请校准 IMU",
      "fr": ""
    },
    "0x16030016_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x1603001C" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x1603001C_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常,请返航或降落",
      "fr": ""
    },
    "0x1603001D" : {
      "en": "Abnormal aircraft vibration. Return to home or land promptly",
      "zh": "飞行器异常振动，请尽快返航或降落",
      "fr": ""
    },
    "0x16040001" : {
      "en": "Barometer error. Restart aircraft",
      "zh": "气压计异常，请重启飞行器",
      "fr": ""
    },
    "0x16040001_in_the_sky" : {
      "en": "Barometer error. Return to home or land",
      "zh": "气压计异常,请返航或降落",
      "fr": ""
    },
    "0x16040004" : {
      "en": "Barometer error. Restart aircraft",
      "zh": "气压计异常，请重启飞行器",
      "fr": ""
    },
    "0x16040004_in_the_sky" : {
      "en": "Barometer error. Return to home or land",
      "zh": "气压计异常,请返航或降落",
      "fr": ""
    },
    "0x16040007" : {
      "en": "Barometer error. Restart aircraft",
      "zh": "气压计异常，请重启飞行器",
      "fr": ""
    },
    "0x16040007_in_the_sky" : {
      "en": "Barometer error. Return to home or land",
      "zh": "气压计异常,请返航或降落",
      "fr": ""
    },
    "0x1604000A" : {
      "en": "Barometer error. Restart aircraft",
      "zh": "气压计异常，请重启飞行器",
      "fr": ""
    },
    "0x1604000A_in_the_sky" : {
      "en": "Barometer error. Return to home or land",
      "zh": "气压计异常,请返航或降落",
      "fr": ""
    },
    "0x16040010" : {
      "en": "Barometer error. Restart aircraft",
      "zh": "气压计异常，请重启飞行器",
      "fr": ""
    },
    "0x16040010_in_the_sky" : {
      "en": "Barometer error. Return to home or land",
      "zh": "气压计异常,请返航或降落",
      "fr": ""
    },
    "0x16040013" : {
      "en": "Barometer error. Restart aircraft",
      "zh": "气压计异常，请重启飞行器",
      "fr": ""
    },
    "0x16040013_in_the_sky" : {
      "en": "Barometer error. Return to home or land",
      "zh": "气压计异常,请返航或降落",
      "fr": ""
    },
    "0x16040016" : {
      "en": "Barometer error. Restart aircraft",
      "zh": "气压计异常，请重启飞行器",
      "fr": ""
    },
    "0x16040016_in_the_sky" : {
      "en": "Barometer error. Return to home or land",
      "zh": "气压计异常,请返航或降落",
      "fr": ""
    },
    "0x16040019" : {
      "en": "Barometer error. Restart aircraft",
      "zh": "气压计异常，请重启飞行器",
      "fr": ""
    },
    "0x16040019_in_the_sky" : {
      "en": "Barometer error. Return to home or land",
      "zh": "气压计异常,请返航或降落",
      "fr": ""
    },
    "0x16050001" : {
      "en": "GNSS error. Restart aircraft",
      "zh": "卫星定位异常，请重启飞行器",
      "fr": ""
    },
    "0x16050001_in_the_sky" : {
      "en": "GNSS error. Return to home or land",
      "zh": "卫星定位异常,请返航或降落",
      "fr": ""
    },
    "0x16050004" : {
      "en": "GNSS error. Restart aircraft",
      "zh": "卫星定位异常，请重启飞行器",
      "fr": ""
    },
    "0x16050004_in_the_sky" : {
      "en": "GNSS error. Return to home or land",
      "zh": "卫星定位异常,请返航或降落",
      "fr": ""
    },
    "0x16050019" : {
      "en": "GNSS error. Restart aircraft",
      "zh": "卫星定位异常，请重启飞行器",
      "fr": ""
    },
    "0x16050019_in_the_sky" : {
      "en": "GNSS error. Return to home or land",
      "zh": "卫星定位异常,请返航或降落",
      "fr": ""
    },
    "0x1605001C" : {
      "en": "GNSS error. Restart aircraft",
      "zh": "卫星定位异常，请重启飞行器",
      "fr": ""
    },
    "0x1605001C_in_the_sky" : {
      "en": "GNSS error. Return to home or land",
      "zh": "卫星定位异常,请返航或降落",
      "fr": ""
    },
    "0x1605001F" : {
      "en": "GNSS signal interfered. Fly with caution",
      "zh": "飞行器卫星定位信号受到干扰，谨慎飞行",
      "fr": ""
    },
    "0x16050020" : {
      "en": "Strong GNSS interference. Aircraft returning to home",
      "zh": "卫星定位信号干扰强，飞行器自动返航",
      "fr": ""
    },
    "0x16050021" : {
      "en": "RTK not converged. Place aircraft in an open area and start task after RTK converged",
      "zh": "RTK 启用未收敛，请将飞机置于空旷环境等待 RTK 收敛后执行任务",
      "fr": ""
    },
    "0x16050022" : {
      "en": "Large errors in GNSS positioning. There may be potential safety risks. Switch to A mode manually",
      "zh": "当前飞行环境卫星定位误差大，存在安全风险，请主动切换至姿态挡飞行",
      "fr": ""
    },
    "0x1605002B" : {
      "en": "Only BDS data used. Number of searched satellites may be affected",
      "zh": "进入单北斗模式，搜星质量可能变差",
      "fr": ""
    },
    "0x16060001" : {
      "en": "Compass error. Restart aircraft",
      "zh": "指南针异常，请重启飞行器",
      "fr": ""
    },
    "0x16060001_in_the_sky" : {
      "en": "Compass error. Return to home or land",
      "zh": "指南针异常,请返航或降落",
      "fr": ""
    },
    "0x16060007" : {
      "en": "Compass error. Restart aircraft",
      "zh": "指南针异常，请重启飞行器",
      "fr": ""
    },
    "0x16060007_in_the_sky" : {
      "en": "Compass error. Return to home or land",
      "zh": "指南针异常,请返航或降落",
      "fr": ""
    },
    "0x1606000A" : {
      "en": "Compass error. Restart aircraft",
      "zh": "指南针异常，请重启飞行器",
      "fr": ""
    },
    "0x1606000A_in_the_sky" : {
      "en": "Compass error. Return to home or land",
      "zh": "指南针异常,请返航或降落",
      "fr": ""
    },
    "0x1606000D" : {
      "en": "Compass interference. Calibrate compass",
      "zh": "指南针受到干扰，请校准指南针",
      "fr": ""
    },
    "0x1606000D_in_the_sky" : {
      "en": "Compass interference. Move aircraft away from interference source",
      "zh": "指南针受到干扰,请远离干扰源",
      "fr": ""
    },
    "0x16060010" : {
      "en": "Compass interference. Calibrate compass",
      "zh": "指南针受到干扰，请校准指南针",
      "fr": ""
    },
    "0x16060010_in_the_sky" : {
      "en": "Compass interference. Move aircraft away from interference source",
      "zh": "指南针受到干扰,请远离干扰源",
      "fr": ""
    },
    "0x16070001" : {
      "en": "Flight controller overheats. Returning to home...",
      "zh": "飞控温度过高，返航中",
      "fr": ""
    },
    "0x16070002" : {
      "en": "Flight controller overheats. Returning to home...",
      "zh": "飞控温度过高，返航中",
      "fr": ""
    },
    "0x16070003" : {
      "en": "Flight controller overheats. Auto landing...",
      "zh": "飞控温度过高，强制降落中",
      "fr": ""
    },
    "0x16070020" : {
      "en": "RTK data not received by aircraft",
      "zh": "飞行器未接收到RTK数据",
      "fr": ""
    },
    "0x16070021" : {
      "en": "RTK data error. Restart aircraft",
      "zh": "RTK 数据异常，请重启飞行器",
      "fr": ""
    },
    "0x16070022" : {
      "en": "",
      "zh": "RTK双天线安装错误",
      "fr": ""
    },
    "0x16070023" : {
      "en": "RTK data refresh frequency error",
      "zh": "RTK 数据更新频率异常",
      "fr": ""
    },
    "0x16070024" : {
      "en": "RTK data error",
      "zh": "RTK 数据异常",
      "fr": ""
    },
    "0x16070025" : {
      "en": "Unable to refresh RTK position data",
      "zh": "RTK 定位数据停止更新",
      "fr": ""
    },
    "0x16070026" : {
      "en": "Sudden RTK position data change",
      "zh": "RTK 定位数据跳变",
      "fr": ""
    },
    "0x16070027" : {
      "en": "RTK and sensor altitude data inconsistent",
      "zh": "RTK 高度与传感器高度数据不一致",
      "fr": ""
    },
    "0x16070028" : {
      "en": "RTK and GNSS positioning do not match",
      "zh": "RTK 定位与卫星定位不一致",
      "fr": ""
    },
    "0x16070029" : {
      "en": "RTK position data changed slightly when aircraft is stationary",
      "zh": "飞行器静止时 RTK 定位缓变",
      "fr": ""
    },
    "0x16070030" : {
      "en": "RTK firmware version does not match",
      "zh": "RTK 固件版本不匹配",
      "fr": ""
    },
    "0x16070031" : {
      "en": "RTK signal source switching error",
      "zh": "RTK信号源切换异常",
      "fr": ""
    },
    "0x16070032" : {
      "en": "D-RTK mobile station detached",
      "zh": "D-RTK 移动站倾倒",
      "fr": ""
    },
    "0x16070033" : {
      "en": "D-RTK mobile station moved",
      "zh": "D-RTK 移动站发生移动",
      "fr": ""
    },
    "0x16070034" : {
      "en": "RTK flight heading inconsistent with other sources",
      "zh": "RTK 航向与其他源不一致",
      "fr": ""
    },
    "0x16070035" : {
      "en": "Aircraft D-RTK antenna error",
      "zh": "机载 D-RTK 天线异常",
      "fr": ""
    },
    "0x16070036" : {
      "en": "Unable to take off. RTK antennas disconnected. Contact DJI Support",
      "zh": "无法起飞：RTK天线断连，请联系DJI售后",
      "fr": ""
    },
    "0x16070036_in_the_sky" : {
      "en": "RTK antennas disconnected. Return to home or land promptly",
      "zh": "RTK天线断连，请尽快返航或降落",
      "fr": ""
    },
    "0x16070037" : {
      "en": "RTK Dongle Certification Error",
      "zh": "RTK认证错误",
      "fr": ""
    },
    "0x16070038" : {
      "en": "",
      "zh": "RTK主天线信号异常",
      "fr": ""
    },
    "0x16070039" : {
      "en": "",
      "zh": "RTK副天线信号异常",
      "fr": ""
    },
    "0x16070040" : {
      "en": "RTK not converged. Place aircraft in an open environment and start task after RTK converged",
      "zh": "RTK 启用未收敛，请将飞机置于空旷环境等待 RTK 收敛后执行任务",
      "fr": ""
    },
    "0x16070042" : {
      "en": "RTK base station data error. Check if network RTK or D-RTK is connected",
      "zh": "RTK基站数据异常，请检查网络RTK或D-RTK是否断联",
      "fr": ""
    },
    "0x16070043" : {
      "en": "GNSS is interfered with error signal. Fly with caution or return to home",
      "zh": "卫星定位受异常信号干扰，请谨慎飞行或返航",
      "fr": ""
    },
    "0x16070043_in_the_sky" : {
      "en": "GNSS is interfered with error signal. Take off with caution",
      "zh": "卫星定位受异常信号干扰，请谨慎起飞",
      "fr": ""
    },
    "0x16070044" : {
      "en": "GNSS is receiving false signal. Return to home or land promptly",
      "zh": "卫星定位受到欺骗，请立即返航或降落",
      "fr": ""
    },
    "0x16070044_in_the_sky" : {
      "en": "GNSS is receiving false signal. Take off with caution",
      "zh": "卫星定位受到欺骗，请谨慎起飞",
      "fr": ""
    },
    "0x16070045" : {
      "en": "Dock moved. Exercise caution",
      "zh": "检测到机场发生移动，请谨慎操作",
      "fr": ""
    },
    "0x16080020" : {
      "en": "Motor %index stalled . Land aircraft immediately",
      "zh": "%index号电机堵转，请停止飞行。",
      "fr": ""
    },
    "0x16080021" : {
      "en": "ESC %index short-circuited . Land immediately and restart aircraft",
      "zh": "%index号电调短路，请停止飞行，并重启飞行器。",
      "fr": ""
    },
    "0x16080022" : {
      "en": "ESC %index overloaded . Land aircraft immediately",
      "zh": "%index号电机过载，请停止飞行。",
      "fr": ""
    },
    "0x16080023" : {
      "en": "Motor %index communication error . Land immediately and restart aircraft",
      "zh": "%index号电机通信异常，请停止飞行，并重启飞行器。",
      "fr": ""
    },
    "0x16080024" : {
      "en": "Motor %index over-accelerating. Stop pressing control stick",
      "zh": "%index号电机油门过高，请回中摇杆。",
      "fr": ""
    },
    "0x16080025" : {
      "en": "Motor %index communication error",
      "zh": "%index号电机通信异常。",
      "fr": ""
    },
    "0x16080026" : {
      "en": "Motor %index communication error",
      "zh": "%index号电机通信异常",
      "fr": ""
    },
    "0x16080027" : {
      "en": "Motor %index communication error",
      "zh": "%index号电机通信异常",
      "fr": ""
    },
    "0x16080028" : {
      "en": "Motor %index communication error",
      "zh": "%index号电机通信异常",
      "fr": ""
    },
    "0x16080029" : {
      "en": "Motor %index propeller detached, propeller not installed, or motor underloaded",
      "zh": "%index号电机射桨、空载或轻载",
      "fr": ""
    },
    "0x1608002A" : {
      "en": "ESC %index overheated",
      "zh": "%index号电调温度过高",
      "fr": ""
    },
    "0x1608002B" : {
      "en": "ESC %index overheated",
      "zh": "%index号电调温度过高",
      "fr": ""
    },
    "0x1608002C" : {
      "en": "ESC %index voltage too high",
      "zh": "%index号电调电压过高",
      "fr": ""
    },
    "0x1608002D" : {
      "en": "ESC %index voltage too low",
      "zh": "%index号电调电压过低",
      "fr": ""
    },
    "0x1608002E" : {
      "en": "ESC %index flash memory error",
      "zh": "%index号电调闪存异常",
      "fr": ""
    },
    "0x1608002F" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080030" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080031" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080032" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080033" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080034" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080035" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080036" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080037" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080038" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080039" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608003a" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608003b" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608003c" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608003d" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608003e" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608003f" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080040" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080041" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080042" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080043" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080044" : {
      "en": "ESC %index voltage too low",
      "zh": "%index号电调电压过低",
      "fr": ""
    },
    "0x16080045" : {
      "en": "ESC %index voltage too high",
      "zh": "%index号电调电压过高",
      "fr": ""
    },
    "0x16080046" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080047" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080048" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080049" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608004a" : {
      "en": "ESC %index overheated",
      "zh": "%index号电调温度过高",
      "fr": ""
    },
    "0x1608004b" : {
      "en": "ESC %index temperature too low",
      "zh": "%index号电调温度过低",
      "fr": ""
    },
    "0x1608004c" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608004d" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608004e" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x1608004f" : {
      "en": "ESC %index auto-check error",
      "zh": "%index号电调自检异常",
      "fr": ""
    },
    "0x16080050" : {
      "en": "ESC error. Unable to take off. Restart aircraft and try again",
      "zh": "无法起飞：电调异常，请尝试重启飞行器",
      "fr": ""
    },
    "0x16080050_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16080051" : {
      "en": "ESC error. Fly with caution",
      "zh": "电调异常，请谨慎飞行",
      "fr": ""
    },
    "0x16080052" : {
      "en": "Propulsion system error. Propellers folded. Unable to take off",
      "zh": "无法起飞：动力系统异常，桨叶未展开",
      "fr": ""
    },
    "0x16080052_in_the_sky" : {
      "en": "Propulsion system error. Propellers folded",
      "zh": "动力系统异常，桨叶未展开",
      "fr": ""
    },
    "0x16080053" : {
      "en": "ESC error. Fly with caution",
      "zh": "电调异常，请谨慎飞行",
      "fr": ""
    },
    "0x16080054" : {
      "en": "ESC error. Unable to take off. Restart aircraft and try again",
      "zh": "无法起飞：电调异常，请尝试重启飞行器",
      "fr": ""
    },
    "0x16080054_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16080055" : {
      "en": "Motor %index overheated. Land aircraft immediately",
      "zh": "%index号电机温度较高，请尽快降落",
      "fr": ""
    },
    "0x16080056" : {
      "en": "Motor %index overheated. Aircraft may be auto landing",
      "zh": "%index号电机温度过高，飞机可能降落",
      "fr": ""
    },
    "0x16080056_in_the_sky" : {
      "en": "Motor %index temperature too high. Flight speed limited",
      "zh": "%index号电机温度过高，飞机可能降落",
      "fr": ""
    },
    "0x16080057" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16080057_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16080058" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x16080058_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16080059" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x16080059_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1608005a" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005A" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005A_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1608005b" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005B" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005B_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1608005c" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005C" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005C_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1608005d" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005D" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005D_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1608005e" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005E" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后",
      "fr": ""
    },
    "0x1608005e_in_the_sky" : {
      "en": "ESC error. Return to home or land promptly",
      "zh": "电调异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1608005F" : {
      "en": "Motor %index overheated. Aircraft auto landing",
      "zh": "%index号电机超温，强制降落",
      "fr": ""
    },
    "0x16080077" : {
      "en": "%index ESC overheated (%alarmid)",
      "zh": "%index号电调严重超温(%alarmid)",
      "fr": ""
    },
    "0x16080078" : {
      "en": "%index ESC overheated (%alarmid)",
      "zh": "%index号电调严重超温(%alarmid)",
      "fr": ""
    },
    "0x16080079" : {
      "en": "%index ESC firmware incompatible with aircraft model (%alarmid)",
      "zh": "%index号电调固件与飞机机型不匹配(%alarmid)",
      "fr": ""
    },
    "0x1608007A" : {
      "en": "%index ESC firmware incompatible with aircraft model (%alarmid)",
      "zh": "%index号电调固件与飞机机型不匹配(%alarmid)",
      "fr": ""
    },
    "0x1608007B" : {
      "en": "%index ESC auto-check error (%alarmid)",
      "zh": "%index号电调自检异常(%alarmid)",
      "fr": ""
    },
    "0x1608007C" : {
      "en": "%index ESC auto-check error (%alarmid)",
      "zh": "%index号电调自检异常(%alarmid)",
      "fr": ""
    },
    "0x1608007D" : {
      "en": "%index ESC or motor auto-check error (%alarmid)",
      "zh": "%index号电调或电机自检异常(%alarmid)",
      "fr": ""
    },
    "0x1608007E" : {
      "en": "%index ESC or motor auto-check error (%alarmid)",
      "zh": "%index号电调或电机自检异常(%alarmid)",
      "fr": ""
    },
    "0x1608007F" : {
      "en": "%index ESC or motor auto-check error (%alarmid)",
      "zh": "%index号电调或电机自检异常(%alarmid)",
      "fr": ""
    },
    "0x16080080" : {
      "en": "%index ESC or motor auto-check error (%alarmid)",
      "zh": "%index号电调或电机自检异常(%alarmid)",
      "fr": ""
    },
    "0x16080083" : {
      "en": "Failed to start Motor %d. Make sure propellers are unfolded and free from obstacles and try again",
      "zh": "%d号电机启动失败，请检查桨叶是否展开以及桨叶周围是否有障碍物后打杆重试",
      "fr": ""
    },
    "0x16090050" : {
      "en": "%battery_index Battery power supply error. Return to home or land promptly",
      "zh": "%battery_index电池供电异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16090051" : {
      "en": "%battery_index Battery power supply error. Return to home or land promptly",
      "zh": "%battery_index电池供电异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16090052" : {
      "en": "%battery_index Battery temperature sensor error. Return to home or land promptly",
      "zh": "%battery_index电池温度传感器异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16090061" : {
      "en": "%battery_index Battery overheated. Return to home or land promptly. Stop using battery",
      "zh": "%battery_index电池温度过高，请尽快返航或降落，停止使用该电池",
      "fr": ""
    },
    "0x16090062" : {
      "en": "%battery_index Battery MOS temperature too high. Return to home or land promptly. Wait until %battery_index Battery cools down",
      "zh": "%battery_index电池MOS温度过高，请尽快返航或降落，等待%battery_index电池温度降低",
      "fr": ""
    },
    "0x16090063" : {
      "en": "%battery_index Battery voltage too high. Return to home or land promptly",
      "zh": "%battery_index电池总电压过高，请尽快返航或降落",
      "fr": ""
    },
    "0x16090064" : {
      "en": "%battery_index Battery voltage too low. Return to home or land promptly",
      "zh": "%battery_index电池总电压过低，请尽快返航或降落",
      "fr": ""
    },
    "0x16090065" : {
      "en": "%battery_index Battery single cell voltage too high. Return to home or land promptly",
      "zh": "%battery_index电池单电芯电压过高，请尽快返航或降落",
      "fr": ""
    },
    "0x16090066" : {
      "en": "%battery_index Battery single cell voltage too low. Return to home or land promptly",
      "zh": "%battery_index电池单电芯电压过低，请尽快返航或降落",
      "fr": ""
    },
    "0x16090067" : {
      "en": "Large static voltage difference between %battery_index Battery cells. Stop using battery",
      "zh": "%battery_index电池静态压差过大，请停止使用该电池",
      "fr": ""
    },
    "0x16090068" : {
      "en": "Large charge voltage difference between %battery_index Battery cells. Return to home or land promptly. Stop using battery",
      "zh": "%battery_index电池充电电芯间压差过大，请尽快返航或降落，并停止使用该电池",
      "fr": ""
    },
    "0x16090069" : {
      "en": "Large discharge voltage difference between %battery_index Battery cells. Return to home or land promptly. Stop using battery",
      "zh": "%battery_index电池放电电芯间压差过大，请尽快返航或降落，并停止使用该电池",
      "fr": ""
    },
    "0x1609006A" : {
      "en": "%battery_index Battery MOS connection error. Return to home or land promptly",
      "zh": "%battery_index电池MOS连接异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1609006B" : {
      "en": "%battery_index Battery MOS impedance error. Return to home or land promptly",
      "zh": "%battery_index电池MOS阻抗异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1609006C" : {
      "en": "%battery_index Battery aging. Flight safety may be affected. Return to home or land promptly",
      "zh": "%battery_index电池老化，可能影响飞行安全，请尽快返航或降落",
      "fr": ""
    },
    "0x1609006D" : {
      "en": "%battery_index Battery experienced micro short circuit. Flight safety may be affected. Return to home or land promptly",
      "zh": "%battery_index电池微短路，可能影响飞行安全，请尽快返航或降落",
      "fr": ""
    },
    "0x1609006F" : {
      "en": "%battery_index Battery connector temperature too high. Return to home or land promptly",
      "zh": "%battery_index电池连接器温度过高，请尽快返航或降落",
      "fr": ""
    },
    "0x16090070" : {
      "en": "%battery_index Battery voltage too low. Return to home or land promptly",
      "zh": "%battery_index电池电压过低，请尽快返航或降落",
      "fr": ""
    },
    "0x16090071" : {
      "en": "Battery overvoltage protection",
      "zh": "电池电压过压保护",
      "fr": ""
    },
    "0x16090072" : {
      "en": "%battery_index Battery overcurrent when charging. Check charging device",
      "zh": "%battery_index电池充电过流，请检查充电设备",
      "fr": ""
    },
    "0x16090073" : {
      "en": "%battery_index Battery overcurrent when discharging. Check if aircraft is overloaded",
      "zh": "%battery_index电池放电过流，请检查飞行器是否有负重",
      "fr": ""
    },
    "0x16090074" : {
      "en": "%battery_index Battery over discharged. Check if aircraft is overloaded",
      "zh": "%battery_index电池放电过载，请检查飞行器是否有负重",
      "fr": ""
    },
    "0x16090075" : {
      "en": "%battery_index Battery system error. Restart %battery_index Battery and try again",
      "zh": "%battery_index电池系统异常，请重启%battery_index电池后重试",
      "fr": ""
    },
    "0x16090076" : {
      "en": "%battery_index Battery internal module error. Return to home or land promptly",
      "zh": "%battery_index电池内部模块异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16090077" : {
      "en": "%battery_index Battery charging temperature too high. Stop charging and wait until %battery_index Battery cools down",
      "zh": "%battery_index电池充电温度过高，禁止充电，等待%battery_index电池温度降低",
      "fr": ""
    },
    "0x16090078" : {
      "en": "%battery_index Battery discharging temperature too high. Return to home or land promptly. Wait until %battery_index Battery cools down",
      "zh": "%battery_index电池放电温度过高，请尽快返航或降落，等待%battery_index电池温度降低",
      "fr": ""
    },
    "0x16090079" : {
      "en": "%battery_index Battery charging temperature too low. Warm up %battery_index Battery before charging",
      "zh": "%battery_index电池充电温度过低，禁止充电，请预热%battery_index电池后充电",
      "fr": ""
    },
    "0x1609007A" : {
      "en": "%battery_index Battery discharging temperature too low. Return to home or land promptly. Warm up %battery_index Battery before takeoff",
      "zh": "%battery_index电池放电温度过低，请尽快返航或降落，请预热%battery_index电池后再起飞",
      "fr": ""
    },
    "0x1609007B" : {
      "en": "%battery_index Battery voltage too high. Reinstall %battery_index Battery before takeoff",
      "zh": "%battery_index电池电压过高，请拔插%battery_index电池后再起飞",
      "fr": ""
    },
    "0x1609007C" : {
      "en": "%battery_index Battery voltage too low. Reinstall %battery_index Battery before takeoff",
      "zh": "%battery_index电池电压过低，请拔插%battery_index电池后再起飞",
      "fr": ""
    },
    "0x1609007D" : {
      "en": "Charging device voltage too high. Check device",
      "zh": "充电器电压过高，请检查充电设备",
      "fr": ""
    },
    "0x1609007E" : {
      "en": "Charging device voltage too low. Check device",
      "zh": "充电器电压过低，请检查充电设备",
      "fr": ""
    },
    "0x1609007F" : {
      "en": "%battery_index Battery overheated. Unable to take off. Wait until %battery_index Battery cools down",
      "zh": "%battery_index电池温度过高，无法起飞，等待%battery_index电池温度降低",
      "fr": ""
    },
    "0x16090080" : {
      "en": "%battery_index Battery overheated. Return to home or land promptly. Wait until %battery_index Battery cools down",
      "zh": "%battery_index电池温度过高，请尽快返航或降落，等待%battery_index电池温度降低",
      "fr": ""
    },
    "0x16090081" : {
      "en": "%battery_index Battery overheated. Return to home or land promptly. Wait until %battery_index Battery cools down",
      "zh": "%battery_index电池温度过高，请尽快返航或降落，等待%battery_index电池温度降低",
      "fr": ""
    },
    "0x16090082" : {
      "en": "%battery_index Battery internal communication error. Return to home or land promptly",
      "zh": "%battery_index电池内部通讯异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16090083" : {
      "en": "%battery_index Battery internal communication error. Return to home or land promptly",
      "zh": "%battery_index电池内部通讯异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16090084" : {
      "en": "%battery_index Battery internal communication error. Return to home or land promptly",
      "zh": "%battery_index电池内部通讯异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16090085" : {
      "en": "%battery_index Battery external communication error. Return to home or land promptly",
      "zh": "%battery_index电池对外通信异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16090086" : {
      "en": "%battery_index battery connector temperature too high. Flight safety affected",
      "zh": "%battery_index电池连接器温度过高，影响飞行安全",
      "fr": ""
    },
    "0x16090086_in_the_sky" : {
      "en": "%battery_index battery connector temperature too high. Flight safety affected. Return to home or land promptly",
      "zh": "%battery_index电池连接器温度过高，影响飞行安全，请尽快返航或降落",
      "fr": ""
    },
    "0x16090092" : {
      "en": "Pack voltage sensor error",
      "zh": "Vpack电压采样异常",
      "fr": ""
    },
    "0x16090093" : {
      "en": "%battery_index Battery voltage unstable. Return to home or land promptly. Restart aircraft after landing",
      "zh": "%battery_index电池电压不稳定，请尽快返航或降落后重启电池",
      "fr": ""
    },
    "0x16090094" : {
      "en": "%battery_index Battery voltage sensor error. Return to home or land promptly",
      "zh": "%battery_index电池电压采集异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16090095" : {
      "en": "%battery_index Battery voltage too high. Return to home or land promptly. Restart aircraft after landing",
      "zh": "%battery_index电池电压过高，请尽快返航或降落后重启电池",
      "fr": ""
    },
    "0x16090096" : {
      "en": "%battery_index Battery maintenance required. Fly with caution",
      "zh": "%battery_index电池需要保养，请谨慎飞行",
      "fr": ""
    },
    "0x16090097" : {
      "en": "%battery_index battery maintenance required. Fly with caution",
      "zh": "%battery_index电池需要保养，请谨慎飞行",
      "fr": ""
    },
    "0x16090098" : {
      "en": "Large voltage difference during discharge",
      "zh": "放电压差大告警",
      "fr": ""
    },
    "0x16090099" : {
      "en": "%battery_index Battery overcurrent. Fly with caution",
      "zh": "%battery_index电池电流过大，请谨慎飞行",
      "fr": ""
    },
    "0x1609009B" : {
      "en": "%battery_index Battery temperature high. Return to home or land promptly. Wait until %battery_index Battery cools down",
      "zh": "%battery_index电池温度高，请尽快返航或降落，等待%battery_index电池温度降低",
      "fr": ""
    },
    "0x1609009C" : {
      "en": "%battery_index Battery temperature high. Return to home or land promptly. Wait until %battery_index Battery cools down",
      "zh": "%battery_index电池温度高，请尽快返航或降落，等待%battery_index电池温度降低",
      "fr": ""
    },
    "0x1609009D" : {
      "en": "%battery_index battery connector temperature too high",
      "zh": "%battery_index电池连接器温度过高",
      "fr": ""
    },
    "0x1609009D_in_the_sky" : {
      "en": "%battery_index battery connector temperature too high. Flight safety affected. Return to home or land promptly",
      "zh": "%battery_index电池连接器温度过高，影响飞行安全，请尽快返航或降落",
      "fr": ""
    },
    "0x1609009E" : {
      "en": "%battery_index Battery voltage high. Return to home or land promptly",
      "zh": "%battery_index电池电压高，请尽快返航或降落",
      "fr": ""
    },
    "0x1609009F" : {
      "en": "%battery_index Battery voltage low. Return to home or land promptly",
      "zh": "%battery_index电池电压低，请尽快返航或降落",
      "fr": ""
    },
    "0x160900A2" : {
      "en": "%index battery connector overheated. Flight safety affected. Fly with caution",
      "zh": "%index电池连接器温升异常，影响飞行安全，请谨慎飞行",
      "fr": ""
    },
    "0x160900A3" : {
      "en": "%index battery exceeds power limit. Flight safety affected. Return to home or land promptly",
      "zh": "%index电池超过使用功率限制范围，影响飞行安全，请尽快返航或降落",
      "fr": ""
    },
    "0x160900A6" : {
      "en": "%battery_index Battery connection error. Return to home or land promptly",
      "zh": "电池槽%battery_index电池接触不良，请尽快返航或降落",
      "fr": ""
    },
    "0x160900B0" : {
      "en": "%battery_index Battery level incorrect. Return to home or land promptly",
      "zh": "%battery_index电池电量不准，请尽快返航或降落",
      "fr": ""
    },
    "0x160900B1" : {
      "en": "%battery_index Battery level unstable. Return to home or land promptly",
      "zh": "%battery_index电池电量变化过大，请尽快返航或降落",
      "fr": ""
    },
    "0x160900B2" : {
      "en": "Abnormal SoC changes",
      "zh": "SOC异常跳变",
      "fr": ""
    },
    "0x160900B3" : {
      "en": "%battery_index Battery capacity error. Fly with caution",
      "zh": "%battery_index电池容量异常，请谨慎飞行",
      "fr": ""
    },
    "0x160900B4" : {
      "en": "%battery_index Battery capacity error. Fly with caution",
      "zh": "%battery_index电池容量异常，请谨慎飞行",
      "fr": ""
    },
    "0x160900B5" : {
      "en": "%battery_index Battery capacity error. Fly with caution",
      "zh": "%battery_index电池容量异常，请谨慎飞行",
      "fr": ""
    },
    "0x160900B6" : {
      "en": "%battery_index Battery capacity error. Fly with caution",
      "zh": "%battery_index电池容量异常，请谨慎飞行",
      "fr": ""
    },
    "0x160900B7" : {
      "en": "%battery_index Battery capacity error. Fly with caution",
      "zh": "%battery_index电池容量异常，请谨慎飞行",
      "fr": ""
    },
    "0x160900B8" : {
      "en": "%battery_index Battery capacity error. Fly with caution",
      "zh": "%battery_index电池容量异常，请谨慎飞行",
      "fr": ""
    },
    "0x160900B9" : {
      "en": "%battery_index Battery capacity not updated for extended period. Maintenance required. Fly with caution",
      "zh": "%battery_index电池容量长期未更新，请谨慎飞行并进行容量校准",
      "fr": ""
    },
    "0x160900BA" : {
      "en": "%battery_index Battery capacity not updated for extended period. Maintenance required. Fly with caution",
      "zh": "%battery_index电池容量长期未更新，请谨慎飞行并进行容量校准",
      "fr": ""
    },
    "0x160900BB" : {
      "en": "%battery_index Battery degraded. Fly with caution",
      "zh": "%battery_index电池性能下降，请谨慎飞行",
      "fr": ""
    },
    "0x160900BC" : {
      "en": "Battery internal resistance unusually low",
      "zh": "电池内阻异常偏小",
      "fr": ""
    },
    "0x160900BD" : {
      "en": "%battery_index Battery aging. Flight safety may be affected. Return to home or land promptly",
      "zh": "%battery_index电池老化，可能影响飞行安全，请尽快返航或降落",
      "fr": ""
    },
    "0x160900BE" : {
      "en": "%battery_index Battery aging. Flight safety may be affected. Return to home or land promptly",
      "zh": "%battery_index电池老化，可能影响飞行安全，请尽快返航或降落",
      "fr": ""
    },
    "0x160900BF" : {
      "en": "%battery_index Battery approaching cycle count limit. It is recommended to replace with new battery and maintain %battery_index Battery",
      "zh": "%battery_index电池循环次数过高，建议更换该%battery_index电池",
      "fr": ""
    },
    "0x160900C0" : {
      "en": "%battery_index Battery rated power exceeded. Performance limited. Fly with caution",
      "zh": "%battery_index电池已超功率使用，飞行器性能受限，请谨慎飞行",
      "fr": ""
    },
    "0x160900C1" : {
      "en": "Imbalanced battery",
      "zh": "电池均衡故障",
      "fr": ""
    },
    "0x160900C2" : {
      "en": "Sudden SoC changes",
      "zh": "显示SOC出现跳变",
      "fr": ""
    },
    "0x160900C3" : {
      "en": "Battery approaching cycle count limit. Continuing use will pose safety risks. Replace battery recommended",
      "zh": "电池循环次数过高，继续使用有安全风险，建议更换该电池",
      "fr": ""
    },
    "0x160900C4" : {
      "en": "%battery_index battery level calibration required. Let battery sit for 2 hours to restore",
      "zh": "%battery_index电池电量需要校准，请静置2h尝试恢复",
      "fr": ""
    },
    "0x160900D2" : {
      "en": "%battery_index battery level not calibrated for a long time. Let battery sit for 1 hour before calibration",
      "zh": "%battery_index电池电量长期未校准，请静置1h以上等待校准",
      "fr": ""
    },
    "0x160900D5" : {
      "en": "Unable to take off: Battery reached end of lifespan. Replace battery",
      "zh": "无法起飞：电池已达最大寿命，请更换电池",
      "fr": ""
    },
    "0x160900D5_in_the_sky" : {
      "en": "Unable to take off: Battery reached end of lifespan. Replace battery",
      "zh": "无法起飞：电池已达最大寿命，请更换电池",
      "fr": ""
    },
    "0x160900D6" : {
      "en": "Battery SOHc low. Battery will reach end of lifespan after 20 cycles or days. Replace battery promptly",
      "zh": "电池健康度低，寿命预计在20循环或20天后耗尽，请及时更换电池",
      "fr": ""
    },
    "0x160A0001" : {
      "en": "Parachute communication error. Make sure parachute is installed properly",
      "zh": "降落伞通信异常，请检查是否正确安装",
      "fr": ""
    },
    "0x160A0011" : {
      "en": "Real-name registration is canceled, which may result in flight safety risks. View Help Documentation and complete real-name registration based on instructions before flight",
      "zh": "飞机实名登记状态已注销，存在飞行风险，请点击查看帮助文档，按照指引完成实名登记后飞行",
      "fr": ""
    },
    "0x16100001" : {
      "en": "Compass error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：指南针异常，请重启飞行器",
      "fr": ""
    },
    "0x16100001_in_the_sky" : {
      "en": "Compass error. Return to home or land",
      "zh": "指南针异常,请返航或降落",
      "fr": ""
    },
    "0x16100002" : {
      "en": "DJI Assistant connected. Unable to take off. Disconnect before taking off",
      "zh": "无法起飞：已连接DJI Assistant 软件，请先断开再起飞",
      "fr": ""
    },
    "0x16100002_in_the_sky" : {
      "en": "DJI Assistant connected. Disconnect before taking off",
      "zh": "已连接DJI Assistant 软件，请先断开再飞行",
      "fr": ""
    },
    "0x16100003" : {
      "en": "Aircraft not activated or firmware out-of-date. Unable to take off. Activate aircraft or update to latest firmware version",
      "zh": "无法起飞：请检查是否激活或尝试升级最新固件",
      "fr": ""
    },
    "0x16100003_in_the_sky" : {
      "en": "Device activation or firmware update required",
      "zh": "请检查是否激活或尝试升级最新固件",
      "fr": ""
    },
    "0x16100005" : {
      "en": "IMU error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16100005_in_the_sky" : {
      "en": "IMU error. Restart aircraft",
      "zh": "IMU异常，请重启飞行器",
      "fr": ""
    },
    "0x16100006" : {
      "en": "Invalid IMU serial number. Unable to take off. Maintenance required",
      "zh": "无法起飞：IMU的SN标记错误，请返厂维修",
      "fr": ""
    },
    "0x16100006_in_the_sky" : {
      "en": "Invalid IMU serial number. Return to home or land",
      "zh": "IMU的SN标记错误，请返航或降落",
      "fr": ""
    },
    "0x16100008" : {
      "en": "Compass calibrating. Unable to take off. Wait for calibration to complete before taking off(%alarmid)",
      "zh": "无法起飞：指南针校准中，请等待校准完成再起飞",
      "fr": ""
    },
    "0x16100008_in_the_sky" : {
      "en": "Compass calibrating. Wait for calibration to complete before taking off",
      "zh": "指南针校准中，请等待校准完成再起飞",
      "fr": ""
    },
    "0x16100009" : {
      "en": "Sensor system initializing. Unable to take off. Wait for initialization to complete before taking off",
      "zh": "无法起飞：传感器系统初始化中，请等待初始化完成",
      "fr": ""
    },
    "0x16100009_in_the_sky" : {
      "en": "Sensor system initializing. Return to home or land",
      "zh": "传感器系统初始化中，请返航或降落",
      "fr": ""
    },
    "0x1610000A" : {
      "en": "Aircraft in Beginner mode. Unable to take off. Take off in an open outdoor area when in Beginner mode",
      "zh": "无法起飞：新手模式下请在室外开阔环境飞行",
      "fr": ""
    },
    "0x1610000A_in_the_sky" : {
      "en": "Beginner mode enabled. When using Beginner mode, take off in an open, outdoor area",
      "zh": "新手模式下请在室外开阔环境飞行",
      "fr": ""
    },
    "0x1610000B" : {
      "en": "Battery cell error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电池电芯错误，请联系售后服务",
      "fr": ""
    },
    "0x1610000B_in_the_sky" : {
      "en": "Battery cell error. Return to home or land",
      "zh": "电池电芯错误，请返航或降落",
      "fr": ""
    },
    "0x1610000C" : {
      "en": "Battery communication error. Unable to take off. Reinstall battery",
      "zh": "无法起飞：电池通信错误，请重新安装电池",
      "fr": ""
    },
    "0x1610000C_in_the_sky" : {
      "en": "Battery communication error. Return to home",
      "zh": "电池通信错误，请返航",
      "fr": ""
    },
    "0x1610000D" : {
      "en": "Critical low battery voltage. Unable to take off. Charge promptly",
      "zh": "无法起飞：严重低电压警报，请及时充电",
      "fr": ""
    },
    "0x1610000D_in_the_sky" : {
      "en": "Critical low battery voltage. Return to home or land promptly",
      "zh": "严重低电压，请尽快返航或降落",
      "fr": ""
    },
    "0x1610000E" : {
      "en": "Critical low battery. Unable to take off. Charge promptly",
      "zh": "无法起飞：严重低电量警报，请及时充电",
      "fr": ""
    },
    "0x1610000E_in_the_sky" : {
      "en": "Critical low battery. Return to home or land promptly",
      "zh": "严重低电量，请尽快返航或降落",
      "fr": ""
    },
    "0x1610000F" : {
      "en": "Critical low battery voltage. Unable to take off. Charge promptly",
      "zh": "无法起飞：严重低电压警报，请及时充电",
      "fr": ""
    },
    "0x1610000F_in_the_sky" : {
      "en": "Critical low battery voltage. Return to home or land promptly",
      "zh": "严重低电压，请尽快返航或降落",
      "fr": ""
    },
    "0x16100010" : {
      "en": "Battery output power insufficient. Unable to take off. Charge promptly",
      "zh": "无法起飞：电池输出功率不足，请充电。若环境温度低，预热电池",
      "fr": ""
    },
    "0x16100010_in_the_sky" : {
      "en": "Battery power output insufficient. Return to home or land",
      "zh": "电池输出功率不足，请尽快返航或降落",
      "fr": ""
    },
    "0x16100011" : {
      "en": "Critical low battery. Unable to take off. Charge promptly",
      "zh": "无法起飞：严重低电量警报，请及时充电",
      "fr": ""
    },
    "0x16100011_in_the_sky" : {
      "en": "Critical low battery. Return to home or land promptly",
      "zh": "严重低电量，请尽快返航或降落",
      "fr": ""
    },
    "0x16100012" : {
      "en": "Battery initializing. Unable to take off. Wait for initialization to complete before taking off",
      "zh": "无法起飞：电池初始化中，请等待初始化完成",
      "fr": ""
    },
    "0x16100012_in_the_sky" : {
      "en": "Battery initialization error. Return to home or land",
      "zh": "电池异常初始化，请返航或降落",
      "fr": ""
    },
    "0x16100013" : {
      "en": "Running Flight Simulator. Unable to take off. Restart aircraft before taking off",
      "zh": "无法起飞：正在运行模拟器，起飞需要重启飞行器",
      "fr": ""
    },
    "0x16100013_in_the_sky" : {
      "en": "Running Flight Simulator. Restart aircraft before taking off",
      "zh": "正在运行模拟器，起飞需要重启飞行器",
      "fr": ""
    },
    "0x16100014" : {
      "en": "Unable to take off. Landing gear in Travel mode",
      "zh": "无法起飞：起落架处于运输模式",
      "fr": ""
    },
    "0x16100015" : {
      "en": "Aircraft pitch angle too large. Unable to take off. Ensure aircraft is level before taking off",
      "zh": "无法起飞：飞行器倾斜角度过大，请水平放置飞行器后起飞",
      "fr": ""
    },
    "0x16100015_in_the_sky" : {
      "en": "Aircraft pitch angle too large. Ensure aircraft is level before taking off",
      "zh": "飞行器倾斜角度过大，请水平放置飞行器后起飞",
      "fr": ""
    },
    "0x16100016" : {
      "en": "Aircraft not activated. Unable to take off. Restart DJI Pilot and activate aircraft",
      "zh": "无法起飞：飞行器未激活，请重启App进行激活",
      "fr": ""
    },
    "0x16100016_in_the_sky" : {
      "en": "Aircraft not activated. Restart DJI Pilot and activate aircraft",
      "zh": "飞行器未激活，请重启App进行激活",
      "fr": ""
    },
    "0x16100017" : {
      "en": "Aircraft in GEO Zone. Unable to take off. Check map to find Recommended Zones",
      "zh": "无法起飞：飞行器在限飞区，请查看地图寻找可飞行区域",
      "fr": ""
    },
    "0x16100017_in_the_sky" : {
      "en": "Aircraft in GEO Zone. Check map to find Recommended Zones",
      "zh": "飞行器在限飞区，请查看地图寻找可飞行区域",
      "fr": ""
    },
    "0x16100018" : {
      "en": "IMU error. Unable to take off. Calibrate IMU",
      "zh": "无法起飞：IMU 异常，请校准 IMU",
      "fr": ""
    },
    "0x16100018_in_the_sky" : {
      "en": "IMU initialization error. Return to home or land",
      "zh": "IMU 初始化异常，请返航或降落",
      "fr": ""
    },
    "0x16100019" : {
      "en": "ESC error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：电调异常，请联系售后服务",
      "fr": ""
    },
    "0x16100019_in_the_sky" : {
      "en": "ESC error. Land immediately",
      "zh": "电调异常，请立即降落",
      "fr": ""
    },
    "0x1610001A" : {
      "en": "Sensor system initializing. Unable to take off. Wait for initialization to complete before taking off",
      "zh": "无法起飞：传感器系统初始化中，请等待初始化完成",
      "fr": ""
    },
    "0x1610001A_in_the_sky" : {
      "en": "Sensor system initializing. Return to home or land",
      "zh": "传感器系统初始化中，请返航或降落",
      "fr": ""
    },
    "0x1610001B" : {
      "en": "System updating. Unable to take off. Wait for update to complete",
      "zh": "无法起飞：系统正在升级，请稍等",
      "fr": ""
    },
    "0x1610001B_in_the_sky" : {
      "en": "System updating. Wait for update to complete before taking off",
      "zh": "系统正在升级，请等待升级结束再起飞",
      "fr": ""
    },
    "0x1610001C" : {
      "en": "Running Flight Simulator. Unable to take off. Restart aircraft before taking off",
      "zh": "无法起飞：已运行模拟器，起飞需要重启飞行器",
      "fr": ""
    },
    "0x1610001C_in_the_sky" : {
      "en": "Running Flight Simulator. Restart aircraft before taking off",
      "zh": "已运行模拟器，起飞需要重启飞行器",
      "fr": ""
    },
    "0x1610001D" : {
      "en": "IMU calibrating. Unable to take off. Wait for calibration to complete before takeoff",
      "zh": "无法起飞：IMU 校准中，请等待校准完毕再起飞",
      "fr": ""
    },
    "0x1610001D_in_the_sky" : {
      "en": "Calibrating IMU. Wait for calibration to complete before taking off",
      "zh": "IMU 校准中，请等待校准完毕再起飞",
      "fr": ""
    },
    "0x1610001E" : {
      "en": "Aircraft pitch angle too large. Unable to take off. Ensure aircraft is level before taking off",
      "zh": "无法起飞：飞行器倾斜角度过大，请水平放置飞行器后起飞",
      "fr": ""
    },
    "0x1610001E_in_the_sky" : {
      "en": "Aircraft pitch angle too large. Ensure aircraft is level before taking off",
      "zh": "飞行器倾斜角度过大，请水平放置飞行器后起飞",
      "fr": ""
    },
    "0x1610001F" : {
      "en": "Unable to take off. Flight controller overheats.",
      "zh": "无法起飞：飞控温度过高",
      "fr": ""
    },
    "0x1610001F_in_the_sky" : {
      "en": "Flight controller overheats. Returning to home...",
      "zh": "飞控温度过高，返航中",
      "fr": ""
    },
    "0x16100020" : {
      "en": "Unable to take off. Flight controller overheats.",
      "zh": "无法起飞：飞控温度过高",
      "fr": ""
    },
    "0x16100020_in_the_sky" : {
      "en": "Flight controller overheats. Returning to home...",
      "zh": "飞控温度过高，返航中",
      "fr": ""
    },
    "0x16100021" : {
      "en": "Unable to take off. Flight controller overheats.",
      "zh": "无法起飞：飞控温度过高",
      "fr": ""
    },
    "0x16100021_in_the_sky" : {
      "en": "Flight controller overheats. Auto landing...",
      "zh": "飞控温度过高，强制降落中",
      "fr": ""
    },
    "0x16100022" : {
      "en": "Unable to take off. Aircraft unable to remain stable for several times. To ensure flight safety, contact DJI Support",
      "zh": "无法起飞：飞机已多次失稳，为保证飞行安全，请联系大疆售后服务",
      "fr": ""
    },
    "0x16100023" : {
      "en": "AirSense error. Unable to obtain crewed aircraft information",
      "zh": "AirSense功能异常，无法接收附近载人飞机信息",
      "fr": ""
    },
    "0x16100024" : {
      "en": "Compass interference. Unable to take off. Move away from source of interference or calibrate compass",
      "zh": "无法起飞：指南针受到干扰，请远离干扰或校准指南针",
      "fr": ""
    },
    "0x16100025" : {
      "en": "Hot swapping not supported for RTK module. Unable to take off",
      "zh": "无法起飞：RTK模块不支持热插拔",
      "fr": ""
    },
    "0x16100025_in_the_sky" : {
      "en": "RTK error. Land promptly",
      "zh": "RTK异常，请尽快降落",
      "fr": ""
    },
    "0x16100026" : {
      "en": "Unable to take off. Non-DJI RTK module detected",
      "zh": "无法起飞：检测到非官方RTK模块",
      "fr": ""
    },
    "0x16100026_in_the_sky" : {
      "en": "Non-DJI RTK module detected",
      "zh": "检测到非官方RTK模块",
      "fr": ""
    },
    "0x16100027" : {
      "en": "Flight control system error. Unable to take off",
      "zh": "无法起飞：飞控系统异常",
      "fr": ""
    },
    "0x16100027_in_the_sky" : {
      "en": "Flight control system error. Land promptly",
      "zh": "飞控系统异常，请尽快降落",
      "fr": ""
    },
    "0x16100028" : {
      "en": "Unable to take off. Models of aircraft and RTK module do not match",
      "zh": "无法起飞：飞行器型号与RTK模块不匹配",
      "fr": ""
    },
    "0x16100029" : {
      "en": "Invalid aircraft serial number. Unable to take off. Contact your local dealer or DJI Support",
      "zh": "无法起飞：飞行器SN异常，请联系就近代理商或者大疆售后服务",
      "fr": ""
    },
    "0x16100029_in_the_sky" : {
      "en": "Invalid aircraft serial number. Return to home or land",
      "zh": "飞行器SN异常，请返航或降落",
      "fr": ""
    },
    "0x1610002D" : {
      "en": "Unable to take off. GNSS signal lost. Restart aircraft",
      "zh": "无法起飞：卫星定位断开连接，请重启飞行器",
      "fr": ""
    },
    "0x1610002D_in_the_sky" : {
      "en": "GNSS signal lost. Return to home or land",
      "zh": "卫星定位断开连接,请返航或降落",
      "fr": ""
    },
    "0x1610002F" : {
      "en": "Data recorder error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：数据记录仪异常，请重启飞行器",
      "fr": ""
    },
    "0x1610002F_in_the_sky" : {
      "en": "Data recorder error. Return to home or land",
      "zh": "数据记录仪异常，请返航或降落",
      "fr": ""
    },
    "0x16100030" : {
      "en": "Aircraft model and firmware version do not match. Unable to take off. Contact your local dealer or DJI Support.",
      "zh": "无法起飞：飞行器机型与固件不匹配，请联系就近代理商或大疆售后服务",
      "fr": ""
    },
    "0x16100030_in_the_sky" : {
      "en": "Aircraft model and firmware version do not match. Return to home or land",
      "zh": "飞行器机型与固件不匹配，请返航或降落",
      "fr": ""
    },
    "0x16100031" : {
      "en": "Unable to take off. Hook is not fully retracted. Make sure hook is retracted and secure",
      "zh": "无法起飞：空吊系统挂钩没有收到位，请将挂钩收到位",
      "fr": ""
    },
    "0x16100032" : {
      "en": "Winch cable wound in reverse direction. Unable to take off. Manually unwind cable before takeoff",
      "zh": "无法起飞：空吊系统线绳反绕，请整理线绳后起飞",
      "fr": ""
    },
    "0x16100032_in_the_sky" : {
      "en": "Winch cable wound in reverse direction. Do not operate winch system and land promptly to unwind cable",
      "zh": "空吊系统线绳反绕，请勿操作空吊并尽快降落理线",
      "fr": ""
    },
    "0x16100033" : {
      "en": "Real-name registration is not performed. View Help Documentation and complete real-name registration based on instructions before flight",
      "zh": "飞机未完成实名登记，请点击查看帮助文档，按照指引完成实名登记后飞行",
      "fr": ""
    },
    "0x16100034" : {
      "en": "Real-name registration is canceled. View Help Documentation and complete real-name registration based on instructions before flight",
      "zh": "飞行器实名登记状态已注销，请点击查看帮助文档，按照指引完成实名登记后飞行",
      "fr": ""
    },
    "0x16100038" : {
      "en": "Unable to take off. ESC voltage error. Contact DJI Support",
      "zh": "无法起飞，电调电压异常请联系售后服务",
      "fr": ""
    },
    "0x16100038_in_the_sky" : {
      "en": "ESC voltage error. Return to home and contact DJI Support",
      "zh": "电调电压异常，请返航并联系售后服务",
      "fr": ""
    },
    "0x16100039" : {
      "en": "Geo-cage function is preparing",
      "zh": "地理鸟笼系统准备中",
      "fr": ""
    },
    "0x16100039_in_the_sky" : {
      "en": "Unable to take off. Geo-cage function is preparing",
      "zh": "无法起飞：地理鸟笼系统准备中",
      "fr": ""
    },
    "0x1610003A" : {
      "en": "Unable to take off. RTK module overheated. Aircraft will power off immediately",
      "zh": "无法起飞：RTK 模块过热，飞行器即将自动关机",
      "fr": ""
    },
    "0x1610003B" : {
      "en": "Unable to take off. Speaker installed. Recalibrating compass required",
      "zh": "无法起飞：已安装喊话器，请重新校准指南针",
      "fr": ""
    },
    "0x1610003D" : {
      "en": "Sensor system disconnected. Unable to take off. Restart aircraft",
      "zh": "无法起飞：传感器系统断开，请重启飞行器",
      "fr": ""
    },
    "0x1610003D_in_the_sky" : {
      "en": "Sensor system disconnected. Return to home or land",
      "zh": "传感器系统断开，请返航或降落",
      "fr": ""
    },
    "0x1610003E" : {
      "en": "Unable to take off. Calibrating remote controller. Wait for calibration to complete",
      "zh": "无法起飞：遥控器校准中，请完成校准流程",
      "fr": ""
    },
    "0x16100041" : {
      "en": "Unable to take off. Control sticks off-centered. Calibrate remote controller",
      "zh": "无法起飞：摇杆不在中位，请校准遥控器",
      "fr": ""
    },
    "0x16100042" : {
      "en": "Unable to take off. Control stick hardware error. Contact DJI Support",
      "zh": "无法起飞：摇杆硬件异常，请联系售后",
      "fr": ""
    },
    "0x16100042_in_the_sky" : {
      "en": "Control stick hardware error. Land promptly. Contact DJI Support",
      "zh": "摇杆硬件异常，请尽快降落，并联系售后",
      "fr": ""
    },
    "0x1610004A" : {
      "en": "Sensor system error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1610004A_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常，请返航或降落",
      "fr": ""
    },
    "0x1610004B" : {
      "en": "Sensor system error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1610004B_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常，请返航或降落",
      "fr": ""
    },
    "0x1610004C" : {
      "en": "Unable to take off. Remote Controller Calibration Required",
      "zh": "无法起飞：遥控器摇杆需要校准",
      "fr": ""
    },
    "0x1610004D" : {
      "en": "Flight controller data error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：飞控数据异常，请重启飞行器",
      "fr": ""
    },
    "0x1610004D_in_the_sky" : {
      "en": "Flight controller data error. Return to home or land",
      "zh": "飞控数据异常，请返航或降落",
      "fr": ""
    },
    "0x1610004E" : {
      "en": "Not enough batteries installed. Unable to take off. Insert two batteries before taking off",
      "zh": "无法起飞：电池数量过少，请插入两块电池再起飞",
      "fr": ""
    },
    "0x1610004E_in_the_sky" : {
      "en": "Insufficient batteries. Return to home or land promptly",
      "zh": "电池数量过少，请尽快返航或降落",
      "fr": ""
    },
    "0x1610004F" : {
      "en": "Battery authentication failed. Unable to take off. Replace with DJI battery",
      "zh": "无法起飞：电池认证失败，请更换DJI官方电池",
      "fr": ""
    },
    "0x1610004F_in_the_sky" : {
      "en": "Battery authentication failed. Replace with standard DJI battery",
      "zh": "电池认证失败，请更换DJI官方电池",
      "fr": ""
    },
    "0x16100051" : {
      "en": "Large voltage difference between batteries. Unable to take off. Replace batteries with new ones of a similar capacity",
      "zh": "无法起飞：两块电池间压差过大，更换电量相近的电池组继续飞行",
      "fr": ""
    },
    "0x16100051_in_the_sky" : {
      "en": "Large voltage difference between batteries. Return to home or land. Replace batteries with new ones of a similar capacity and try again",
      "zh": "两块电池间压差过大，请返航或降落，更换电量相近的电池组继续飞行",
      "fr": ""
    },
    "0x16100053" : {
      "en": "Aircraft module firmware versions do not match. Unable to take off. Update to latest firmware versions.",
      "zh": "无法起飞：飞行器模块间固件不匹配，请升级固件版本",
      "fr": ""
    },
    "0x16100053_in_the_sky" : {
      "en": "Aircraft module firmware versions do not match. Update to latest firmware versions",
      "zh": "飞行器模块间固件不匹配，请升级固件版本",
      "fr": ""
    },
    "0x16100054" : {
      "en": "Gimbal error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：云台异常，请联系大疆售后服务",
      "fr": ""
    },
    "0x16100054_in_the_sky" : {
      "en": "Gimbal error. Return to home or land",
      "zh": "云台异常，返航或降落",
      "fr": ""
    },
    "0x16100055" : {
      "en": "Gimbal error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：云台异常，请联系大疆售后服务",
      "fr": ""
    },
    "0x16100055_in_the_sky" : {
      "en": "Gimbal error. Return to home or land",
      "zh": "云台异常，返航或降落",
      "fr": ""
    },
    "0x16100056" : {
      "en": "Gimbal error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：云台异常，请联系大疆售后服务",
      "fr": ""
    },
    "0x16100056_in_the_sky" : {
      "en": "Gimbal error. Return to home or land",
      "zh": "云台异常，返航或降落",
      "fr": ""
    },
    "0x16100057" : {
      "en": "Gimbal error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：云台异常，请联系大疆售后服务",
      "fr": ""
    },
    "0x16100057_in_the_sky" : {
      "en": "Gimbal error. Return to home or land",
      "zh": "云台异常，返航或降落",
      "fr": ""
    },
    "0x16100058" : {
      "en": "Gimbal firmware updating. Unable to take off...",
      "zh": "无法起飞：云台升级中，请稍后",
      "fr": ""
    },
    "0x16100058_in_the_sky" : {
      "en": "Gimbal firmware update in progress",
      "zh": "云台升级中，请稍后",
      "fr": ""
    },
    "0x1610005D" : {
      "en": "IMU calibration successful. Unable to take off. Restarting aircraft required",
      "zh": "无法起飞：IMU 校准成功，需重启飞行器",
      "fr": ""
    },
    "0x1610005D_in_the_sky" : {
      "en": "IMU calibration error. Return to home or land",
      "zh": "IMU 校准异常，请返航或降落",
      "fr": ""
    },
    "0x1610005E" : {
      "en": "Aircraft rolled during takeoff. Unable to take off. Check whether propellers were installed correctly",
      "zh": "无法起飞：起飞时侧翻，请检查桨叶安装是否正确",
      "fr": ""
    },
    "0x1610005E_in_the_sky" : {
      "en": "Aircraft rolled during takeoff. Check whether propellers are installed correctly",
      "zh": "起飞时侧翻，请检查桨叶安装是否正确",
      "fr": ""
    },
    "0x1610005F" : {
      "en": "Motor stalled. Unable to take off. Power off aircraft and check whether motor can rotate freely",
      "zh": "无法起飞：电机堵转，关机后检查电机能否自由旋转",
      "fr": ""
    },
    "0x1610005F_in_the_sky" : {
      "en": "Motor stalled. Land promptly. Power off airfcraft and check whether motor can rotate freely",
      "zh": "电机堵转，请降落，在关机后检查电机能否自由旋转",
      "fr": ""
    },
    "0x16100060" : {
      "en": "Motor rotation speed error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：电机转速异常，请重启飞行器",
      "fr": ""
    },
    "0x16100060_in_the_sky" : {
      "en": "Motor rotation speed error. Land and restart aircraft",
      "zh": "电机转速异常，请停桨后重启飞行器",
      "fr": ""
    },
    "0x16100061" : {
      "en": "Motor idle. Unable to take off. Check whether propellers are detached or installed incorrectly",
      "zh": "无法起飞：电机空转，无法起飞，请检查桨叶是否脱落或未正确安装桨叶",
      "fr": ""
    },
    "0x16100061_in_the_sky" : {
      "en": "Motor idle. Unable to take off. Check whether propellers are detached or installed incorrectly",
      "zh": "电机空转，无法起飞，请检查桨叶是否脱落或未正确安装桨叶",
      "fr": ""
    },
    "0x16100062" : {
      "en": "Unable to turn on motor. Unable to take off. Check aircraft status and restart",
      "zh": "无法起飞：电机无法启动，请检查飞行器状态并重启飞行器",
      "fr": ""
    },
    "0x16100062_in_the_sky" : {
      "en": "Unable to turn on aircraft motor(s). Check aircraft status and restart",
      "zh": "电机无法启动，请检查飞行器状态并重启飞行器",
      "fr": ""
    },
    "0x16100063" : {
      "en": "Auto Takeoff failed. Unable to take off",
      "zh": "无法起飞：自动起飞失败",
      "fr": ""
    },
    "0x16100063_in_the_sky" : {
      "en": "Auto Takeoff failed",
      "zh": "自动起飞失败",
      "fr": ""
    },
    "0x16100064" : {
      "en": "Aircraft rolled over. Unable to take off. Restart aircraft and ensure it is level before taking off",
      "zh": "无法起飞：飞行器姿态翻滚，请重启飞行器水平放置后起飞",
      "fr": ""
    },
    "0x16100064_in_the_sky" : {
      "en": "Aircraft rolled over. Return to home or land",
      "zh": "飞行器姿态翻滚， 请返航或降落",
      "fr": ""
    },
    "0x16100065" : {
      "en": "Battery firmware version error. Unable to take off. Replace battery or update battery firmware to latest version",
      "zh": "无法起飞：电池固件版本不一致，请更换电池或将电池升级到最新版本",
      "fr": ""
    },
    "0x16100065_in_the_sky" : {
      "en": "Battery firmware version error. Replace battery or update to the latest firmware version",
      "zh": "电池固件版本不一致，请更换电池或将电池升级到最新版本",
      "fr": ""
    },
    "0x16100066" : {
      "en": "RTK signal weak. Unable to take off. Move to an open area for takeoff or turn off RTK",
      "zh": "无法起飞：RTK 信号差，请至空旷地起飞，或关闭RTK功能",
      "fr": ""
    },
    "0x16100066_in_the_sky" : {
      "en": "RTK signal weak. Move to an open area for takeoff or turn off RTK",
      "zh": "RTK 信号差，请至空旷地起飞，或关闭RTK功能",
      "fr": ""
    },
    "0x16100067" : {
      "en": "Compass interference. Unable to take off. Calibrate compass",
      "zh": "无法起飞：指南针受到干扰，请校准指南针",
      "fr": ""
    },
    "0x16100067_in_the_sky" : {
      "en": "Compass interference. Move away from interference source",
      "zh": "指南针受到干扰，请远离干扰源飞行",
      "fr": ""
    },
    "0x16100068" : {
      "en": "ESC short-circuited. Unable to take off. Restart aircraft",
      "zh": "无法起飞：电调短路，请重启飞行器",
      "fr": ""
    },
    "0x16100068_in_the_sky" : {
      "en": "ESC short-circuited. Restart aircraft",
      "zh": "电调短路，请重启飞行器",
      "fr": ""
    },
    "0x16100069" : {
      "en": "ESC auto-check error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：电子调速器自检异常，请重启飞行器",
      "fr": ""
    },
    "0x16100069_in_the_sky" : {
      "en": "ESC auto-check error. Return to home or land",
      "zh": "电子调速器自检异常，请返航或降落",
      "fr": ""
    },
    "0x1610006A" : {
      "en": "Incompatible battery. Replace battery",
      "zh": "电池不匹配，请更换电池",
      "fr": ""
    },
    "0x1610006B" : {
      "en": "Unable to take off. Battery firmware update required",
      "zh": "无法起飞：电池固件需要升级",
      "fr": ""
    },
    "0x1610006B_in_the_sky" : {
      "en": "Battery firmware error. Return to home or land promptly",
      "zh": "电池固件异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1610006C" : {
      "en": "Unable to take off. Severe battery error",
      "zh": "无法起飞：电池严重异常",
      "fr": ""
    },
    "0x1610006C_in_the_sky" : {
      "en": "Severe battery error. Auto landing...",
      "zh": "电池严重异常：强制降落中",
      "fr": ""
    },
    "0x1610006D" : {
      "en": "Unable to take off. Power restricted. Check battery warning for issue reason",
      "zh": "无法起飞：已限制功率，原因请参考电池告警",
      "fr": ""
    },
    "0x1610006D_in_the_sky" : {
      "en": "Power and flight attitude restricted. Return to home promptly. Check battery warning for issue reason",
      "zh": "已限制功率和飞行姿态，请尽快返航，原因请参考电池告警",
      "fr": ""
    },
    "0x16100070" : {
      "en": "Not Applicable. This string has been deleted",
      "zh": "还在用么？160没用这个了",
      "fr": ""
    },
    "0x16100070_in_the_sky" : {
      "en": "Not Applicable. This string has been deleted",
      "zh": "还在用么？160没用这个了",
      "fr": ""
    },
    "0x16100071" : {
      "en": "Unable to take off. GNSS error. Restart aircraft",
      "zh": "无法起飞：卫星定位异常，请重启飞行器",
      "fr": ""
    },
    "0x16100071_in_the_sky" : {
      "en": "GNSS error. Return to home or land",
      "zh": "卫星定位异常，请降落或返航",
      "fr": ""
    },
    "0x16100072" : {
      "en": "Gimbal calibrating. Unable to take off",
      "zh": "无法起飞：云台校准中，请稍后起飞",
      "fr": ""
    },
    "0x16100072_in_the_sky" : {
      "en": "Gimbal calibration error. Return to home or land",
      "zh": "云台校准异常，请返航或降落",
      "fr": ""
    },
    "0x16100073" : {
      "en": "Takeoff conditions not met. Unable to take off. Firmware out-of-date or flight route uploading to aircraft",
      "zh": "无法起飞：当前状态不支持起飞。固件版本过低或正在上传航线至飞行器",
      "fr": ""
    },
    "0x16100073_in_the_sky" : {
      "en": "Firmware out of date or flight route uploading to aircraft. Return to home or land",
      "zh": "固件版本过低或正在上传航线至飞行器，请返航或降落",
      "fr": ""
    },
    "0x16100074" : {
      "en": "Takeoff altitude error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：飞行器起飞高度异常，请重启飞行器",
      "fr": ""
    },
    "0x16100074_in_the_sky" : {
      "en": "Takeoff altitude error. Restart aircraft",
      "zh": "飞行器起飞高度异常，请重启飞行器",
      "fr": ""
    },
    "0x16100075" : {
      "en": "ESC firmware versions do not match. Unable to take off. Update to latest firmware version",
      "zh": "无法起飞：电调版本不一致，请更新飞行器固件",
      "fr": ""
    },
    "0x16100075_in_the_sky" : {
      "en": "ESC firmware versions do not match. Update to latest firmware versions",
      "zh": "电调版本不一致，请更新飞行器固件",
      "fr": ""
    },
    "0x16100076" : {
      "en": "IMU error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：IMU异常，请联系大疆售后服务",
      "fr": ""
    },
    "0x16100076_in_the_sky" : {
      "en": "IMU error. Return to home or land",
      "zh": "IMU异常，请返航或降落",
      "fr": ""
    },
    "0x16100078" : {
      "en": "Compass error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞：指南针异常，请联系大疆售后服务",
      "fr": ""
    },
    "0x16100078_in_the_sky" : {
      "en": "Compass error. Return to home or land",
      "zh": "指南针异常，请返航或降落",
      "fr": ""
    },
    "0x1610007A" : {
      "en": "ESC beeping. Unable to take off. Turn off ESC beeping before takeoff",
      "zh": "无法起飞：电调鸣叫中，关闭后可正常飞行",
      "fr": ""
    },
    "0x1610007A_in_the_sky" : {
      "en": "ESC beeping. Return to home or land",
      "zh": "电调异常鸣叫中，请返航或降落",
      "fr": ""
    },
    "0x1610007B" : {
      "en": "ESC overheated. Unable to take off. Power off aircraft and wait for temperature to return to normal",
      "zh": "无法起飞：电调温度过高，请关机至恢复正常温度",
      "fr": ""
    },
    "0x1610007B_in_the_sky" : {
      "en": "ESC overheated. Land promptly. Power off aircraft and wait for temperature to return to normal",
      "zh": "电调温度过高，请降落，并关机冷却至恢复正常温度",
      "fr": ""
    },
    "0x1610007C" : {
      "en": "Battery installed incorrectly. Detach battery and reinstall it",
      "zh": "电池安装不到位，请重新拔插电池",
      "fr": ""
    },
    "0x1610007D" : {
      "en": "Impact detected. Takeoff failed and aircraft landed. Unable to take off. Restart aircraft",
      "zh": "无法起飞：检测到被撞击，飞行器已停止飞行，请重启飞行器",
      "fr": ""
    },
    "0x1610007D_in_the_sky" : {
      "en": "Impact detected. Aircraft landed. Restart aircraft",
      "zh": "检测到被撞击，飞行器已停止飞行，请重启飞行器",
      "fr": ""
    },
    "0x1610007F" : {
      "en": "Impact detected. Unable to take off. Restart aircraft",
      "zh": "无法起飞：检测到飞行器发生过撞击，请重启飞行器",
      "fr": ""
    },
    "0x1610007F_in_the_sky" : {
      "en": "Impact detected. Return to home or land",
      "zh": "检测到飞行器发生过撞击，请返航或降落",
      "fr": ""
    },
    "0x16100080" : {
      "en": "Aircraft altitude control error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：飞行器高度控制异常，请重启飞行器",
      "fr": ""
    },
    "0x16100080_in_the_sky" : {
      "en": "Aircraft altitude control error. RTH or land",
      "zh": "飞行器高度控制异常，请返航或降落",
      "fr": ""
    },
    "0x16100081" : {
      "en": "Battery firmware out-of-date. Unable to take off. Update to latest firmware version",
      "zh": "无法起飞：电池固件版本过低，请更新飞行器固件",
      "fr": ""
    },
    "0x16100081_in_the_sky" : {
      "en": "Battery firmware version out of date. Return to home or land. Update to latest firmware version",
      "zh": "电池固件版本过低，请返航或降落，并更新飞行器固件",
      "fr": ""
    },
    "0x16100082" : {
      "en": "Large voltage different between battery cells. Unable to take off. Battery maintenance required",
      "zh": "无法起飞：电池电芯压差过大，请对电池进行保养",
      "fr": ""
    },
    "0x16100082_in_the_sky" : {
      "en": "Large difference in battery cell voltage detected. Return to home or land. Battery maintenance required",
      "zh": "电池电芯压差过大，请返航或降落，再对电池进行保养",
      "fr": ""
    },
    "0x16100083" : {
      "en": "Battery installed incorrectly. Unable to take off. Turn battery locker to its limit and ensure both batteries are installed correctly",
      "zh": "无法起飞：电池安装不到位，请将电池锁紧旋钮旋转到位",
      "fr": ""
    },
    "0x16100083_in_the_sky" : {
      "en": "Battery installed incorrectly. Return to home or land. Turn battery locker to its limit and ensure both batteries are installed correctly",
      "zh": "电池安装不到位，请返航或降落，并检查电池锁紧旋是否钮旋转到位",
      "fr": ""
    },
    "0x16100084" : {
      "en": "Upper fan error. Unable to take off. Check whether upper fan is stalled",
      "zh": "无法起飞：上风扇异常，请检查飞行器上风扇是否有堵转",
      "fr": ""
    },
    "0x16100084_in_the_sky" : {
      "en": "Upper fan error. Return to home or land. Check whether upper fan is stalled",
      "zh": "上风扇异常，请返航或降落，再检查飞行器上风扇是否有堵转",
      "fr": ""
    },
    "0x16100085" : {
      "en": "Aircraft overheated. Unable to take off. Power off aircraft and wait for temperature to return to normal",
      "zh": "无法起飞：飞行器过热，请关闭飞行器至恢复正常温度",
      "fr": ""
    },
    "0x16100085_in_the_sky" : {
      "en": "Aircraft overheated. Return to home or land. Power off aircraft and wait for temperature to return to normal",
      "zh": "飞行器过热，请返航或降落，再关闭飞行器至恢复正常温度",
      "fr": ""
    },
    "0x16100087" : {
      "en": "Emergency Propeller Stop triggered. Unable to take off",
      "zh": "无法起飞：已触发紧急停桨",
      "fr": ""
    },
    "0x16100087_in_the_sky" : {
      "en": "Emergency Propeller Stop triggered",
      "zh": "已触发紧急停浆",
      "fr": ""
    },
    "0x16100088" : {
      "en": "Unable to take off. Calibrating remote controller. Exit calibration first",
      "zh": "无法起飞：遥控器校准中，请先退出校准状态",
      "fr": ""
    },
    "0x16100088_in_the_sky" : {
      "en": "Unable to take off. Calibrating remote controller. Exit calibration first",
      "zh": "无法起飞：遥控器校准中，请先退出校准状态",
      "fr": ""
    },
    "0x16100089" : {
      "en": "Unable to take off. Remote controller not bound/still confirming binding status. Use bound remote controller or bind aircraft to current remote controller",
      "zh": "无法起飞：绑定设备不匹配或正在校验中，请使用绑定遥控器或绑定当下遥控器。",
      "fr": ""
    },
    "0x16100089_in_the_sky" : {
      "en": "Takeoff error. Failed to verify remote controller. Use bound remote controller or bind aircraft to current remote controller",
      "zh": "异常起飞：遥控器绑定校验失败，请使用绑定遥控器或绑定当下遥控器。",
      "fr": ""
    },
    "0x1610008A" : {
      "en": "Flight controller unit error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：飞控系统组件异常，请重启飞行器",
      "fr": ""
    },
    "0x1610008A_in_the_sky" : {
      "en": "Flight controller unit error. Return to home or land",
      "zh": "飞控系统组件异常，请返航或降落",
      "fr": ""
    },
    "0x1610008F" : {
      "en": "Aircraft antenna satellite signal searching error. Unable to take off. Move to an open area for takeoff",
      "zh": "无法起飞：机载天线搜星质量较差，请至空旷地起飞",
      "fr": ""
    },
    "0x1610008F_in_the_sky" : {
      "en": "Aircraft antenna satellite signal searching error. Fly with caution",
      "zh": "机载天线搜星质量较差，请谨慎飞行",
      "fr": ""
    },
    "0x16100090" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "无法起飞：传感器系统异常，请重启飞行器",
      "fr": ""
    },
    "0x16100090_in_the_sky" : {
      "en": "Sensor system error. Return to home or land",
      "zh": "传感器系统异常,请返航或降落",
      "fr": ""
    },
    "0x16100091" : {
      "en": "Flight prohibited in current area. Unable to take off",
      "zh": "无法起飞：该飞行器无法在此区域飞行",
      "fr": ""
    },
    "0x16100091_in_the_sky" : {
      "en": "Flying prohibited in current area. Return to home or land",
      "zh": "该飞行器无法在此区域飞行，请返航或降落",
      "fr": ""
    },
    "0x16100091_in_the_sky_special" : {
      "en": "Unable to fly in this area. Max flight altitude limited to %1$s m",
      "zh": "该飞行器无法在此区域飞行，限高%1$s m",
      "fr": ""
    },
    "0x16100092" : {
      "en": "Battery capacity error. Unable to take off. Battery maintenance required",
      "zh": "无法起飞：电池电量异常，请进行电池保养",
      "fr": ""
    },
    "0x16100092_in_the_sky" : {
      "en": "Battery capacity error. Return to home or land. Battery maintenance required",
      "zh": "电池电量异常，请返航或降落，再进行电池保养",
      "fr": ""
    },
    "0x16100095" : {
      "en": "Unable to take off. Set Hover mode before flying",
      "zh": "无法起飞：请在起飞前设置飞行器悬停模式",
      "fr": ""
    },
    "0x16100096" : {
      "en": "%battery_index Battery power supply error. Aircraft auto landing",
      "zh": "%battery_index电池供电异常，飞行器强制降落",
      "fr": ""
    },
    "0x16100099" : {
      "en": "Gimbal starting error. Unable to take off. Check whether gimbal can rotate freely and restart aircraft",
      "zh": "无法起飞：云台启动异常，请检查云台是否能自由转动，再重启飞行器",
      "fr": ""
    },
    "0x16100099_in_the_sky" : {
      "en": "Gimbal startup error. Return to home or land. Check whether gimbal can rotate freely and restart aircraft",
      "zh": "云台启动异常，请返航或降落，再检查云台是否能自由转动，再重启飞行器",
      "fr": ""
    },
    "0x1610009A" : {
      "en": "Excessive gimbal vibration. Unable to take off. Check whether gimbal can rotate freely or is damaged. Restart aircraft",
      "zh": "无法起飞：云台异常振动，请检查云台是否能自由转动、是否受损，再重启飞行器",
      "fr": ""
    },
    "0x1610009A_in_the_sky" : {
      "en": "Excessive gimbal vibration. Return to home or land. Check whether gimbal can rotate freely or is damaged. Restart aircraft",
      "zh": "云台异常振动，请返航或降落，再检查云台是否能自由转动、是否受损，再重启飞行器",
      "fr": ""
    },
    "0x1610009F" : {
      "en": "Flight controller unit error. Unable to take off. Restart aircraft",
      "zh": "无法起飞：飞控系统组件异常，请重启飞行器",
      "fr": ""
    },
    "0x1610009F_in_the_sky" : {
      "en": "Flight controller unit error. Return to home or land",
      "zh": "飞控系统组件异常，请返航或降落",
      "fr": ""
    },
    "0x161000A0" : {
      "en": "GEO module error. Unable to take off",
      "zh": "无法起飞：限飞模块组件异常",
      "fr": ""
    },
    "0x161000A0_in_the_sky" : {
      "en": "GEO module error . Return to home or land promptly",
      "zh": "限飞模块组件异常，请返航或降落",
      "fr": ""
    },
    "0x161000a1" : {
      "en": "Unable to take off. Check whether frame arm sleeves are tightened securely",
      "zh": "无法起飞：请检查机臂套筒是否固定到位",
      "fr": ""
    },
    "0x161000A1" : {
      "en": "Unable to take off. Check whether frame arm sleeves are tightened securely",
      "zh": "无法起飞：请检查机臂套筒是否固定到位",
      "fr": ""
    },
    "0x161000A1_in_the_sky" : {
      "en": "Land promptly and check whether frame arm sleeves are tightened securely",
      "zh": "请尽快降落并检查机臂套筒是否固定到位",
      "fr": ""
    },
    "0x161000a2" : {
      "en": "Lower fan error. Unable to take off. Check whether lower fan is stalled",
      "zh": "无法起飞：下风扇异常，请检查飞行器下风扇是否有堵转",
      "fr": ""
    },
    "0x161000A2" : {
      "en": "Lower fan error. Unable to take off. Check whether lower fan is stalled",
      "zh": "无法起飞：下风扇异常，请检查飞行器下风扇是否有堵转",
      "fr": ""
    },
    "0x161000a2_in_the_sky" : {
      "en": "Lower fan error. Return to home or land. Check whether lower fan is stalled",
      "zh": "下风扇异常，请返航或降落，再检查飞行器下风扇是否有堵转",
      "fr": ""
    },
    "0x161000A2_in_the_sky" : {
      "en": "Lower fan error. Return to home or land. Check whether lower fan is stalled",
      "zh": "下风扇异常，请返航或降落，再检查飞行器下风扇是否有堵转",
      "fr": ""
    },
    "0x161000A3" : {
      "en": "Unable to take off. Disconnect aircraft from USB and try again",
      "zh": "无法起飞，请断开飞机 USB 连接后重试",
      "fr": ""
    },
    "0x161000A4" : {
      "en": "Unable to take off. Aircraft on moving platform",
      "zh": "无法起飞：飞行器处于移动平台",
      "fr": ""
    },
    "0x161000A4_in_the_sky" : {
      "en": "Flight controller error. Return to home or land promptly",
      "zh": "飞控系统异常，请尽快返航或降落",
      "fr": ""
    },
    "0x161000A5" : {
      "en": "Unable to take off. Propellers folded",
      "zh": "无法起飞：桨叶未展开",
      "fr": ""
    },
    "0x161000A5_in_the_sky" : {
      "en": "Flight controller error. Return to home or land promptly",
      "zh": "飞控系统异常，请尽快返航或降落",
      "fr": ""
    },
    "0x161000a6" : {
      "en": "Remote controller battery low. Unable to take off. Recharge battery",
      "zh": "无法起飞：遥控器电量过低，请给遥控器充电",
      "fr": ""
    },
    "0x161000A6" : {
      "en": "Remote controller battery low. Unable to take off. Recharge battery",
      "zh": "无法起飞：遥控器电量过低，请给遥控器充电",
      "fr": ""
    },
    "0x161000a6_in_the_sky" : {
      "en": "Remote controller battery low. Return to home or land promptly",
      "zh": "遥控器电量过低，请尽快返航或降落",
      "fr": ""
    },
    "0x161000A6_in_the_sky" : {
      "en": "Remote controller battery low. Return to home or land promptly",
      "zh": "遥控器电量过低，请尽快返航或降落",
      "fr": ""
    },
    "0x161000A7" : {
      "en": "Unable to take off. Failed to verify remote controller. Max number of temporary flights reached. Use bound remote controller or bind to another remote controller",
      "zh": "无法起飞：遥控器绑定校验失败，临时起飞次数耗尽，请使用绑定遥控器或者换绑",
      "fr": ""
    },
    "0x161000A7_in_the_sky" : {
      "en": "Flight controller error. Return to home or land promptly",
      "zh": "飞控系统异常，请尽快返航或降落",
      "fr": ""
    },
    "0x161000A9" : {
      "en": "Propellers in slow motion mode. Unable to take off",
      "zh": "无法起飞：飞行器处于慢转桨模式",
      "fr": ""
    },
    "0x161000A9_in_the_sky" : {
      "en": "Propeller motion error. Return to home or land promptly",
      "zh": "飞行器异常慢转桨，请尽快返航或降落",
      "fr": ""
    },
    "0x161000AA" : {
      "en": "GEO module error. Unable to take off",
      "zh": "无法起飞：限飞模块组件异常",
      "fr": ""
    },
    "0x161000AA_in_the_sky" : {
      "en": "GEO module error. Return to home or land promptly",
      "zh": "限飞模块组件异常，请尽快返航或降落",
      "fr": ""
    },
    "0x161000AB" : {
      "en": "Fly Safe database error. Unable to take off",
      "zh": "无法起飞：飞行安全数据库异常",
      "fr": ""
    },
    "0x161000AB_in_the_sky" : {
      "en": "Fly Safe database error. Return to home or land promptly",
      "zh": "飞行安全数据库异常，请尽快返航或降落",
      "fr": ""
    },
    "0x161000AC" : {
      "en": "Flight control system error. Unable to take off",
      "zh": "无法起飞：飞控系统异常",
      "fr": ""
    },
    "0x161000AC_in_the_sky" : {
      "en": "Flight control system error. Land promptly",
      "zh": "飞控系统异常，请尽快降落",
      "fr": ""
    },
    "0x161000AF" : {
      "en": "Initializing flight control system. Unable to take off",
      "zh": "无法起飞：飞控系统初始化中",
      "fr": ""
    },
    "0x161000AF_in_the_sky" : {
      "en": "Flight control system initialization error. Return to home or land promptly",
      "zh": "飞控系统异常初始化，请尽快返航或降落",
      "fr": ""
    },
    "0x161000B1" : {
      "en": "Landing gear status error. Try to release Landing Gear Auto Lock and press the transform button to reset the landing gear",
      "zh": "起落架状态异常，请尝试解除起落架锁定，并点击变形按键尝试复位",
      "fr": ""
    },
    "0x161000B1_in_the_sky" : {
      "en": "Landing gear status error. Try to press the transform button to reset the landing gear",
      "zh": "起落架状态异常，请尝试点击变形按键复位",
      "fr": ""
    },
    "0x161000B2" : {
      "en": "Unable to take off. Landing gear transforming...",
      "zh": "无法起飞：起落架变形中",
      "fr": ""
    },
    "0x161000B3" : {
      "en": "Unable to take off. Landing gear in Travel mode. Remove gimbal camera to transform",
      "zh": "无法起飞：起落架已进入运输模式，等待摘除云台",
      "fr": ""
    },
    "0x161000b4" : {
      "en": "Remote ID broadcast error. Failed to obtain remote controller location. Unable to take off",
      "zh": "无法起飞：Remote ID 播报异常，无法获取遥控器位置",
      "fr": ""
    },
    "0x161000B4" : {
      "en": "Remote ID broadcast error. Failed to obtain remote controller location. Unable to take off",
      "zh": "无法起飞：Remote ID 播报异常，无法获取遥控器位置",
      "fr": ""
    },
    "0x161000b5" : {
      "en": "Remote ID module error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞，Remote ID 模块异常，请联系售后服务",
      "fr": ""
    },
    "0x161000B5" : {
      "en": "Remote ID module error. Unable to take off. Contact DJI Support",
      "zh": "无法起飞，Remote ID 模块异常，请联系售后服务",
      "fr": ""
    },
    "0x161000B6" : {
      "en": "Average battery power output too low. Unable to take off. Reduce payload or replace with fully charged batteries",
      "zh": "无法起飞：电池平均功率过低，请降低载重或更换满电电池",
      "fr": ""
    },
    "0x161000B7" : {
      "en": "Payload exceeded max allowable weight. Reduce payload or fully charge battery",
      "zh": "已超最大允许载重，请降低载重或补充至满电",
      "fr": ""
    },
    "0x161000B7_in_the_sky" : {
      "en": "Payload exceeded max allowable weight. Return to home or land promptly",
      "zh": "已超最大允许载重，请尽快返航或降落",
      "fr": ""
    },
    "0x161000B8" : {
      "en": "Obstacle detected near aircraft. Unable to take off",
      "zh": "无法起飞：飞行器周围有障碍物",
      "fr": ""
    },
    "0x161000BD" : {
      "en": "Parachute built-in battery voltage too low. Unable to take off",
      "zh": "电池温度过高，无法起飞",
      "fr": ""
    },
    "0x161000BE" : {
      "en": "Incompatible battery models. Unable to take off",
      "zh": "无法起飞：电池类型不匹配",
      "fr": ""
    },
    "0x161000BF" : {
      "en": "Single battery flight not enabled. Unable to take off",
      "zh": "无法起飞：单电池模式未打开",
      "fr": ""
    },
    "0x161000c0" : {
      "en": "Unable to take off: left battery and right battery models do not match. Replace battery for model consistency",
      "zh": "无法起飞：左右电池型号不一致，请更换电池保持一致",
      "fr": ""
    },
    "0x161000C0" : {
      "en": "Unable to take off. Gimbal camera with current mount not supported. Update aircraft firmware",
      "zh": "无法起飞：不支持当前卡口云台，请升级飞行器固件",
      "fr": ""
    },
    "0x161000c0_in_the_sky" : {
      "en": "Left battery and right battery models do not match. Land aircraft immediately and replace battery",
      "zh": "左右电池型号不一致，请尽快降落更换电池",
      "fr": ""
    },
    "0x161000C4" : {
      "en": "Unable to take off. Auto checking ESC...",
      "zh": "无法起飞：电调自检中",
      "fr": ""
    },
    "0x161000C7" : {
      "en": "Battery temperature lower than 10°C. Unable to take off",
      "zh": "无法起飞：电池温度低于10度",
      "fr": ""
    },
    "0x161000C7_in_the_sky" : {
      "en": "Battery temperature lower than 10°C. Return to home or land promptly",
      "zh": "电池温度低于10度，尽快返航或降落",
      "fr": ""
    },
    "0x161000C8" : {
      "en": "Unable to take off. Check whether aircraft is connected to DJI Assistant or system is updating",
      "zh": "无法起飞：请确认usb是否已连接或者系统正在升级中",
      "fr": ""
    },
    "0x161000C8_in_the_sky" : {
      "en": "Check whether aircraft is connected to DJI Assistant or system is updating",
      "zh": "请确认usb是否已连接或者系统正在升级中",
      "fr": ""
    },
    "0x161000C9" : {
      "en": "Unable to take off. Check whether aircraft is connected to DJI Assistant or system is updating",
      "zh": "无法起飞：请确认usb是否已连接或者系统正在升级中",
      "fr": ""
    },
    "0x161000C9_in_the_sky" : {
      "en": "Check whether aircraft is connected to DJI Assistant or system is updating",
      "zh": "请确认usb是否已连接或者系统正在升级中",
      "fr": ""
    },
    "0x161000F1" : {
      "en": "Unable to take off. Check whether front right frame arm is fully unfolded",
      "zh": "无法起飞：请检查右前机臂是否展开并固定到位",
      "fr": ""
    },
    "0x161000F1_in_the_sky" : {
      "en": "Front right frame arm error. Land promptly",
      "zh": "右前机臂异常，请尽快降落",
      "fr": ""
    },
    "0x161000F2" : {
      "en": "Unable to take off. Check whether front left frame arm is fully unfolded",
      "zh": "无法起飞：请检查左前机臂是否展开并固定到位",
      "fr": ""
    },
    "0x161000F2_in_the_sky" : {
      "en": "Front left frame arm error. Land promptly",
      "zh": "左前机臂异常，请尽快降落",
      "fr": ""
    },
    "0x161000F3" : {
      "en": "Unable to take off. Check whether back left frame arm is fully unfolded",
      "zh": "无法起飞：请检查左后机臂是否展开并固定到位",
      "fr": ""
    },
    "0x161000F3_in_the_sky" : {
      "en": "Back left frame arm error. Land promptly",
      "zh": "左后机臂异常，请尽快降落",
      "fr": ""
    },
    "0x161000F4" : {
      "en": "Unable to take off. Check whether back right frame arm is fully unfolded",
      "zh": "无法起飞：请检查右后机臂是否展开并固定到位",
      "fr": ""
    },
    "0x161000F4_in_the_sky" : {
      "en": "Back right frame arm error. Land promptly",
      "zh": "右后机臂异常，请尽快降落",
      "fr": ""
    },
    "0x161000F5" : {
      "en": "Initializing system. Unable to take off",
      "zh": "无法起飞：系统初始化中",
      "fr": ""
    },
    "0x161000F5_in_the_sky" : {
      "en": "Flight control system error. Land promptly",
      "zh": "飞控系统异常，请尽快降落",
      "fr": ""
    },
    "0x161000F6" : {
      "en": "Flight control system error. Unable to take off",
      "zh": "无法起飞：飞控系统异常",
      "fr": ""
    },
    "0x161000F6_in_the_sky" : {
      "en": "Flight control system error. Land promptly",
      "zh": "飞控系统异常，请尽快降落",
      "fr": ""
    },
    "0x161000F7" : {
      "en": "Sensor system initialization in progress",
      "zh": "无法起飞：感知系统初始化中",
      "fr": ""
    },
    "0x161000F7_in_the_sky" : {
      "en": "Sensor system error. Land promptly or fly with caution",
      "zh": "感知系统异常，请尽快降落或谨慎飞行",
      "fr": ""
    },
    "0x161000F8" : {
      "en": "Sensor system initialization in progress",
      "zh": "无法起飞：感知系统初始化中",
      "fr": ""
    },
    "0x161000F8_in_the_sky" : {
      "en": "Sensor system error. Land promptly",
      "zh": "感知系统异常，请尽快降落",
      "fr": ""
    },
    "0x161000F9" : {
      "en": "Unable to take off. Remote controller signal weak. Take off near remote controller",
      "zh": "无法起飞：遥控器信号弱，开启增强图传后请靠近飞行器起飞",
      "fr": ""
    },
    "0x161000F9_in_the_sky" : {
      "en": "Flight controller error. Return to home or land promptly",
      "zh": "飞控系统异常，请尽快返航或降落",
      "fr": ""
    },
    "0x161000FA" : {
      "en": "Unable to take off. Remote controller signal weak. Take off near remote controller",
      "zh": "无法起飞：遥控器信号弱，开启增强图传后请靠近飞行器起飞",
      "fr": ""
    },
    "0x161000FA_in_the_sky" : {
      "en": "Flight controller error. Return to home or land promptly",
      "zh": "飞控系统异常，请尽快返航或降落",
      "fr": ""
    },
    "0x161000FB" : {
      "en": "Unable to take off. Propeller damaged. Contact DJI Support",
      "zh": "无法起飞：桨叶损坏，请联系售后服务",
      "fr": ""
    },
    "0x161000FC" : {
      "en": "Unable to take off. DJI Dock in site selection process",
      "zh": "无法起飞：机场选址中",
      "fr": ""
    },
    "0x161000FD" : {
      "en": "Unable to take off. Aircraft is outside of custom task area or within 10 meters of the area boundary",
      "zh": "无法起飞，请在自定义作业区内或远离边界10m以上",
      "fr": ""
    },
    "0x161000FD_in_the_sky" : {
      "en": "Execute task in custom task area",
      "zh": "请在自定义作业区内作业",
      "fr": ""
    },
    "0x1611000A" : {
      "en": "Signal lost. RTH in progress",
      "zh": "失联返航中",
      "fr": ""
    },
    "0x16110023" : {
      "en": "Aircraft output power insufficient. Land immediately with caution",
      "zh": "动力临近饱和，请就近谨慎降落",
      "fr": ""
    },
    "0x16110029" : {
      "en": "Payload detected. Aircraft flight and wind-resistance performances reduced",
      "zh": "检测到安装负载，飞行器飞行性能和抗风性能降低",
      "fr": ""
    },
    "0x1611002A" : {
      "en": "",
      "zh": "探照灯断开连接",
      "fr": ""
    },
    "0x1611002B" : {
      "en": "",
      "zh": "喊话器断开连接",
      "fr": ""
    },
    "0x1611004F" : {
      "en": "Battery authentication failed",
      "zh": "电池认证失败",
      "fr": ""
    },
    "0x16110065" : {
      "en": "Aircraft overheated. AI recognition disabled. Wait for temperature to return to normal before use",
      "zh": "机身过热，AI 目标识别关闭，请降温后使用",
      "fr": ""
    },
    "0x16110066" : {
      "en": "RTK module overheated. Wait for temperature to return to normal before use",
      "zh": "RTK 模块过热，请降温后使用",
      "fr": ""
    },
    "0x16110067" : {
      "en": "RTK module overheated and disabled. Wait for temperature to return to normal before use",
      "zh": "RTK 模块过热并关闭，请降温后使用",
      "fr": ""
    },
    "0x1612000B" : {
      "en": "Altitude too high. Using high-altitude propellers recommended",
      "zh": "海拔过高，推荐使用高原桨",
      "fr": ""
    },
    "0x1612000C" : {
      "en": "Altitude too high. Use high-altitude propellers only",
      "zh": "海拔过高，请务必使用高原桨",
      "fr": ""
    },
    "0x1612000D" : {
      "en": "Reaching maximum flight altitude. Pay attention to flight safety and altitude",
      "zh": "海拔即将超过最大飞行高度，请注意飞行安全并控制高度",
      "fr": ""
    },
    "0x16120010" : {
      "en": "Approaching ground. Fly with caution",
      "zh": "接近地面，谨慎飞行",
      "fr": ""
    },
    "0x16130001" : {
      "en": "Aircraft will take off from boat. Aircraft attitude angle too large. Fly with caution",
      "zh": "船上起降模式，飞行器姿态过大，请谨慎飞行",
      "fr": ""
    },
    "0x16130002" : {
      "en": "Aircraft will take off from boat. Boat speed too fast. Fly with caution",
      "zh": "船上起降模式，船身速度过大，请谨慎飞行",
      "fr": ""
    },
    "0x16130003" : {
      "en": "Aircraft will take off from boat. Aircraft attitude angle too large. Fly with caution",
      "zh": "船上起降模式，飞行器姿态过大，请谨慎飞行",
      "fr": ""
    },
    "0x16200101" : {
      "en": "Aircraft connected to USB device. Unable to take off",
      "zh": "无法起飞：已连接USB",
      "fr": ""
    },
    "0x16200101_in_the_sky" : {
      "en": "USB port error. Fly with caution",
      "zh": "USB接口异常，请谨慎飞行",
      "fr": ""
    },
    "0x16200102" : {
      "en": "Clearing logs. Unable to take off",
      "zh": "无法起飞：清除日志中",
      "fr": ""
    },
    "0x16200102_in_the_sky" : {
      "en": "Clearing logs. Fly with caution",
      "zh": "清除日志中，请谨慎飞行",
      "fr": ""
    },
    "0x16200103" : {
      "en": "Updating firmware. Unable to take off",
      "zh": "无法起飞：固件升级中",
      "fr": ""
    },
    "0x16200103_in_the_sky" : {
      "en": "Updating firmware. Fly with caution",
      "zh": "固件升级中，请谨慎飞行",
      "fr": ""
    },
    "0x16200104" : {
      "en": "Unable to take off. Firmware update required or update in progress",
      "zh": "无法起飞：固件需要升级或正在升级中",
      "fr": ""
    },
    "0x16200104_in_the_sky" : {
      "en": "Firmware update required. Fly with caution",
      "zh": "固件强制升级中，请谨慎飞行",
      "fr": ""
    },
    "0x16200201" : {
      "en": "Updating Fly Safe database. Unable to take off",
      "zh": "无法起飞：限飞数据库升级中",
      "fr": ""
    },
    "0x16200201_in_the_sky" : {
      "en": "Updating Fly Safe database. Fly with caution",
      "zh": "限飞数据库升级中，请谨慎飞行",
      "fr": ""
    },
    "0x16200202" : {
      "en": "Vision sensor calibration error. Unable to take off",
      "zh": "无法起飞：视觉传感器标定异常",
      "fr": ""
    },
    "0x16200202_in_the_sky" : {
      "en": "Vision sensor calibration error. Fly with caution",
      "zh": "视觉传感器标定异常，请谨慎飞行",
      "fr": ""
    },
    "0x16200203" : {
      "en": "ToF sensor calibration error. Unable to take off",
      "zh": "无法起飞：ToF标定异常",
      "fr": ""
    },
    "0x16200203_in_the_sky" : {
      "en": "ToF sensor calibration error. Fly with caution",
      "zh": "ToF标定异常，请谨慎飞行",
      "fr": ""
    },
    "0x16200204" : {
      "en": "Vision sensor status error. Unable to take off",
      "zh": "无法起飞：视觉传感器状态异常",
      "fr": ""
    },
    "0x16200204_in_the_sky" : {
      "en": "Vision sensor status error. Fly with caution",
      "zh": "视觉传感器状态异常，请谨慎飞行",
      "fr": ""
    },
    "0x16200207" : {
      "en": "Unable to take off. Downward infrared sensor connection error",
      "zh": "无法起飞: 下视红外传感器连接异常",
      "fr": ""
    },
    "0x16200208" : {
      "en": "Propeller error. Unable to take off. Make sure propellers are not damaged. Restart aircraft and try again",
      "zh": "桨叶异常，无法起飞，请确认桨叶完好无损后重启飞机再试",
      "fr": ""
    },
    "0x16200301" : {
      "en": "Extension port device error. Unable to take off. Check PSDK device",
      "zh": "无法起飞：扩展口设备异常，请检查PSDK设备",
      "fr": ""
    },
    "0x16200301_in_the_sky" : {
      "en": "Extension port device error. Return to home or land promptly",
      "zh": "扩展口设备异常，请尽快返航或降落",
      "fr": ""
    },
    "0x16200302" : {
      "en": "Third-party payload error. Unable to take off",
      "zh": "无法起飞：第三方负载设备异常",
      "fr": ""
    },
    "0x16200302_in_the_sky" : {
      "en": "Stopping propellers. Predict landing area based on current aircraft location",
      "zh": "执行空中紧急停桨，请根据飞行器当前位置预测降落点位置",
      "fr": ""
    },
    "0x16200401" : {
      "en": "Mandatory Fly Safe database update in progress. Unable to take off",
      "zh": "无法起飞：APP限飞数据库强制升级中",
      "fr": ""
    },
    "0x16200401_in_the_sky" : {
      "en": "Mandatory Fly Safe database update in progress. Fly with caution",
      "zh": "APP限飞数据库强制升级中，请谨慎飞行",
      "fr": ""
    },
    "0x16200402" : {
      "en": "Mandatory firmware update in progress. Unable to take off",
      "zh": "无法起飞：APP固件强制升级中",
      "fr": ""
    },
    "0x16200402_in_the_sky" : {
      "en": "Mandatory firmware update in progress. Fly with caution",
      "zh": "APP固件强制升级中，请谨慎飞行",
      "fr": ""
    },
    "0x16200501" : {
      "en": "Incompatible battery versions. Unable to take off",
      "zh": "无法起飞：电池版本不匹配",
      "fr": ""
    },
    "0x16200501_in_the_sky" : {
      "en": "Incompatible battery versions. Return to home or land promptly",
      "zh": "电池版本不匹配，请尽快返航或降落",
      "fr": ""
    },
    "0x16200601" : {
      "en": "Initializing flight system...",
      "zh": "飞行系统初始化中，请等待",
      "fr": ""
    },
    "0x16200601_in_the_sky" : {
      "en": "Initializing flight system...",
      "zh": "飞行系统初始化中，请等待",
      "fr": ""
    },
    "0x16200A01" : {
      "en": "Unable to take off. Battery cover off",
      "zh": "无法起飞：未接电池帽盖",
      "fr": ""
    },
    "0x16200A01_in_the_sky" : {
      "en": "Battery communication error. Fly with caution",
      "zh": "电池通信异常，请谨慎飞行",
      "fr": ""
    },
    "0x16400002" : {
      "en": "",
      "zh": "AP主动释放控制权",
      "fr": ""
    },
    "0x16400003" : {
      "en": "",
      "zh": "AP控制指令异常",
      "fr": ""
    },
    "0x16400004" : {
      "en": "",
      "zh": "AP心跳异常",
      "fr": ""
    },
    "0x16400005" : {
      "en": "",
      "zh": "mcu侧mission调度器状态数据包异常",
      "fr": ""
    },
    "0x16400006" : {
      "en": "",
      "zh": "mission调度器异常",
      "fr": ""
    },
    "0x16400007" : {
      "en": "",
      "zh": "调度器没有mission运行",
      "fr": ""
    },
    "0x16400008" : {
      "en": "",
      "zh": "AP到MCU链路异常",
      "fr": ""
    },
    "0x16400009" : {
      "en": "",
      "zh": "AP没有发送控制指令",
      "fr": ""
    },
    "0x1640000A" : {
      "en": "",
      "zh": "AP挂死",
      "fr": ""
    },
    "0x1640000B" : {
      "en": "",
      "zh": "系统实时性异常",
      "fr": ""
    },
    "0x1640000C" : {
      "en": "",
      "zh": "业务实时性异常",
      "fr": ""
    },
    "0x16400100" : {
      "en": "",
      "zh": "抽象数据fly_core无内容",
      "fr": ""
    },
    "0x16400101" : {
      "en": "",
      "zh": "抽象数据fly_extend无内容",
      "fr": ""
    },
    "0x16400102" : {
      "en": "",
      "zh": "抽象数据fmu_gps无内容",
      "fr": ""
    },
    "0x16400103" : {
      "en": "",
      "zh": "抽象数据fmu_rtk无内容",
      "fr": ""
    },
    "0x16400104" : {
      "en": "",
      "zh": "抽象数据fusion_out无内容",
      "fr": ""
    },
    "0x16400105" : {
      "en": "",
      "zh": "抽象数据vio_result无内容",
      "fr": ""
    },
    "0x16400106" : {
      "en": "",
      "zh": "抽象数据image_status无内容",
      "fr": ""
    },
    "0x16400107" : {
      "en": "",
      "zh": "抽象数据radar_detect_info无内容",
      "fr": ""
    },
    "0x16400108" : {
      "en": "",
      "zh": "抽象数据gimbal_state无内容",
      "fr": ""
    },
    "0x16400109" : {
      "en": "",
      "zh": "抽象数据camera_state无内容",
      "fr": ""
    },
    "0x1640010A" : {
      "en": "",
      "zh": "抽象数据camera_cap_status无内容",
      "fr": ""
    },
    "0x1640010B" : {
      "en": "",
      "zh": "抽象数据camera_video_param无内容",
      "fr": ""
    },
    "0x1640010C" : {
      "en": "",
      "zh": "抽象数据camera_lens_param无内容",
      "fr": ""
    },
    "0x1640010D" : {
      "en": "",
      "zh": "抽象数据camera_lens_param_ir无内容",
      "fr": ""
    },
    "0x1640010E" : {
      "en": "",
      "zh": "抽象数据camera_data_hd无内容",
      "fr": ""
    },
    "0x1640010F" : {
      "en": "",
      "zh": "抽象数据camera_data_vga无内容",
      "fr": ""
    },
    "0x16400110" : {
      "en": "",
      "zh": "抽象数据gimbal_state无内容",
      "fr": ""
    },
    "0x16400111" : {
      "en": "",
      "zh": "抽象数据camera_state无内容",
      "fr": ""
    },
    "0x16400112" : {
      "en": "",
      "zh": "抽象数据camera_cap_status无内容",
      "fr": ""
    },
    "0x16400113" : {
      "en": "",
      "zh": "抽象数据camera_video_param无内容",
      "fr": ""
    },
    "0x16400114" : {
      "en": "",
      "zh": "抽象数据camera_lens_param无内容",
      "fr": ""
    },
    "0x16400115" : {
      "en": "",
      "zh": "抽象数据camera_lens_param_ir无内容",
      "fr": ""
    },
    "0x16400116" : {
      "en": "",
      "zh": "抽象数据camera_data_hd无内容",
      "fr": ""
    },
    "0x16400117" : {
      "en": "",
      "zh": "抽象数据camera_data_vga无内容",
      "fr": ""
    },
    "0x16400118" : {
      "en": "",
      "zh": "杆量直通rc异常",
      "fr": ""
    },
    "0x16400119" : {
      "en": "",
      "zh": "杆量直通motion_rc异常",
      "fr": ""
    },
    "0x16416001" : {
      "en": "",
      "zh": "DSP向ARM发出中断失败",
      "fr": ""
    },
    "0x16416002" : {
      "en": "",
      "zh": "DSP侧交互部分超时",
      "fr": ""
    },
    "0x16418000" : {
      "en": "",
      "zh": "使用者调用dsp接口出错",
      "fr": ""
    },
    "0x16418001" : {
      "en": "",
      "zh": "DSP输入参数错误",
      "fr": ""
    },
    "0x16418500" : {
      "en": "",
      "zh": "开发者设计dsp接口出错",
      "fr": ""
    },
    "0x16418501" : {
      "en": "",
      "zh": "DSP算子调用超时",
      "fr": ""
    },
    "0x16418502" : {
      "en": "",
      "zh": "DSP算子调用忙",
      "fr": ""
    },
    "0x16420000" : {
      "en": "",
      "zh": "飞行系统模块初始化失败",
      "fr": ""
    },
    "0x16420001" : {
      "en": "",
      "zh": "飞行系统AP_Linux模块init失败",
      "fr": ""
    },
    "0x16420002" : {
      "en": "",
      "zh": "飞行系统AP_Linux模块start失败",
      "fr": ""
    },
    "0x16420003" : {
      "en": "",
      "zh": "飞行系统AP_RTOS模块init失败",
      "fr": ""
    },
    "0x16420004" : {
      "en": "",
      "zh": "飞行系统AP_RTOS模块start失败",
      "fr": ""
    },
    "0x16420010" : {
      "en": "",
      "zh": "飞行系统功耗管理异常",
      "fr": ""
    },
    "0x16420011" : {
      "en": "",
      "zh": "sysmode未响应event事件",
      "fr": ""
    },
    "0x16420012" : {
      "en": "",
      "zh": "飞行系统event事件通知失败",
      "fr": ""
    },
    "0x16420013" : {
      "en": "",
      "zh": "飞行系统功耗场景切换超时",
      "fr": ""
    },
    "0x16420014" : {
      "en": "",
      "zh": "功耗管理消息队列发送超时",
      "fr": ""
    },
    "0x16420015" : {
      "en": "",
      "zh": "功耗管理节点状态同步失败",
      "fr": ""
    },
    "0x16420016" : {
      "en": "",
      "zh": "功耗管理子节点间V1消息不通",
      "fr": ""
    },
    "0x16420020" : {
      "en": "",
      "zh": "能力项参数同步失败",
      "fr": ""
    },
    "0x16420021" : {
      "en": "",
      "zh": "csdk断连",
      "fr": ""
    },
    "0x16420022" : {
      "en": "",
      "zh": "能力集参数表数据读取失败",
      "fr": ""
    },
    "0x16420100" : {
      "en": "",
      "zh": "dbus话题app_state无数据",
      "fr": ""
    },
    "0x16420101" : {
      "en": "",
      "zh": "dbus话题battery_state无数据",
      "fr": ""
    },
    "0x16420102" : {
      "en": "",
      "zh": "dbus话题flight_state无数据",
      "fr": ""
    },
    "0x16420103" : {
      "en": "",
      "zh": "dbus话题fly_limit无数据",
      "fr": ""
    },
    "0x16420104" : {
      "en": "",
      "zh": "dbus话题home_state无数据",
      "fr": ""
    },
    "0x16420105" : {
      "en": "",
      "zh": "dbus话题mission_config无数据",
      "fr": ""
    },
    "0x16420106" : {
      "en": "",
      "zh": "dbus话题rc_state无数据",
      "fr": ""
    },
    "0x16420107" : {
      "en": "",
      "zh": "dbus话题sensor_data无数据",
      "fr": ""
    },
    "0x16420108" : {
      "en": "",
      "zh": "dbus话题flight_record无数据",
      "fr": ""
    },
    "0x16420109" : {
      "en": "",
      "zh": "dbus话题motion_rc_info无数据",
      "fr": ""
    },
    "0x1642010A" : {
      "en": "",
      "zh": "dbus话题vio_result无数据",
      "fr": ""
    },
    "0x1642010B" : {
      "en": "",
      "zh": "dbus话题image_status无数据",
      "fr": ""
    },
    "0x1642010C" : {
      "en": "",
      "zh": "dbus话题fmu_gps无数据",
      "fr": ""
    },
    "0x1642010D" : {
      "en": "",
      "zh": "dbus话题fmu_rtk无数据",
      "fr": ""
    },
    "0x1642010E" : {
      "en": "",
      "zh": "dbus话题fusion_out无数据",
      "fr": ""
    },
    "0x1642010F" : {
      "en": "",
      "zh": "dbus话题radar_detect_info无数据",
      "fr": ""
    },
    "0x16420110" : {
      "en": "",
      "zh": "dbus话题gimbal_state无数据",
      "fr": ""
    },
    "0x16420111" : {
      "en": "",
      "zh": "dbus话题camera_state无数据",
      "fr": ""
    },
    "0x16420112" : {
      "en": "",
      "zh": "dbus话题camera_cap_status无数据",
      "fr": ""
    },
    "0x16420113" : {
      "en": "",
      "zh": "dbus话题camera_video_param无数据",
      "fr": ""
    },
    "0x16420114" : {
      "en": "",
      "zh": "dbus话题camera_lens_param无数据",
      "fr": ""
    },
    "0x16420115" : {
      "en": "",
      "zh": "dbus话题camera_lens_param_ir无数据",
      "fr": ""
    },
    "0x16420116" : {
      "en": "",
      "zh": "dbus话题camera_data_hd无数据",
      "fr": ""
    },
    "0x16420117" : {
      "en": "",
      "zh": "dbus话题camera_data_vga无数据",
      "fr": ""
    },
    "0x16430001" : {
      "en": "",
      "zh": "异常退出焦点跟随",
      "fr": ""
    },
    "0x16430002" : {
      "en": "",
      "zh": "异常退出到聚焦",
      "fr": ""
    },
    "0x16430003" : {
      "en": "",
      "zh": "异常退出到多目标扫描",
      "fr": ""
    },
    "0x16430004" : {
      "en": "",
      "zh": "焦点跟随异常提示",
      "fr": ""
    },
    "0x16430005" : {
      "en": "",
      "zh": "融合数据无效",
      "fr": ""
    },
    "0x16430006" : {
      "en": "",
      "zh": "传感器数据更新失败",
      "fr": ""
    },
    "0x16430007" : {
      "en": "",
      "zh": "未起飞",
      "fr": ""
    },
    "0x16430008" : {
      "en": "",
      "zh": "相机模式不支持",
      "fr": ""
    },
    "0x16430009" : {
      "en": "",
      "zh": "融合时间戳异常",
      "fr": ""
    },
    "0x1643000A" : {
      "en": "",
      "zh": "抽象数据指针为空",
      "fr": ""
    },
    "0x1643000B" : {
      "en": "",
      "zh": "DBUS获取数据指针为空",
      "fr": ""
    },
    "0x1643000C" : {
      "en": "",
      "zh": "TM异常",
      "fr": ""
    },
    "0x1643000D" : {
      "en": "",
      "zh": "飞机姿态过大",
      "fr": ""
    },
    "0x1643000E" : {
      "en": "",
      "zh": "环境光过暗",
      "fr": ""
    },
    "0x1643000F" : {
      "en": "",
      "zh": "遥控器断连",
      "fr": ""
    },
    "0x16430010" : {
      "en": "",
      "zh": "TKPlanner异常",
      "fr": ""
    },
    "0x16430011" : {
      "en": "",
      "zh": "TE异常",
      "fr": ""
    },
    "0x16430012" : {
      "en": "",
      "zh": "POI异常",
      "fr": ""
    },
    "0x16430013" : {
      "en": "",
      "zh": "ML异常",
      "fr": ""
    },
    "0x16430014" : {
      "en": "",
      "zh": "数据链路异常",
      "fr": ""
    },
    "0x16430015" : {
      "en": "",
      "zh": "IMU数据异常",
      "fr": ""
    },
    "0x16430016" : {
      "en": "",
      "zh": "云台数据异常",
      "fr": ""
    },
    "0x16430017" : {
      "en": "",
      "zh": "fov数据异常",
      "fr": ""
    },
    "0x16430018" : {
      "en": "",
      "zh": "ml状态异常",
      "fr": ""
    },
    "0x16430019" : {
      "en": "",
      "zh": "soe数据异常",
      "fr": ""
    },
    "0x1643001A" : {
      "en": "",
      "zh": "IMU数据无效",
      "fr": ""
    },
    "0x1643001B" : {
      "en": "",
      "zh": "云台数据无效",
      "fr": ""
    },
    "0x1643001C" : {
      "en": "",
      "zh": "fov数据无效",
      "fr": ""
    },
    "0x1643001D" : {
      "en": "",
      "zh": "ml状态数据无效",
      "fr": ""
    },
    "0x1643001E" : {
      "en": "",
      "zh": "soe数据无效",
      "fr": ""
    },
    "0x1643001F" : {
      "en": "",
      "zh": "环绕测距时间过长",
      "fr": ""
    },
    "0x16430020" : {
      "en": "",
      "zh": "环绕时距地面过近",
      "fr": ""
    },
    "0x16430021" : {
      "en": "",
      "zh": "限远",
      "fr": ""
    },
    "0x16430022" : {
      "en": "",
      "zh": "限高",
      "fr": ""
    },
    "0x16430023" : {
      "en": "",
      "zh": "目标类型不支持",
      "fr": ""
    },
    "0x16430024" : {
      "en": "",
      "zh": "将要进入Tracking/环绕时目标丢失",
      "fr": ""
    },
    "0x16430025" : {
      "en": "",
      "zh": "目标跟随中注意变焦范围",
      "fr": ""
    },
    "0x16430026" : {
      "en": "",
      "zh": "目标在画面中占比过大",
      "fr": ""
    },
    "0x16430101" : {
      "en": "",
      "zh": "异常退出一键短片",
      "fr": ""
    },
    "0x16430102" : {
      "en": "",
      "zh": "异常终止一键短片拍摄",
      "fr": ""
    },
    "0x16430103" : {
      "en": "",
      "zh": "传感器数据验证错误",
      "fr": ""
    },
    "0x16430104" : {
      "en": "",
      "zh": "空指针",
      "fr": ""
    },
    "0x16430105" : {
      "en": "",
      "zh": "抽象数据指针为空",
      "fr": ""
    },
    "0x16430106" : {
      "en": "",
      "zh": "DBUS获取数据指针为空",
      "fr": ""
    },
    "0x16430107" : {
      "en": "",
      "zh": "在地面不能执行一键短片",
      "fr": ""
    },
    "0x16430108" : {
      "en": "",
      "zh": "用户打杆",
      "fr": ""
    },
    "0x16430109" : {
      "en": "",
      "zh": "用户暂停",
      "fr": ""
    },
    "0x1643010A" : {
      "en": "",
      "zh": "限高",
      "fr": ""
    },
    "0x1643010B" : {
      "en": "",
      "zh": "限远",
      "fr": ""
    },
    "0x1643010C" : {
      "en": "",
      "zh": "录像停止错误",
      "fr": ""
    },
    "0x1643010D" : {
      "en": "",
      "zh": "录像开始错误",
      "fr": ""
    },
    "0x1643010E" : {
      "en": "",
      "zh": "避障",
      "fr": ""
    },
    "0x1643010F" : {
      "en": "",
      "zh": "遥控器信号丢失",
      "fr": ""
    },
    "0x16430110" : {
      "en": "",
      "zh": "初始化失败",
      "fr": ""
    },
    "0x16430111" : {
      "en": "",
      "zh": "夺权失败",
      "fr": ""
    },
    "0x16430112" : {
      "en": "",
      "zh": "储存空间不足",
      "fr": ""
    },
    "0x16430113" : {
      "en": "",
      "zh": "目标丢失",
      "fr": ""
    },
    "0x16430114" : {
      "en": "",
      "zh": "拍照失败",
      "fr": ""
    },
    "0x16430115" : {
      "en": "",
      "zh": "合成失败",
      "fr": ""
    },
    "0x16430116" : {
      "en": "",
      "zh": "加载相机参数失败",
      "fr": ""
    },
    "0x16430117" : {
      "en": "",
      "zh": "调整相机参数失败",
      "fr": ""
    },
    "0x16430118" : {
      "en": "",
      "zh": "相机角度错误",
      "fr": ""
    },
    "0x16430119" : {
      "en": "",
      "zh": "相机未知错误",
      "fr": ""
    },
    "0x1643011A" : {
      "en": "",
      "zh": "相机参数错误",
      "fr": ""
    },
    "0x1643011B" : {
      "en": "",
      "zh": "相机状态错误",
      "fr": ""
    },
    "0x1643011C" : {
      "en": "",
      "zh": "设置TOPMODE超时",
      "fr": ""
    },
    "0x1643011D" : {
      "en": "",
      "zh": "相机TOPMODE错误",
      "fr": ""
    },
    "0x1643011E" : {
      "en": "",
      "zh": "异常提示一键短片",
      "fr": ""
    },
    "0x16430201" : {
      "en": "",
      "zh": "大师镜头异常退出",
      "fr": ""
    },
    "0x16430202" : {
      "en": "",
      "zh": "大师镜头异常暂停",
      "fr": ""
    },
    "0x16430203" : {
      "en": "",
      "zh": "大师镜头发现空指针",
      "fr": ""
    },
    "0x16430204" : {
      "en": "",
      "zh": "大师镜头抽象数据指针为空",
      "fr": ""
    },
    "0x16430205" : {
      "en": "",
      "zh": "大师镜头DBUS获取数据指针为空",
      "fr": ""
    },
    "0x16430206" : {
      "en": "",
      "zh": "大师镜头传感器数据验证错误",
      "fr": ""
    },
    "0x16430207" : {
      "en": "",
      "zh": "大师镜头用户打杆",
      "fr": ""
    },
    "0x16430208" : {
      "en": "",
      "zh": "大师镜头用户暂停",
      "fr": ""
    },
    "0x16430209" : {
      "en": "",
      "zh": "大师镜头遇限高",
      "fr": ""
    },
    "0x1643020A" : {
      "en": "",
      "zh": "大师镜头遇限远",
      "fr": ""
    },
    "0x1643020B" : {
      "en": "",
      "zh": "大师镜头录像停止失败",
      "fr": ""
    },
    "0x1643020C" : {
      "en": "",
      "zh": "大师镜头录像开始失败",
      "fr": ""
    },
    "0x1643020D" : {
      "en": "",
      "zh": "大师镜头遇障碍物",
      "fr": ""
    },
    "0x1643020E" : {
      "en": "",
      "zh": "大师镜头遥控器信号丢失",
      "fr": ""
    },
    "0x1643020F" : {
      "en": "",
      "zh": "大师镜头初始化失败",
      "fr": ""
    },
    "0x16430210" : {
      "en": "",
      "zh": "大师镜头夺权失败",
      "fr": ""
    },
    "0x16430211" : {
      "en": "",
      "zh": "大师镜头储存空间不足",
      "fr": ""
    },
    "0x16430212" : {
      "en": "",
      "zh": "大师镜头目标丢失",
      "fr": ""
    },
    "0x16430213" : {
      "en": "",
      "zh": "大师镜头相机参数错误",
      "fr": ""
    },
    "0x16430214" : {
      "en": "",
      "zh": "大师镜头设置TOPMODE超时",
      "fr": ""
    },
    "0x16430215" : {
      "en": "",
      "zh": "大师镜头设置TOPMODE异常",
      "fr": ""
    },
    "0x16430216" : {
      "en": "",
      "zh": "大师镜头警告",
      "fr": ""
    },
    "0x16430217" : {
      "en": "",
      "zh": "大师镜头调整相机参数失败",
      "fr": ""
    },
    "0x16430218" : {
      "en": "",
      "zh": "大师镜头云台控制错误",
      "fr": ""
    },
    "0x16430219" : {
      "en": "",
      "zh": "大师镜头Yaw控制错误",
      "fr": ""
    },
    "0x1643021A" : {
      "en": "",
      "zh": "大师镜头VA控制错误",
      "fr": ""
    },
    "0x1643021B" : {
      "en": "",
      "zh": "大师镜头速度控制错误",
      "fr": ""
    },
    "0x1643021C" : {
      "en": "",
      "zh": "大师镜头相机控制错误",
      "fr": ""
    },
    "0x1643021D" : {
      "en": "",
      "zh": "大师镜头任务不匹配",
      "fr": ""
    },
    "0x16430301" : {
      "en": "",
      "zh": "异常退出延时摄影",
      "fr": ""
    },
    "0x16430302" : {
      "en": "",
      "zh": "延时摄影异常退出当前任务",
      "fr": ""
    },
    "0x16430303" : {
      "en": "",
      "zh": "延时摄影异常进入暂停状态",
      "fr": ""
    },
    "0x16430304" : {
      "en": "",
      "zh": "延时摄影异常提示",
      "fr": ""
    },
    "0x16430305" : {
      "en": "",
      "zh": "地面电机已启动",
      "fr": ""
    },
    "0x16430306" : {
      "en": "",
      "zh": "相机模式异常",
      "fr": ""
    },
    "0x16430307" : {
      "en": "",
      "zh": "当前任务不匹配",
      "fr": ""
    },
    "0x16430308" : {
      "en": "",
      "zh": "抽象数据为空",
      "fr": ""
    },
    "0x16430309" : {
      "en": "",
      "zh": "相机模式超时",
      "fr": ""
    },
    "0x1643030a" : {
      "en": "",
      "zh": "相机模式不匹配",
      "fr": ""
    },
    "0x1643030b" : {
      "en": "",
      "zh": "定向延时中框丢失",
      "fr": ""
    },
    "0x1643030c" : {
      "en": "",
      "zh": "返回首航点航线平台异常",
      "fr": ""
    },
    "0x1643030d" : {
      "en": "",
      "zh": "环绕测距超时",
      "fr": ""
    },
    "0x1643030e" : {
      "en": "",
      "zh": "限飞",
      "fr": ""
    },
    "0x1643030f" : {
      "en": "",
      "zh": "地面延时电量低",
      "fr": ""
    },
    "0x16430310" : {
      "en": "GNSS signal weak",
      "zh": "卫星定位信号差",
      "fr": ""
    },
    "0x16430311" : {
      "en": "",
      "zh": "避障",
      "fr": ""
    },
    "0x16430312" : {
      "en": "",
      "zh": "环绕测距触发限飞",
      "fr": ""
    },
    "0x16430313" : {
      "en": "",
      "zh": "轨迹延时触发限高",
      "fr": ""
    },
    "0x16430314" : {
      "en": "",
      "zh": "返回首航点触发限飞",
      "fr": ""
    },
    "0x16430315" : {
      "en": "",
      "zh": "避障失效",
      "fr": ""
    },
    "0x16430316" : {
      "en": "",
      "zh": "返回首航点触发避障",
      "fr": ""
    },
    "0x16430317" : {
      "en": "",
      "zh": "运行过程中触发避障",
      "fr": ""
    },
    "0x16430318" : {
      "en": "",
      "zh": "拍摄过程中触发限飞",
      "fr": ""
    },
    "0x16430319" : {
      "en": "",
      "zh": "航线平台异常终止",
      "fr": ""
    },
    "0x1643031a" : {
      "en": "",
      "zh": "相机存储慢",
      "fr": ""
    },
    "0x1643031b" : {
      "en": "",
      "zh": "卫星定位信号弱轨迹点记录失败",
      "fr": ""
    },
    "0x1643031c" : {
      "en": "",
      "zh": "已达到最大照片限制",
      "fr": ""
    },
    "0x1643031d" : {
      "en": "",
      "zh": "存储空间不足",
      "fr": ""
    },
    "0x1643031e" : {
      "en": "",
      "zh": "定向延时航线未锁定",
      "fr": ""
    },
    "0x1643031f" : {
      "en": "",
      "zh": "云台姿态变化太小",
      "fr": ""
    },
    "0x16430320" : {
      "en": "",
      "zh": "云台姿态变化超限",
      "fr": ""
    },
    "0x16430321" : {
      "en": "",
      "zh": "轨迹载入失败",
      "fr": ""
    },
    "0x16430322" : {
      "en": "",
      "zh": "增加1s失败",
      "fr": ""
    },
    "0x16430323" : {
      "en": "",
      "zh": "完成照片太少无法合成视频",
      "fr": ""
    },
    "0x16430324" : {
      "en": "",
      "zh": "返回首航点轨迹生成失败",
      "fr": ""
    },
    "0x16432400" : {
      "en": "",
      "zh": "异常退出 ApasMission",
      "fr": ""
    },
    "0x16432401" : {
      "en": "",
      "zh": "融合数据订阅异常",
      "fr": ""
    },
    "0x16432402" : {
      "en": "",
      "zh": "Json文件读取失败",
      "fr": ""
    },
    "0x16432403" : {
      "en": "",
      "zh": "FlyCore数据订阅异常",
      "fr": ""
    },
    "0x16432404" : {
      "en": "",
      "zh": "融合数据超时",
      "fr": ""
    },
    "0x16432405" : {
      "en": "",
      "zh": "融合定位数据无效",
      "fr": ""
    },
    "0x16432410" : {
      "en": "",
      "zh": "ApasMission 异常退出到关闭",
      "fr": ""
    },
    "0x16432411" : {
      "en": "",
      "zh": "ImageStatus 订阅异常",
      "fr": ""
    },
    "0x16432412" : {
      "en": "",
      "zh": "夜景模式",
      "fr": ""
    },
    "0x16432413" : {
      "en": "",
      "zh": "环境光过暗且飞行环境安全",
      "fr": ""
    },
    "0x16432414" : {
      "en": "",
      "zh": "环境光过暗且悬停无水平杆",
      "fr": ""
    },
    "0x16432415" : {
      "en": "",
      "zh": "APAS Planner 功能异常且飞行环境安全",
      "fr": ""
    },
    "0x16432416" : {
      "en": "",
      "zh": "APAS Planner 功能异常且悬停无水平杆",
      "fr": ""
    },
    "0x16432417" : {
      "en": "",
      "zh": "OA Planner 功能异常且飞行环境安全",
      "fr": ""
    },
    "0x16432418" : {
      "en": "",
      "zh": "OA Planner 功能异常且悬停无水平杆",
      "fr": ""
    },
    "0x16432419" : {
      "en": "",
      "zh": "在云雾中",
      "fr": ""
    },
    "0x16432420" : {
      "en": "",
      "zh": "ApasMission 绕行异常退出到刹停",
      "fr": ""
    },
    "0x16432421" : {
      "en": "",
      "zh": "限飞区边缘",
      "fr": ""
    },
    "0x16432422" : {
      "en": "",
      "zh": "距离地面过近小于0.5m",
      "fr": ""
    },
    "0x16432423" : {
      "en": "",
      "zh": "部分环境光过暗",
      "fr": ""
    },
    "0x16432424" : {
      "en": "",
      "zh": "APAS Planner功能异常",
      "fr": ""
    },
    "0x16432425" : {
      "en": "",
      "zh": "高帧率录像",
      "fr": ""
    },
    "0x16432430" : {
      "en": "",
      "zh": "ApasMission 异常触发刹车",
      "fr": ""
    },
    "0x16432431" : {
      "en": "",
      "zh": "环境光过暗普通刹车",
      "fr": ""
    },
    "0x16432432" : {
      "en": "",
      "zh": "环境光过暗紧急刹车",
      "fr": ""
    },
    "0x16432433" : {
      "en": "",
      "zh": "APAS Planner 功能异常普通刹车",
      "fr": ""
    },
    "0x16432434" : {
      "en": "",
      "zh": "APAS Planner 功能异常紧急刹车",
      "fr": ""
    },
    "0x16432435" : {
      "en": "",
      "zh": "OA Planner 功能异常普通刹车",
      "fr": ""
    },
    "0x16432436" : {
      "en": "",
      "zh": "OA Planner 功能异常紧急刹车",
      "fr": ""
    },
    "0x16432500" : {
      "en": "",
      "zh": "OA模块无法正常工作",
      "fr": ""
    },
    "0x16432501" : {
      "en": "",
      "zh": "OA模块因地图异常无法正常工作",
      "fr": ""
    },
    "0x16432502" : {
      "en": "",
      "zh": "OA模块因地图异常无法正常工作",
      "fr": ""
    },
    "0x16432503" : {
      "en": "",
      "zh": "相机处于夜景模式OA无法正常工作",
      "fr": ""
    },
    "0x16432504" : {
      "en": "",
      "zh": "OA模块因处于云雾中无法正常工作",
      "fr": ""
    },
    "0x16432505" : {
      "en": "",
      "zh": "OA模块因环境光过暗无法正常工作",
      "fr": ""
    },
    "0x16432506" : {
      "en": "",
      "zh": "OA模块tof避障无法正常工作",
      "fr": ""
    },
    "0x16432550" : {
      "en": "",
      "zh": "OA模块触发异常保护",
      "fr": ""
    },
    "0x16432551" : {
      "en": "",
      "zh": "OA模块触发紧急刹车",
      "fr": ""
    },
    "0x16450001" : {
      "en": "",
      "zh": "飞机未能返回机场",
      "fr": ""
    },
    "0x16450002" : {
      "en": "",
      "zh": "飞机机场外触发不可取消降落",
      "fr": ""
    },
    "0x16450011" : {
      "en": "",
      "zh": "飞机悬停超时",
      "fr": ""
    },
    "0x16450012" : {
      "en": "",
      "zh": "飞机无法接收到机场状态",
      "fr": ""
    },
    "0x16450013" : {
      "en": "",
      "zh": "机场暂时不允许降落",
      "fr": ""
    },
    "0x16450014" : {
      "en": "",
      "zh": "Marker水平位置源无效",
      "fr": ""
    },
    "0x16450015" : {
      "en": "",
      "zh": "Marker水平位置源偏差大",
      "fr": ""
    },
    "0x16450016" : {
      "en": "",
      "zh": "Marker水平位置源订阅失败",
      "fr": ""
    },
    "0x16450017" : {
      "en": "",
      "zh": "RTK水平位置源无效",
      "fr": ""
    },
    "0x16450018" : {
      "en": "",
      "zh": "RTK水平位置源电离层校验不通过",
      "fr": ""
    },
    "0x16450019" : {
      "en": "",
      "zh": "飞机水平控制能力弱",
      "fr": ""
    },
    "0x16450021" : {
      "en": "",
      "zh": "机场降落功能运行异常",
      "fr": ""
    },
    "0x16450022" : {
      "en": "",
      "zh": "飞机因为切姿态变为普通降落",
      "fr": ""
    },
    "0x16450023" : {
      "en": "",
      "zh": "机场没有设置备降点无法触发备降",
      "fr": ""
    },
    "0x16450024" : {
      "en": "",
      "zh": "飞机没有触发提前停桨",
      "fr": ""
    },
    "0x16450025" : {
      "en": "",
      "zh": "抽象数据更新失败",
      "fr": ""
    },
    "0x16450031" : {
      "en": "",
      "zh": "飞机触发备降",
      "fr": ""
    },
    "0x16450032" : {
      "en": "",
      "zh": "飞机MCU接管控制",
      "fr": ""
    },
    "0x16450033" : {
      "en": "",
      "zh": "机场状态异常永久不允许降落",
      "fr": ""
    },
    "0x16450034" : {
      "en": "",
      "zh": "飞机悬停到低电量触发备降",
      "fr": ""
    },
    "0x16450035" : {
      "en": "",
      "zh": "飞机未能到达备降点中途降落",
      "fr": ""
    },
    "0x16450101" : {
      "en": "",
      "zh": "航线异常暂停",
      "fr": ""
    },
    "0x16450102" : {
      "en": "",
      "zh": "航线异常中止",
      "fr": ""
    },
    "0x16450103" : {
      "en": "",
      "zh": "航线功能异常",
      "fr": ""
    },
    "0x16450104" : {
      "en": "",
      "zh": "航线限高",
      "fr": ""
    },
    "0x16450105" : {
      "en": "",
      "zh": "航线限低",
      "fr": ""
    },
    "0x16450106" : {
      "en": "",
      "zh": "航线限远",
      "fr": ""
    },
    "0x16450107" : {
      "en": "",
      "zh": "航线触碰到禁飞区",
      "fr": ""
    },
    "0x16450108" : {
      "en": "",
      "zh": "航线执行中检测到障碍物",
      "fr": ""
    },
    "0x16450109" : {
      "en": "GNSS signal weak during task",
      "zh": "航线执行中卫星定位信号弱",
      "fr": ""
    },
    "0x1645010A" : {
      "en": "",
      "zh": "低电量",
      "fr": ""
    },
    "0x1645010B" : {
      "en": "",
      "zh": "航线生成超时",
      "fr": ""
    },
    "0x1645010C" : {
      "en": "",
      "zh": "拿不到抽象数据",
      "fr": ""
    },
    "0x1645010D" : {
      "en": "",
      "zh": "参数表读取失败",
      "fr": ""
    },
    "0x1645010E" : {
      "en": "",
      "zh": "轨迹库计算失败",
      "fr": ""
    },
    "0x1645010F" : {
      "en": "",
      "zh": "请求起飞失败",
      "fr": ""
    },
    "0x16450110" : {
      "en": "",
      "zh": "请求航线任务失败",
      "fr": ""
    },
    "0x16450111" : {
      "en": "",
      "zh": "请求返航失败",
      "fr": ""
    },
    "0x16450112" : {
      "en": "",
      "zh": "请求降落失败",
      "fr": ""
    },
    "0x16450113" : {
      "en": "",
      "zh": "飞行器失联",
      "fr": ""
    },
    "0x16450114" : {
      "en": "",
      "zh": "实时仿地过程中，相机状态有问题（过亮，过暗，两侧亮度不一致）",
      "fr": ""
    },
    "0x16450115" : {
      "en": "",
      "zh": "实时仿地过程中全局地图计算出错",
      "fr": ""
    },
    "0x16450116" : {
      "en": "",
      "zh": "航线动作组解析失败",
      "fr": ""
    },
    "0x16450117" : {
      "en": "",
      "zh": "飞行任务冲突，无法获取飞机控制权",
      "fr": ""
    },
    "0x16450118" : {
      "en": "",
      "zh": "要执行的文件解析错误",
      "fr": ""
    },
    "0x16450119" : {
      "en": "",
      "zh": "等待wpmz文件读取时间过长",
      "fr": ""
    },
    "0x1645011A" : {
      "en": "",
      "zh": "航线已经开始，不能再次开始",
      "fr": ""
    },
    "0x1645011B" : {
      "en": "",
      "zh": "相机抽象设备异常",
      "fr": ""
    },
    "0x1645011C" : {
      "en": "",
      "zh": "云台抽象设备异常",
      "fr": ""
    },
    "0x1645011D" : {
      "en": "",
      "zh": "app链路异常",
      "fr": ""
    },
    "0x1645011E" : {
      "en": "",
      "zh": "工厂文件未删除",
      "fr": ""
    },
    "0x1645011F" : {
      "en": "",
      "zh": "RTK状态跳变，航线已退出",
      "fr": ""
    },
    "0x16450120" : {
      "en": "",
      "zh": "请求快速起飞失败",
      "fr": ""
    },
    "0x16450121" : {
      "en": "",
      "zh": "自动起飞运行失败",
      "fr": ""
    },
    "0x16450122" : {
      "en": "",
      "zh": "航线触碰到自定义飞行区",
      "fr": ""
    },
    "0x16450123" : {
      "en": "",
      "zh": "航线全景拍照动作出错",
      "fr": ""
    },
    "0x16450124" : {
      "en": "",
      "zh": "执行全景拍照过程超时",
      "fr": ""
    },
    "0x16450125" : {
      "en": "",
      "zh": "全景拍照设置相机topmode失败",
      "fr": ""
    },
    "0x16450126" : {
      "en": "",
      "zh": "全景拍照设置相机submode失败",
      "fr": ""
    },
    "0x16450127" : {
      "en": "",
      "zh": "全景拍照前飞机转yaw超时",
      "fr": ""
    },
    "0x16450128" : {
      "en": "",
      "zh": "全景拍照后飞机恢复yaw超时",
      "fr": ""
    },
    "0x16450129" : {
      "en": "",
      "zh": "全景拍照空指针错误",
      "fr": ""
    },
    "0x16461000" : {
      "en": "",
      "zh": "融合定位系统异常切换",
      "fr": ""
    },
    "0x16461001" : {
      "en": "",
      "zh": "ap_fusion 断联",
      "fr": ""
    },
    "0x16461002" : {
      "en": "",
      "zh": "ap_fusion 存在严重故障",
      "fr": ""
    },
    "0x16461003" : {
      "en": "",
      "zh": "默认融合定位系统被修改",
      "fr": ""
    },
    "0x16462001" : {
      "en": "",
      "zh": "霍尔设备断开",
      "fr": ""
    },
    "0x16462004" : {
      "en": "",
      "zh": "霍尔校准数据异常",
      "fr": ""
    },
    "0x16462007" : {
      "en": "",
      "zh": "霍尔传感器缺少磁环，工作异常",
      "fr": ""
    },
    "0x1646200A" : {
      "en": "",
      "zh": "霍尔传感器间互检失败",
      "fr": ""
    },
    "0x16463001" : {
      "en": "",
      "zh": "RTK No NLFix",
      "fr": ""
    },
    "0x16463004" : {
      "en": "",
      "zh": "主天线观测质量差",
      "fr": ""
    },
    "0x16463005" : {
      "en": "",
      "zh": "信号频繁失锁",
      "fr": ""
    },
    "0x16463006" : {
      "en": "",
      "zh": "电离层活跃",
      "fr": ""
    },
    "0x16463007" : {
      "en": "",
      "zh": "主天线SNR陡降",
      "fr": ""
    },
    "0x16463008" : {
      "en": "",
      "zh": "副天线SNR陡降",
      "fr": ""
    },
    "0x16463009" : {
      "en": "",
      "zh": "主天线开路或短路",
      "fr": ""
    },
    "0x1646300A" : {
      "en": "",
      "zh": "副天线开路或短路",
      "fr": ""
    },
    "0x1646300B" : {
      "en": "",
      "zh": "RTK Heading No NLFix",
      "fr": ""
    },
    "0x16463011" : {
      "en": "",
      "zh": "RTK基站RTCM数据异常",
      "fr": ""
    },
    "0x16463012" : {
      "en": "",
      "zh": "2607未收到RTCM",
      "fr": ""
    },
    "0x16463013" : {
      "en": "",
      "zh": "2607 RTCM V1组包异常",
      "fr": ""
    },
    "0x16463014" : {
      "en": "",
      "zh": "2607RTCM传输误码",
      "fr": ""
    },
    "0x16463021" : {
      "en": "",
      "zh": "2906未收到RTCM",
      "fr": ""
    },
    "0x16463022" : {
      "en": "",
      "zh": "2906RTK数据源不一致",
      "fr": ""
    },
    "0x16463023" : {
      "en": "",
      "zh": "2906RTK数据源无效",
      "fr": ""
    },
    "0x16463024" : {
      "en": "",
      "zh": "2906RTK数据源初始化失败",
      "fr": ""
    },
    "0x16463031" : {
      "en": "",
      "zh": "2606未收到RTCM",
      "fr": ""
    },
    "0x16463032" : {
      "en": "",
      "zh": "2606RTK数据源不一致",
      "fr": ""
    },
    "0x16463033" : {
      "en": "",
      "zh": "2606RTK数据源无效",
      "fr": ""
    },
    "0x16463034" : {
      "en": "",
      "zh": "2606未收到RTK信息源的信息",
      "fr": ""
    },
    "0x16471000" : {
      "en": "",
      "zh": "定位无输出，可能是FC传感器未就绪",
      "fr": ""
    },
    "0x16471001" : {
      "en": "",
      "zh": "定位异常，系统异常或loading异常",
      "fr": ""
    },
    "0x16471002" : {
      "en": "",
      "zh": "定位输出速度位置一致性差",
      "fr": ""
    },
    "0x16471003" : {
      "en": "",
      "zh": "飞控传感器未就绪",
      "fr": ""
    },
    "0x16471004" : {
      "en": "",
      "zh": "状态实时性delay太大",
      "fr": ""
    },
    "0x16471005" : {
      "en": "",
      "zh": "loop耗时异常",
      "fr": ""
    },
    "0x16471006" : {
      "en": "",
      "zh": "状态时间戳异常",
      "fr": ""
    },
    "0x16471007" : {
      "en": "",
      "zh": "IMU BIAS随机游走异常",
      "fr": ""
    },
    "0x16471010" : {
      "en": "",
      "zh": "视觉定位多方向同步异常",
      "fr": ""
    },
    "0x16471012" : {
      "en": "",
      "zh": "硬件加速器调用异常",
      "fr": ""
    },
    "0x16471100" : {
      "en": "",
      "zh": "IMU 时间戳异常",
      "fr": ""
    },
    "0x16471101" : {
      "en": "",
      "zh": "视觉时间戳异常",
      "fr": ""
    },
    "0x16471102" : {
      "en": "",
      "zh": "UBLOX GPS时间戳异常",
      "fr": ""
    },
    "0x16471103" : {
      "en": "",
      "zh": "DJI GPS时间戳异常",
      "fr": ""
    },
    "0x16471201" : {
      "en": "",
      "zh": "IMU静止检测更新异常",
      "fr": ""
    },
    "0x16471204" : {
      "en": "",
      "zh": "气压计更新异常",
      "fr": ""
    },
    "0x16471205" : {
      "en": "",
      "zh": "TOF更新异常",
      "fr": ""
    },
    "0x16471207" : {
      "en": "",
      "zh": "视觉更新异常",
      "fr": ""
    },
    "0x16471209" : {
      "en": "GNSS positioning information update error",
      "zh": "卫星定位更新异常",
      "fr": ""
    },
    "0x16476000" : {
      "en": "",
      "zh": "VIO 前端异常",
      "fr": ""
    },
    "0x16476001" : {
      "en": "",
      "zh": "初始化异常",
      "fr": ""
    },
    "0x16476002" : {
      "en": "",
      "zh": "前端启动错误",
      "fr": ""
    },
    "0x16476003" : {
      "en": "Vision sensor error. Restart aircraft and try again",
      "zh": "视觉定位前端获取里程计异常,尝试重启后再工作",
      "fr": ""
    },
    "0x16476004" : {
      "en": "",
      "zh": "TF树异常",
      "fr": ""
    },
    "0x16476005" : {
      "en": "",
      "zh": "circular_tracking错误",
      "fr": ""
    },
    "0x16476006" : {
      "en": "",
      "zh": "DSP translation KLT异常",
      "fr": ""
    },
    "0x16476007" : {
      "en": "",
      "zh": "DSP eis KLT异常",
      "fr": ""
    },
    "0x16476008" : {
      "en": "",
      "zh": "输入harris点数大于最大设置点数",
      "fr": ""
    },
    "0x16476009" : {
      "en": "",
      "zh": "相机参数未更新",
      "fr": ""
    },
    "0x16476100" : {
      "en": "",
      "zh": "VIO 动态切图异常",
      "fr": ""
    },
    "0x16476101" : {
      "en": "",
      "zh": "动态切图初始化异常",
      "fr": ""
    },
    "0x16476102" : {
      "en": "",
      "zh": "动态切图参数异常",
      "fr": ""
    },
    "0x16476103" : {
      "en": "",
      "zh": "acc_rectify_channel_update异常",
      "fr": ""
    },
    "0x16476104" : {
      "en": "",
      "zh": "insert_rectify_one_channel异常",
      "fr": ""
    },
    "0x16476105" : {
      "en": "",
      "zh": "ss_dbus_shm_acquire异常",
      "fr": ""
    },
    "0x16476106" : {
      "en": "",
      "zh": "ss_dbus_shm_publish异常",
      "fr": ""
    },
    "0x16476107" : {
      "en": "",
      "zh": "获取相机参数超时",
      "fr": ""
    },
    "0x16479000" : {
      "en": "",
      "zh": "V1-RTK功能异常",
      "fr": ""
    },
    "0x16479001" : {
      "en": "",
      "zh": "RTK初始化异常",
      "fr": ""
    },
    "0x16479002" : {
      "en": "",
      "zh": "RTK DSP运行异常",
      "fr": ""
    },
    "0x16479003" : {
      "en": "",
      "zh": "RTK进程调度异常",
      "fr": ""
    },
    "0x16479004" : {
      "en": "",
      "zh": "RTK输出频率异常",
      "fr": ""
    },
    "0x16479005" : {
      "en": "",
      "zh": "RTK MIPI数据异常",
      "fr": ""
    },
    "0x16479006" : {
      "en": "",
      "zh": "RTK 设备驱动异常",
      "fr": ""
    },
    "0x16479011" : {
      "en": "",
      "zh": "RTK 设备配置异常",
      "fr": ""
    },
    "0x16479012" : {
      "en": "",
      "zh": "RTK初始化资源申请异常",
      "fr": ""
    },
    "0x16479013" : {
      "en": "",
      "zh": "MIPI初始化异常",
      "fr": ""
    },
    "0x16479014" : {
      "en": "",
      "zh": "RTK初始化参数配置异常",
      "fr": ""
    },
    "0x16479015" : {
      "en": "",
      "zh": "RTK固件版本不匹配",
      "fr": ""
    },
    "0x16479021" : {
      "en": "",
      "zh": "RTK算子异常挂死",
      "fr": ""
    },
    "0x16479022" : {
      "en": "",
      "zh": "RTK算子运行超时",
      "fr": ""
    },
    "0x16479031" : {
      "en": "",
      "zh": "RTK系统中断异常",
      "fr": ""
    },
    "0x16479032" : {
      "en": "",
      "zh": "RTK系统实时性异常",
      "fr": ""
    },
    "0x16479041" : {
      "en": "",
      "zh": "RTK时序错误",
      "fr": ""
    },
    "0x16479051" : {
      "en": "",
      "zh": "RTK MIPI数据同步错误",
      "fr": ""
    },
    "0x16479052" : {
      "en": "",
      "zh": "RTK MIPI数据丢帧",
      "fr": ""
    },
    "0x1647C010" : {
      "en": "",
      "zh": "指南针需要校准",
      "fr": ""
    },
    "0x1647C011" : {
      "en": "",
      "zh": "指南针模长过大，需要校准",
      "fr": ""
    },
    "0x1647C012" : {
      "en": "",
      "zh": "指南针Yaw误差大，需要校准",
      "fr": ""
    },
    "0x1647C013" : {
      "en": "",
      "zh": "指南针yaw不一致，需要校准",
      "fr": ""
    },
    "0x1647C014" : {
      "en": "",
      "zh": "指南针模长不一致，需要校准",
      "fr": ""
    },
    "0x1647C015" : {
      "en": "",
      "zh": "指南针航向不一致，需要校准",
      "fr": ""
    },
    "0x1647C016" : {
      "en": "",
      "zh": "指南针长距离未校准，需要校准",
      "fr": ""
    },
    "0x1647C017" : {
      "en": "",
      "zh": "指南针长时间未校准，需要校准",
      "fr": ""
    },
    "0x1647C018" : {
      "en": "",
      "zh": "指南针长时间异常，需要校准",
      "fr": ""
    },
    "0x1647C019" : {
      "en": "",
      "zh": "指南针航向与融合航向不一致，需要校准",
      "fr": ""
    },
    "0x1647C020" : {
      "en": "",
      "zh": "需要移动飞机",
      "fr": ""
    },
    "0x1647C021" : {
      "en": "",
      "zh": "指南针校准完后模长过大，需要移动飞机",
      "fr": ""
    },
    "0x1647C022" : {
      "en": "",
      "zh": "指南针校准完后Yaw误差大，需要移动飞机",
      "fr": ""
    },
    "0x1647C023" : {
      "en": "",
      "zh": "指南针校准完后yaw不一致，需要移动飞机",
      "fr": ""
    },
    "0x1647C024" : {
      "en": "",
      "zh": "指南针校准完后模长不一致，需要移动飞机",
      "fr": ""
    },
    "0x1647C025" : {
      "en": "",
      "zh": "指南针校准完后航向不一致，需要移动飞机",
      "fr": ""
    },
    "0x1647C030" : {
      "en": "",
      "zh": "需要移动飞机或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C031" : {
      "en": "",
      "zh": "指南针校准完后模长过大，需要移动飞机或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C032" : {
      "en": "",
      "zh": "指南针校准完后Yaw误差大，需要移动飞机或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C033" : {
      "en": "",
      "zh": "指南针校准完后yaw不一致，需要移动飞机或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C034" : {
      "en": "",
      "zh": "指南针校准完后模长不一致，需要移动飞机或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C035" : {
      "en": "",
      "zh": "指南针校准完后航向不一致，需要移动飞机或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C040" : {
      "en": "",
      "zh": "指南针需要校准或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C041" : {
      "en": "",
      "zh": "指南针模长过大，需要校准或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C042" : {
      "en": "",
      "zh": "指南针Yaw误差大，需要校准或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C043" : {
      "en": "",
      "zh": "指南针yaw不一致，需要校准或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C044" : {
      "en": "",
      "zh": "指南针模长不一致，需要校准或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C045" : {
      "en": "",
      "zh": "指南针航向不一致，需要校准或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C046" : {
      "en": "",
      "zh": "指南针长距离未校准，需要校准或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C047" : {
      "en": "",
      "zh": "指南针长时间未校准，需要校准或等待RTK-FIX",
      "fr": ""
    },
    "0x1647C048" : {
      "en": "",
      "zh": "指南针长时间异常，需要校准或等待RTK-FIX",
      "fr": ""
    },
    "0x16490001" : {
      "en": "",
      "zh": "tracking planner异常退出",
      "fr": ""
    },
    "0x16490002" : {
      "en": "",
      "zh": "tracking planner参数无效",
      "fr": ""
    },
    "0x16490003" : {
      "en": "Vertical altitude error",
      "zh": "垂直高度反馈异常",
      "fr": ""
    },
    "0x16490004" : {
      "en": "",
      "zh": "tracking planner跟随失败",
      "fr": ""
    },
    "0x16490005" : {
      "en": "",
      "zh": "tracking planner地图超时",
      "fr": ""
    },
    "0x16490006" : {
      "en": "",
      "zh": "tracking planner地图空指针",
      "fr": ""
    },
    "0x16490007" : {
      "en": "",
      "zh": "tracking planner避障异常退出",
      "fr": ""
    },
    "0x16490008" : {
      "en": "",
      "zh": "tracking planner目标安全性异常",
      "fr": ""
    },
    "0x16490009" : {
      "en": "",
      "zh": "tracking planner轨迹跟随异常",
      "fr": ""
    },
    "0x1649000A" : {
      "en": "",
      "zh": "tracking planner目标估计错误",
      "fr": ""
    },
    "0x1649000B" : {
      "en": "",
      "zh": "tracking planner失效",
      "fr": ""
    },
    "0x1649000C" : {
      "en": "",
      "zh": "tracking planner紧急刹车",
      "fr": ""
    },
    "0x1649000D" : {
      "en": "",
      "zh": "tracking planner平滑性异常",
      "fr": ""
    },
    "0x1649000E" : {
      "en": "",
      "zh": "tracking planner轨迹检测异常",
      "fr": ""
    },
    "0x1649000F" : {
      "en": "",
      "zh": "tracking planner刹车规划异常",
      "fr": ""
    },
    "0x16490010" : {
      "en": "",
      "zh": "tracking planner路径规划异常",
      "fr": ""
    },
    "0x16490011" : {
      "en": "",
      "zh": "tracking planner轨迹规划异常",
      "fr": ""
    },
    "0x16493000" : {
      "en": "",
      "zh": "全局地图：拿不到MCU的高频推送 fly_core",
      "fr": ""
    },
    "0x16493100" : {
      "en": "",
      "zh": "全局地图：拿不到MCU的低频推送 fly_extend",
      "fr": ""
    },
    "0x16493200" : {
      "en": "",
      "zh": "全局地图：拿不到有效的定位数据 fusion_output",
      "fr": ""
    },
    "0x16493300" : {
      "en": "",
      "zh": "全局地图：拿不到有效的标定数据",
      "fr": ""
    },
    "0x16493400" : {
      "en": "",
      "zh": "全局地图：拿不到有效的天空语义",
      "fr": ""
    },
    "0x16493500" : {
      "en": "",
      "zh": "全局地图：拿不到有效的局部地图",
      "fr": ""
    },
    "0x16493600" : {
      "en": "",
      "zh": "全局地图：局部地图处理失败/超时",
      "fr": ""
    },
    "0x16494000" : {
      "en": "",
      "zh": "APAS Planner 功能异常",
      "fr": ""
    },
    "0x16494001" : {
      "en": "",
      "zh": "局部地图订阅异常",
      "fr": ""
    },
    "0x16494002" : {
      "en": "",
      "zh": "环境限速订阅异常",
      "fr": ""
    },
    "0x16494003" : {
      "en": "",
      "zh": "APAS Planner 阻塞",
      "fr": ""
    },
    "0x16494004" : {
      "en": "",
      "zh": "APAS Follower 阻塞",
      "fr": ""
    },
    "0x16494100" : {
      "en": "",
      "zh": "APAS Planner 性能异常",
      "fr": ""
    },
    "0x16494101" : {
      "en": "",
      "zh": "APAS Planner 局部地图共享内存超时",
      "fr": ""
    },
    "0x16494102" : {
      "en": "",
      "zh": "APAS Planner 初始轨迹求解失败",
      "fr": ""
    },
    "0x16494103" : {
      "en": "",
      "zh": "APAS Planner 绕行轨迹求解失败",
      "fr": ""
    },
    "0x16494104" : {
      "en": "",
      "zh": "APAS Planner 触发紧急刹车",
      "fr": ""
    },
    "0x16494105" : {
      "en": "",
      "zh": "APAS Follower 跟踪误差过大",
      "fr": ""
    },
    "0x16494106" : {
      "en": "",
      "zh": "APAS Follower 控制序列碰撞检查失败",
      "fr": ""
    },
    "0x16497100" : {
      "en": "",
      "zh": "仿地绕行异常",
      "fr": ""
    },
    "0x16497110" : {
      "en": "",
      "zh": "仿地绕行任务设置异常",
      "fr": ""
    },
    "0x16497111" : {
      "en": "",
      "zh": "仿地绕行任务高度异常",
      "fr": ""
    },
    "0x16497112" : {
      "en": "",
      "zh": "仿地绕行任务速度异常",
      "fr": ""
    },
    "0x16497113" : {
      "en": "",
      "zh": "仿地绕行任务航线设置异常",
      "fr": ""
    },
    "0x16497120" : {
      "en": "",
      "zh": "仿地绕行感知输入异常",
      "fr": ""
    },
    "0x16497121" : {
      "en": "",
      "zh": "仿地绕行建图异常",
      "fr": ""
    },
    "0x16497122" : {
      "en": "",
      "zh": "仿地绕行地图超时",
      "fr": ""
    },
    "0x16497130" : {
      "en": "",
      "zh": "仿地绕行规划失败",
      "fr": ""
    },
    "0x16497131" : {
      "en": "",
      "zh": "仿地绕行搜索路径无效",
      "fr": ""
    },
    "0x16497132" : {
      "en": "",
      "zh": "仿地绕行搜索失败",
      "fr": ""
    },
    "0x16497133" : {
      "en": "",
      "zh": "仿地绕行轨迹优化失败",
      "fr": ""
    },
    "0x164a0001" : {
      "en": "",
      "zh": "垂直高度控制异常",
      "fr": ""
    },
    "0x164a0002" : {
      "en": "",
      "zh": "垂直速度控制异常",
      "fr": ""
    },
    "0x164a0003" : {
      "en": "",
      "zh": "垂直高度反馈异常",
      "fr": ""
    },
    "0x164a0004" : {
      "en": "",
      "zh": "垂直速度反馈异常",
      "fr": ""
    },
    "0x164a0005" : {
      "en": "",
      "zh": "垂直动力饱和异常",
      "fr": ""
    },
    "0x164a1001" : {
      "en": "",
      "zh": "水平控制异常",
      "fr": ""
    },
    "0x164a1002" : {
      "en": "",
      "zh": "水平速度控制异常",
      "fr": ""
    },
    "0x164a1003" : {
      "en": "",
      "zh": "水平速度反馈异常",
      "fr": ""
    },
    "0x164a1004" : {
      "en": "",
      "zh": "姿态控制异常",
      "fr": ""
    },
    "0x164A1005" : {
      "en": "In No Position Hold mode, aircraft is unable to hover stably. It is recommended to switch to Normal mode before flying",
      "zh": "当前为无位置保持模式，飞行器无法稳定悬停，建议切换为普通模式后起飞",
      "fr": ""
    },
    "0x164A1005_in_the_sky" : {
      "en": "In No Position Hold mode, aircraft is unable to hover stably, and flight safety is affected. It is recommended to switch to Normal mode",
      "zh": "无位置保持模式下，无法稳定悬停，可能影响飞行安全，建议切换为普通模式",
      "fr": ""
    },
    "0x164C0000" : {
      "en": "",
      "zh": "局部地图模块异常",
      "fr": ""
    },
    "0x164C0040" : {
      "en": "",
      "zh": "局部地图模块接受数据异常",
      "fr": ""
    },
    "0x164C0080" : {
      "en": "",
      "zh": "局部地图模块数据处理异常",
      "fr": ""
    },
    "0x164C00C0" : {
      "en": "",
      "zh": "局部地图模块规划指令订阅异常",
      "fr": ""
    },
    "0x164C0100" : {
      "en": "",
      "zh": "局部地图模块订阅下视dpp异常",
      "fr": ""
    },
    "0x164C0101" : {
      "en": "",
      "zh": "局部地图模块订阅前视dpp异常",
      "fr": ""
    },
    "0x164C0102" : {
      "en": "",
      "zh": "局部地图模块订阅后视dpp异常",
      "fr": ""
    },
    "0x164C0103" : {
      "en": "",
      "zh": "局部地图模块订阅右视dpp异常",
      "fr": ""
    },
    "0x164C0104" : {
      "en": "",
      "zh": "局部地图模块订阅左视dpp异常",
      "fr": ""
    },
    "0x164C0105" : {
      "en": "",
      "zh": "局部地图模块订阅上视dpp异常",
      "fr": ""
    },
    "0x164C013E" : {
      "en": "",
      "zh": "局部地图模块订阅dpp异常",
      "fr": ""
    },
    "0x164C0140" : {
      "en": "",
      "zh": "局部地图模块订阅标定参数异常",
      "fr": ""
    },
    "0x164C0180" : {
      "en": "",
      "zh": "局部地图模块订阅相机状态异常",
      "fr": ""
    },
    "0x164C01C0" : {
      "en": "",
      "zh": "局部地图模块数据处理超时",
      "fr": ""
    },
    "0x164C0200" : {
      "en": "",
      "zh": "局部地图模块数据处理过程错误",
      "fr": ""
    },
    "0x164C0240" : {
      "en": "",
      "zh": "dpp模块下视视差图时序异常",
      "fr": ""
    },
    "0x164C0241" : {
      "en": "",
      "zh": "dpp模块前视视差图时序异常",
      "fr": ""
    },
    "0x164C0242" : {
      "en": "",
      "zh": "dpp模块后视视差图时序异常",
      "fr": ""
    },
    "0x164C0243" : {
      "en": "",
      "zh": "dpp模块右视视差图时序异常",
      "fr": ""
    },
    "0x164C0244" : {
      "en": "",
      "zh": "dpp模块左视视差图时序异常",
      "fr": ""
    },
    "0x164C0245" : {
      "en": "",
      "zh": "dpp模块上视视差图时序异常",
      "fr": ""
    },
    "0x164C027E" : {
      "en": "",
      "zh": "dpp模块视差图时序异常",
      "fr": ""
    },
    "0x164C0280" : {
      "en": "",
      "zh": "dpp模块下视视差图丢失",
      "fr": ""
    },
    "0x164C0281" : {
      "en": "",
      "zh": "dpp模块前视视差图丢失",
      "fr": ""
    },
    "0x164C0282" : {
      "en": "",
      "zh": "dpp模块后视视差图丢失",
      "fr": ""
    },
    "0x164C0283" : {
      "en": "",
      "zh": "dpp模块右视视差图丢失",
      "fr": ""
    },
    "0x164C0284" : {
      "en": "",
      "zh": "dpp模块左视视差图丢失",
      "fr": ""
    },
    "0x164C0285" : {
      "en": "",
      "zh": "dpp模块上视视差图丢失",
      "fr": ""
    },
    "0x164C02BE" : {
      "en": "",
      "zh": "dpp模块某方向固定丢失视差图",
      "fr": ""
    },
    "0x164C02C0" : {
      "en": "",
      "zh": "局部地图模块地图更新延迟大",
      "fr": ""
    },
    "0x164C0300" : {
      "en": "",
      "zh": "局部地图模块esdf计算延迟大",
      "fr": ""
    },
    "0x164C0440" : {
      "en": "",
      "zh": "局部地图模块订阅位姿数据异常",
      "fr": ""
    },
    "0x164C04BE" : {
      "en": "",
      "zh": "dpp模块订阅语义depth数据异常",
      "fr": ""
    },
    "0x164C04FE" : {
      "en": "",
      "zh": "dpp模块订阅sgbm数据异常",
      "fr": ""
    },
    "0x164C053E" : {
      "en": "",
      "zh": "dpp模块订阅语义炫光检测数据异常",
      "fr": ""
    },
    "0x164C057E" : {
      "en": "",
      "zh": "dpp模块订阅语义天空数据异常",
      "fr": ""
    },
    "0x164C05BE" : {
      "en": "",
      "zh": "dpp模块订阅语义桨叶检测数据异常",
      "fr": ""
    },
    "0x164C05FE" : {
      "en": "",
      "zh": "dpp模块数据处理异常",
      "fr": ""
    },
    "0x164C0600" : {
      "en": "",
      "zh": "语义depth模块初始化异常",
      "fr": ""
    },
    "0x164C0640" : {
      "en": "",
      "zh": "语义感知模块订阅主方向数据异常",
      "fr": ""
    },
    "0x164C0680" : {
      "en": "",
      "zh": "语义感知模块订阅图像状态数据异常",
      "fr": ""
    },
    "0x164C06C0" : {
      "en": "",
      "zh": "语义感知模块订阅输入图数据异常",
      "fr": ""
    },
    "0x164C0700" : {
      "en": "",
      "zh": "语义感知模块订阅最新帧号数据异常",
      "fr": ""
    },
    "0x164C0740" : {
      "en": "",
      "zh": "语义感知模块执行异常",
      "fr": ""
    },
    "0x164C0780" : {
      "en": "",
      "zh": "语义depth模块发布视差结果异常",
      "fr": ""
    },
    "0x164C07C0" : {
      "en": "",
      "zh": "语义感知模块调用nnf接口异常",
      "fr": ""
    },
    "0x164C0800" : {
      "en": "",
      "zh": "语义depth模块获取视差结果异常",
      "fr": ""
    },
    "0x164C0840" : {
      "en": "",
      "zh": "语义炫光模块初始化异常",
      "fr": ""
    },
    "0x164C0940" : {
      "en": "",
      "zh": "语义炫光模块发布炫光检测结果异常",
      "fr": ""
    },
    "0x164C09C0" : {
      "en": "",
      "zh": "语义天空模块初始化异常",
      "fr": ""
    },
    "0x164C0A40" : {
      "en": "",
      "zh": "语义感知模块订阅channel_manager数据异常",
      "fr": ""
    },
    "0x164C0B00" : {
      "en": "",
      "zh": "语义感知模块后处理异常",
      "fr": ""
    },
    "0x164C0BC0" : {
      "en": "",
      "zh": "语义天空模块发布分割结果异常",
      "fr": ""
    },
    "0x164C0C00" : {
      "en": "",
      "zh": "语义天空模块地平线计算异常",
      "fr": ""
    },
    "0x164C0C40" : {
      "en": "",
      "zh": "语义天空模块发布天空数量异常",
      "fr": ""
    },
    "0x164C0C80" : {
      "en": "",
      "zh": "语义天空模块订阅内参数据异常",
      "fr": ""
    },
    "0x164C0CC0" : {
      "en": "",
      "zh": "语义天空模块订阅外参数据异常",
      "fr": ""
    },
    "0x164C0d00" : {
      "en": "",
      "zh": "语义天空模块订阅vio位姿数据异常",
      "fr": ""
    },
    "0x164C0D40" : {
      "en": "",
      "zh": "语义天空模块订阅坐标转换数据异常",
      "fr": ""
    },
    "0x164C0D80" : {
      "en": "",
      "zh": "语义桨叶检测模块初始化异常",
      "fr": ""
    },
    "0x164C0E80" : {
      "en": "",
      "zh": "语义桨叶检测模块发布分割结果异常",
      "fr": ""
    },
    "0x164C0EC0" : {
      "en": "",
      "zh": "marker识别模块初始化异常",
      "fr": ""
    },
    "0x164C0ED0" : {
      "en": "",
      "zh": "marker识别模块订阅fusion_data数据异常",
      "fr": ""
    },
    "0x164C0F40" : {
      "en": "",
      "zh": "marker识别模块发布marker_info数据异常",
      "fr": ""
    },
    "0x164C0F80" : {
      "en": "",
      "zh": "marker识别模块发布marker_status数据异常",
      "fr": ""
    },
    "0x164D0000" : {
      "en": "",
      "zh": "环境检测异常",
      "fr": ""
    },
    "0x164D0001" : {
      "en": "",
      "zh": "环境检测模块初始化异常",
      "fr": ""
    },
    "0x164D0002" : {
      "en": "",
      "zh": "环境检测模块DBUS发布异常",
      "fr": ""
    },
    "0x164D0003" : {
      "en": "",
      "zh": "环境检测模块V1发布异常",
      "fr": ""
    },
    "0x164D0004" : {
      "en": "",
      "zh": "环境检测模块过暗标志推送异常",
      "fr": ""
    },
    "0x164D0005" : {
      "en": "",
      "zh": "环境检测模块进入低功耗",
      "fr": ""
    },
    "0x164D0006" : {
      "en": "",
      "zh": "环境检测模块退出低功耗",
      "fr": ""
    },
    "0x164D0040" : {
      "en": "",
      "zh": "照度检测模块异常",
      "fr": ""
    },
    "0x164D0041" : {
      "en": "",
      "zh": "水面检测模块异常",
      "fr": ""
    },
    "0x164D0042" : {
      "en": "",
      "zh": "云雾检测模块异常",
      "fr": ""
    },
    "0x164D0043" : {
      "en": "",
      "zh": "桨保检测模块异常",
      "fr": ""
    },
    "0x164D0044" : {
      "en": "",
      "zh": "脏污检测模块异常",
      "fr": ""
    },
    "0x164D0045" : {
      "en": "",
      "zh": "遮挡检测模块异常",
      "fr": ""
    },
    "0x164D0046" : {
      "en": "",
      "zh": "室内检测模块异常",
      "fr": ""
    },
    "0x164D0080" : {
      "en": "",
      "zh": "环境检测模块AEC数据订阅异常",
      "fr": ""
    },
    "0x164D0081" : {
      "en": "",
      "zh": "环境检测模块照度矩阵订阅异常",
      "fr": ""
    },
    "0x164D0082" : {
      "en": "",
      "zh": "环境检测模块maphex订阅异常",
      "fr": ""
    },
    "0x164D0083" : {
      "en": "",
      "zh": "环境检测模块视觉云雾数据异常",
      "fr": ""
    },
    "0x164D0084" : {
      "en": "",
      "zh": "环境检测模块VIO前端数据异常",
      "fr": ""
    },
    "0x164D0085" : {
      "en": "",
      "zh": "环境检测模块TOF云雾数据异常",
      "fr": ""
    },
    "0x164D0086" : {
      "en": "",
      "zh": "环境检测模块桨保图像订阅异常",
      "fr": ""
    },
    "0x164D0087" : {
      "en": "",
      "zh": "环境检测模块3DTOF数据异常",
      "fr": ""
    },
    "0x164D0088" : {
      "en": "",
      "zh": "环境检测模块CNN脏污数据异常",
      "fr": ""
    },
    "0x164D0089" : {
      "en": "",
      "zh": "环境检测模块CNN室内数据异常",
      "fr": ""
    },
    "0x164D008A" : {
      "en": "",
      "zh": "环境检测模块CNN水面数据异常",
      "fr": ""
    },
    "0x164D008B" : {
      "en": "",
      "zh": "环境检测模块CNN炫光数据异常",
      "fr": ""
    },
    "0x164D008C" : {
      "en": "",
      "zh": "环境检测模块FMU FLY CORE数据异常",
      "fr": ""
    },
    "0x164D008D" : {
      "en": "",
      "zh": "环境检测模块飞行状态数据异常",
      "fr": ""
    },
    "0x164D008E" : {
      "en": "",
      "zh": "环境检测模块PARSING态数据异常",
      "fr": ""
    },
    "0x164DFFF1" : {
      "en": "",
      "zh": "1DTOF异常",
      "fr": ""
    },
    "0x164DFFF2" : {
      "en": "",
      "zh": "3DtoF异常",
      "fr": ""
    },
    "0x164DFFF3" : {
      "en": "",
      "zh": "雷达传感器异常",
      "fr": ""
    },
    "0x164DFFF4" : {
      "en": "",
      "zh": "超声波传感器异常",
      "fr": ""
    },
    "0x16670000" : {
      "en": "No power lines identified ahead. Power Line Follow task ended",
      "zh": "前方未识别到线路，仿线任务已结束",
      "fr": ""
    },
    "0x16670001" : {
      "en": "Home Point not set. Check and update Home Point",
      "zh": "返航点未设置，请检查刷新返航点",
      "fr": ""
    },
    "0x16670002" : {
      "en": "GNSS signal weak. Power Line Follow task stopped",
      "zh": "卫星定位信号差，停止仿线",
      "fr": ""
    },
    "0x16670003" : {
      "en": "Power Line Follow in progress. Stop task and try again",
      "zh": "仿线正在执行中，请停止仿线后重试",
      "fr": ""
    },
    "0x16670004" : {
      "en": "Power Line Follow not supported by current payload type",
      "zh": "当前负载类型不支持仿线",
      "fr": ""
    },
    "0x16670005" : {
      "en": "GNSS signal weak. Power Line Follow task stopped",
      "zh": "卫星定位信号差，停止仿线",
      "fr": ""
    },
    "0x16670006" : {
      "en": "Remote controller signal lost. Power Line Follow task stopped",
      "zh": "遥控器信号丢失，停止仿线",
      "fr": ""
    },
    "0x16670007" : {
      "en": "Power Line Follow not supported in S mode. Switch to N mode",
      "zh": "运动挡不支持仿线，请切换为 N 挡",
      "fr": ""
    },
    "0x16670101" : {
      "en": "Too close to obstacle. Power Line Follow task stopped",
      "zh": "障碍物距离过近，停止仿线",
      "fr": ""
    },
    "0x16670102" : {
      "en": "Approaching ground. Power Line Follow task stopped",
      "zh": "接近限低区，停止仿线",
      "fr": ""
    },
    "0x16670103" : {
      "en": "Approaching Altitude Zone. Power Line Follow task stopped",
      "zh": "接近限高区，停止仿线",
      "fr": ""
    },
    "0x16670104" : {
      "en": "Reaching max flight distance. Power Line Follow task stopped",
      "zh": "接近限远，停止仿线",
      "fr": ""
    },
    "0x16670105" : {
      "en": "Approaching GEO Zone. Power Line Follow task stopped",
      "zh": "接近限飞区，停止仿线",
      "fr": ""
    },
    "0x16670106" : {
      "en": "Approaching Altitude Zone. Power Line Follow task stopped",
      "zh": "接近限高区，停止仿线",
      "fr": ""
    },
    "0x16670107" : {
      "en": "Identifying power lines...",
      "zh": "线路识别中，请稍等",
      "fr": ""
    },
    "0x16670108" : {
      "en": "Identifying power lines...",
      "zh": "线路识别中，请稍等",
      "fr": ""
    },
    "0x16670201" : {
      "en": "Payload communication link error. Power Line Follow task stopped",
      "zh": "负载通信链路异常，停止仿线",
      "fr": ""
    },
    "0x16670202" : {
      "en": "LiDAR communication link error. Power Line Follow task stopped",
      "zh": "激光雷达通信链路异常，停止仿线",
      "fr": ""
    },
    "0x16670203" : {
      "en": "Error in receiving point cloud data. Power Line Follow task stopped",
      "zh": "点云数据接收异常，停止仿线",
      "fr": ""
    },
    "0x16670204" : {
      "en": "Point cloud recording stopped. Power Line Follow task stopped",
      "zh": "点云录制已停止，停止仿线",
      "fr": ""
    },
    "0x16670205" : {
      "en": "Storage full. Free up storage space before performing task",
      "zh": "存储卡已满，请整理存储卡后执行仿线任务",
      "fr": ""
    },
    "0x16670301" : {
      "en": "Flight speed of Power Line Follow exceeds limit. Confirm settings",
      "zh": "仿线飞行速度设置超出范围，请检查确认",
      "fr": ""
    },
    "0x16670302" : {
      "en": "Flight altitude of Power Line Follow exceeds limit. Confirm settings",
      "zh": "仿线飞行高度设置超出范围，请检查确认",
      "fr": ""
    },
    "0x16670303" : {
      "en": "Gimbal tilt angle exceeds limit. Confirm settings",
      "zh": "云台俯仰角设置超出范围，请检查确认",
      "fr": ""
    },
    "0x16670304" : {
      "en": "Failed to identify power lines. Try again",
      "zh": "已选路线识别失败，请重试",
      "fr": ""
    },
    "0x16670305" : {
      "en": "Failed to identify power lines. Try again",
      "zh": "已选路线识别失败，请重试",
      "fr": ""
    },
    "0x16670401" : {
      "en": "Failed to recenter gimbal. Try again",
      "zh": "云台回中失败，请重试",
      "fr": ""
    },
    "0x16670402" : {
      "en": "Failed to set gimbal tilt angle. Try again",
      "zh": "云台俯仰角设置失败，请重试",
      "fr": ""
    },
    "0x16670403" : {
      "en": "Failed to start recording point cloud. Try again",
      "zh": "开启点云录制失败，请重试",
      "fr": ""
    },
    "0x16670501" : {
      "en": "Power Line Follow task ended",
      "zh": "已结束仿线",
      "fr": ""
    },
    "0x16670502" : {
      "en": "Aircraft returning to home or landing. Power Line Follow task stopped",
      "zh": "开始返航或降落，停止仿线",
      "fr": ""
    },
    "0x16670503" : {
      "en": "Too close to crewed aircraft. Power Line Follow task stopped",
      "zh": "检测到客机距离过近，停止仿线",
      "fr": ""
    },
    "0x16670504" : {
      "en": "Power Line Follow task stopped",
      "zh": "仿线任务已终止",
      "fr": ""
    },
    "0x16670505" : {
      "en": "Failed to obtain camera view. Power Line Follow task stopped",
      "zh": "相机画面获取失败，停止仿线",
      "fr": ""
    },
    "0x16670506" : {
      "en": "Failed to calibrate IMU. Try again",
      "zh": "航向标定失败，请重试",
      "fr": ""
    },
    "0x17000001" : {
      "en": "Primary image transmission disconnected",
      "zh": "主链路图传已断开",
      "fr": ""
    },
    "0x17000001_in_the_sky" : {
      "en": "Primary image transmission disconnected. Adjust antennas",
      "zh": "主链路图传已断开，请尝试调整天线角度",
      "fr": ""
    },
    "0x17000002" : {
      "en": "Remote controller signal weak. Adjust antennas",
      "zh": "遥控器信号微弱，请调整天线",
      "fr": ""
    },
    "0x17000002_in_the_sky" : {
      "en": "Remote controller signal weak. Adjust antennas",
      "zh": "遥控器信号微弱，请调整天线",
      "fr": ""
    },
    "0x17000003" : {
      "en": "Strong signal interference in aircraft location. Fly with caution",
      "zh": "飞行器所在位置信号干扰较强，请谨慎飞行",
      "fr": ""
    },
    "0x17000003_in_the_sky" : {
      "en": "Strong signal interference in aircraft location. Fly with caution",
      "zh": "飞行器所在位置信号干扰较强，请谨慎飞行",
      "fr": ""
    },
    "0x17000004" : {
      "en": "Image transmission signal weak. Adjust antennas",
      "zh": "图传信号弱，请调整遥控器朝向飞行器",
      "fr": ""
    },
    "0x17000004_in_the_sky" : {
      "en": "Image transmission signal weak. Adjust antennas",
      "zh": "图传信号弱，请调整遥控器朝向飞行器",
      "fr": ""
    },
    "0x17000005" : {
      "en": "Strong signal interference in remote controller location. Fly with caution",
      "zh": "遥控器信号干扰较强，请注意飞行安全",
      "fr": ""
    },
    "0x17000005_in_the_sky" : {
      "en": "Strong signal interference in remote controller location. Fly with caution",
      "zh": "遥控器信号干扰较强，请注意飞行安全",
      "fr": ""
    },
    "0x17000006" : {
      "en": "Country code not updated. Certain features unavailable. Make sure GNSS signal is good and connect to DJI Pilot to update automatically",
      "zh": "国家码未更新，部分功能受限，请保证飞机卫星定位信号良好并连接 DJI Pilot 自动更新",
      "fr": ""
    },
    "0x17000006_in_the_sky" : {
      "en": "Country code not updated. Certain features unavailable",
      "zh": "国家码未更新，部分功能受限",
      "fr": ""
    },
    "0x17000011" : {
      "en": "Avionics system memory insufficient. Restart aircraft to restore",
      "zh": "航电系统内存低，请重启飞行器尝试恢复",
      "fr": ""
    },
    "0x17000011_in_the_sky" : {
      "en": "Avionics system memory insufficient. Fly with caution",
      "zh": "航电系统内存低，请谨慎飞行",
      "fr": ""
    },
    "0x17000013" : {
      "en": "Remote controller signal interference",
      "zh": "遥控器信号受干扰",
      "fr": ""
    },
    "0x17000014" : {
      "en": "Strong remote controller signal interference. Move away from other remote controllers or source of interference",
      "zh": "遥控器侧干扰较强，请远离其他遥控器或干扰源",
      "fr": ""
    },
    "0x17000015" : {
      "en": "Strong aircraft signal interference. Return to home promptly or move away from source of interference",
      "zh": "飞行器侧干扰较强，请尽快返航或飞离干扰源",
      "fr": ""
    },
    "0x17000016" : {
      "en": "Remote controller signal weak. Adjust antenna",
      "zh": "遥控器信号微弱，请尝试调整天线",
      "fr": ""
    },
    "0x17000017" : {
      "en": "Controller A signal weak. Make sure antennas of Controller A are unfolded and no obstacle is blocking aircraft and remote controller",
      "zh": "A控信号弱，请检查A控天线已展开并和飞机之间无遮挡",
      "fr": ""
    },
    "0x17000018" : {
      "en": "Controller B signal weak. Make sure antennas of controller B are unfolded and no obstacle is blocking aircraft and remote controller",
      "zh": "B控信号弱，请检查B控天线已展开并和飞机之间无遮挡",
      "fr": ""
    },
    "0x17000019" : {
      "en": "Camera error. Detach and remount gimbal",
      "zh": "相机异常，请尝试重新插拔云台",
      "fr": ""
    },
    "0x17000041" : {
      "en": "Unable to get control stick input",
      "zh": "无法获取遥控器杆量",
      "fr": ""
    },
    "0x17000071" : {
      "en": "Avionics system overloaded. Check whether logs are being transmitted. Restart aircraft to restore",
      "zh": "航电系统负载高，请重启飞行器尝试恢复",
      "fr": ""
    },
    "0x17000071_in_the_sky" : {
      "en": "Avionics system overloaded. Fly with caution",
      "zh": "航电系统负载高，请谨慎飞行",
      "fr": ""
    },
    "0x17000081" : {
      "en": "Avionics system memory insufficient. Restart aircraft to restore",
      "zh": "航电系统内存低，请重启飞行器尝试恢复",
      "fr": ""
    },
    "0x17000081_in_the_sky" : {
      "en": "Avionics system memory insufficient. Fly with caution",
      "zh": "航电系统内存低，请谨慎飞行",
      "fr": ""
    },
    "0x17010021" : {
      "en": "Flight controller error. Return to home promptly",
      "zh": "飞控系统异常，请尽快返航",
      "fr": ""
    },
    "0x17110041" : {
      "en": "Unable to obtain control stick input",
      "zh": "无法获取遥控器杆量信号",
      "fr": ""
    },
    "0x17110041_in_the_sky" : {
      "en": "Control stick input error. Fly with caution and land promptly",
      "zh": "遥控器杆量信号异常，请注意飞行安全，尽快降落",
      "fr": ""
    },
    "0x17200020" : {
      "en": "Winch system motor stalled",
      "zh": "空吊电机堵转",
      "fr": ""
    },
    "0x17200022" : {
      "en": "Winch system motor overloaded",
      "zh": "空吊电机过载",
      "fr": ""
    },
    "0x1720002B" : {
      "en": "Winch system ESC overheated",
      "zh": "空吊电调温度过高",
      "fr": ""
    },
    "0x1720002C" : {
      "en": "Winch system ESC voltage too high",
      "zh": "空吊电调电压过高",
      "fr": ""
    },
    "0x1720002D" : {
      "en": "Winch system ESC voltage too low",
      "zh": "空吊电调电压过低",
      "fr": ""
    },
    "0x1720002F" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200030" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200031" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200032" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200033" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200034" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200035" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200036" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x17200037" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x17200038" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x17200039" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x1720003A" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x1720003B" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x1720003C" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x1720003D" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x1720003E" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x1720003F" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200040" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x17200041" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x17200042" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x17200043" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x17200044" : {
      "en": "Winch system ESC voltage too low",
      "zh": "空吊电调电压过低",
      "fr": ""
    },
    "0x17200045" : {
      "en": "Winch system ESC voltage too high",
      "zh": "空吊电调电压过高",
      "fr": ""
    },
    "0x17200046" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200047" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200048" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200049" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x1720004A" : {
      "en": "Winch system ESC overheated",
      "zh": "空吊电调温度过高",
      "fr": ""
    },
    "0x1720004B" : {
      "en": "Winch system ESC temperature too low",
      "zh": "空吊电调温度过低",
      "fr": ""
    },
    "0x1720004C" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x1720004D" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x1720004E" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x17200055" : {
      "en": "Winch system motor may be overheated. Do not quickly reel up and down when aircraft is loaded",
      "zh": "空吊电机存在超温风险，不要反复带载快速收放",
      "fr": ""
    },
    "0x17200056" : {
      "en": "Winch system motor severely overheated. Aircraft will land automatically",
      "zh": "空吊电机严重超温，待电机冷却后重启使用",
      "fr": ""
    },
    "0x17200058" : {
      "en": "Winch system ESC speed and current error",
      "zh": "空吊电调转速、电流异常",
      "fr": ""
    },
    "0x1720005D" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x1720005E" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x17200077" : {
      "en": "Winch system ESC severely overheated",
      "zh": "空吊电调严重超温",
      "fr": ""
    },
    "0x17200078" : {
      "en": "Winch system ESC severely overheated",
      "zh": "空吊电调严重超温",
      "fr": ""
    },
    "0x17200079" : {
      "en": "Winch system ESC firmware incompatible with aircraft model",
      "zh": "空吊电调固件与飞机机型不匹配",
      "fr": ""
    },
    "0x1720007B" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x1720007C" : {
      "en": "Winch system ESC auto-check error",
      "zh": "空吊电调自检异常",
      "fr": ""
    },
    "0x1720007D" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x1720007E" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x1720007F" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200080" : {
      "en": "Winch system ESC or motor auto-check error",
      "zh": "空吊电调或电机自检异常",
      "fr": ""
    },
    "0x17200083" : {
      "en": "Winch system ESC calibration failed",
      "zh": "空吊电调校准失败",
      "fr": ""
    },
    "0x17200200" : {
      "en": "Cable stuck or reversely reeled in. Enable repair mode to manually unwind cable",
      "zh": "空吊系统绕线卡塞或反转，请开启检修模式，整理绕线",
      "fr": ""
    },
    "0x17200201" : {
      "en": "Cable cutter of winch system damaged. Replace cable cutter promptly. Otherwise, flight safety will be affected",
      "zh": "空吊系统熔断器损坏，请及时更换，否则影响飞行安全",
      "fr": ""
    },
    "0x17200201_in_the_sky" : {
      "en": "Cable cutter of winch system damaged. Replace cable cutter promptly. Otherwise, flight safety will be affected",
      "zh": "空吊系统熔断器损坏，请及时更换，否则影响飞行安全",
      "fr": ""
    },
    "0x17200202" : {
      "en": "Winch reeling down without payload. Attach payload",
      "zh": "空吊系统空载放线，请带载放线",
      "fr": ""
    },
    "0x17200203" : {
      "en": "Winch system motor not calibrated. Calibrate motor",
      "zh": "空吊系统电机未校准，请校准再工作",
      "fr": ""
    },
    "0x17200204" : {
      "en": "Winch system triaxial force sensor not calibrated. Calibrate sensor",
      "zh": "空吊系统三向力未校准，请校准再工作",
      "fr": ""
    },
    "0x17200205" : {
      "en": "Winch system cable length not calibrated. Calibrate cable length",
      "zh": "空吊系统绳长未校准，请校准再工作",
      "fr": ""
    },
    "0x17200206" : {
      "en": "Winch brake hardware damaged. Restart aircraft and try again",
      "zh": "空吊系统制动器硬件已损坏，尝试重启后再工作",
      "fr": ""
    },
    "0x17200207" : {
      "en": "Winch brake auto-check error. Unable to take off",
      "zh": "空吊系统制动器自检异常，无法起飞",
      "fr": ""
    },
    "0x17200208" : {
      "en": "Winch cable auto-check error. Check if cable is wound in reverse direction or not secure",
      "zh": "空吊系统线绳自检异常，起飞前请确认是否反绕或不在位",
      "fr": ""
    },
    "0x17200209" : {
      "en": "Winch limit switch auto-check error. Stop propellers and rotate dial manually. Make sure winch system motor works properly",
      "zh": "空吊系统在位开关自检异常，请停桨手动波轮，观察空吊电机是否正常运行",
      "fr": ""
    },
    "0x1720020A" : {
      "en": "Winch limit switch error. Check if the switch is stuck or damaged",
      "zh": "空吊在位开关功能异常，请检查在位开关是否粘连或损坏",
      "fr": ""
    },
    "0x17210000" : {
      "en": "Parachute sensor error",
      "zh": "降落伞传感器异常",
      "fr": ""
    },
    "0x17210001" : {
      "en": "Parachute igniter error",
      "zh": "降落伞点火器异常",
      "fr": ""
    },
    "0x17210002" : {
      "en": "Parachute connection error",
      "zh": "降落伞链路异常",
      "fr": ""
    },
    "0x17210003" : {
      "en": "Parachute igniter communication error",
      "zh": "降落伞点火器通信异常",
      "fr": ""
    },
    "0x17210004" : {
      "en": "Parachute igniter connection error",
      "zh": "降落伞点火器连接异常",
      "fr": ""
    },
    "0x17210005" : {
      "en": "Parachute igniter voltage error",
      "zh": "降落伞点火器电压异常",
      "fr": ""
    },
    "0x17210006" : {
      "en": "Parachute igniter resistance error",
      "zh": "降落伞点火器电阻异常",
      "fr": ""
    },
    "0x17210007" : {
      "en": "Parachute ignition error",
      "zh": "降落伞点火器点火异常",
      "fr": ""
    },
    "0x17210008" : {
      "en": "Parachute IMU communication error",
      "zh": "降落伞IMU通信异常",
      "fr": ""
    },
    "0x17210009" : {
      "en": "Parachute IMU connection error",
      "zh": "降落伞IMU连接异常",
      "fr": ""
    },
    "0x1721000A" : {
      "en": "Parachute barometer communication error",
      "zh": "降落伞气压计通信异常",
      "fr": ""
    },
    "0x1721000B" : {
      "en": "Parachute internal storage error",
      "zh": "降落伞机身存储异常",
      "fr": ""
    },
    "0x1721000C" : {
      "en": "Parachute control error",
      "zh": "降落伞控制链路异常",
      "fr": ""
    },
    "0x1721000D" : {
      "en": "Parachute connection error",
      "zh": "降落伞融合链路异常",
      "fr": ""
    },
    "0x1721000E" : {
      "en": "Parachute speed deviation too large",
      "zh": "降落伞融合速度误差大",
      "fr": ""
    },
    "0x1721000F" : {
      "en": "Parachute built-in battery voltage too low",
      "zh": "降落伞内置电池电压过低",
      "fr": ""
    },
    "0x17210010" : {
      "en": "Parachute Built-in Battery Overheated",
      "zh": "降落伞内置电池温度过高",
      "fr": ""
    },
    "0x17210011" : {
      "en": "Parachute File System Error",
      "zh": "降落伞文件系统异常",
      "fr": ""
    },
    "0x17210013" : {
      "en": "Parachute deployed",
      "zh": "降落伞已开伞",
      "fr": ""
    },
    "0x17210020" : {
      "en": "Parachute opened. Watch out for pedestrians nearby",
      "zh": "降落伞已经开伞，请注意周围行人安全",
      "fr": ""
    },
    "0x19000001" : {
      "en": "Avionics system overloaded. Check whether logs are being transmitted. Restart aircraft to restore",
      "zh": "航电系统负载高，请确认是否正在进行日志回传操作，可以重启飞行器尝试恢复",
      "fr": ""
    },
    "0x19000001_in_the_sky" : {
      "en": "Avionics system overloaded. Fly with caution",
      "zh": "航电系统负载高，请谨慎飞行",
      "fr": ""
    },
    "0x19000002" : {
      "en": "Avionics system overloaded. Check whether logs are being transmitted. Restart aircraft to restore",
      "zh": "航电系统负载高，请确认是否正在进行日志回传操作，可以重启飞行器尝试恢复",
      "fr": ""
    },
    "0x19000002_in_the_sky" : {
      "en": "Avionics system overloaded. Fly with caution",
      "zh": "航电系统负载高，请谨慎飞行",
      "fr": ""
    },
    "0x19000003" : {
      "en": "存在业务cpu loading超限",
      "zh": "存在业务cpu loading超限",
      "fr": ""
    },
    "0x19000004" : {
      "en": "存在业务内存资源使用超限",
      "zh": "存在业务内存资源使用超限",
      "fr": ""
    },
    "0x19000005" : {
      "en": "中断频率过高",
      "zh": "中断频率过高",
      "fr": ""
    },
    "0x19000006" : {
      "en": "内存申请失败",
      "zh": "内存申请失败",
      "fr": ""
    },
    "0x19000007" : {
      "en": "rt进程cpu loading过高",
      "zh": "rt进程cpu loading过高",
      "fr": ""
    },
    "0x19000008" : {
      "en": "系统内存不足",
      "zh": "系统内存不足",
      "fr": ""
    },
    "0x19000009" : {
      "en": "系统内存严重不足",
      "zh": "系统内存严重不足",
      "fr": ""
    },
    "0x1900000A" : {
      "en": "rcu stall异常",
      "zh": "rcu stall异常",
      "fr": ""
    },
    "0x1900000B" : {
      "en": "进程长期处于D状态",
      "zh": "进程长期处于D状态",
      "fr": ""
    },
    "0x1900000C" : {
      "en": "原子操作异常",
      "zh": "原子操作异常",
      "fr": ""
    },
    "0x1900000D" : {
      "en": "自旋锁操作异常",
      "zh": "自旋锁操作异常",
      "fr": ""
    },
    "0x19000011" : {
      "en": "Avionics system memory insufficient. Restart aircraft to restore",
      "zh": "航电系统内存低，请重启飞行器尝试恢复",
      "fr": ""
    },
    "0x19000011_in_the_sky" : {
      "en": "Avionics system memory insufficient. Fly with caution",
      "zh": "航电系统内存低，请谨慎飞行",
      "fr": ""
    },
    "0x19000012" : {
      "en": "Avionics system memory insufficient. Restart aircraft to restore",
      "zh": "航电系统内存低，请重启飞行器尝试恢复",
      "fr": ""
    },
    "0x19000012_in_the_sky" : {
      "en": "Avionics system memory insufficient. Fly with caution",
      "zh": "航电系统内存低，请谨慎飞行",
      "fr": ""
    },
    "0x19000020" : {
      "en": "camera进程异常崩溃",
      "zh": "camera进程异常",
      "fr": ""
    },
    "0x19000021" : {
      "en": "Avionics system error. Restart aircraft to restore",
      "zh": "相机回放进程异常",
      "fr": ""
    },
    "0x19000021_in_the_sky" : {
      "en": "Avionics system error. Fly with caution",
      "zh": "相机回放进程异常",
      "fr": ""
    },
    "0x19000022" : {
      "en": "Avionics system error. Restart aircraft to restore",
      "zh": "相机音频进程异常",
      "fr": ""
    },
    "0x19000022_in_the_sky" : {
      "en": "Avionics system error. Fly with caution",
      "zh": "相机音频进程异常",
      "fr": ""
    },
    "0x19000023" : {
      "en": "相机麦克风进程异常奔溃",
      "zh": "相机麦克风进程异常",
      "fr": ""
    },
    "0x19000024" : {
      "en": "相机进程异常崩溃",
      "zh": "相机进程异常崩溃",
      "fr": ""
    },
    "0x19000025" : {
      "en": "相机进程发生crash，请拉日志分析",
      "zh": "相机进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x19000026" : {
      "en": "相机进程发生crash，请拉日志分析",
      "zh": "相机进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x19000027" : {
      "en": "相机进程发生crash，请拉日志分析",
      "zh": "相机进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x19000028" : {
      "en": "嵌入式dji_sys进程异常崩溃",
      "zh": "嵌入式dji_sys进程异常崩溃",
      "fr": ""
    },
    "0x19000029" : {
      "en": "嵌入式日志进程异常崩溃",
      "zh": "嵌入式日志进程异常崩溃",
      "fr": ""
    },
    "0x1900002A" : {
      "en": "嵌入式图传进程异常崩溃",
      "zh": "嵌入式图传进程异常崩溃",
      "fr": ""
    },
    "0x1900002B" : {
      "en": "嵌入式进程异常崩溃",
      "zh": "嵌入式进程异常崩溃",
      "fr": ""
    },
    "0x1900002C" : {
      "en": "嵌入式进程dji_gateway异常崩溃",
      "zh": "嵌入式进程dji_gateway异常崩溃",
      "fr": ""
    },
    "0x1900002D" : {
      "en": "进程发生crash，请拉日志分析",
      "zh": "进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x1900002E" : {
      "en": "进程发生crash，请拉日志分析",
      "zh": "进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x1900002F" : {
      "en": "相机进程发生crash，请拉日志分析",
      "zh": "相机进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x19000030" : {
      "en": "飞行系统感知进程异常崩溃",
      "zh": "飞行系统感知进程异常崩溃",
      "fr": ""
    },
    "0x19000031" : {
      "en": "Unable to take off. Clear data and restart aircraft",
      "zh": "无法起飞：数据清除完成后需重启飞行器",
      "fr": ""
    },
    "0x19000031_in_the_sky" : {
      "en": "Restart aircraft after clearing data",
      "zh": "数据清除完成后需重启飞行器",
      "fr": ""
    },
    "0x19000032" : {
      "en": "飞行系统进程异常崩溃",
      "zh": "飞行系统进程异常崩溃",
      "fr": ""
    },
    "0x19000033" : {
      "en": "飞行系统rtk_fusion进程异常崩溃",
      "zh": "飞行系统rtk_fusion进程异常崩溃",
      "fr": ""
    },
    "0x19000034" : {
      "en": "CRobot进程异常崩溃",
      "zh": "CRobot进程异常崩溃",
      "fr": ""
    },
    "0x19000035" : {
      "en": "进程发生crash，请拉日志分析",
      "zh": "进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x19000036" : {
      "en": "机器学习进程异常崩溃",
      "zh": "机器学习进程异常崩溃",
      "fr": ""
    },
    "0x19000037" : {
      "en": "进程发生crash，请拉日志分析",
      "zh": "进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x19000038" : {
      "en": "进程发生crash，请拉日志分析",
      "zh": "进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x19000039" : {
      "en": "电池进程异常崩溃",
      "zh": "电池进程异常崩溃",
      "fr": ""
    },
    "0x1900003A" : {
      "en": "进程发生crash，请拉日志分析",
      "zh": "进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x1900003B" : {
      "en": "进程发生crash，请拉日志分析",
      "zh": "进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x1900003C" : {
      "en": "激光雷达进程进程异常崩溃",
      "zh": "激光雷达进程进程异常崩溃",
      "fr": ""
    },
    "0x1900003D" : {
      "en": "进程发生crash，请拉日志分析",
      "zh": "进程发生crash，请拉日志分析",
      "fr": ""
    },
    "0x1900003E" : {
      "en": "System panic",
      "zh": "系统panic",
      "fr": ""
    },
    "0x1900003F" : {
      "en": "进程异常崩溃",
      "zh": "进程异常崩溃",
      "fr": ""
    },
    "0x19000041" : {
      "en": "USB connection detected. Unable to take off. Disconnect USB cable and restart aircraft",
      "zh": "无法起飞：连接USB阻飞，请拔下USB后重启飞行器尝试恢复",
      "fr": ""
    },
    "0x19000041_in_the_sky" : {
      "en": "USB connection detected. Fly with caution and land promptly",
      "zh": "连接USB，请谨慎飞行并尽快降落",
      "fr": ""
    },
    "0x19000042" : {
      "en": "Unable to take off. Clear data and restart aircraft",
      "zh": "无法起飞：清除数据阻飞，请数据清除完成后重启飞行器",
      "fr": ""
    },
    "0x19000042_in_the_sky" : {
      "en": "Restart aircraft after clearing data",
      "zh": "清除数据中，请谨慎飞行并尽快降落",
      "fr": ""
    },
    "0x19000051" : {
      "en": "Firmware updating. Unable to take off. Wait for update to complete",
      "zh": "无法起飞：固件升级中，请等待固件升级完成",
      "fr": ""
    },
    "0x19000051_in_the_sky" : {
      "en": "Firmware updating. Fly with caution and land promptly",
      "zh": "固件升级中，请谨慎飞行并尽快降落",
      "fr": ""
    },
    "0x19000060" : {
      "en": "Selinux permission check error",
      "zh": "Selinux 权限检查错误",
      "fr": ""
    },
    "0x19000061" : {
      "en": "Selinux permission check errors",
      "zh": "Selinux 权限检查错误",
      "fr": ""
    },
    "0x19000070" : {
      "en": "File system error. File may be damaged or storage card may be removed. Remove and insert storage card or format storage card",
      "zh": "文件系统异常:文件可能损坏或存储卡异常拔出，建议尝试拔插存储卡或格式化",
      "fr": ""
    },
    "0x190003ED" : {
      "en": "dji_wlm_slave cpu loading超限",
      "zh": "dji_wlm_slave cpu loading超限",
      "fr": ""
    },
    "0x190003EE" : {
      "en": "logd loading 超限",
      "zh": "logd loading 超限",
      "fr": ""
    },
    "0x190003EF" : {
      "en": "dji_autoflight cpu loading 超限",
      "zh": "dji_autoflight cpu loading 超限",
      "fr": ""
    },
    "0x190003F1" : {
      "en": "dji_sdrs_agent cpu loading 超限",
      "zh": "dji_sdrs_agent cpu loading 超限",
      "fr": ""
    },
    "0x190003F2" : {
      "en": "dji_lte cpu loading超限",
      "zh": "dji_lte cpu loading超限",
      "fr": ""
    },
    "0x190003F3" : {
      "en": "dji_wlm cpu loading超限",
      "zh": "dji_wlm cpu loading超限",
      "fr": ""
    },
    "0x190003F5" : {
      "en": "dji_nn_server loading超限",
      "zh": "dji_nn_server loading超限",
      "fr": ""
    },
    "0x190003F6" : {
      "en": "dji_ml cpu loading超限",
      "zh": "dji_ml cpu loading超限",
      "fr": ""
    },
    "0x190003F9" : {
      "en": "dji_media_server cpu loading 超限",
      "zh": "dji_media_server cpu loading 超限",
      "fr": ""
    },
    "0x190003FB" : {
      "en": "dji_rcam cpu loading  超限",
      "zh": "dji_rcam cpu loading  超限",
      "fr": ""
    },
    "0x190003FC" : {
      "en": "dji_camera cpu loading超限",
      "zh": "dji_camera cpu loading超限",
      "fr": ""
    },
    "0x190003FD" : {
      "en": "dji_perception cpu loading超限",
      "zh": "dji_perception cpu loading超限",
      "fr": ""
    },
    "0x190003FE" : {
      "en": "dji_blackbox loading超限",
      "zh": "dji_blackbox loading超限",
      "fr": ""
    },
    "0x190003FF" : {
      "en": "dji_sys loading超限",
      "zh": "dji_sys loading超限",
      "fr": ""
    },
    "0x19000400" : {
      "en": "SD异常",
      "zh": "SD异常",
      "fr": ""
    },
    "0x19000401" : {
      "en": "",
      "zh": "存储：sd卡状态异常（一直busy）",
      "fr": ""
    },
    "0x19000402" : {
      "en": "",
      "zh": "存储：sd卡进入hw reset并失败",
      "fr": ""
    },
    "0x19000403" : {
      "en": "",
      "zh": "存储：sd卡进入hw reset并成功",
      "fr": ""
    },
    "0x19000600" : {
      "en": "",
      "zh": "存储：访问无效的文件系统cluster",
      "fr": ""
    },
    "0x19000601" : {
      "en": "",
      "zh": "存储：访问无效的文件系统目录项",
      "fr": ""
    },
    "0x19000602" : {
      "en": "",
      "zh": "存储：访问无效的文件系统FAT表",
      "fr": ""
    },
    "0x19000603" : {
      "en": "",
      "zh": "存储：尝试截断零簇",
      "fr": ""
    },
    "0x19000604" : {
      "en": "",
      "zh": "存储：不允许分配cluster",
      "fr": ""
    },
    "0x19000605" : {
      "en": "",
      "zh": "存储：文件大小超过FAT表",
      "fr": ""
    },
    "0x19000606" : {
      "en": "",
      "zh": "存储：破损的FAT表",
      "fr": ""
    },
    "0x19000607" : {
      "en": "",
      "zh": "存储：新分配的虚假cluster",
      "fr": ""
    },
    "0x19000608" : {
      "en": "",
      "zh": "存储：请求的bmap超出范围",
      "fr": ""
    },
    "0x19000609" : {
      "en": "",
      "zh": "存储：非法的大小",
      "fr": ""
    },
    "0x1900060A" : {
      "en": "",
      "zh": "存储：文件大小超出FAT表",
      "fr": ""
    },
    "0x1900060B" : {
      "en": "",
      "zh": "存储：非空大小的文件起始于一个空cluster",
      "fr": ""
    },
    "0x19000700" : {
      "en": "File system error. File may be damaged or storage card may be removed. Remove and insert storage card or format storage card",
      "zh": "文件系统异常:文件可能损坏或存储卡异常拔出，建议尝试拔插存储卡或格式化",
      "fr": ""
    },
    "0x19000701" : {
      "en": "磁盘扫描异常",
      "zh": "磁盘扫描异常",
      "fr": ""
    },
    "0x19000702" : {
      "en": "File system error",
      "zh": "文件系统检查异常",
      "fr": ""
    },
    "0x19000703" : {
      "en": "SD card not recommended. User experience may be\n affected",
      "zh": "SD卡为非推荐卡，可能会影响使用体验",
      "fr": ""
    },
    "0x19000800" : {
      "en": "Aircraft fan %index error. Check whether fan is stalled",
      "zh": "机身%index号风扇异常，请检查飞行器风扇是否有堵转",
      "fr": ""
    },
    "0x19000801" : {
      "en": "Camera fan error. Check whether fan is stalled",
      "zh": "相机风扇异常，请检查相机风扇是否有堵转",
      "fr": ""
    },
    "0x19000802" : {
      "en": "Camera processor overheated. Wait for camera processor to cool down before use",
      "zh": "相机芯片温度过高，请待冷却后使用",
      "fr": ""
    },
    "0x19000803" : {
      "en": "Camera overheated. Recording will stop soon. Wait for camera to cool down before use",
      "zh": "相机温度过高，将无法录制，请待冷却后使用",
      "fr": ""
    },
    "0x19000810" : {
      "en": "Aircraft in low-power state",
      "zh": "飞机进入低功耗模式",
      "fr": ""
    },
    "0x19000811" : {
      "en": "Air unit in low-power state",
      "zh": "air unit处于低功耗状态",
      "fr": ""
    },
    "0x19000C00" : {
      "en": "Connection error between avionics board and radio frequency board. Downward radar and video transmission performance may be affected",
      "zh": "航电板与射频板连接异常，可能影响下雷达与图传",
      "fr": ""
    },
    "0x1900E001" : {
      "en": "Log storage space insufficient. Unable to store logs",
      "zh": "日志空间不足，避免无法存储日志",
      "fr": ""
    },
    "0x1900E002" : {
      "en": "Log data missing",
      "zh": "日志数据丢失",
      "fr": ""
    },
    "0x1900E003" : {
      "en": "Log data missing",
      "zh": "日志数据丢失",
      "fr": ""
    },
    "0x1900E004" : {
      "en": "Storage device mounting error",
      "zh": "存储设备挂载异常",
      "fr": ""
    },
    "0x1900F001" : {
      "en": "Goggles only support motion controller",
      "zh": "眼镜只支持穿越摇杆飞行",
      "fr": ""
    },
    "0x19018001" : {
      "en": "System in factory mode",
      "zh": "系统处于工厂模式",
      "fr": ""
    },
    "0x1901C080" : {
      "en": "Current aircraft does not support working with both Zenmuse L2 and H30 series. Use one of the payloads separately",
      "zh": "当前飞行器不支持H30系列和L2同时工作，请单独挂载使用",
      "fr": ""
    },
    "0x1901C081" : {
      "en": "Current aircraft does not support working with more than one Zenmuse H30 series payload. Use one of the payloads separately",
      "zh": "当前飞行器不支持多个H30系列同时工作，请单独挂载使用",
      "fr": ""
    },
    "0x1901C082" : {
      "en": "Current aircraft does not support working with more than one Zenmuse L2 payload. Use one of the payloads separately",
      "zh": "当前飞行器不支持多个L2同时工作，请单独挂载使用",
      "fr": ""
    },
    "0x19100041" : {
      "en": "Livestream network connection unavailable",
      "zh": "视频直播网络不通",
      "fr": ""
    },
    "0x19100041_in_the_sky" : {
      "en": "No livestream network connection",
      "zh": "视频直播网络不通",
      "fr": ""
    },
    "0x19100042" : {
      "en": "Livestream registration password error",
      "zh": "视频直播注册密码错误",
      "fr": ""
    },
    "0x19100042_in_the_sky" : {
      "en": "Incorrect livestream registration password",
      "zh": "视频直播注册密码错误",
      "fr": ""
    },
    "0x19100043" : {
      "en": "Livestream registration timed out",
      "zh": "视频直播注册超时",
      "fr": ""
    },
    "0x19100043_in_the_sky" : {
      "en": "Livestream registration timed out",
      "zh": "视频直播注册超时",
      "fr": ""
    },
    "0x19100044" : {
      "en": "Livestream channel %d connection failed",
      "zh": "直播通道%d连接失败",
      "fr": ""
    },
    "0x19100044_in_the_sky" : {
      "en": "Failed to connect to livestream channel %d",
      "zh": "直播通道%d连接失败",
      "fr": ""
    },
    "0x19100045" : {
      "en": "Livestream channel %d URL parameter format error",
      "zh": "直播通道%d URL参数格式错误",
      "fr": ""
    },
    "0x19100045_in_the_sky" : {
      "en": "Livestream channel %d URL parameter format error",
      "zh": "直播通道%d URL参数格式错误",
      "fr": ""
    },
    "0x19100051" : {
      "en": "Selecting livestream channel %d timed out",
      "zh": "直播通道%d点播超时",
      "fr": ""
    },
    "0x19100051_in_the_sky" : {
      "en": "Livestream channel %d timed out",
      "zh": "直播通道%d点播超时",
      "fr": ""
    },
    "0x19100052" : {
      "en": "Selecting livestream channel %d. Parameters error",
      "zh": "直播通道%d点播参数错误",
      "fr": ""
    },
    "0x19100052_in_the_sky" : {
      "en": "Livestream channel %d parameter error",
      "zh": "直播通道%d点播参数错误",
      "fr": ""
    },
    "0x19100053" : {
      "en": "Selecting livestream channel %d received no response",
      "zh": "直播通道%d点播未响应",
      "fr": ""
    },
    "0x19100053_in_the_sky" : {
      "en": "Livestream channel %d timed out",
      "zh": "直播通道%d点播未响应",
      "fr": ""
    },
    "0x19100054" : {
      "en": "删除",
      "zh": "直播通道%d长时间未有点播",
      "fr": ""
    },
    "0x19100054_in_the_sky" : {
      "en": "Livestream channel %d timed out",
      "zh": "直播通道%d长时间未有点播",
      "fr": ""
    },
    "0x19100055" : {
      "en": "Livestream channel %d successfully selected. No streaming data",
      "zh": "直播通道%d点播成功，无视频流数据",
      "fr": ""
    },
    "0x19100055_in_the_sky" : {
      "en": "Livestream channel %d connected. No streaming data yet",
      "zh": "直播通道%d点播成功，但未有视频流发送",
      "fr": ""
    },
    "0x19100056" : {
      "en": "Livestream channel %d bit rate error",
      "zh": "直播通道%d直播码率异常",
      "fr": ""
    },
    "0x19100056_in_the_sky" : {
      "en": "Livestream channel %d bit rate error",
      "zh": "直播通道%d直播码率过大或者过小",
      "fr": ""
    },
    "0x19100057" : {
      "en": "Livestream channel %d frame rate error",
      "zh": "直播通道%d直播帧率异常",
      "fr": ""
    },
    "0x19100057_in_the_sky" : {
      "en": "Livestream channel %d frame rate error",
      "zh": "直播通道%d直播帧率过大或者过小",
      "fr": ""
    },
    "0x19100058" : {
      "en": "Livestream channel %d data sending error",
      "zh": "直播通道%d视频数据发送失败",
      "fr": ""
    },
    "0x19100058_in_the_sky" : {
      "en": "Failed to send livestream channel %d data",
      "zh": "直播通道%d视频数据发送失败",
      "fr": ""
    },
    "0x19100071" : {
      "en": "Livestream channel %d losing data packet",
      "zh": "直播通道%d网络持续丢包",
      "fr": ""
    },
    "0x19100071_in_the_sky" : {
      "en": "Livestream channel %d packet loss",
      "zh": "直播通道%d网络持续丢包",
      "fr": ""
    },
    "0x19100072" : {
      "en": "Livestream channel %d experiencing high network latency",
      "zh": "直播通道%d网络延迟大",
      "fr": ""
    },
    "0x19100072_in_the_sky" : {
      "en": "Network latency on livestream channel %d",
      "zh": "直播通道%d网络延迟大",
      "fr": ""
    },
    "0x19100073" : {
      "en": "Livestream channel %d experiencing high network jitter",
      "zh": "直播通道%d网络抖动明显",
      "fr": ""
    },
    "0x19100073_in_the_sky" : {
      "en": "Network jitter on livestream channel %d",
      "zh": "直播通道%d网络抖动明显",
      "fr": ""
    },
    "0x19100074" : {
      "en": "Livestream channel %d experiencing network congestion",
      "zh": "直播通道%d出现网络拥塞",
      "fr": ""
    },
    "0x19100074_in_the_sky" : {
      "en": "Network congestion on livestream channel %d",
      "zh": "直播通道%d出现网络拥塞",
      "fr": ""
    },
    "0x19100081" : {
      "en": "Livestream metadata transfer frequency error",
      "zh": "视频直播扩展数据回传频率异常",
      "fr": ""
    },
    "0x19100081_in_the_sky" : {
      "en": "Livestream metadata transfer frequency error",
      "zh": "视频直播扩展数据回传频率异常",
      "fr": ""
    },
    "0x19100082" : {
      "en": "Livestream unable to get metadata",
      "zh": "视频直播未收到扩展数据",
      "fr": ""
    },
    "0x19100082_in_the_sky" : {
      "en": "Failed to send metadata",
      "zh": "视频直播未收到扩展数据",
      "fr": ""
    },
    "0x19100083" : {
      "en": "Livestream unable to get aircraft location",
      "zh": "视频直播无法获取无人机位置",
      "fr": ""
    },
    "0x19100083_in_the_sky" : {
      "en": "Failed to send aircraft location info",
      "zh": "视频直播无法获取无人机位置",
      "fr": ""
    },
    "0x1910F003" : {
      "en": "Dock external security camera not installed or disconnected",
      "zh": "机场舱外监控摄像头未安装或断连",
      "fr": ""
    },
    "0x19110000" : {
      "en": "Dock %1$s cover motor stalled",
      "zh": "%1$s舱盖电机堵转",
      "fr": ""
    },
    "0x19110002" : {
      "en": "Dock %1$s cover excessive position error",
      "zh": "%1$s舱盖位置误差过大",
      "fr": ""
    },
    "0x19110003" : {
      "en": "Dock %1$s cover motor overspeed",
      "zh": "%1$s舱盖电机运动超速",
      "fr": ""
    },
    "0x19110004" : {
      "en": "Dock %1$s cover motor out of control",
      "zh": "%1$s舱盖电机无法控制",
      "fr": ""
    },
    "0x19110005" : {
      "en": "Dock %1$s cover motor voltage too low",
      "zh": "%1$s舱盖电机电压过低",
      "fr": ""
    },
    "0x19110006" : {
      "en": "Dock %1$s cover motor voltage too high",
      "zh": "%1$s舱盖电机电压过高",
      "fr": ""
    },
    "0x1911000F" : {
      "en": "Dock %1$s cover motor driver communication error",
      "zh": "%1$s舱盖驱动器通讯异常",
      "fr": ""
    },
    "0x19110011" : {
      "en": "Dock %1$s cover unknown error",
      "zh": "%1$s舱盖运行未知错误",
      "fr": ""
    },
    "0x19110012" : {
      "en": "Calibrating dock %dock_cover_index cover or position calibration data error",
      "zh": "%1$s舱盖位置校准数据错误",
      "fr": ""
    },
    "0x19110013" : {
      "en": "Dock %1$s cover not properly open or closed",
      "zh": "%1$s舱盖开启或关闭时位置不到位",
      "fr": ""
    },
    "0x19110014" : {
      "en": "Opening dock %1$s cover timed out",
      "zh": "%1$s舱盖开启超时",
      "fr": ""
    },
    "0x19110015" : {
      "en": "Closing dock %1$s cover timed out",
      "zh": "%1$s舱盖关闭超时",
      "fr": ""
    },
    "0x19110016" : {
      "en": "Dock %1$s cover stalled. Failed to close",
      "zh": "%1$s舱盖关闭时触发防夹，未成功关闭",
      "fr": ""
    },
    "0x19110017" : {
      "en": "Dock %1$s cover stalled. Failed to open",
      "zh": "%1$s舱盖开启时触发防夹，未成功开启",
      "fr": ""
    },
    "0x19110020" : {
      "en": "%s dock cover Hall sensor error",
      "zh": "%s舱盖霍尔传感器故障",
      "fr": ""
    },
    "0x19110021" : {
      "en": "Opening or closing %s dock cover timed out",
      "zh": "%s舱盖开启或关闭超时",
      "fr": ""
    },
    "0x19110022" : {
      "en": "Pinch protection triggered when opening or closing dock %dock_cover_index cover",
      "zh": "%s舱盖打开或关闭时触发防夹",
      "fr": ""
    },
    "0x19110023" : {
      "en": "Driving rod of %s dock cover voltage too low",
      "zh": "%s舱盖推杆电压过低",
      "fr": ""
    },
    "0x19110024" : {
      "en": "Driving rod of %s dock cover disconnected",
      "zh": "%s舱盖推杆断线",
      "fr": ""
    },
    "0x19110025" : {
      "en": "%s driving rod short-circuited",
      "zh": "%s推杆短路",
      "fr": ""
    },
    "0x19110026" : {
      "en": "%s driving rod temperature too high",
      "zh": "%s推杆温度过高",
      "fr": ""
    },
    "0x19110027" : {
      "en": "%s dock cover error",
      "zh": "%s舱盖异常",
      "fr": ""
    },
    "0x19110028" : {
      "en": "%s flight pause button error",
      "zh": "%s急停按钮故障",
      "fr": ""
    },
    "0x19110029" : {
      "en": "%s dock cover command execution failed",
      "zh": "%s舱盖命令执行失败",
      "fr": ""
    },
    "0x1911002A" : {
      "en": "%s dock cover not sealed",
      "zh": "%s舱盖未处于密封状态",
      "fr": ""
    },
    "0x1911002D" : {
      "en": "Dock %dock_cover_index cover positioning error",
      "zh": "%dock_cover_index位置功能异常",
      "fr": ""
    },
    "0x19110400" : {
      "en": "Dock %1$s driving rod position calibration data error",
      "zh": "%1$s推杆位置标定数据错误",
      "fr": ""
    },
    "0x19110401" : {
      "en": "Dock %1$s driving rod steering gear stalled",
      "zh": "%1$s推杆舵机堵转",
      "fr": ""
    },
    "0x19110402" : {
      "en": "Excessive resistance in steering %1$s driving rod",
      "zh": "%1$s推杆舵机阻力过大",
      "fr": ""
    },
    "0x19110403" : {
      "en": "Dock %1$s driving rod steering gear overheated",
      "zh": "%1$s推杆舵机温度过高",
      "fr": ""
    },
    "0x19110404" : {
      "en": "Dock %1$s driving rod steering gear communication error",
      "zh": "%1$s推杆舵机通讯异常",
      "fr": ""
    },
    "0x19110405" : {
      "en": "Dock %1$s driving rod steering gear internal error",
      "zh": "%1$s推杆舵机内部错误",
      "fr": ""
    },
    "0x19110406" : {
      "en": "Dock %1$s driving rod internal limit switch error",
      "zh": "%1$s推杆内侧限位开关工作异常",
      "fr": ""
    },
    "0x19110407" : {
      "en": "Dock %1$s driving rod internal limit switch error",
      "zh": "%1$s推杆内侧限位开关工作异常",
      "fr": ""
    },
    "0x19110408" : {
      "en": "Dock %1$s driving rod external limit switch error",
      "zh": "%1$s推杆外侧限位开关工作异常",
      "fr": ""
    },
    "0x19110409" : {
      "en": "Dock %1$s driving rod external limit switch error",
      "zh": "%1$s推杆外侧限位开关工作异常",
      "fr": ""
    },
    "0x1911040B" : {
      "en": "Pushing %1$s driving rod timed out",
      "zh": "%1$s推杆闭合超时",
      "fr": ""
    },
    "0x1911040C" : {
      "en": "Pulling %1$s driving rod timed out",
      "zh": "%1$s推杆展开超时",
      "fr": ""
    },
    "0x19110800" : {
      "en": "Failed to charge dock backup battery",
      "zh": "机场蓄电池无法充电",
      "fr": ""
    },
    "0x19110801" : {
      "en": "Dock backup battery level low",
      "zh": "机场蓄电池电量低",
      "fr": ""
    },
    "0x19110802" : {
      "en": "Dock backup battery overheated",
      "zh": "机场蓄电池温度过高",
      "fr": ""
    },
    "0x19110803" : {
      "en": "Dock backup battery temperature too low",
      "zh": "机场蓄电池温度过低",
      "fr": ""
    },
    "0x19110804" : {
      "en": "Dock backup battery switch not turned on",
      "zh": "机场蓄电池开关未开启",
      "fr": ""
    },
    "0x19110805" : {
      "en": "Dock backup battery completely depleted. Unable to work properly",
      "zh": "机场蓄电池过度放电，已无法正常工作",
      "fr": ""
    },
    "0x19110806" : {
      "en": "Dock backup battery charging function error",
      "zh": "机场蓄电池充电功能异常",
      "fr": ""
    },
    "0x19110807" : {
      "en": "Dock backup battery charging function error",
      "zh": "机场蓄电池充电功能异常",
      "fr": ""
    },
    "0x19110808" : {
      "en": "Dock backup battery function error",
      "zh": "机场蓄电池功能异常",
      "fr": ""
    },
    "0x19110809" : {
      "en": "Dock backup battery function error",
      "zh": "机场蓄电池功能异常",
      "fr": ""
    },
    "0x19110C00" : {
      "en": "Dock security camera not installed or disconnected",
      "zh": "机场监控摄像头未安装或断连",
      "fr": ""
    },
    "0x19111400" : {
      "en": "Dock electrical cabinet cover open",
      "zh": "机场配电柜柜门被打开",
      "fr": ""
    },
    "0x19111401" : {
      "en": "Door sensor of dock electrical cabinet error",
      "zh": "机场配电柜柜门传感器异常",
      "fr": ""
    },
    "0x19111402" : {
      "en": "Door sensor of dock electrical cabinet error",
      "zh": "机场配电柜柜门传感器异常",
      "fr": ""
    },
    "0x19111800" : {
      "en": "Emergency stop button pressed down",
      "zh": "急停按钮被按下",
      "fr": ""
    },
    "0x19111D01" : {
      "en": "Aircraft inside dock is not linked. Linked aircraft is outside of dock",
      "zh": "舱内飞行器未对频，已对频飞行器在舱外",
      "fr": ""
    },
    "0x19112C01" : {
      "en": "Temperature sensor of dock control module damaged",
      "zh": "机场主控模块温度传感器损坏",
      "fr": ""
    },
    "0x19112C02" : {
      "en": "Temperature sensor of dock control module damaged",
      "zh": "机场主控模块温度传感器损坏",
      "fr": ""
    },
    "0x19112C03" : {
      "en": "Dock environment temperature sensor damaged",
      "zh": "机场环境温度传感器损坏",
      "fr": ""
    },
    "0x19112C04" : {
      "en": "Temperature sensor of dock control module damaged",
      "zh": "机场主控模块温度传感器损坏",
      "fr": ""
    },
    "0x19112C05" : {
      "en": "Temperature sensor of dock control module damaged",
      "zh": "机场主控模块温度传感器损坏",
      "fr": ""
    },
    "0x19112C06" : {
      "en": "Temperature sensor of dock left charging connector damaged",
      "zh": "机场左侧充电连接器温度传感器损坏",
      "fr": ""
    },
    "0x19112C07" : {
      "en": "Temperature sensor of dock right charging connector damaged",
      "zh": "机场右侧充电连接器温度传感器损坏",
      "fr": ""
    },
    "0x19112C08" : {
      "en": "Temperature sensor of landing pad interface board damaged",
      "zh": "停机坪接口板温度传感器损坏",
      "fr": ""
    },
    "0x19112C09" : {
      "en": "Temperature sensor of landing pad interface board damaged",
      "zh": "停机坪接口板温度传感器损坏",
      "fr": ""
    },
    "0x19112C0A" : {
      "en": "Temperature sensor of landing pad interface board damaged",
      "zh": "停机坪接口板温度传感器损坏",
      "fr": ""
    },
    "0x19112C0B" : {
      "en": "Temperature sensor of dock control module damaged",
      "zh": "机场主控模块温度传感器损坏",
      "fr": ""
    },
    "0x19112C0C" : {
      "en": "Temperature sensor of dock control module not connected",
      "zh": "机场主控模块温度传感器未连接",
      "fr": ""
    },
    "0x19112C0D" : {
      "en": "Temperature sensor of dock charging module damaged",
      "zh": "机场充电电源模块温度传感器损坏",
      "fr": ""
    },
    "0x19112C0E" : {
      "en": "Temperature sensor of dock charging module not connected",
      "zh": "机场充电电源模块温度传感器未连接",
      "fr": ""
    },
    "0x19112C0F" : {
      "en": "Temperature sensor of dock battery module damaged",
      "zh": "机场电源模块温度传感器损坏",
      "fr": ""
    },
    "0x19112C10" : {
      "en": "Temperature sensor of dock power module not connected",
      "zh": "机场电源模块温度传感器未连接",
      "fr": ""
    },
    "0x19112C11" : {
      "en": "Temperature sensor of dock battery module connector damaged",
      "zh": "机场电源模块连接器温度传感器损坏",
      "fr": ""
    },
    "0x19112C12" : {
      "en": "Temperature sensor of dock battery module connector not connected",
      "zh": "机场电源模块连接器温度传感器未连接",
      "fr": ""
    },
    "0x19112C13" : {
      "en": "Temperature sensor of dock charging module connector damaged",
      "zh": "机场充电模块连接器温度传感器损坏",
      "fr": ""
    },
    "0x19112C14" : {
      "en": "Temperature sensor of dock charging module connector not connected",
      "zh": "机场充电模块连接器温度传感器未连接",
      "fr": ""
    },
    "0x19112C15" : {
      "en": "Temperature sensor of dock AC battery module damaged",
      "zh": "机场空调电源模块温度传感器损坏",
      "fr": ""
    },
    "0x19112C16" : {
      "en": "Temperature sensor of dock AC battery module not connected",
      "zh": "机场空调电源模块温度传感器未连接",
      "fr": ""
    },
    "0x19112C17" : {
      "en": "Temperature sensor of dock AC battery module connector damaged",
      "zh": "机场空调电源模块连接器温度传感器损坏",
      "fr": ""
    },
    "0x19112C18" : {
      "en": "Temperature sensor of dock AC battery module connector not connected",
      "zh": "机场空调电源模块连接器温度传感器未连接",
      "fr": ""
    },
    "0x19112C19" : {
      "en": "Temperature sensor of dock backup battery damaged",
      "zh": "机场蓄电池温度传感器损坏",
      "fr": ""
    },
    "0x19112C1A" : {
      "en": "Temperature sensor of dock backup battery not connected",
      "zh": "机场蓄电池温度传感器未连接",
      "fr": ""
    },
    "0x19113000" : {
      "en": "Dock vibration sensor error",
      "zh": "机场振动传感器工作异常",
      "fr": ""
    },
    "0x19113001" : {
      "en": "Dock vibration detected. Dock may be moved or damaged",
      "zh": "机场产生振动，可能被移动或遭到破坏",
      "fr": ""
    },
    "0x19113401" : {
      "en": "Aircraft battery charge voltage error",
      "zh": "飞行器电池充电电压异常",
      "fr": ""
    },
    "0x19113403" : {
      "en": "Aircraft battery not properly installed, or battery level too low and battery enters hibernation mode",
      "zh": "飞行器电池不在位，或电量极低已进入休眠模式",
      "fr": ""
    },
    "0x19113404" : {
      "en": "Failed to charge aircraft battery",
      "zh": "飞行器电池充电失败",
      "fr": ""
    },
    "0x19113406" : {
      "en": "Aircraft battery error",
      "zh": "飞行器电池异常",
      "fr": ""
    },
    "0x19113407" : {
      "en": "Dock power supply module error. Unable to charge aircraft",
      "zh": "机场供电电源模块异常，无法给飞行器电池充电",
      "fr": ""
    },
    "0x19113414" : {
      "en": "Battery overheated (≥44° C). Unable to start charging",
      "zh": "电池温度过高（≥44℃）无法开始充电",
      "fr": ""
    },
    "0x19113800" : {
      "en": "Dock internal power module error",
      "zh": "机场内部电源模块工作异常",
      "fr": ""
    },
    "0x19113802" : {
      "en": "Dock electronic module power supply error",
      "zh": "机场弱电模块供电异常",
      "fr": ""
    },
    "0x19113803" : {
      "en": "Dock power supply disconnected",
      "zh": "机场供电电源断开",
      "fr": ""
    },
    "0x19113806" : {
      "en": "Dock battery module error",
      "zh": "机场电源模块故障",
      "fr": ""
    },
    "0x19113807" : {
      "en": "Output voltage of dock battery module too high",
      "zh": "机场电源模块输出电压过高",
      "fr": ""
    },
    "0x19113808" : {
      "en": "Output voltage of dock battery module too low",
      "zh": "机场电源模块输出电压过低",
      "fr": ""
    },
    "0x19113809" : {
      "en": "Dock battery module temperature too high",
      "zh": "机场电源模块温度过高",
      "fr": ""
    },
    "0x1911380A" : {
      "en": "Dock battery module temperature too low",
      "zh": "机场电源模块温度过低",
      "fr": ""
    },
    "0x1911380B" : {
      "en": "Dock battery module connector temperature too high",
      "zh": "机场电源模块连接器温度过高",
      "fr": ""
    },
    "0x1911380C" : {
      "en": "Dock battery module connector temperature too low",
      "zh": "机场电源模块连接器温度过低",
      "fr": ""
    },
    "0x19113901" : {
      "en": "Battery voltage of dock system too high",
      "zh": "机场系统电源电压过高",
      "fr": ""
    },
    "0x19113902" : {
      "en": "Battery voltage of dock system too low",
      "zh": "机场系统电源电压过低",
      "fr": ""
    },
    "0x19113903" : {
      "en": "Dock control module powered off abnormally",
      "zh": "机场主控模块异常掉电",
      "fr": ""
    },
    "0x19113C00" : {
      "en": "Surge protector circuit breaker not turned on, or surge protector device damaged",
      "zh": "防雷器后备保护器开关未开启，或防雷器损坏",
      "fr": ""
    },
    "0x19113C01" : {
      "en": "Landing pad connection error",
      "zh": "停机坪连接异常",
      "fr": ""
    },
    "0x19113C02" : {
      "en": "Rainfall gauge connection error",
      "zh": "雨量计连接异常",
      "fr": ""
    },
    "0x19113C03" : {
      "en": "AC connection error",
      "zh": "空调连接异常",
      "fr": ""
    },
    "0x19113C04" : {
      "en": "Dock charging module connection error",
      "zh": "机场充电模块连接异常",
      "fr": ""
    },
    "0x19113D00" : {
      "en": "AC cooler damaged",
      "zh": "空调制冷片损坏",
      "fr": ""
    },
    "0x19113D01" : {
      "en": "AC cooler damaged",
      "zh": "空调制冷片损坏",
      "fr": ""
    },
    "0x19113D02" : {
      "en": "AC cooling error",
      "zh": "空调制冷片损坏",
      "fr": ""
    },
    "0x19113D03" : {
      "en": "AC heater damaged",
      "zh": "空调加热器损坏",
      "fr": ""
    },
    "0x19113D04" : {
      "en": "AC heater damaged",
      "zh": "空调加热器损坏",
      "fr": ""
    },
    "0x19113D05" : {
      "en": "AC internal circulation fan damaged",
      "zh": "空调内循环风扇损坏",
      "fr": ""
    },
    "0x19113D06" : {
      "en": "AC external circulation fan damaged",
      "zh": "空调外循环风扇损坏",
      "fr": ""
    },
    "0x19113D07" : {
      "en": "Temperature sensor of AC external circulation supply vent damaged",
      "zh": "空调外循环出风口温度传感器损坏",
      "fr": ""
    },
    "0x19113D08" : {
      "en": "Temperature sensor of AC internal circulation return vent damaged",
      "zh": "空调内循环进风口温度传感器损坏",
      "fr": ""
    },
    "0x19113D09" : {
      "en": "Temperature sensor on the right of AC internal circulation supply vent damaged",
      "zh": "空调内循环出风口右侧温度传感器损坏",
      "fr": ""
    },
    "0x19113D0A" : {
      "en": "Temperature sensor on the left of AC internal circulation supply vent damaged",
      "zh": "空调内循环出风口左侧温度传感器损坏",
      "fr": ""
    },
    "0x19113D0B" : {
      "en": "AC cooler temperature sensor damaged",
      "zh": "空调制冷片温度传感器损坏",
      "fr": ""
    },
    "0x19113D0C" : {
      "en": "Temperature sensor of AC internal circulation tube damaged",
      "zh": "空调内循环风道温度传感器损坏",
      "fr": ""
    },
    "0x19113D0D" : {
      "en": "Dock cover damaged, or unable to close cover properly",
      "zh": "舱盖破损或无法完全关闭",
      "fr": ""
    },
    "0x19113D0E" : {
      "en": "AC internal circulation return vent blocked",
      "zh": "空调内循环进风口堵塞",
      "fr": ""
    },
    "0x19113D0F" : {
      "en": "AC internal circulation supply vent blocked",
      "zh": "空调内循环出风口堵塞",
      "fr": ""
    },
    "0x19113D10" : {
      "en": "Large temperature difference (≥20° C) between AC internal circulation supply and return vents",
      "zh": "空调外循环出风口与进风口温差过大（≥20℃）",
      "fr": ""
    },
    "0x19113D11" : {
      "en": "AC cooler power supply error",
      "zh": "空调制冷片供电异常",
      "fr": ""
    },
    "0x19113D12" : {
      "en": "AC heater power supply error",
      "zh": "空调加热器供电异常",
      "fr": ""
    },
    "0x19113D13" : {
      "en": "AC external circulation fan power supply error",
      "zh": "空调外循环风扇供电异常",
      "fr": ""
    },
    "0x19113D14" : {
      "en": "AC internal circulation fan power supply error",
      "zh": "空调内循环风扇供电异常",
      "fr": ""
    },
    "0x19113D15" : {
      "en": "AC power supply error",
      "zh": "空调供电异常",
      "fr": ""
    },
    "0x19113D16" : {
      "en": "",
      "zh": "空调外循环进风口堵塞",
      "fr": ""
    },
    "0x19113D20" : {
      "en": "Temperature sensor of return vent of AC external circulation damaged",
      "zh": "空调外循环进风口温度传感器损坏",
      "fr": ""
    },
    "0x19113D21" : {
      "en": "Temperature sensor of supply vent of AC internal circulation damaged",
      "zh": "空调内循环出风口温度传感器损坏",
      "fr": ""
    },
    "0x19113D22" : {
      "en": "Temperature sensor of AC TEC cold side damaged",
      "zh": "空调TEC冷端温度传感器损坏",
      "fr": ""
    },
    "0x19113D23" : {
      "en": "Large temperature difference between AC external circulation supply vent and return vent (≥10° C)",
      "zh": "空调外循环出风口与进风口温差过大（≥10℃）",
      "fr": ""
    },
    "0x19113D24" : {
      "en": "NTC temperature sensor of left driving rod damaged",
      "zh": "左推杆温感NTC温度传感器损坏",
      "fr": ""
    },
    "0x19113D25" : {
      "en": "NTC temperature sensor of right driving rod damaged",
      "zh": "右推杆温感NTC温度传感器损坏",
      "fr": ""
    },
    "0x19113D26" : {
      "en": "High temperature warning (≥45℃)",
      "zh": "高温预警（≥45℃）",
      "fr": ""
    },
    "0x19113D27" : {
      "en": "Low temperature warning (≤-20℃)",
      "zh": "低温预警（≤-20℃）",
      "fr": ""
    },
    "0x19113D28" : {
      "en": "Temperature sensor of AC external circulation supply vent short-circuited",
      "zh": "空调外循环出风口温度传感器短路",
      "fr": ""
    },
    "0x19113D29" : {
      "en": "Temperature sensor of AC internal circulation return vent short-circuited",
      "zh": "空调内循环进风口温度传感器短路",
      "fr": ""
    },
    "0x19113D2A" : {
      "en": "AC cooler temperature sensor short-circuited",
      "zh": "空调制冷片温度传感器短路",
      "fr": ""
    },
    "0x19113D2B" : {
      "en": "Temperature sensor of AC TEC cold side short-circuited",
      "zh": "空调TEC冷端温度传感器短路",
      "fr": ""
    },
    "0x19113D2C" : {
      "en": "Temperature sensor of AC external circulation return vent short-circuited",
      "zh": "空调外循环进风口温度传感器短路",
      "fr": ""
    },
    "0x19113D2D" : {
      "en": "Temperature sensor of AC internal circulation supply vent short-circuited",
      "zh": "空调内循环出风口温度传感器短路",
      "fr": ""
    },
    "0x19113D2E" : {
      "en": "NTC temperature sensor of left driving rod short-circuited",
      "zh": "左推杆温感NTC温度传感器短路",
      "fr": ""
    },
    "0x19113D2F" : {
      "en": "NTC temperature sensor of right driving rod short-circuited",
      "zh": "右推杆温感NTC温度传感器短路",
      "fr": ""
    },
    "0x19113D60" : {
      "en": "AC cooling error",
      "zh": "空调制冷功能异常",
      "fr": ""
    },
    "0x19113D61" : {
      "en": "AC cooling error",
      "zh": "空调制冷功能异常",
      "fr": ""
    },
    "0x19113D62" : {
      "en": "AC external circulation fan damaged",
      "zh": "空调外循环风扇损坏",
      "fr": ""
    },
    "0x19113D63" : {
      "en": "AC external circulation fan speed error",
      "zh": "空调外循环风扇风速异常",
      "fr": ""
    },
    "0x19113D64" : {
      "en": "AC internal circulation fan damaged",
      "zh": "空调内循环风扇损坏",
      "fr": ""
    },
    "0x19113D65" : {
      "en": "AC internal circulation fan speed error",
      "zh": "空调内循环风扇风速异常",
      "fr": ""
    },
    "0x19114000" : {
      "en": "Wind speed too high (≥ 9 m/s). Unable to perform task",
      "zh": "风速过大（≥9 m/s），无法执行飞行任务",
      "fr": ""
    },
    "0x19114800" : {
      "en": "Heavy rainfall. Unable to perform task",
      "zh": "雨量过大，无法执行飞行任务",
      "fr": ""
    },
    "0x19114801" : {
      "en": "Dock security camera power supply error",
      "zh": "机场监控摄像头供电异常",
      "fr": ""
    },
    "0x19114802" : {
      "en": "DJI Cellular Dongle power supply error",
      "zh": "DJI Cellular 模块供电异常",
      "fr": ""
    },
    "0x19114803" : {
      "en": "Power supply error in status indicator on dock cover",
      "zh": "舱盖告警灯供电异常",
      "fr": ""
    },
    "0x19114804" : {
      "en": "Wind speed gauge heating module power supply error",
      "zh": "风速计加热供电异常",
      "fr": ""
    },
    "0x19114805" : {
      "en": "Temperature and humidity sensor connection error",
      "zh": "舱内温湿度传感器连接异常",
      "fr": ""
    },
    "0x19114806" : {
      "en": "Rainfall gauge connection error",
      "zh": "雨量计连接异常",
      "fr": ""
    },
    "0x19114807" : {
      "en": "Rainfall gauge heating module power supply error",
      "zh": "雨量计加热模块供电异常",
      "fr": ""
    },
    "0x19114808" : {
      "en": "Temperature sensor of rainfall gauge heating module connection error",
      "zh": "雨量计加热模块温度传感器连接异常",
      "fr": ""
    },
    "0x19114809" : {
      "en": "Temperature sensor of rainfall gauge heating module overheated",
      "zh": "雨量计加热模块温度传感器温度过高",
      "fr": ""
    },
    "0x1911480A" : {
      "en": "Temperature sensor of wind speed gauge heating module damaged",
      "zh": "风速计加热模块温度传感器损坏",
      "fr": ""
    },
    "0x1911480B" : {
      "en": "Temperature sensor of wind speed gauge heating module overheated",
      "zh": "风速计加热模块温度传感器温度过高",
      "fr": ""
    },
    "0x1911480C" : {
      "en": "Dock cover temperature sensor damaged. Heating module unable to work properly in low-temperature environments",
      "zh": "舱盖除冰加热温度传感器损坏",
      "fr": ""
    },
    "0x1911480D" : {
      "en": "Dock cover temperature sensor overheated. Heating module failed to work properly",
      "zh": "舱盖除冰加热温度传感器温度过高",
      "fr": ""
    },
    "0x1911480E" : {
      "en": "Rainfall gauge connection error",
      "zh": "雨量计连接异常",
      "fr": ""
    },
    "0x1911480F" : {
      "en": "Rainfall gauge short-circuited",
      "zh": "雨量计短路",
      "fr": ""
    },
    "0x19114810" : {
      "en": "",
      "zh": "风速计模块连接异常",
      "fr": ""
    },
    "0x19114811" : {
      "en": "Hall temperature sensor of wind speed gauge damaged",
      "zh": "风速计霍尔温度传感器损坏",
      "fr": ""
    },
    "0x19114812" : {
      "en": "Hall temperature sensor of wind speed gauge damaged",
      "zh": "风速计霍尔温度传感器损坏",
      "fr": ""
    },
    "0x19114813" : {
      "en": "Temperature and humidity sensor self-heating time too long",
      "zh": "温湿度传感器自加热时间过久",
      "fr": ""
    },
    "0x19114814" : {
      "en": "Rainfall gauge damaged",
      "zh": "雨量计检测部件损坏",
      "fr": ""
    },
    "0x19114815" : {
      "en": "Rainfall gauge damaged",
      "zh": "雨量计检测部件损坏",
      "fr": ""
    },
    "0x1911481A" : {
      "en": "Dock cover failed to deice",
      "zh": "机场舱盖除冰功能异常",
      "fr": ""
    },
    "0x1911481B" : {
      "en": "Wind speed gauge power supply error",
      "zh": "风速计供电异常",
      "fr": ""
    },
    "0x19114C00" : {
      "en": "Water immersion detected",
      "zh": "机场浸水",
      "fr": ""
    },
    "0x19115000" : {
      "en": "Error occurred and dock restarted",
      "zh": "机场异常重启",
      "fr": ""
    },
    "0x19116000" : {
      "en": "Battery of dock charging module error",
      "zh": "机场充电模块电源故障",
      "fr": ""
    },
    "0x19116001" : {
      "en": "Battery voltage of dock charging module too high",
      "zh": "机场充电模块电源电压过高",
      "fr": ""
    },
    "0x19116002" : {
      "en": "Battery voltage of dock charging module too low",
      "zh": "机场充电模块电源电压过低",
      "fr": ""
    },
    "0x19116003" : {
      "en": "Electric current of dock charging module too large",
      "zh": "机场充电模块电源电流过大",
      "fr": ""
    },
    "0x19116004" : {
      "en": "Electric current of dock charging module too small",
      "zh": "机场充电模块电源电流过小",
      "fr": ""
    },
    "0x19116005" : {
      "en": "Battery MOS of dock charging module temperature too high",
      "zh": "机场充电模块电源MOS温度过高",
      "fr": ""
    },
    "0x19116006" : {
      "en": "Battery MOS of dock charging module temperature too low",
      "zh": "机场充电模块电源MOS温度过低",
      "fr": ""
    },
    "0x19116007" : {
      "en": "Controller battery of dock charging module error",
      "zh": "机场充电模块控制器电源异常",
      "fr": ""
    },
    "0x19116008" : {
      "en": "Dock charging module connector temperature too high",
      "zh": "机场充电模块连接器温度过高",
      "fr": ""
    },
    "0x19116009" : {
      "en": "Dock charging module connector temperature too low",
      "zh": "机场充电模块连接器温度过低",
      "fr": ""
    },
    "0x1911600A" : {
      "en": "Dock AC battery power supply error",
      "zh": "机场空调电源模块供电异常",
      "fr": ""
    },
    "0x1911600B" : {
      "en": "Dock AC battery voltage too high",
      "zh": "机场空调电源模块电压过高",
      "fr": ""
    },
    "0x1911600C" : {
      "en": "Dock AC battery voltage too low",
      "zh": "机场空调电源模块电压过低",
      "fr": ""
    },
    "0x1911600D" : {
      "en": "Electric current of dock AC power module too large",
      "zh": "机场空调电源模块电流过大",
      "fr": ""
    },
    "0x1911600E" : {
      "en": "Electric current of dock AC power module too small",
      "zh": "机场空调电源模块电流过小",
      "fr": ""
    },
    "0x1911600F" : {
      "en": "Dock AC controller module battery error",
      "zh": "机场空调控制器模块电源故障",
      "fr": ""
    },
    "0x19116010" : {
      "en": "Electric current of dock AC controller module too large",
      "zh": "机场空调控制器模块电流过大",
      "fr": ""
    },
    "0x19116011" : {
      "en": "Electric current of dock AC controller module too small",
      "zh": "机场空调控制器模块电流过小",
      "fr": ""
    },
    "0x19116012" : {
      "en": "Battery MOS of dock AC module temperature too high",
      "zh": "机场空调模块电源MOS温度过高",
      "fr": ""
    },
    "0x19116013" : {
      "en": "Battery MOS of dock AC module temperature too low",
      "zh": "机场空调模块电源MOS温度过低",
      "fr": ""
    },
    "0x19116014" : {
      "en": "AC module connector temperature too high",
      "zh": "空调模块连接器温度过高",
      "fr": ""
    },
    "0x19116015" : {
      "en": "AC module connector temperature too low",
      "zh": "空调模块连接器温度过低",
      "fr": ""
    },
    "0x19116016" : {
      "en": "Battery of weather station module error",
      "zh": "气象站模块电源故障",
      "fr": ""
    },
    "0x19116017" : {
      "en": "Electric current of weather station module too large",
      "zh": "气象站模块电源电流过大",
      "fr": ""
    },
    "0x19116018" : {
      "en": "Electric current of weather station module too small",
      "zh": "气象站模块电源电流过小",
      "fr": ""
    },
    "0x1911601B" : {
      "en": "Battery of dock image transmission module error",
      "zh": "机场图传模块电源异常",
      "fr": ""
    },
    "0x1911601F" : {
      "en": "Battery voltage of dock internal security camera too high",
      "zh": "机场舱内监控摄像头电压过高",
      "fr": ""
    },
    "0x19116020" : {
      "en": "Battery voltage of dock internal security camera too low",
      "zh": "机场舱内监控摄像头电压过低",
      "fr": ""
    },
    "0x19116021" : {
      "en": "Battery voltage of right dock cover too high",
      "zh": "右舱盖电源电压过高",
      "fr": ""
    },
    "0x19116022" : {
      "en": "Battery voltage of right dock cover too low",
      "zh": "右舱盖电源电压过低",
      "fr": ""
    },
    "0x19116023" : {
      "en": "Dock control module temperature too high",
      "zh": "机场主控模块温度过高",
      "fr": ""
    },
    "0x19116024" : {
      "en": "Dock control module temperature too low",
      "zh": "机场主控模块温度过低",
      "fr": ""
    },
    "0x19117000" : {
      "en": "Failed to recharge aircraft battery",
      "zh": "飞行器电池充电失败",
      "fr": ""
    },
    "0x19117021" : {
      "en": "Dock cover moving. Charging aircraft battery failed",
      "zh": "舱盖运动中，飞行器电池充电失败",
      "fr": ""
    },
    "0x19117022" : {
      "en": "Updating dock. Charging aircraft battery failed",
      "zh": "机场升级中，飞行器电池充电失败",
      "fr": ""
    },
    "0x19117023" : {
      "en": "No aircraft found",
      "zh": "未检测到飞行器",
      "fr": ""
    },
    "0x19117024" : {
      "en": "Metal foreign objects detected in dock charging module. Charging aircraft battery failed",
      "zh": "机场充电模块检测到金属异物，飞行器电池充电失败",
      "fr": ""
    },
    "0x19117025" : {
      "en": "Dock cover opened. Charging aircraft battery failed",
      "zh": "检测到机场舱盖已打开，飞行器充电失败",
      "fr": ""
    },
    "0x19117041" : {
      "en": "Aircraft not connected",
      "zh": "飞行器未连接",
      "fr": ""
    },
    "0x19117042" : {
      "en": "",
      "zh": "飞机充电板未进入充电",
      "fr": ""
    },
    "0x19117043" : {
      "en": "Aircraft battery level critically low. Unable to power on aircraft",
      "zh": "飞行器严重低电量，无法开机",
      "fr": ""
    },
    "0x19117045" : {
      "en": "Aircraft battery error. Unable to charge battery or power on aircraft",
      "zh": "飞行器电池故障，无法充电或开机",
      "fr": ""
    },
    "0x19117046" : {
      "en": "Aircraft battery communication error",
      "zh": "飞行器电池通信异常",
      "fr": ""
    },
    "0x19117047" : {
      "en": "Aircraft battery level high. No battery charging required",
      "zh": "飞行器电量较高，无需充电",
      "fr": ""
    },
    "0x19117048" : {
      "en": "Aircraft wireless charging module error",
      "zh": "飞行器无线充电模块异常",
      "fr": ""
    },
    "0x19117061" : {
      "en": "Waking aircraft charging module failed",
      "zh": "飞行器充电模块唤醒失败",
      "fr": ""
    },
    "0x19117100" : {
      "en": "",
      "zh": "电池无法加热保温",
      "fr": ""
    },
    "0x19117121" : {
      "en": "",
      "zh": "电池未进入保温状态",
      "fr": ""
    },
    "0x19117200" : {
      "en": "",
      "zh": "飞机开机发生故障",
      "fr": ""
    },
    "0x19117202" : {
      "en": "Powering on aircraft timed out",
      "zh": "飞行器开机超时",
      "fr": ""
    },
    "0x19117221" : {
      "en": "Failed to connect dock to aircraft Bluetooth",
      "zh": "机场连接飞行器蓝牙失败",
      "fr": ""
    },
    "0x19117222" : {
      "en": "Dock Bluetooth link error",
      "zh": "机场蓝牙模块链路故障",
      "fr": ""
    },
    "0x19117223" : {
      "en": "Aircraft Bluetooth signal weak",
      "zh": "飞行器蓝牙模块信号弱",
      "fr": ""
    },
    "0x19117300" : {
      "en": "",
      "zh": "飞机关机失败",
      "fr": ""
    },
    "0x19117321" : {
      "en": "Aircraft image transmission link error. Powering off failed",
      "zh": "飞行器图传链路异常，关机失败",
      "fr": ""
    },
    "0x19117322" : {
      "en": "Powering off aircraft timed out",
      "zh": "飞行器关机超时",
      "fr": ""
    },
    "0x19117420" : {
      "en": "",
      "zh": "飞机电池温度过低，不能工作",
      "fr": ""
    },
    "0x19117440" : {
      "en": "",
      "zh": "飞机电池超45度，不能工作",
      "fr": ""
    },
    "0x19117460" : {
      "en": "Battery voltage of dock charging module too low",
      "zh": "机场充电电源模块电压过低",
      "fr": ""
    },
    "0x19117461" : {
      "en": "Electric current of dock charging module too large",
      "zh": "机场充电电源模块电流过大",
      "fr": ""
    },
    "0x19117462" : {
      "en": "Aircraft charging module coil overcurrent",
      "zh": "飞行器充电模块线圈电流过大",
      "fr": ""
    },
    "0x19117463" : {
      "en": "Aircraft charging module error",
      "zh": "飞行器充电电源故障",
      "fr": ""
    },
    "0x19117464" : {
      "en": "Battery voltage of aircraft charging module too high",
      "zh": "飞行器充电电源过压",
      "fr": ""
    },
    "0x19117465" : {
      "en": "Battery voltage of dock charging module too high",
      "zh": "机场充电电源过压",
      "fr": ""
    },
    "0x19117470" : {
      "en": "Aircraft charging module error",
      "zh": "飞行器充电电源故障",
      "fr": ""
    },
    "0x19117480" : {
      "en": "Dock charging module temperature too high",
      "zh": "机场充电模块温度过高",
      "fr": ""
    },
    "0x19117481" : {
      "en": "Electric current of dock charging module too large",
      "zh": "机场充电模块充电电流过大",
      "fr": ""
    },
    "0x191174A0" : {
      "en": "Temperature of dock charging module coil too high",
      "zh": "机场充电模块线圈温度过高",
      "fr": ""
    },
    "0x191174B0" : {
      "en": "Temperature of dock wireless charging module error",
      "zh": "机场无线充电模块温度检测异常",
      "fr": ""
    },
    "0x191174B1" : {
      "en": "Temperature sensor of dock charging module coil not connected",
      "zh": "机场充电模块线圈温度传感器未连接",
      "fr": ""
    },
    "0x191174B2" : {
      "en": "Temperature sensor of dock charging module coil error",
      "zh": "机场充电模块线圈温度传感器异常",
      "fr": ""
    },
    "0x191174C0" : {
      "en": "Temperature of aircraft charging module coil too high",
      "zh": "飞行器充电模块线圈温度过高",
      "fr": ""
    },
    "0x191174D0" : {
      "en": "Temperature of aircraft wireless charging module error",
      "zh": "飞行器无线充电模块温度检测异常",
      "fr": ""
    },
    "0x191174D1" : {
      "en": "Temperature sensor of aircraft charging module coil not connected",
      "zh": "飞行器充电模块线圈温度传感器未连接",
      "fr": ""
    },
    "0x191174D2" : {
      "en": "Temperature sensor of aircraft charging module coil error",
      "zh": "飞行器充电模块线圈温度传感器异常",
      "fr": ""
    },
    "0x19200001" : {
      "en": "Payload system CPU usage too high. Restart aircraft to restore",
      "zh": "负载系统CPU负载高，请重启飞行器尝试恢复",
      "fr": ""
    },
    "0x19200001_in_the_sky" : {
      "en": "Payload system CPU usage too high. Camera tasks may be affected",
      "zh": "负载系统CPU负载高，可能影响作业",
      "fr": ""
    },
    "0x19200011" : {
      "en": "Payload system memory low. Restart aircraft to restore",
      "zh": "负载系统内存低，请重启飞行器尝试恢复",
      "fr": ""
    },
    "0x19200011_in_the_sky" : {
      "en": "Payload system low on memory. Camera tasks may be affected",
      "zh": "负载系统内存低，可能影响作业",
      "fr": ""
    },
    "0x19200021" : {
      "en": "Payload system error. Restart aircraft to restore",
      "zh": "负载系统异常，请重启飞行器尝试恢复",
      "fr": ""
    },
    "0x19200021_in_the_sky" : {
      "en": "Payload system error. Camera tasks may be affected",
      "zh": "负载系统异常，可能影响作业",
      "fr": ""
    },
    "0x1A010004" : {
      "en": "",
      "zh": "视觉NN降噪异常(视觉降噪)",
      "fr": ""
    },
    "0x1A010006" : {
      "en": "",
      "zh": "视觉传感器图像链路异常",
      "fr": ""
    },
    "0x1A010007" : {
      "en": "System in factory mode. Contact DJI Support",
      "zh": "当前处于工厂模式，请联系售后维修",
      "fr": ""
    },
    "0x1A010040" : {
      "en": "Bottom (left) vision sensor connection error. Restart aircraft",
      "zh": "下视左侧视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010040_in_the_sky" : {
      "en": "Bottom (left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "下视左侧视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010041" : {
      "en": "Bottom (right) vision sensor connection error. Restart aircraft",
      "zh": "下视右侧视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010041_in_the_sky" : {
      "en": "Bottom (right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "下视右侧视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010042" : {
      "en": "Front (left) vision sensor connection error. Restart aircraft",
      "zh": "前视左侧视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010042_in_the_sky" : {
      "en": "Front (left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "前视左侧视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010043" : {
      "en": "Front (right) vision sensor connection error. Restart aircraft",
      "zh": "前视右侧视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010043_in_the_sky" : {
      "en": "Front (right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "前视右侧视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010044" : {
      "en": "Back (left) vision sensor connection error. Restart aircraft",
      "zh": "后视左侧视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010044_in_the_sky" : {
      "en": "Back (left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "后视左侧视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010045" : {
      "en": "Back (right) vision sensor connection error. Restart aircraft",
      "zh": "后视右侧视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010045_in_the_sky" : {
      "en": "Back (right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "后视右侧视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010046" : {
      "en": "Top (left) vision sensor connection error. Restart aircraft",
      "zh": "上视左侧视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010046_in_the_sky" : {
      "en": "Top (left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "上视左侧视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010047" : {
      "en": "Top (right) vision sensor connection error. Restart aircraft",
      "zh": "上视右侧视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010047_in_the_sky" : {
      "en": "Top (right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "上视右侧视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010048" : {
      "en": "Side (back left) vision sensor connection error. Restart aircraft",
      "zh": "左视后部视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010048_in_the_sky" : {
      "en": "Side (back left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "左视后部视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010049" : {
      "en": "Side (front left) vision sensor connection error. Restart aircraft",
      "zh": "左视前部视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A010049_in_the_sky" : {
      "en": "Side (front left) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "左视前部视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A01004A" : {
      "en": "Side (front right) vision sensor connection error. Restart aircraft",
      "zh": "右视前部视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A01004A_in_the_sky" : {
      "en": "Side (front right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "右视前部视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A01004B" : {
      "en": "Side (back right) vision sensor connection error. Restart aircraft",
      "zh": "右视后部视觉传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A01004B_in_the_sky" : {
      "en": "Side (back right) vision sensor connection error. Fly with caution. Return to home or land (%alarmid)",
      "zh": "右视后部视觉传感器连接异常,请谨慎飞行，返航或降落（%alarmid）",
      "fr": ""
    },
    "0x1A010080" : {
      "en": "Bottom (left) vision sensor connection error. Restart aircraft",
      "zh": "下视左侧视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010080_in_the_sky" : {
      "en": "Bottom (left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "下视左侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A010081" : {
      "en": "Bottom (right) vision sensor connection error. Restart aircraft",
      "zh": "下视右侧视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010081_in_the_sky" : {
      "en": "Bottom (right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "下视右侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A010082" : {
      "en": "Front (left) vision sensor connection error. Restart aircraft",
      "zh": "前视左侧视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010082_in_the_sky" : {
      "en": "Front (left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "前视左侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A010083" : {
      "en": "Front (right) vision sensor connection error. Restart aircraft",
      "zh": "前视右侧视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010083_in_the_sky" : {
      "en": "Front (right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "前视右侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A010084" : {
      "en": "Back (left) vision sensor connection error. Restart aircraft",
      "zh": "后视左侧视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010084_in_the_sky" : {
      "en": "Back (left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "后视左侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A010085" : {
      "en": "Back (right) vision sensor connection error. Restart aircraft",
      "zh": "后视右侧视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010085_in_the_sky" : {
      "en": "Back (right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "后视右侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A010086" : {
      "en": "Top (left) vision sensor connection error. Restart aircraft",
      "zh": "上视左侧视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010086_in_the_sky" : {
      "en": "Top (left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "上视左侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A010087" : {
      "en": "Top (right) vision sensor connection error. Restart aircraft",
      "zh": "上视右侧视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010087_in_the_sky" : {
      "en": "Top (right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "上视右侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A010088" : {
      "en": "Side (back left) vision sensor connection error. Restart aircraft",
      "zh": "左视后部视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010088_in_the_sky" : {
      "en": "Side (back right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "右视后部视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A010089" : {
      "en": "Side (front left) vision sensor connection error. Restart aircraft",
      "zh": "左视前部视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A010089_in_the_sky" : {
      "en": "Side (front left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "左视前部视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A01008A" : {
      "en": "Side (front right) vision sensor connection error. Restart aircraft",
      "zh": "右视前部视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A01008A_in_the_sky" : {
      "en": "Side (front right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "右视前部视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A01008B" : {
      "en": "Side (back right) vision sensor connection error. Restart aircraft",
      "zh": "右视后部视觉传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A01008B_in_the_sky" : {
      "en": "Side (back right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "右视后部视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C0" : {
      "en": "Bottom (left) vision sensor connection error. Restart sensor",
      "zh": "下视左侧视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C0_in_the_sky" : {
      "en": "Bottom (left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "下视左侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C1" : {
      "en": "Bottom (right) vision sensor connection error. Restart sensor",
      "zh": "下视右侧视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C1_in_the_sky" : {
      "en": "Bottom (right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "下视右侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C2" : {
      "en": "Front (left) vision sensor connection error. Restart sensor",
      "zh": "前视左侧视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C2_in_the_sky" : {
      "en": "Front (left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "前视左侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C3" : {
      "en": "Front (right) vision sensor connection error. Restart sensor",
      "zh": "前视右侧视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C3_in_the_sky" : {
      "en": "Front (right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "前视右侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C4" : {
      "en": "Back (left) vision sensor connection error. Restart sensor",
      "zh": "后视左侧视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C4_in_the_sky" : {
      "en": "Back (left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "后视左侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C5" : {
      "en": "Back (right) vision sensor connection error. Restart sensor",
      "zh": "后视右侧视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C5_in_the_sky" : {
      "en": "Back (right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "后视右侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C6" : {
      "en": "Top (left) vision sensor connection error. Restart sensor",
      "zh": "上视左侧视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C6_in_the_sky" : {
      "en": "Top (left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "上视左侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C7" : {
      "en": "Top (right) vision sensor connection error. Restart sensor",
      "zh": "上视右侧视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C7_in_the_sky" : {
      "en": "Back (right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "后视右侧视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C8" : {
      "en": "Side (back left) vision sensor connection error. Restart sensor",
      "zh": "左视后部视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C8_in_the_sky" : {
      "en": "Side (back left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "左视后部视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100C9" : {
      "en": "Side (front left) vision sensor connection error. Restart sensor",
      "zh": "左视前部视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100C9_in_the_sky" : {
      "en": "Side (front left) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "左视前部视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100CA" : {
      "en": "Side (front right) vision sensor connection error. Restart sensor",
      "zh": "右视前部视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100CA_in_the_sky" : {
      "en": "Side (front right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "右视前部视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100CB" : {
      "en": "Side (back right) vision sensor connection error. Restart sensor",
      "zh": "右视后部视觉传感器连接异常，请重启传感器",
      "fr": ""
    },
    "0x1A0100CB_in_the_sky" : {
      "en": "Side (back right) vision sensor connection error. Fly with caution. Return to home or land",
      "zh": "右视后部视觉传感器连接异常,请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0100F0" : {
      "en": "",
      "zh": "感知传感器初始化正常(仅用于工厂链路测试)",
      "fr": ""
    },
    "0x1A011340" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A011341" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A011342" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A011343" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A011344" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A011345" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A011346" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A011347" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A011348" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A011349" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A01134A" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A01134B" : {
      "en": "Vision system calibration error",
      "zh": "视觉系统标定异常",
      "fr": ""
    },
    "0x1A020040" : {
      "en": "Bottom infrared sensor connection error. Restart aircraft",
      "zh": "下视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020040_in_the_sky" : {
      "en": "Bottom infrared sensor connection error. Return to home or land. Pay attention to the landing speed",
      "zh": "下视红外传感器连接异常,请注意控制降落着地速度，请返航或降落",
      "fr": ""
    },
    "0x1A020041" : {
      "en": "Front infrared sensor connection error. Restart aircraft",
      "zh": "前视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020041_in_the_sky" : {
      "en": "Front infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "前视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A020042" : {
      "en": "Right infrared sensor connection error. Restart aircraft",
      "zh": "右视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020042_in_the_sky" : {
      "en": "Right infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "右视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A020043" : {
      "en": "Back infrared sensor connection error. Restart aircraft",
      "zh": "后视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020043_in_the_sky" : {
      "en": "Back infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "后视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A020044" : {
      "en": "Left infrared sensor connection error. Restart aircraft",
      "zh": "左视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020044_in_the_sky" : {
      "en": "Left infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "左视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A020045" : {
      "en": "Top infrared sensor connection error. Restart aircraft",
      "zh": "上视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020045_in_the_sky" : {
      "en": "Top infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "上视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A020080" : {
      "en": "Bottom infrared sensor connection error. Restart aircraft",
      "zh": "下视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020080_in_the_sky" : {
      "en": "Bottom infrared sensor connection error. Return to Home or land. Pay attention to the landing speed",
      "zh": "下视红外传感器连接异常,请注意控制降落着地速度，请返航或降落",
      "fr": ""
    },
    "0x1A020081" : {
      "en": "Front infrared sensor connection error. Restart aircraft",
      "zh": "前视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020081_in_the_sky" : {
      "en": "Front infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "前视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A020082" : {
      "en": "Right infrared sensor connection error. Restart aircraft",
      "zh": "右视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020082_in_the_sky" : {
      "en": "Right infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "右视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A020083" : {
      "en": "Back infrared sensor connection error. Restart aircraft",
      "zh": "后视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020083_in_the_sky" : {
      "en": "Back infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "后视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A020084" : {
      "en": "Left infrared sensor connection error. Restart aircraft",
      "zh": "左视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020084_in_the_sky" : {
      "en": "Left infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "左视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A020085" : {
      "en": "Top infrared sensor connection error. Restart aircraft",
      "zh": "上视红外传感器连接异常，请重启飞行器",
      "fr": ""
    },
    "0x1A020085_in_the_sky" : {
      "en": "Top infrared sensor connection error. Fly with caution. Return to home or land",
      "zh": "上视红外传感器连接异常，请谨慎飞行，返航或降落",
      "fr": ""
    },
    "0x1A0200C0" : {
      "en": "Downward Infrared Sensor Connection Error",
      "zh": "下视红外传感器连接异常",
      "fr": ""
    },
    "0x1A0200C0_in_the_sky" : {
      "en": "Bottom infrared sensor connection error. Return to home or land. Pay attention to the landing speed",
      "zh": "下视红外传感器连接异常，请注意控制降落着地速度，请返航或降落",
      "fr": ""
    },
    "0x1A0200C1" : {
      "en": "Forward infrared sensor connection error",
      "zh": "前视红外传感器连接异常",
      "fr": ""
    },
    "0x1A0200C1_in_the_sky" : {
      "en": "Front infrared sensor connection error. Return to home or land",
      "zh": "前视红外传感器连接异常，请返航或降落",
      "fr": ""
    },
    "0x1A0200C2" : {
      "en": "Right infrared sensor connection error",
      "zh": "右视红外传感器连接异常",
      "fr": ""
    },
    "0x1A0200C2_in_the_sky" : {
      "en": "Right infrared sensor connection error. Return to home or land",
      "zh": "右视红外传感器连接异常，请返航或降落",
      "fr": ""
    },
    "0x1A0200C3" : {
      "en": "Backward infrared sensor connection error",
      "zh": "后视红外传感器连接异常",
      "fr": ""
    },
    "0x1A0200C3_in_the_sky" : {
      "en": "Back infrared sensor connection error. Return to home or land",
      "zh": "后视红外传感器连接异常，请返航或降落",
      "fr": ""
    },
    "0x1A0200C4" : {
      "en": "Left infrared sensor connection error",
      "zh": "左视红外传感器连接异常",
      "fr": ""
    },
    "0x1A0200C4_in_the_sky" : {
      "en": "Left infrared sensor connection error. Return to home or land",
      "zh": "左视红外传感器连接异常，请返航或降落",
      "fr": ""
    },
    "0x1A0200C5" : {
      "en": "Upward infrared sensor connection error",
      "zh": "上视红外传感器连接异常",
      "fr": ""
    },
    "0x1A0200C5_in_the_sky" : {
      "en": "Top infrared sensor connection error. Return to home or land",
      "zh": "上视红外传感器连接异常，请返航或降落",
      "fr": ""
    },
    "0x1A020100" : {
      "en": "Downward infrared sensor calibration error",
      "zh": "下视红外传感器标定异常",
      "fr": ""
    },
    "0x1A020101" : {
      "en": "Forward infrared sensor calibration error",
      "zh": "前视红外传感器标定异常",
      "fr": ""
    },
    "0x1A020102" : {
      "en": "Right infrared sensor calibration error",
      "zh": "右视红外传感器标定异常",
      "fr": ""
    },
    "0x1A020103" : {
      "en": "Backward infrared sensor calibration error",
      "zh": "后视红外传感器标定异常",
      "fr": ""
    },
    "0x1A020104" : {
      "en": "Left infrared sensor calibration error",
      "zh": "左视红外传感器标定异常",
      "fr": ""
    },
    "0x1A020105" : {
      "en": "Upward infrared sensor calibration error",
      "zh": "上视红外传感器标定异常",
      "fr": ""
    },
    "0x1A020140" : {
      "en": "Infrared sensors blocked",
      "zh": "视觉红外传感器被遮挡",
      "fr": ""
    },
    "0x1a020180" : {
      "en": "Infrared sensors overheated. Return to home or land promptly. Move away from high-temperature environment",
      "zh": "视觉红外传感器温度过高，请尽快返航或降落，远离高温环境",
      "fr": ""
    },
    "0x1A020180" : {
      "en": "Infrared sensors overheated. Return to home or land promptly. Move away from high-temperature environment",
      "zh": "视觉红外传感器温度过高，请尽快返航或降落，远离高温环境",
      "fr": ""
    },
    "0x1A020400" : {
      "en": "Low visibility. Fly with caution",
      "zh": "环境能见度差，请谨慎飞行",
      "fr": ""
    },
    "0x1A030040" : {
      "en": "Bottom infrared sensor connection error. Restart aircraft",
      "zh": "下视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030040_in_the_sky" : {
      "en": "Bottom infrared sensor connection error. Return to home or land. Pay attention to the landing speed",
      "zh": "下视红外传感器连接异常,请注意控制降落着地速度,请返航或降落",
      "fr": ""
    },
    "0x1A030041" : {
      "en": "Front infrared sensor connection error. Restart aircraft",
      "zh": "前视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030041_in_the_sky" : {
      "en": "Front infrared sensor connection error. Return to home or land",
      "zh": "前视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030042" : {
      "en": "Back infrared sensor connection error. Restart aircraft",
      "zh": "后视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030042_in_the_sky" : {
      "en": "Back infrared sensor connection error. Return to home or land",
      "zh": "后视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030043" : {
      "en": "Top infrared sensor connection error. Restart aircraft",
      "zh": "上视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030043_in_the_sky" : {
      "en": "Top infrared sensor connection error. Return to home or land",
      "zh": "上视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030044" : {
      "en": "Left infrared sensor connection error. Restart aircraft",
      "zh": "左视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030044_in_the_sky" : {
      "en": "Left infrared sensor connection error. Return to home or land",
      "zh": "左视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030045" : {
      "en": "Right infrared sensor connection error. Restart aircraft",
      "zh": "右视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030045_in_the_sky" : {
      "en": "Right infrared sensor connection error. Return to home or land",
      "zh": "右视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030080" : {
      "en": "Bottom infrared sensor connection error. Restart aircraft",
      "zh": "下视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030080_in_the_sky" : {
      "en": "Bottom infrared sensor connection error. Pay attention to the landing speed. Return to home or land",
      "zh": "下视红外传感器连接异常,请注意控制降落着地速度，请返航或降落",
      "fr": ""
    },
    "0x1A030081" : {
      "en": "Front infrared sensor connection error. Restart aircraft",
      "zh": "前视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030081_in_the_sky" : {
      "en": "Front infrared sensor connection error. Return to home or land",
      "zh": "前视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030082" : {
      "en": "Back infrared sensor connection error. Restart aircraft",
      "zh": "后视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030082_in_the_sky" : {
      "en": "Back infrared sensor connection error. Return to home or land",
      "zh": "后视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030083" : {
      "en": "Top infrared sensor connection error. Restart aircraft",
      "zh": "上视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030083_in_the_sky" : {
      "en": "Top infrared sensor connection error. Return to home or land",
      "zh": "上视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030084" : {
      "en": "Left infrared sensor connection error. Restart aircraft",
      "zh": "左视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030084_in_the_sky" : {
      "en": "Left infrared sensor connection error. Return to home or land",
      "zh": "左视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030085" : {
      "en": "Right infrared sensor connection error. Restart aircraft",
      "zh": "右视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030085_in_the_sky" : {
      "en": "Right infrared sensor connection error. Return to home or land",
      "zh": "右视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030180" : {
      "en": "Bottom infrared sensor connection error. Restart aircraft",
      "zh": "下视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030180_in_the_sky" : {
      "en": "Bottom infrared sensor connection error. Pay attention to the landing speed. Return to home or land",
      "zh": "下视红外传感器连接异常,请注意控制降落着地速度，请返航或降落",
      "fr": ""
    },
    "0x1A030181" : {
      "en": "Front infrared sensor connection error. Restart aircraft",
      "zh": "前视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030181_in_the_sky" : {
      "en": "Front infrared sensor connection error. Return to home or land",
      "zh": "前视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030182" : {
      "en": "Back infrared sensor connection error. Restart aircraft",
      "zh": "后视红外传感器连接异常,请重启飞行器",
      "fr": ""
    },
    "0x1A030182_in_the_sky" : {
      "en": "Back infrared sensor connection error. Return to home or land",
      "zh": "后视红外传感器连接异常,请返航或降落",
      "fr": ""
    },
    "0x1A030183" : {
      "en": "",
      "zh": "3DTOF 出图异常(上视)",
      "fr": ""
    },
    "0x1A030184" : {
      "en": "",
      "zh": "3DTOF 出图异常(左视)",
      "fr": ""
    },
    "0x1A030185" : {
      "en": "",
      "zh": "3DTOF 出图异常(右视)",
      "fr": ""
    },
    "0x1A0301C0" : {
      "en": "",
      "zh": "TOF3D_CALIBRATION_FAIL_0(下视)",
      "fr": ""
    },
    "0x1A0301C1" : {
      "en": "",
      "zh": "TOF3D_CALIBRATION_FAIL_1(前视)",
      "fr": ""
    },
    "0x1A0301C2" : {
      "en": "",
      "zh": "3DTOF 标定异常(后视)",
      "fr": ""
    },
    "0x1A0301C3" : {
      "en": "",
      "zh": "3DTOF 标定异常(上视)",
      "fr": ""
    },
    "0x1A0301C4" : {
      "en": "",
      "zh": "3DTOF 标定异常(左视)",
      "fr": ""
    },
    "0x1A0301C5" : {
      "en": "",
      "zh": "3DTOF 标定异常(右视)",
      "fr": ""
    },
    "0x1A040001" : {
      "en": "Power mode error. Restart aircraft",
      "zh": "功耗切换异常，请重启飞行器",
      "fr": ""
    },
    "0x1A050040" : {
      "en": "Obstacle sensing error. Fly with caution",
      "zh": "感知避障异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A050041" : {
      "en": "Obstacle sensing error. Fly with caution",
      "zh": "感知避障异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A050042" : {
      "en": "Obstacle sensing error. Fly with caution",
      "zh": "感知避障异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A050043" : {
      "en": "Obstacle sensing error. Fly with caution",
      "zh": "感知避障异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A060041" : {
      "en": "",
      "zh": "前雷达传感器连接异常",
      "fr": ""
    },
    "0x1A060042" : {
      "en": "",
      "zh": "后雷达传感器连接异常",
      "fr": ""
    },
    "0x1A060043" : {
      "en": "",
      "zh": "中心雷达传感器连接异常",
      "fr": ""
    },
    "0x1A060080" : {
      "en": "",
      "zh": "上雷达传感器标定异常",
      "fr": ""
    },
    "0x1A060081" : {
      "en": "",
      "zh": "前雷达传感器标定异常",
      "fr": ""
    },
    "0x1A060082" : {
      "en": "",
      "zh": "后雷达传感器标定异常",
      "fr": ""
    },
    "0x1A060083" : {
      "en": "",
      "zh": "中心雷达传感器标定异常",
      "fr": ""
    },
    "0x1A0600C0" : {
      "en": "",
      "zh": "上雷达传感器硬件故障",
      "fr": ""
    },
    "0x1A0600C1" : {
      "en": "",
      "zh": "前雷达传感器硬件故障",
      "fr": ""
    },
    "0x1A0600C2" : {
      "en": "",
      "zh": "后雷达传感器硬件故障",
      "fr": ""
    },
    "0x1A0600C3" : {
      "en": "",
      "zh": "中心雷达传感器硬件故障",
      "fr": ""
    },
    "0x1A080080" : {
      "en": "",
      "zh": "下前超声波传感器硬件故障",
      "fr": ""
    },
    "0x1A080081" : {
      "en": "",
      "zh": "下后超声波传感器硬件故障",
      "fr": ""
    },
    "0x1A080082" : {
      "en": "",
      "zh": "下左超声波传感器硬件故障",
      "fr": ""
    },
    "0x1A080083" : {
      "en": "",
      "zh": "下右超声波传感器硬件故障",
      "fr": ""
    },
    "0x1A080084" : {
      "en": "",
      "zh": "中心左超声波传感器硬件故障",
      "fr": ""
    },
    "0x1A080085" : {
      "en": "",
      "zh": "中心右超声波传感器硬件异常",
      "fr": ""
    },
    "0x1A090043" : {
      "en": "Upward LiDAR connection error. Fly with caution",
      "zh": "上视激光雷达连接异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A090043_in_the_sky" : {
      "en": "Upward LiDAR connection error. Fly with caution and return to home promptly",
      "zh": "上视激光雷达连接异常，请谨慎飞行并尽快返航",
      "fr": ""
    },
    "0x1A210180" : {
      "en": "Sensor system error. Land promptly or fly with caution",
      "zh": "感知系统异常，请尽快降落或谨慎飞行",
      "fr": ""
    },
    "0x1A210181" : {
      "en": "Sensor system error. Land promptly or fly with caution",
      "zh": "感知系统异常，请尽快降落或谨慎飞行",
      "fr": ""
    },
    "0x1A210182" : {
      "en": "Sensor system error. Land promptly or fly with caution",
      "zh": "感知系统异常，请尽快降落或谨慎飞行",
      "fr": ""
    },
    "0x1A210183" : {
      "en": "Sensor system error. Land promptly or fly with caution",
      "zh": "感知系统异常，请尽快降落或谨慎飞行",
      "fr": ""
    },
    "0x1A210184" : {
      "en": "Sensor system error. Land promptly or fly with caution",
      "zh": "感知系统异常，请尽快降落或谨慎飞行",
      "fr": ""
    },
    "0x1A210185" : {
      "en": "Sensor system error. Land promptly or fly with caution",
      "zh": "感知系统异常，请尽快降落或谨慎飞行",
      "fr": ""
    },
    "0x1A2101C0" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "感知系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1A2101C1" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "感知系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1A2101C2" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "感知系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1A2101C3" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "感知系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1A2101C4" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "感知系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1A2101C5" : {
      "en": "Sensor system error. Restart aircraft",
      "zh": "感知系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1A210240" : {
      "en": "Bottom vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
      "zh": "下视视觉遮挡，避障能力下降，请谨慎飞行",
      "fr": ""
    },
    "0x1A210241" : {
      "en": "Front vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
      "zh": "前视视觉遮挡，避障能力下降，请谨慎飞行",
      "fr": ""
    },
    "0x1A210242" : {
      "en": "Back vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
      "zh": "后视视觉遮挡，避障能力下降，请谨慎飞行",
      "fr": ""
    },
    "0x1A210243" : {
      "en": "Right-side vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
      "zh": "右视视觉遮挡，避障能力下降，请谨慎飞行",
      "fr": ""
    },
    "0x1A210244" : {
      "en": "Left-side vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
      "zh": "左视视觉遮挡，避障能力下降，请谨慎飞行",
      "fr": ""
    },
    "0x1A210245" : {
      "en": "Top vision sensor is blocked. Obstacle avoidance capabilities decreased. Fly with caution",
      "zh": "上视视觉遮挡，避障能力下降，请谨慎飞行",
      "fr": ""
    },
    "0x1A310980" : {
      "en": "Vision positioning system error",
      "zh": "视觉定位系统异常",
      "fr": ""
    },
    "0x1A310981" : {
      "en": "Vision positioning system error",
      "zh": "视觉定位系统异常",
      "fr": ""
    },
    "0x1A420040" : {
      "en": "Downward obstacle sensing system error",
      "zh": "下视障碍物感知系统异常",
      "fr": ""
    },
    "0x1A420041" : {
      "en": "Forward obstacle sensing system error",
      "zh": "前视障碍物感知系统异常",
      "fr": ""
    },
    "0x1A420042" : {
      "en": "Right obstacle sensing system error",
      "zh": "右视障碍物感知系统异常",
      "fr": ""
    },
    "0x1A420043" : {
      "en": "Backward obstacle sensing system error",
      "zh": "后视障碍物感知系统异常",
      "fr": ""
    },
    "0x1A420044" : {
      "en": "Left obstacle sensing system error",
      "zh": "左视障碍物感知系统异常",
      "fr": ""
    },
    "0x1A420045" : {
      "en": "Upward obstacle sensing system error",
      "zh": "上视障碍物感知系统异常",
      "fr": ""
    },
    "0x1A420440" : {
      "en": "Obstacle sensing system error",
      "zh": "障碍物感知系统异常",
      "fr": ""
    },
    "0x1A4205C0" : {
      "en": "Obstacle sensing system error",
      "zh": "障碍物感知系统异常",
      "fr": ""
    },
    "0x1A420680" : {
      "en": "Obstacle sensing system error",
      "zh": "障碍物感知系统异常",
      "fr": ""
    },
    "0x1a420bc0" : {
      "en": "Downward ambient light too low. Obstacle avoidance unavailable. Fly with caution",
      "zh": "下视环境光过暗，下方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420BC0" : {
      "en": "Downward ambient light too low. Downward obstacle sensing unavailable. Fly with caution",
      "zh": "下视环境光过暗，下视视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420bc1" : {
      "en": "Forward ambient light too low. Obstacle avoidance unavailable. Fly with caution",
      "zh": "前视环境光过暗，前向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420BC1" : {
      "en": "Forward ambient light too low. Forward obstacle sensing unavailable. Fly with caution",
      "zh": "前视环境光过暗，前视视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420bc2" : {
      "en": "Backward ambient light too low. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "后视环境光过暗，后向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420BC2" : {
      "en": "Backward ambient light too low. Backward obstacle sensing unavailable. Fly with caution",
      "zh": "后视环境光过暗，后视视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420bc3" : {
      "en": "Rightward ambient light too low. Rightward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "右视环境光过暗，右向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420BC3" : {
      "en": "Right ambient light too low. Right obstacle sensing unavailable. Fly with caution",
      "zh": "右视环境光过暗，右视视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420bc4" : {
      "en": "Leftward ambient light too low. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "左视环境光过暗，左向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420BC4" : {
      "en": "Left ambient light too low. Left obstacle sensing unavailable. Fly with caution",
      "zh": "左视环境光过暗，左视视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420bc5" : {
      "en": "Upward ambient light too low. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "上视环境光过暗，上方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420BC5" : {
      "en": "Upward ambient light too low. Upward obstacle sensing unavailable. Fly with caution",
      "zh": "上视环境光过暗，上视视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420bc6" : {
      "en": "Horizontal ambient light too low. Horizontal obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "水平方向环境光过暗，水平方向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420BC6" : {
      "en": "Horizontal ambient light too low. Horizontal obstacle sensing unavailable. Fly with caution",
      "zh": "水平方向环境光过暗，水平方向视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c00" : {
      "en": "Downward ambient light too bright. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "下视环境光过亮，下方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C00" : {
      "en": "Downward ambient light too bright. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "下视环境光过亮，下方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c01" : {
      "en": "Forward ambient light too bright. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "前视环境光过亮，前向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C01" : {
      "en": "Forward ambient light too bright. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "前视环境光过亮，前向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c02" : {
      "en": "Backward ambient light too bright. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "后视环境光过亮，后向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C02" : {
      "en": "Backward ambient light too bright. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "后视环境光过亮，后向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c03" : {
      "en": "Rightward ambient light too bright. Rightward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "右视环境光过亮，右向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C03" : {
      "en": "Rightward ambient light too bright. Rightward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "右视环境光过亮，右向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c04" : {
      "en": "Leftward ambient light too bright. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "左视环境光过亮，左向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C04" : {
      "en": "Leftward ambient light too bright. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "左视环境光过亮，左向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c05" : {
      "en": "Upward ambient light too bright. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "上视环境光过亮，上方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C05" : {
      "en": "Upward ambient light too bright. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "上视环境光过亮，上方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c06" : {
      "en": "Horizontal ambient light too bright. Horizontal obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "水平方向环境光过亮，水平方向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C06" : {
      "en": "Horizontal ambient light too bright. Horizontal obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "水平方向环境光过亮，水平方向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c40" : {
      "en": "Downward sensor(s) blocked. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "下视可能遮挡，下方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C40" : {
      "en": "Downward sensor(s) blocked. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "下视可能遮挡，下方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c41" : {
      "en": "Forward sensor(s) blocked. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "前视可能遮挡，前向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C41" : {
      "en": "Forward sensor(s) blocked. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "前视可能遮挡，前向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c42" : {
      "en": "Backward sensor(s) blocked. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "后视可能遮挡，后向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C42" : {
      "en": "Backward sensor(s) blocked. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "后视可能遮挡，后向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c43" : {
      "en": "Rightward sensor(s) blocked. Rightward obstacle avoidance unavailable. Only infrared sensors available.  Fly with caution",
      "zh": "右视可能遮挡，右向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C43" : {
      "en": "Rightward sensor(s) blocked. Rightward obstacle avoidance unavailable. Only infrared sensors available.  Fly with caution",
      "zh": "右视可能遮挡，右向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c44" : {
      "en": "Leftward sensor(s) blocked. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "左视可能遮挡，左向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C44" : {
      "en": "Leftward sensor(s) blocked. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "左视可能遮挡，左向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c45" : {
      "en": "Upward sensor(s) blocked. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "上视可能遮挡，上方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C45" : {
      "en": "Upward sensor(s) blocked. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "上视可能遮挡，上方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C46" : {
      "en": "Payload detected. Aircraft obstacle sensing capabilities decreased. Check radar chart and fly with caution",
      "zh": "检测到安装负载，飞行器避障能力下降，请观察雷达图谨慎飞行",
      "fr": ""
    },
    "0x1a420c80" : {
      "en": "Downward sensor(s) blurry. Downward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "下视可能脏污，下方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C80" : {
      "en": "Downward sensor(s) blurry. Downward obstacle avoidance unavailable. Fly with caution",
      "zh": "下视可能脏污，下方视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c81" : {
      "en": "Forward sensor(s) blurry. Forward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "前视可能脏污，前向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C81" : {
      "en": "Forward sensor(s) blurry. Forward obstacle avoidance unavailable. Fly with caution",
      "zh": "前视可能脏污，前向视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c82" : {
      "en": "Backward sensor(s) blurry. Backward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "后视可能脏污，后向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C82" : {
      "en": "Backward sensor(s) blurry. Backward obstacle avoidance unavailable. Fly with caution",
      "zh": "后视可能脏污，后向视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c83" : {
      "en": "Right sensor(s) blurry. Rightward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "右视可能脏污，右向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C83" : {
      "en": "Right sensor(s) blurry. Rightward obstacle avoidance unavailable. Fly with caution",
      "zh": "右视可能脏污，右向视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c84" : {
      "en": "Left sensor(s) blurry. Leftward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "左视可能脏污，左向视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C84" : {
      "en": "Left sensor(s) blurry. Leftward obstacle avoidance unavailable. Fly with caution",
      "zh": "左视可能脏污，左向视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420c85" : {
      "en": "Upward sensor(s) blurry. Upward obstacle avoidance unavailable. Only infrared sensors available. Fly with caution",
      "zh": "上视可能脏污，上方视觉避障失效，仅红外传感器工作，请谨慎飞行",
      "fr": ""
    },
    "0x1A420C85" : {
      "en": "Upward sensor(s) blurry. Upward obstacle avoidance unavailable. Fly with caution",
      "zh": "上视可能脏污，上方视觉避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420cc0" : {
      "en": "Aircraft attitude angle too large. Obstacle avoidance unavailable. Fly with caution",
      "zh": "飞行器姿态角过大，避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1A420CC0" : {
      "en": "Aircraft attitude angle too large. Obstacle avoidance unavailable. Fly with caution",
      "zh": "飞行器姿态角过大，避障失效，请谨慎飞行",
      "fr": ""
    },
    "0x1a420d00" : {
      "en": "Aircraft attitude angle too large. Landing protection unavailable. Land manually",
      "zh": "飞行器姿态角过大，降落保护失效，请手动降落",
      "fr": ""
    },
    "0x1A420D00" : {
      "en": "Aircraft attitude angle too large. Landing protection unavailable. Land manually",
      "zh": "飞行器姿态角过大，降落保护失效，请手动降落",
      "fr": ""
    },
    "0x1a420d40" : {
      "en": "Aircraft approaching obstacle sensing blind spot and may be unable to detect obstacles. Fly with caution",
      "zh": "正飞向障碍物感知盲区，可能无法检测障碍物，请谨慎飞行",
      "fr": ""
    },
    "0x1A420D40" : {
      "en": "Aircraft approaching obstacle sensing blind spot and may be unable to detect obstacles. Fly with caution",
      "zh": "正飞向障碍物感知盲区，可能无法检测障碍物，请谨慎飞行",
      "fr": ""
    },
    "0x1A421B00" : {
      "en": "Vision system disabled. Switched to radar obstacle avoidance. The obstacle avoidance available range will change",
      "zh": "视觉避障失效，已切换为雷达避障，注意可避障区间变化",
      "fr": ""
    },
    "0x1A421B40" : {
      "en": "",
      "zh": "激光雷达已连接",
      "fr": ""
    },
    "0x1A421B80" : {
      "en": "",
      "zh": "激光雷达连接已断开",
      "fr": ""
    },
    "0x1A430680" : {
      "en": "Unstable lighting conditions. Vision system and obstacle sensing may be unavailable. Fly with caution",
      "zh": "环境光线差异较大，视觉系统及避障可能失效，请注意飞行安全",
      "fr": ""
    },
    "0x1A510380" : {
      "en": "Downward vision sensor calibration error",
      "zh": "下视传感器标定异常",
      "fr": ""
    },
    "0x1A510381" : {
      "en": "Forward vision sensor calibration error",
      "zh": "前视传感器标定异常",
      "fr": ""
    },
    "0x1A510382" : {
      "en": "Backward vision sensor calibration error",
      "zh": "后视传感器标定异常",
      "fr": ""
    },
    "0x1A510383" : {
      "en": "Upward vision sensor calibration error",
      "zh": "上视传感器标定异常",
      "fr": ""
    },
    "0x1A510384" : {
      "en": "Left vision sensor calibration error",
      "zh": "左视传感器标定异常",
      "fr": ""
    },
    "0x1A510385" : {
      "en": "Right vision sensor calibration error",
      "zh": "右视传感器标定异常",
      "fr": ""
    },
    "0x1a5103c0" : {
      "en": "Downward vision sensor calibration error",
      "zh": "下视传感器标定异常",
      "fr": ""
    },
    "0x1A5103C0" : {
      "en": "Downward vision sensor calibration error",
      "zh": "下视传感器标定异常",
      "fr": ""
    },
    "0x1a5103c1" : {
      "en": "Forward vision sensor calibration error",
      "zh": "前视传感器标定异常",
      "fr": ""
    },
    "0x1A5103C1" : {
      "en": "Forward vision sensor calibration error",
      "zh": "前视传感器标定异常",
      "fr": ""
    },
    "0x1a5103c2" : {
      "en": "Backward vision sensor calibration error",
      "zh": "后视传感器标定异常",
      "fr": ""
    },
    "0x1A5103C2" : {
      "en": "Backward vision sensor calibration error",
      "zh": "后视传感器标定异常",
      "fr": ""
    },
    "0x1a5103c3" : {
      "en": "Upward vision sensor calibration error",
      "zh": "上视传感器标定异常",
      "fr": ""
    },
    "0x1A5103C3" : {
      "en": "Upward vision sensor calibration error",
      "zh": "上视传感器标定异常",
      "fr": ""
    },
    "0x1a5103c4" : {
      "en": "Left vision sensor calibration error",
      "zh": "左视传感器标定异常",
      "fr": ""
    },
    "0x1A5103C4" : {
      "en": "Left vision sensor calibration error",
      "zh": "左视传感器标定异常",
      "fr": ""
    },
    "0x1a5103c5" : {
      "en": "Right vision sensor calibration error",
      "zh": "右视传感器标定异常",
      "fr": ""
    },
    "0x1A5103C5" : {
      "en": "Right vision sensor calibration error",
      "zh": "右视传感器标定异常",
      "fr": ""
    },
    "0x1A5104C0" : {
      "en": "Downward obstacle sensing error. Fly with caution",
      "zh": "下视避障感知异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A5104C1" : {
      "en": "Forward obstacle sensing error. Fly with caution",
      "zh": "前视避障感知异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A5104C2" : {
      "en": "Backward obstacle sensing error. Fly with caution",
      "zh": "后视避障感知异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A5104C3" : {
      "en": "Upward obstacle sensing error. Fly with caution",
      "zh": "上视避障感知异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A5104C4" : {
      "en": "Left obstacle sensing error. Fly with caution",
      "zh": "左视避障感知异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A5104C5" : {
      "en": "Right obstacle sensing error. Fly with caution",
      "zh": "右视避障感知异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A5104C6" : {
      "en": "Omnidirectional obstacle sensing error. Fly with caution",
      "zh": "环视避障感知异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A5104C7" : {
      "en": "Upward and downward obstacle sensing error. Fly with caution",
      "zh": "上下避障感知异常，请谨慎飞行",
      "fr": ""
    },
    "0x1A680040" : {
      "en": "Propeller guards mounted. Obstacle Avoidance unavailable. Flight performance and wind resistance performance reduced",
      "zh": "桨叶保护罩已安装，避障功能失效，飞行性能和抗风性能降低",
      "fr": ""
    },
    "0x1A680080" : {
      "en": "Propeller guards removed",
      "zh": "桨叶保护罩已移除",
      "fr": ""
    },
    "0x1AFC0040" : {
      "en": "",
      "zh": "设置了ssd_en，但是没有插SSD",
      "fr": ""
    },
    "0x1AFC0080" : {
      "en": "",
      "zh": "存储模块丢图",
      "fr": ""
    },
    "0x1AFC0100" : {
      "en": "",
      "zh": "感知关键日志即将到达上限，请尽快降落拉取日志",
      "fr": ""
    },
    "0x1AFC0140" : {
      "en": "",
      "zh": "存在炸机日志，拉取并清理炸机日志后在进行飞测",
      "fr": ""
    },
    "0x1afd0040" : {
      "en": "Sensor system error. Unable to take off. Flight prohibited",
      "zh": "无法起飞：感知传感器系统异常，禁止起飞",
      "fr": ""
    },
    "0x1AFD0040" : {
      "en": "Sensor system error. Unable to take off. Flight prohibited",
      "zh": "无法起飞：感知传感器系统异常，禁止起飞",
      "fr": ""
    },
    "0x1afd0040_in_the_sky" : {
      "en": "Sensor system error. Return to home or land promptly",
      "zh": "感知传感器系统异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1AFD0040_in_the_sky" : {
      "en": "Sensor system error. Return to home or land promptly",
      "zh": "感知传感器系统异常，请尽快返航或降落",
      "fr": ""
    },
    "0x1afe0040" : {
      "en": "Vision system overloaded. Fly to open area",
      "zh": "视觉系统负载过高，请谨慎飞行至开阔环境",
      "fr": ""
    },
    "0x1AFE0040" : {
      "en": "Vision system overloaded. Fly to open area",
      "zh": "视觉系统负载过高，请谨慎飞行至开阔环境",
      "fr": ""
    },
    "0x1B010001" : {
      "en": "Navigation system error . Restart aircraft",
      "zh": "导航系统异常，请重启飞行器",
      "fr": ""
    },
    "0x1B010002" : {
      "en": "Target Acquisition unavailable with current payload",
      "zh": "当前负载不支持目标锁定功能",
      "fr": ""
    },
    "0x1B010003" : {
      "en": "Camera mode error. Smart Track disabled",
      "zh": "相机模式异常，智能跟踪已关闭",
      "fr": ""
    },
    "0x1B010004" : {
      "en": "Target too close",
      "zh": "距离目标物体过近",
      "fr": ""
    },
    "0x1B010005" : {
      "en": "Target lost. Target Acquisition paused",
      "zh": "目标已丢失，目标锁定功能停止",
      "fr": ""
    },
    "0x1B010006" : {
      "en": "Gimbal not facing flight direction. Fly with caution",
      "zh": "云台已偏离航向，请谨慎飞行",
      "fr": ""
    },
    "0x1B010007" : {
      "en": "Target Acquisition paused . Switch to P mode",
      "zh": "目标锁定功能停止，请切换飞行挡位至P挡",
      "fr": ""
    },
    "0x1B010007_n_mode" : {
      "en": "Target Acquisition stopped. Switch to N mode",
      "zh": "目标锁定功能停止，请切换飞行挡位至N挡",
      "fr": ""
    },
    "0x1B010008" : {
      "en": "Enabling Target Acquisition failed",
      "zh": "目标锁定功能开启失败",
      "fr": ""
    },
    "0x1B010009" : {
      "en": "Obstacle detected. Circling stopped. Manually control aircraft to avoid obstacle",
      "zh": "遇到障碍物，停止环绕，请手动控制飞机远离障碍",
      "fr": ""
    },
    "0x1B01000A" : {
      "en": "GEO Zone nearby. Circling stopped. Manually control aircraft to avoid GEO Zone",
      "zh": "遇到限飞区，停止环绕，请手动控制飞机远离限飞区",
      "fr": ""
    },
    "0x1B01000B" : {
      "en": "Smart Track paused",
      "zh": "智能跟踪功能停止",
      "fr": ""
    },
    "0x1B01000C" : {
      "en": "Target moving too fast. Circling stopped",
      "zh": "目标物体运动过快，停止环绕",
      "fr": ""
    },
    "0x1B01000D" : {
      "en": "Unusual target movement. Drag-select target again",
      "zh": "目标发生异常移动，请重新确认目标",
      "fr": ""
    },
    "0x1B01000E" : {
      "en": "GNSS signal weak, and vision positioning unavailable. Aircraft switched to A mode. Control aircraft manually",
      "zh": "卫星定位信号弱且视觉定位失效，飞行器切换至姿态模式，请手动控制飞行器",
      "fr": ""
    },
    "0x1B01000F" : {
      "en": "Target lost. Searching...",
      "zh": "目标丢失，正在搜索中",
      "fr": ""
    },
    "0x1B010010" : {
      "en": "During Smart Track, you can control gimbals within a certain limit",
      "zh": "智能跟踪时只能在一定范围内控制云台",
      "fr": ""
    },
    "0x1B010011" : {
      "en": "During Smart Track, you can control lens zoom within a certain limit",
      "zh": "智能跟踪时只能在一定范围内控制变焦",
      "fr": ""
    },
    "0x1B010401" : {
      "en": "Camera sending data error. Target acquisition stopped. Try again later",
      "zh": "相机发送数据异常，目标锁定功能停止，请稍后重试",
      "fr": ""
    },
    "0x1B010402" : {
      "en": "Camera sending data error. Smart Track stopped. Try again later",
      "zh": "相机发送数据异常，智能跟踪功能停止，请稍后重试",
      "fr": ""
    },
    "0x1B010403" : {
      "en": "Camera data sending error. Smart Track paused.",
      "zh": "相机发送数据异常，智能跟踪功能停止",
      "fr": ""
    },
    "0x1B010404" : {
      "en": "Camera sending data error. Smart Track stopped. Try again later",
      "zh": "相机数据发送异常，智能跟踪功能停止，请稍后重试",
      "fr": ""
    },
    "0x1B010405" : {
      "en": "Camera sending data error. Smart Track stopped. Try again later",
      "zh": "相机发送数据异常，智能跟踪功能停止，请稍后重试",
      "fr": ""
    },
    "0x1B010406" : {
      "en": "Camera sending data error. Smart Track stopped. Try again later",
      "zh": "相机发送数据异常，智能跟踪功能停止，请稍后重试",
      "fr": ""
    },
    "0x1B010407" : {
      "en": "Camera sending data error. Smart Track stopped. Try again later",
      "zh": "相机发送数据异常，智能跟踪功能停止，请稍后重试",
      "fr": ""
    },
    "0x1B010408" : {
      "en": "Camera sending data error. Smart Track stopped. Try again later",
      "zh": "相机发送数据异常，智能跟踪功能停止，请稍后重试",
      "fr": ""
    },
    "0x1B010801" : {
      "en": "DJI Pilot error. Target Acquisition paused. Restart DJI Pilot",
      "zh": "APP状态异常，目标锁定功能停止，请重启APP",
      "fr": ""
    },
    "0x1B010802" : {
      "en": "DJI Pilot error. Smart Track paused. Restart DJI Pilot",
      "zh": "智能跟踪功能异常，请重启APP",
      "fr": ""
    },
    "0x1B010803" : {
      "en": "DJI Pilot error. Smart Track paused. Restart DJI Pilot",
      "zh": "智能跟踪功能异常，请重启APP",
      "fr": ""
    },
    "0x1B010C01" : {
      "en": "Flight Controller data sending error. Target Acquisition paused. Restart aircraft",
      "zh": "飞控数据发送异常，目标锁定功能停止，请重启飞行器",
      "fr": ""
    },
    "0x1B010C02" : {
      "en": "Flight Controller data sending error. Smart Track paused. Restart aircraft",
      "zh": "飞控数据发送异常，智能跟踪功能停止，请重启飞行器",
      "fr": ""
    },
    "0x1B010C03" : {
      "en": "Flight Controller data sending error. Smart Track paused. Restart aircraft",
      "zh": "飞控数据发送异常，智能跟踪功能停止，请重启飞行器",
      "fr": ""
    },
    "0x1B011001" : {
      "en": "Gimbal data sending error. Target Acquisition paused. Reinstall payload",
      "zh": "云台数据发送异常，目标锁定功能停止，请重新拔插负载",
      "fr": ""
    },
    "0x1B011002" : {
      "en": "Gimbal data sending error. Smart Track paused. Reinstall payload",
      "zh": "云台数据发送异常，智能跟踪功能停止，请重新拔插负载",
      "fr": ""
    },
    "0x1B011003" : {
      "en": "Gimbal data sending error. Smart Track paused. Reinstall payload",
      "zh": "云台数据发送异常，智能跟踪功能停止，请重新拔插负载",
      "fr": ""
    },
    "0x1B011801" : {
      "en": "Remote controller data sending error. Target Acquisition stopped. Restart RC",
      "zh": "遥控器数据发送异常，目标锁定功能停止，请重启遥控器",
      "fr": ""
    },
    "0x1B011802" : {
      "en": "Remote controller data sending error. Target Acquisition paused. Check connection between RC and aircraft",
      "zh": "遥控器数据发送异常，目标锁定功能停止，请检查遥控器与飞行器的连接状况",
      "fr": ""
    },
    "0x1B030001" : {
      "en": "Obstacle detected. RTH stopped. Manually control aircraft to avoid obstacle",
      "zh": "遇到障碍物，自动返航停止，请手动控制飞机远离障碍",
      "fr": ""
    },
    "0x1B030002" : {
      "en": "GEO Zone nearby. RTH stopped. Manually control aircraft to avoid GEO Zone",
      "zh": "遇到限飞区，自动返航停止，请手动控制飞机远离限飞区",
      "fr": ""
    },
    "0x1B030003" : {
      "en": "RTH error. Fly aircraft manually",
      "zh": "自动返航异常，请切换至手动飞行",
      "fr": ""
    },
    "0x1B030004" : {
      "en": "Aircraft signal lost. RTH started",
      "zh": "飞行器失联，开始返航",
      "fr": ""
    },
    "0x1B030005" : {
      "en": "Enabling RTH Obstacle Check failed. Control aircraft to return to home manually",
      "zh": "自动返航避障功能启动失败，请切换至手动返航",
      "fr": ""
    },
    "0x1B030006" : {
      "en": "Obstacle avoidance or backlight detected. Press the Pause button on the remote controller to exit RTH and manually control aircraft to return to home",
      "zh": "遇到障碍物或环境逆光，请按遥控器上暂停键退出自动返航，进行手动返航",
      "fr": ""
    },
    "0x1B030007" : {
      "en": "Control stick pushed down. Aircraft descending. Aircraft RTH canceled",
      "zh": "检测到打杆下降，已退出自动返航",
      "fr": ""
    },
    "0x1B030008" : {
      "en": "Control stick pushed down. Aircraft flying backward. Aircraft RTH canceled",
      "zh": "检测到打杆后退，已退出自动返航",
      "fr": ""
    },
    "0x1B03000D" : {
      "en": "Positioning poor during RTH. Unable to continue RTH. Manually control aircraft to return to home",
      "zh": "返航过程中定位不佳，无法继续返航。请手动控制飞机返航",
      "fr": ""
    },
    "0x1B030010" : {
      "en": "Approaching evening. Setting RTH altitude recommended",
      "zh": "临近或已处于夜晚，请提前设置好返航高度",
      "fr": ""
    },
    "0x1B030011" : {
      "en": "Failed to fly optimal RTH route. Aircraft returning at preset altitude",
      "zh": "智能返航失效，将执行设定高度返航",
      "fr": ""
    },
    "0x1B030012" : {
      "en": "Aircraft accelerating. Battery draining faster",
      "zh": "返航加速中，电量消耗加速",
      "fr": ""
    },
    "0x1B030013" : {
      "en": "RTH stopped. Control stick moved opposite to flight direction",
      "zh": "返航过程中用户反向打杆，退出返航。",
      "fr": ""
    },
    "0x1B030014" : {
      "en": "Battery level low. Return to home promptly",
      "zh": "电量不足请尽快返航",
      "fr": ""
    },
    "0x1B030015" : {
      "en": "Home Point in Altitude Zone. Aircraft will return at lower altitude",
      "zh": "返航点在限高区内，将降低返航高度",
      "fr": ""
    },
    "0x1B030016" : {
      "en": "Complex environment. RTH stopped. Manually control aircraft to return to home",
      "zh": "环境复杂，返航中断，请手动返航。",
      "fr": ""
    },
    "0x1B030017" : {
      "en": "Unable to return to home due to low battery level. Aircraft may land earlier. Selecting alternate landing site recommended",
      "zh": "电量不足以完成返航，可能提前降落，请注意选择备降位置",
      "fr": ""
    },
    "0x1B030018" : {
      "en": "Max flight altitude limit too low. Flight safety during RTH affected",
      "zh": "限高过低影响返航飞行安全",
      "fr": ""
    },
    "0x1b030019" : {
      "en": "Aircraft not flying along route. Safe RTH exited",
      "zh": "飞行器已偏离航线，航线安全返航失效",
      "fr": ""
    },
    "0x1B030019" : {
      "en": "Aircraft not flying along route. Safe RTH exited",
      "zh": "飞行器已偏离航线，航线安全返航失效",
      "fr": ""
    },
    "0x1B03001A" : {
      "en": "Vision positioning unavailable. Unable to return to home. Confirm area below is safe and land aircraft manually",
      "zh": "视觉定位失效无法继续返航，请确认下方安全后手动降落",
      "fr": ""
    },
    "0x1B03002B" : {
      "en": "Obstacle sensed during RTH. Pay attention to remaining battery level and be prepared to manually control aircraft",
      "zh": "返航中触发避障,请注意剩余电量,及时接管",
      "fr": ""
    },
    "0x1B03002C" : {
      "en": "",
      "zh": "返航路线变化，返航剩余电量不准。拉取log并提单给规划同事分析",
      "fr": ""
    },
    "0x1B03002D" : {
      "en": "",
      "zh": "环境风速变化大，返航剩余电量不准。拉取log给规划同事分析，无需提单",
      "fr": ""
    },
    "0x1B03002E" : {
      "en": "",
      "zh": "返航速度不稳定，返航剩余电量不准。拉取log并提单给规划同事分析",
      "fr": ""
    },
    "0x1B03002F" : {
      "en": "",
      "zh": "飞行器功率异常，返航剩余电量不准。拉取log并提单给规划同事分析",
      "fr": ""
    },
    "0x1B030030" : {
      "en": "Aircraft approaching Dynamic Home Point. RTH exited. Control aircraft manually",
      "zh": "动态返航已完成，自动退出返航模式，请注意接管飞行器",
      "fr": ""
    },
    "0x1B030031" : {
      "en": "",
      "zh": "电池能量估计异常，返航剩余电量不准。拉取log并提单给电池同事分析",
      "fr": ""
    },
    "0x1B030032" : {
      "en": "",
      "zh": "电池能量估计偏差过大，返航剩余电量不准。拉取log并提单给电池同事分析",
      "fr": ""
    },
    "0x1B030033" : {
      "en": "Aircraft power consumption higher than estimated. Pay attention to remaining battery level and fly safely",
      "zh": "飞行器功率偏大，请注意剩余电量，安全飞行",
      "fr": ""
    },
    "0x1b030034" : {
      "en": "Strong interference or spoofing of positioning signal. Return to home promptly",
      "zh": "检测到定位信号强干扰或诱骗，请立即返航",
      "fr": ""
    },
    "0x1B030C01" : {
      "en": "",
      "zh": "",
      "fr": ""
    },
    "0x1B030C02" : {
      "en": "GNSS signal weak. RTH accuracy low. It is recommended to manually control aircraft to return to home",
      "zh": "卫星定位信号弱，自动返航精度低，建议切换至手动返航",
      "fr": ""
    },
    "0x1B040001" : {
      "en": "Focused shooting unavailable with current payload",
      "zh": "当前负载不支持精准拍照",
      "fr": ""
    },
    "0x1B040002" : {
      "en": "Focused shooting failed . Switched to normal shooting mode",
      "zh": "精准拍照失败，执行普通拍照",
      "fr": ""
    },
    "0x1B040003" : {
      "en": "AI Spot-Check failed. Switched to normal shooting mode",
      "zh": "精准复拍失败，执行普通拍照",
      "fr": ""
    },
    "0x1B040004" : {
      "en": "Camera not mounted. Focused shooting failed",
      "zh": "未挂载相机，精准拍照失败",
      "fr": ""
    },
    "0x1B040401" : {
      "en": "Camera zoom timed out. AI Spot-Check failed. Try again later",
      "zh": "相机变焦超时，精准复拍失败，请稍后重试",
      "fr": ""
    },
    "0x1B040402" : {
      "en": "Switching shooting modes failed. AI Spot-Check failed. Try again later",
      "zh": "切换相机拍照模式失败，精准复拍失败，请稍后重试",
      "fr": ""
    },
    "0x1B040403" : {
      "en": "Camera zoom timed out. AI Spot-Check failed. Try again later",
      "zh": "相机变焦超时，精准复拍失败，请稍后重试",
      "fr": ""
    },
    "0x1B040801" : {
      "en": "Unable to locate focused shooting sample. Reupload flight route",
      "zh": "精准拍照示意图未找到，请重新上传航线",
      "fr": ""
    },
    "0x1B040802" : {
      "en": "Target box parameter error. Readjust target box",
      "zh": "目标框参数错误，请调整目标框",
      "fr": ""
    },
    "0x1B041001" : {
      "en": "Gimbal error. Focused shooting failed. Reinstall payload",
      "zh": "云台异常，精准拍照失败，请重新拔插负载",
      "fr": ""
    },
    "0x1B050010" : {
      "en": "Failed to update Dynamic Home Point. Unable to obtain remote controller positioning info",
      "zh": "无法获取遥控器定位信息，无法刷新动态返航点",
      "fr": ""
    },
    "0x1B050011" : {
      "en": "Remote controller positioning info obtained. Updating Dynamic Home Point...",
      "zh": "重新获取遥控器定位信息，继续刷新动态返航点",
      "fr": ""
    },
    "0x1B050012" : {
      "en": "Failed to update Dynamic Home Point. Remote controller positioning accuracy low",
      "zh": "当前遥控器定位精度低，无法刷新动态返航点",
      "fr": ""
    },
    "0x1B050013" : {
      "en": "Dynamic Home Point update stopped. Remote controller in Restricted Zone",
      "zh": "当前遥控器进入禁飞区，暂停刷新动态返航点",
      "fr": ""
    },
    "0x1B050014" : {
      "en": "Remote controller not in Restricted Zone. Updating Dynamic Home Point...",
      "zh": "当前遥控器离开禁飞区，继续刷新动态返航点",
      "fr": ""
    },
    "0x1B050015" : {
      "en": "Home Point update stopped. Remote controller far away from aircraft",
      "zh": "当前遥控器距离飞行器过远，暂停刷新返航点",
      "fr": ""
    },
    "0x1B050016" : {
      "en": "Failed to update Dynamic Home Point. Unable to obtain remote controller positioning info",
      "zh": "无法获取遥控器定位信息，无法刷新动态返航点",
      "fr": ""
    },
    "0x1B050017" : {
      "en": "Failed to update Dynamic Home Point. Remote controller positioning accuracy low",
      "zh": "当前遥控器定位精度低，无法刷新动态返航点",
      "fr": ""
    },
    "0x1B060001" : {
      "en": "Flight speed limited. Firmware update required",
      "zh": "飞行速度受限，固件需要升级",
      "fr": ""
    },
    "0x1B070001" : {
      "en": "Payload exceeds capacity. Reduce payload or adjust flight plan",
      "zh": "货物超重，请减少货物或修改飞行计划",
      "fr": ""
    },
    "0x1B070001_in_the_sky" : {
      "en": "Payload exceeds capacity. Land promptly and reduce payload",
      "zh": "货物超重，请尽快降落，减少货物",
      "fr": ""
    },
    "0x1B070002" : {
      "en": "Payload weight not evenly distributed. Adjust payload placement",
      "zh": "货物重心偏移，请重新摆放货物",
      "fr": ""
    },
    "0x1B070002_in_the_sky" : {
      "en": "Payload weight not evenly distributed. Land promptly and adjust payload placement",
      "zh": "货物重心偏移，请尽快降落，重新摆放货物",
      "fr": ""
    },
    "0x1B070003" : {
      "en": "Cargo case weight sensor error",
      "zh": "货箱称重传感器异常",
      "fr": ""
    },
    "0x1B070004" : {
      "en": "Weight sensor error. Calibrate cargo case weight sensor",
      "zh": "称重异常，请重新校准货箱称重传感器",
      "fr": ""
    },
    "0x1B070005" : {
      "en": "Weight sensor error. Calibrate cargo case weight sensor",
      "zh": "称重异常，请重新校准货箱称重传感器",
      "fr": ""
    },
    "0x1B070006" : {
      "en": "Payload exceeds capacity. Reduce payload or adjust flight plan",
      "zh": "货物超重，请减少货物或修改飞行计划",
      "fr": ""
    },
    "0x1B070006_in_the_sky" : {
      "en": "Payload exceeds capacity. Land promptly and reduce payload",
      "zh": "货物超重，请尽快降落，减少货物",
      "fr": ""
    },
    "0x1B070008" : {
      "en": "Winch system weight sensor error",
      "zh": "空吊称重传感器异常",
      "fr": ""
    },
    "0x1B070009" : {
      "en": "Weight sensor error. Calibrate winch system weight sensor",
      "zh": "称重异常，请重新校准空吊称重传感器",
      "fr": ""
    },
    "0x1B07000A" : {
      "en": "Weight sensor error. Calibrate winch system weight sensor",
      "zh": "称重异常，请重新校准空吊称重传感器",
      "fr": ""
    },
    "0x1B07000B" : {
      "en": "Swing angle too large. Fly with caution",
      "zh": "空吊摆角过大，请谨慎飞行",
      "fr": ""
    },
    "0x1B07000C" : {
      "en": "Cable broke. Check payload on winch system",
      "zh": "空吊绳索断裂，请检查吊挂货物",
      "fr": ""
    },
    "0x1B07000D" : {
      "en": "Winch system motor stalled. Check payload on winch system",
      "zh": "空吊电机堵转，请检查吊挂货物",
      "fr": ""
    },
    "0x1B07000E" : {
      "en": "Winch system motor overheated. Check if payload exceeds capacity",
      "zh": "空吊电机温度过高，请检查货物是否超重",
      "fr": ""
    },
    "0x1b080001" : {
      "en": "Remote ID broadcast error. Failed to obtain remote controller location",
      "zh": "Remote ID 播报异常，无法获取遥控器位置",
      "fr": ""
    },
    "0x1B080001" : {
      "en": "Remote ID broadcast error. Failed to obtain remote controller location",
      "zh": "Remote ID 播报异常，无法获取遥控器位置",
      "fr": ""
    },
    "0x1b080002" : {
      "en": "Remote ID module error. Contact DJI Support",
      "zh": "Remote ID 模块异常，请联系售后服务",
      "fr": ""
    },
    "0x1B080002" : {
      "en": "Remote ID module error. Contact DJI Support",
      "zh": "Remote ID 模块异常，请联系售后服务",
      "fr": ""
    },
    "0x1B090001" : {
      "en": "Target tracking stopped",
      "zh": "停止目标追踪",
      "fr": ""
    },
    "0x1B090002" : {
      "en": "Target tracking stopped",
      "zh": "停止智能跟踪",
      "fr": ""
    },
    "0x1B090003" : {
      "en": "Target tracking stopped",
      "zh": "停止智能跟踪",
      "fr": ""
    },
    "0x1B092C01" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C02" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C03" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C04" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C05" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C06" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C07" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C08" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C09" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C0A" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C0B" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C0C" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C0D" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C0E" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C0F" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C10" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C11" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C12" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C13" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C14" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C15" : {
      "en": "Target identification error",
      "zh": "目标识别异常",
      "fr": ""
    },
    "0x1B092C16" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C17" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C18" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C19" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C1A" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C1B" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C1C" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C1D" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C1E" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C1F" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C20" : {
      "en": "Enabling Smart Track failed. Ensure selected target is valid",
      "zh": "智能追踪功能启动失败，请确保框选有效目标",
      "fr": ""
    },
    "0x1B092C21" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C22" : {
      "en": "Enabling Smart Track failed. Reduce selected area",
      "zh": "智能追踪功能启动失败，请缩小目标区域",
      "fr": ""
    },
    "0x1B092C23" : {
      "en": "Enabling Smart Track failed. Increase selected area",
      "zh": "智能追踪功能启动失败，请扩大目标区域",
      "fr": ""
    },
    "0x1B092C24" : {
      "en": "Enabling Smart Track failed. Ensure selected target is valid",
      "zh": "智能跟踪功能启动失败，请确保框选有效目标",
      "fr": ""
    },
    "0x1B092C25" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B092C26" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093001" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093002" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093003" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093004" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093005" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093006" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093007" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093008" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093009" : {
      "en": "Enabling Smart Track failed. Increase selected area",
      "zh": "智能跟踪功能启动失败，请扩大目标区域",
      "fr": ""
    },
    "0x1B09300A" : {
      "en": "Enabling Smart Track failed. Ensure selected target is valid",
      "zh": "智能跟踪功能启动失败，请确保框选有效目标",
      "fr": ""
    },
    "0x1B09300B" : {
      "en": "Target lost. Exited Target Acquisition",
      "zh": "目标已丢失，目标锁定功能已退出",
      "fr": ""
    },
    "0x1B09300C" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B09300D" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B09300E" : {
      "en": "Camera parameters changed. Exited Target Acquisition",
      "zh": "相机参数被修改，目标锁定功能退出",
      "fr": ""
    },
    "0x1B09300F" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093010" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093011" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093012" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093013" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093014" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093015" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093016" : {
      "en": "Target lost. Exited Smart Track",
      "zh": "目标已丢失，智能跟踪功能已退出",
      "fr": ""
    },
    "0x1B093017" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B093018" : {
      "en": "Target too far away. Exited Target Acquisition",
      "zh": "目标距离过远，目标锁定功能已退出",
      "fr": ""
    },
    "0x1B093019" : {
      "en": "Camera parameters changed. Exited Smart Track",
      "zh": "相机参数被修改，智能跟踪功能退出",
      "fr": ""
    },
    "0x1B09301A" : {
      "en": "Enabling Smart Track failed. Check and try again",
      "zh": "智能跟踪功能启动失败，请重试",
      "fr": ""
    },
    "0x1B0A0001" : {
      "en": "GNSS signal weak. Geo-awareness function degraded. Fly with caution",
      "zh": "卫星定位信号弱，地理感知功能降级，请谨慎飞行",
      "fr": ""
    },
    "0x1B0A0002" : {
      "en": "Failed to load dynamic safety data. Geo-awareness function degraded. It is recommended to update FlySafe database",
      "zh": "动态安全数据加载失败，地理感知功能降级，建议更新飞行安全数据库",
      "fr": ""
    },
    "0x1B0A0003" : {
      "en": "Failed to query dynamic safety data. Geo-awareness function degraded. It is recommended to update FlySafe database",
      "zh": "动态安全数据查询失败，地理感知功能降级，建议更新飞行安全数据库",
      "fr": ""
    },
    "0x1B0A0004" : {
      "en": "FlySafe data density high in current region. Aircraft may not be able to fully process data. It is recommended to update FlySafe database",
      "zh": "限飞数据库在当前区域数据密度较高，可能会出现飞行器解析不完整的情况，建议更新飞行安全数据库。",
      "fr": ""
    },
    "0x1B0B0001" : {
      "en": "Unable to take off. Failed to obtain aircraft location. Take off in open area",
      "zh": "无法起飞：未获取飞行器位置，请在开阔区域起飞",
      "fr": ""
    },
    "0x1B0B0001_in_the_sky" : {
      "en": "Failed to obtain aircraft location. Take off in open area",
      "zh": "未获取飞行器位置，请在开阔区域飞行",
      "fr": ""
    },
    "0x1B0B0002" : {
      "en": "Unable to take off. Take off inside geo-cage",
      "zh": "无法起飞：请在地理鸟笼区域内起飞",
      "fr": ""
    },
    "0x1B0B0002_in_the_sky" : {
      "en": "Fly aircraft inside geo-cage",
      "zh": "请在地理鸟笼区域内飞行",
      "fr": ""
    },
    "0x1B0B0003" : {
      "en": "Unable to take off. No geo-cage data found",
      "zh": "无法起飞：飞行器无地理鸟笼数据",
      "fr": ""
    },
    "0x1B0B0003_in_the_sky" : {
      "en": "No geo-cage data found. Return to home promptly",
      "zh": "飞行器无地理鸟笼数据，请尽快返航",
      "fr": ""
    },
    "0x1B0B0004" : {
      "en": "Unable to take off. Geo-cage data error",
      "zh": "无法起飞：地理鸟笼数据异常",
      "fr": ""
    },
    "0x1B0B0004_in_the_sky" : {
      "en": "Geo-cage data error. Return to home promptly",
      "zh": "飞行鸟笼数据异常，请尽快返航",
      "fr": ""
    },
    "0x1B0B0005" : {
      "en": "Unable to take off. Geo-cage function error",
      "zh": "无法起飞：地理鸟笼功能异常",
      "fr": ""
    },
    "0x1B0B0005_in_the_sky" : {
      "en": "Geo-cage function error. Return to home promptly",
      "zh": "地理鸟笼功能异常，请尽快返航",
      "fr": ""
    },
    "0x1B0B0006" : {
      "en": "Unable to fly automatically. Manually fly aircraft back to flight geography area",
      "zh": "无法自动飞行，请手动操控返回作业区域",
      "fr": ""
    },
    "0x1B0B0006_in_the_sky" : {
      "en": "Unable to fly automatically. Manually fly aircraft back to flight geography area",
      "zh": "无法自动飞行，请手动操控返回作业区域",
      "fr": ""
    },
    "0x1B0B0007" : {
      "en": "Home Point should be set in flight geography area of geo-cage",
      "zh": "返航点需设置在地理鸟笼作业区域内",
      "fr": ""
    },
    "0x1B0B0007_in_the_sky" : {
      "en": "Home Point should be set in flight geography area of geo-cage",
      "zh": "返航点需设置在地理鸟笼作业区域内",
      "fr": ""
    },
    "0x1B0B0008" : {
      "en": "Unable to return to home automatically. Manually fly aircraft back to flight geography area",
      "zh": "无法自动返航，请手动操控返回作业区域",
      "fr": ""
    },
    "0x1B0B0008_in_the_sky" : {
      "en": "Unable to return to home automatically. Manually fly aircraft back to flight geography area",
      "zh": "无法自动返航，请手动操控返回作业区域",
      "fr": ""
    },
    "0x1B0C0001" : {
      "en": "",
      "zh": "禁降区数据库不可用，请重新导入禁降区数据库文件",
      "fr": ""
    },
    "0x1B0C0001_in_the_sky" : {
      "en": "",
      "zh": "禁降区数据库不可用，请重新导入禁降区数据库文件",
      "fr": ""
    },
    "0x1B0C0002" : {
      "en": "",
      "zh": "飞行器处于禁降区内，10s 后将自动飞离禁降区，可持续向下打杆退出",
      "fr": ""
    },
    "0x1B0C0002_in_the_sky" : {
      "en": "",
      "zh": "飞行器处于禁降区内，10s 后将自动飞离禁降区，可持续向下打杆退出",
      "fr": ""
    },
    "0x1B0C0003" : {
      "en": "",
      "zh": "正在飞离禁降区并返航",
      "fr": ""
    },
    "0x1B0C0003_in_the_sky" : {
      "en": "",
      "zh": "正在飞离禁降区并返航",
      "fr": ""
    },
    "0x1B0C0004" : {
      "en": "",
      "zh": "正在飞离禁降区，可持续向下打杆退出",
      "fr": ""
    },
    "0x1B0C0004_in_the_sky" : {
      "en": "",
      "zh": "正在飞离禁降区，可持续向下打杆退出",
      "fr": ""
    },
    "0x1B0C0005" : {
      "en": "",
      "zh": "自动飞离禁降区功能受限，飞行器即将原地降落。请确认降落环境是否安全或打杆接管飞行器",
      "fr": ""
    },
    "0x1B0C0005_in_the_sky" : {
      "en": "",
      "zh": "自动飞离禁降区功能受限，飞行器即将原地降落。请确认降落环境是否安全或打杆接管飞行器",
      "fr": ""
    },
    "0x1B0C0006" : {
      "en": "",
      "zh": "已成功飞离禁降区，飞行器即将降落",
      "fr": ""
    },
    "0x1B0C0006_in_the_sky" : {
      "en": "",
      "zh": "已成功飞离禁降区，飞行器即将降落",
      "fr": ""
    },
    "0x1B0C0007" : {
      "en": "",
      "zh": "已退出自动飞离禁降区功能，飞行器即将原地降落，请确认降落环境是否安全",
      "fr": ""
    },
    "0x1B0C0007_in_the_sky" : {
      "en": "",
      "zh": "已退出自动飞离禁降区功能，飞行器即将原地降落，请确认降落环境是否安全",
      "fr": ""
    },
    "0x1B100000" : {
      "en": "Target lost. Tracking stopped",
      "zh": "目标丢失，跟踪停止",
      "fr": ""
    },
    "0x1B100001" : {
      "en": "Target too small. Easy to lose",
      "zh": "目标较小，容易丢失",
      "fr": ""
    },
    "0x1B300001" : {
      "en": "Unable to obtain cargo case data. Make sure cargo case is installed properly",
      "zh": "无法获得货箱数据，请检查安装情况",
      "fr": ""
    },
    "0x1B300002" : {
      "en": "Winch system communication error. Check winch system connection",
      "zh": "空吊设备通信异常，请检查设备连接状况",
      "fr": ""
    },
    "0x1B300003" : {
      "en": "Payload exceeds capacity. Reduce payload and adjust flight plan",
      "zh": "货物过重，请减少货物和修改飞行计划",
      "fr": ""
    },
    "0x1B300004" : {
      "en": "Payload exceeds capacity. Cancel flight",
      "zh": "货物超重，请终止飞行计划",
      "fr": ""
    },
    "0x1B300005" : {
      "en": "Payload weight not evenly distributed. Secure payload in center of cargo case",
      "zh": "货物偏离中心，请把货物摆放在货箱中心",
      "fr": ""
    },
    "0x1B300006" : {
      "en": "Cargo case severely imbalanced. Secure payload in center of cargo case",
      "zh": "货物严重偏离中心，请把货物摆放在货箱中心",
      "fr": ""
    },
    "0x1B300007" : {
      "en": "Cargo case wobbling. Secure cargo case and payload inside",
      "zh": "货箱晃动，请绑好货箱或固定货物在货箱中的位置",
      "fr": ""
    },
    "0x1B300008" : {
      "en": "Cargo case wobbles significantly. Secure cargo case and payload inside",
      "zh": "货箱晃动严重，请绑好货箱或固定货物在货箱中的位置",
      "fr": ""
    },
    "0x1B300009" : {
      "en": "Payload on winch system exceeds capacity. Reduce payload and adjust flight plan",
      "zh": "挂载货物过重，请减少货物和修改飞行计划",
      "fr": ""
    },
    "0x1B30000A" : {
      "en": "Payload on winch system exceeds capacity. Cancel flight",
      "zh": "挂载货物超重，请终止飞行计划",
      "fr": ""
    },
    "0x1B30000B" : {
      "en": "Payload swings slightly. Fly with caution",
      "zh": "挂载货物小幅摆动，请注意飞行安全",
      "fr": ""
    },
    "0x1B30000C" : {
      "en": "Payload swings significantly. Fly with caution",
      "zh": "挂载货物大幅摆动，请注意飞行安全",
      "fr": ""
    },
    "0x1B30000D" : {
      "en": "Payload on winch system approaching obstacle. Fly with caution",
      "zh": "挂载货物接近障碍物，请注意飞行安全",
      "fr": ""
    },
    "0x1B30000E" : {
      "en": "Payload on winch system very close to obstacle. Fly with caution",
      "zh": "挂载货物非常接近障碍物，请注意飞行安全",
      "fr": ""
    },
    "0x1B30000F" : {
      "en": "Extending or retracting winch cable is prohibited during flight. Make sure aircraft is hovering before extending or retracting winch cable",
      "zh": "飞行过程中禁止收放空吊线缆，请悬停后再进行线缆收放",
      "fr": ""
    },
    "0x1B300010" : {
      "en": "Payload swings greatly. Do not reel up winch cable. Wait until payload swing reduces before reeling up",
      "zh": "货物摆动大，禁止空吊收绳，请等待摆动减小后再收绳",
      "fr": ""
    },
    "0x1B310001" : {
      "en": "Battery level too low to complete flight mission. Adjust flight plan",
      "zh": "当前电量不够完成航线任务，请更改飞行计划",
      "fr": ""
    },
    "0x1B310001_in_the_sky" : {
      "en": "Battery level too low to complete flight mission. Adjust flight plan",
      "zh": "当前电量不够完成航线任务，请更改飞行计划",
      "fr": ""
    },
    "0x1B310002" : {
      "en": "Battery level too low to fly to alternate landing site. Land promptly",
      "zh": "当前电量不够前往备降点，请尽快降落",
      "fr": ""
    },
    "0x1B310002_in_the_sky" : {
      "en": "Battery level too low to fly to alternate landing site. Land promptly",
      "zh": "当前电量不够前往备降点，请尽快降落",
      "fr": ""
    },
    "0x1B310003" : {
      "en": "Current payload exceeds propulsion system capability limit. Motors may be overheated. Reduce payload weight before taking off",
      "zh": "当前载重超过动力系统载重限制，可能导致电机超温，请降低载重后起飞",
      "fr": ""
    },
    "0x1B310003_in_the_sky" : {
      "en": "Current payload exceeds propulsion system capability limit. Motors may be overheated. Return to home or land promptly",
      "zh": "当前载重超过动力系统载重限制，可能导致电机超温，请尽快返航或降落",
      "fr": ""
    },
    "0x1B310004" : {
      "en": "Current payload exceeds battery capability limit. Battery may be damaged. Reduce payload weight before taking off",
      "zh": "当前载重超过电池限制，可能导致电池损坏，请降低载重后起飞",
      "fr": ""
    },
    "0x1B310004_in_the_sky" : {
      "en": "Current payload exceeds battery capability limit. Battery may be damaged. Return to home or land promptly",
      "zh": "当前载重超过电池限制，可能导致电池损坏，请尽快返航或降落",
      "fr": ""
    },
    "0x1B310005" : {
      "en": "Altitude detection function of radar module unavailable. Safe altitude changed. Fly with caution",
      "zh": "雷达模块高度探测失效，安全飞行高度发生变更，请注意飞行安全",
      "fr": ""
    },
    "0x1B310006" : {
      "en": "Altitude detection function of radar module available. Safe altitude changed. Fly with caution",
      "zh": "雷达模块高度探测恢复正常，安全飞行高度发生变更，请注意飞行安全",
      "fr": ""
    },
    "0x1B310007" : {
      "en": "Aircraft in area with terrain data. Fly under safe altitude",
      "zh": "飞行器处于地形数据区域，请在安全飞行高度以下飞行",
      "fr": ""
    },
    "0x1B310007_in_the_sky" : {
      "en": "Aircraft entered area with terrain data. Safe altitude changed",
      "zh": "飞行器进入地形数据区域，安全飞行高度发生变更",
      "fr": ""
    },
    "0x1B310008" : {
      "en": "Aircraft not in area with terrain data. Apply terrain data",
      "zh": "飞行器不在地形数据区域，请应用地形数据",
      "fr": ""
    },
    "0x1B310008_in_the_sky" : {
      "en": "Aircraft out of area with terrain data. Safe altitude changed. Fly with caution",
      "zh": "飞行器飞出地形数据区域，安全飞行高度发生变更，请注意飞行安全",
      "fr": ""
    },
    "0x1B310009" : {
      "en": "Aircraft flight altitude exceeded safe altitude. Fly aircraft under safe altitude",
      "zh": "飞行器当前飞行高度超过安全飞行高度，请在安全飞行高度以下飞行",
      "fr": ""
    },
    "0x1B31000A" : {
      "en": "Winch system not fully reeled up. Propellers may be impacted during landing. Reel up cable before landing",
      "zh": "空吊未收到位，降落存在打桨风险，请收绳后再降落",
      "fr": ""
    },
    "0x1B31000B" : {
      "en": "Aircraft Stops. Fly with caution",
      "zh": "飞行器急停，请注意飞行安全",
      "fr": ""
    },
    "0x1B31000B_in_the_sky" : {
      "en": "Aircraft Stops. Fly with caution",
      "zh": "飞行器急停，请注意飞行安全",
      "fr": ""
    },
    "0x1B310011" : {
      "en": "Battery temperature low. Warm up battery before takeoff",
      "zh": "电池温度低，请加热后起飞",
      "fr": ""
    },
    "0x1B310011_in_the_sky" : {
      "en": "Battery temperature low. Fly with caution",
      "zh": "电池温度低，请谨慎飞行",
      "fr": ""
    },
    "0x1BA10000" : {
      "en": "Cruise control enabled",
      "zh": "当前在杆量保持中",
      "fr": ""
    },
    "0x1BA10001" : {
      "en": "Aircraft not in flight. Cruise control disabled",
      "zh": "未起飞，已终止定速巡航",
      "fr": ""
    },
    "0x1BA10002" : {
      "en": "Switching flight modes. Cruise control disabled",
      "zh": "飞行模式切换中，已终止定速巡航",
      "fr": ""
    },
    "0x1BA10003" : {
      "en": "Aircraft braking. Cruise control disabled",
      "zh": "紧急刹车中，已终止定速巡航",
      "fr": ""
    },
    "0x1BA10004" : {
      "en": "Flight speed limited. Cruise control disabled",
      "zh": "飞机速度受到限制，已终止定速巡航",
      "fr": ""
    },
    "0x1BA10005" : {
      "en": "Aircraft approaching the set max flight altitude or distance. Cruise control disabled",
      "zh": "飞机接近最大限制高度或最远限制距离，已终止定速巡航",
      "fr": ""
    },
    "0x1BA10006" : {
      "en": "Cruise control unavailable in current flight mode. Cruise control disabled",
      "zh": "当前飞行模式不支持定速巡航，已终止定速巡航",
      "fr": ""
    },
    "0x1BA10007" : {
      "en": "Aircraft braking. Cruise control disabled",
      "zh": "紧急刹车中，已终止杆量保持",
      "fr": ""
    },
    "0x1BA10008" : {
      "en": "Remote controller signal lost. Cruise control disabled",
      "zh": "遥控器信号丢失，已终止定速巡航",
      "fr": ""
    },
    "0x1BA10009" : {
      "en": "Aircraft reached the destination point. Cruise Control exited",
      "zh": "到达航线终点，定速巡航已退出",
      "fr": ""
    },
    "0x1C000001" : {
      "en": "",
      "zh": "X号云台相机过热，请等待降温后再使用",
      "fr": ""
    },
    "0x1C000103" : {
      "en": "Camera processor temperature high (%alarmid). Power off aircraft and wait for temperature to return to normal before use",
      "zh": "相机芯片温度高（%alarmid），请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C000103_in_the_sky" : {
      "en": "Camera processor temperature high (%alarmid). Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度高（%alarmid），请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C000104" : {
      "en": "Camera processor temperature too high. Power off aircraft.  Wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C000104_in_the_sky" : {
      "en": "Camera processor temperature too high. Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C000201" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000202" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000203" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000204" : {
      "en": "Camera image sensor overheated",
      "zh": "相机图像传感器温度过高",
      "fr": ""
    },
    "0x1C000207" : {
      "en": "Check if camera connection cable is loose or has been eroded",
      "zh": "请检查FPV接线是否松脱或腐蚀",
      "fr": ""
    },
    "0x1C00020A" : {
      "en": "Image sensor calibration data error. Restart aircraft",
      "zh": "图像传感器标定数据异常，请重启",
      "fr": ""
    },
    "0x1C000303" : {
      "en": "Camera connection error. Restart camera and check whether camera is installed properly",
      "zh": "镜头连接异常，请检查镜头是否正确安装",
      "fr": ""
    },
    "0x1C000305" : {
      "en": "Shutter trigger count reached 100K design limit",
      "zh": "快门使用次数达到十万次",
      "fr": ""
    },
    "0x1C000306" : {
      "en": "Non-DJI Enterprise lens",
      "zh": "非DJI ENTERPRISE镜头",
      "fr": ""
    },
    "0x1C000310" : {
      "en": "Camera lens not detected",
      "zh": "相机镜头未连接",
      "fr": ""
    },
    "0x1C000311" : {
      "en": "Camera lens error. Re-install lens",
      "zh": "相机镜头故障，请尝试重新安装镜头",
      "fr": ""
    },
    "0x1C000312" : {
      "en": "Camera lens error. Re-install lens",
      "zh": "相机镜头故障，请尝试重新安装镜头",
      "fr": ""
    },
    "0x1C000313" : {
      "en": "Camera lens error. Re-install lens",
      "zh": "相机镜头故障，请尝试重新安装镜头",
      "fr": ""
    },
    "0x1C000314" : {
      "en": "Camera lens error. Re-install lens",
      "zh": "相机镜头故障，请尝试重新安装镜头",
      "fr": ""
    },
    "0x1C000317" : {
      "en": "Lens calibration data error. Re-install lens or restart aircraft",
      "zh": "镜头标定数据异常，请插拔镜头或重启",
      "fr": ""
    },
    "0x1C000401" : {
      "en": "Invalid memory card. Replace card (%alarmid)",
      "zh": "无效存储卡，请更换存储卡（%alarmid）",
      "fr": ""
    },
    "0x1C000402" : {
      "en": "Memory card speed low. Replace with faster card",
      "zh": "存储卡为慢速卡，请更换",
      "fr": ""
    },
    "0x1C000403" : {
      "en": "Memory card error. Replace card (%alarmid)",
      "zh": "存储卡异常，请更换存储卡（%alarmid）",
      "fr": ""
    },
    "0x1C000404" : {
      "en": "No memory card",
      "zh": "无存储卡",
      "fr": ""
    },
    "0x1C000405" : {
      "en": "Confirm memory card read and write permissions",
      "zh": "请确认存储卡读写属性",
      "fr": ""
    },
    "0x1C000407" : {
      "en": "Formatting memory card...",
      "zh": "存储卡正在格式化，请等待",
      "fr": ""
    },
    "0x1C000408" : {
      "en": "Memory card file system not supported. Format card before use",
      "zh": "不支持该存储卡文件系统，请格式化后使用",
      "fr": ""
    },
    "0x1C00040A" : {
      "en": "Memory card full. Clear space",
      "zh": "存储卡已满，请清除内存",
      "fr": ""
    },
    "0x1C00040B" : {
      "en": "Max file index exceeded. Format SD card",
      "zh": "文件索引超出最大限制，请格式化SD卡",
      "fr": ""
    },
    "0x1C00040C" : {
      "en": "Initializing memory card...",
      "zh": "存储卡正在初始化，请等待",
      "fr": ""
    },
    "0x1C00040D" : {
      "en": "Memory card error. Format card before use",
      "zh": "存储卡异常，请格式化存储卡后使用",
      "fr": ""
    },
    "0x1C00040E" : {
      "en": "Memory card write speed low",
      "zh": "存储卡写入速度过慢",
      "fr": ""
    },
    "0x1C00040F" : {
      "en": "Memory card write speed low",
      "zh": "存储卡写入速度过慢",
      "fr": ""
    },
    "0x1C000411" : {
      "en": "SD card write error. Replace SD card",
      "zh": "SD卡写入异常，请更换",
      "fr": ""
    },
    "0x1C000412" : {
      "en": "Verification required before using memory card. Enter password to verify",
      "zh": "存储卡加密待验证，请输入密码验证后使用",
      "fr": ""
    },
    "0x1C000414" : {
      "en": "SD card storage severely fragmented. Back up files and format SD card",
      "zh": "SD卡存储碎片化程度严重，请备份素材后格式化",
      "fr": ""
    },
    "0x1C000602" : {
      "en": "Ambient Light Too Low",
      "zh": "相机拍照环境过暗",
      "fr": ""
    },
    "0x1c000603" : {
      "en": "Risk of overexposure in photo",
      "zh": "照片存在欠曝风险",
      "fr": ""
    },
    "0x1C000603" : {
      "en": "Photos may be underexposed",
      "zh": "照片存在欠曝风险",
      "fr": ""
    },
    "0x1c000604" : {
      "en": "Risk of overexposure in photo",
      "zh": "照片存在过曝风险",
      "fr": ""
    },
    "0x1C000604" : {
      "en": "Photos may be overexposed",
      "zh": "照片存在过曝风险",
      "fr": ""
    },
    "0x1C000901" : {
      "en": "PPS signal sending error",
      "zh": "PPS对时信号异常",
      "fr": ""
    },
    "0x1C000902" : {
      "en": "Camera time synchronization error",
      "zh": "相机时间同步异常",
      "fr": ""
    },
    "0x1C000903" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000904" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000905" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000906" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000907" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000908" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000909" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C00090A" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000A01" : {
      "en": "Frames dropped in recording. Firmware update recommended",
      "zh": "录像丢帧，建议升级固件",
      "fr": ""
    },
    "0x1C000A02" : {
      "en": "Frames dropped in recording. Firmware update recommended",
      "zh": "录像丢帧，建议升级固件",
      "fr": ""
    },
    "0x1C000B01" : {
      "en": "Camera hardware error. Restart and try again",
      "zh": "相机硬件异常，请尝试重新启动",
      "fr": ""
    },
    "0x1C000D01" : {
      "en": "Focusing failed",
      "zh": "对焦失败",
      "fr": ""
    },
    "0x1C000D02" : {
      "en": "Lens infinity focus not calibrated",
      "zh": "镜头未进行无穷远标定",
      "fr": ""
    },
    "0x1C000D03" : {
      "en": "Infinity focus calibration data expired. Recalibrate",
      "zh": "无穷远标定数据过期，请重新标定",
      "fr": ""
    },
    "0x1C000D04" : {
      "en": "Infinity focus calibration data expired. Recalibrate",
      "zh": "无穷远标定数据过期，请重新标定",
      "fr": ""
    },
    "0x1C000E01" : {
      "en": "Camera and lens intrinsic parameters calibration data do not match",
      "zh": "镜头与相机内参检校不匹配",
      "fr": ""
    },
    "0x1C000E02" : {
      "en": "Intrinsic parameters calibration data expired",
      "zh": "内参检校参数过旧",
      "fr": ""
    },
    "0x1C001001" : {
      "en": "DJI PROSSD fragmentation risk detected. Formatting storage device recommended",
      "zh": "DJI PROSSD存储碎片化即将满，建议格式化",
      "fr": ""
    },
    "0x1C001002" : {
      "en": "DJI PROSSD fragmented. Formatting storage device recommended",
      "zh": "DJI PROSSD存储碎片化已满，建议格式化",
      "fr": ""
    },
    "0x1C001003" : {
      "en": "",
      "zh": "获取 DJI PROSSD 存储信息失败，避免存储风险，请备份素材后格式化",
      "fr": ""
    },
    "0x1C001101" : {
      "en": "DJI PROSSD approaching end of lifespan. Replacing storage device recommended",
      "zh": "DJI PROSSD读写量即将到达上限，建议更换",
      "fr": ""
    },
    "0x1C001102" : {
      "en": "DJI PROSSD reached end of lifespan. Replacing storage device recommended",
      "zh": "DJI PROSSD读写量已达上限，建议更换",
      "fr": ""
    },
    "0x1C001103" : {
      "en": "Failed to obtain data stored in DJI PROSSD. Back up files before formatting DJI PROSSD to avoid data loss",
      "zh": "获取 DJI PROSSD 存储信息失败，避免存储风险，请备份素材后格式化",
      "fr": ""
    },
    "0x1C001201" : {
      "en": "Use DJI PROSSD to start recording",
      "zh": "请使用DJI PROSSD以正常使用录像功能",
      "fr": ""
    },
    "0x1C001301" : {
      "en": "Failed to write video to storage. Stopping recording...",
      "zh": "视频写入失败，正在停止录像",
      "fr": ""
    },
    "0x1C001302" : {
      "en": "DJI PROSSD write speed low. Stopping recording...",
      "zh": "DJI PROSSD写入速度慢，正在停止录像",
      "fr": ""
    },
    "0x1C001303" : {
      "en": "Insufficient storage on DJI PROSSD. Stopping recording...",
      "zh": "DJI PROSSD剩余空间不足，正在停止录像",
      "fr": ""
    },
    "0x1C001303_special" : {
      "en": "Insufficient storage on memory card. Stopping recording...",
      "zh": "存储卡剩余空间不足，正在停止录像",
      "fr": ""
    },
    "0x1C001306" : {
      "en": "System busy. Recording not allowed",
      "zh": "系统业务繁忙，禁止录像",
      "fr": ""
    },
    "0x1C001307" : {
      "en": "System not busy. Recording available",
      "zh": "业务繁忙解除，允许录像",
      "fr": ""
    },
    "0x1C001401" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C001402" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C001403" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C001404" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C001405" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C001406" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C001407" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C001408" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C001409" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C00140A" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C00140E" : {
      "en": "Camera error. Restarting aircraft recommended",
      "zh": "相机异常，建议重启飞行器",
      "fr": ""
    },
    "0x1C00140F" : {
      "en": "Camera connection unstable. Detach and remount gimbal",
      "zh": "相机信号链路不稳定，请尝试重新拔插云台",
      "fr": ""
    },
    "0x1C001501" : {
      "en": "Light sensor error. Contact DJI Support",
      "zh": "光照传感器异常，请联系售后服务",
      "fr": ""
    },
    "0x1C001502" : {
      "en": "Light sensor error. Contact DJI Support",
      "zh": "光照传感器异常，请联系售后服务",
      "fr": ""
    },
    "0x1C001503" : {
      "en": "Light sensor calibration data error. Contact DJI Support",
      "zh": "光照传感器标定数据异常，请联系售后服务",
      "fr": ""
    },
    "0x1C001603" : {
      "en": "Unable to use DJI PROSSD. Remove and insert storage device again",
      "zh": "DJI PROSSD存储不可挂载，请重新拔插",
      "fr": ""
    },
    "0x1C001604" : {
      "en": "No memory card",
      "zh": "无存储卡",
      "fr": ""
    },
    "0x1C001605" : {
      "en": "SSD file system error. Remove and insert SSD again. Back up SSD files and then format SSD card if issue persists",
      "zh": "SSD文件系统异常，请重新拔插SSD，若无效请备份后格式化",
      "fr": ""
    },
    "0x1C001606" : {
      "en": "DJI PROSSD not formatted",
      "zh": "DJI PROSSD存储未格式化",
      "fr": ""
    },
    "0x1C001607" : {
      "en": "Formatting DJI PROSSD...",
      "zh": "DJI PROSSD正在格式化",
      "fr": ""
    },
    "0x1C001608" : {
      "en": "DJI PROSSD file system format not supported",
      "zh": "DJI PROSSD文件系统不支持",
      "fr": ""
    },
    "0x1C001609" : {
      "en": "Refreshing DJI PROSSD...",
      "zh": "DJI PROSSD正在刷新",
      "fr": ""
    },
    "0x1C00160A" : {
      "en": "DJI PROSSD full",
      "zh": "DJI PROSSD存储空间已满",
      "fr": ""
    },
    "0x1C00160B" : {
      "en": "DJI PROSSD file naming index full. Delete extra files",
      "zh": "DJI PROSSD文件序号溢出，请删除多余素材",
      "fr": ""
    },
    "0x1C00160C" : {
      "en": "Initializing DJI PROSSD…",
      "zh": "DJI PROSSD正在初始化",
      "fr": ""
    },
    "0x1C00160D" : {
      "en": "Reformatting DJI PROSSD recommended",
      "zh": "DJI PROSSD建议重新格式化",
      "fr": ""
    },
    "0x1C00160E" : {
      "en": "Restoring files on DJI PROSSD...",
      "zh": "DJI PROSSD存储文件正在修复中",
      "fr": ""
    },
    "0x1C00160F" : {
      "en": "DJI PROSSD speed low. Replacing storage device recommended",
      "zh": "DJI PROSSD存储速度慢，建议更换",
      "fr": ""
    },
    "0x1C001701" : {
      "en": "Timed shot interval too short. Unable to start shooting",
      "zh": "定时拍间隔过小，无法开始拍摄",
      "fr": ""
    },
    "0x1C001702" : {
      "en": "Timed shot interval too short. Unable to switch cameras",
      "zh": "定时拍间隔过小，无法切换相机",
      "fr": ""
    },
    "0x1C001703" : {
      "en": "Photo format inconsistent. Unable to switch cameras",
      "zh": "照片格式不同，无法切换相机",
      "fr": ""
    },
    "0x1C001801" : {
      "en": "Timecode error. Restart aircraft",
      "zh": "TIMECODE错误，请重启飞行器",
      "fr": ""
    },
    "0x1C001901" : {
      "en": "ProRes RAW codec not authorized,purchase on the official website",
      "zh": "ProRes RAW编码格式未授权，请到官网购买使用授权",
      "fr": ""
    },
    "0x1C001902" : {
      "en": "CinemaDNG encoding format not authorized. Purchase license from official website",
      "zh": "CinemaDNG编码格式未授权，请到官网购买使用授权",
      "fr": ""
    },
    "0x1C001903" : {
      "en": "ProRes RAW codec not authorized,purchase on the official website",
      "zh": "ProRes RAW编码格式未授权，请到官网购买使用授权",
      "fr": ""
    },
    "0x1C001904" : {
      "en": "CinemaDNG encoding format not authorized，purchase on the official website",
      "zh": "CinemaDNG编码格式未授权，请到官网购买使用授权",
      "fr": ""
    },
    "0x1C001A01" : {
      "en": "DJI PROSSD write speed low. Restarting aircraft recommended",
      "zh": "DJI PROSSD写入速度慢，建议重新启动飞行器",
      "fr": ""
    },
    "0x1C001B01" : {
      "en": "Usage count of gimbal port reached",
      "zh": "云台接口已达预设使用次数",
      "fr": ""
    },
    "0x1C001E04" : {
      "en": "System busy. Photo is not allowed",
      "zh": "系统业务繁忙，禁止拍照",
      "fr": ""
    },
    "0x1C001E05" : {
      "en": "System not busy.Photo available",
      "zh": "业务繁忙解除，允许拍照",
      "fr": ""
    },
    "0x1C001F01" : {
      "en": "System busy. Zoom is not available",
      "zh": "系统业务繁忙，禁止变焦",
      "fr": ""
    },
    "0x1C001F02" : {
      "en": "System not busy. Zoom available",
      "zh": "业务繁忙解除，允许变焦",
      "fr": ""
    },
    "0x1C002001" : {
      "en": "System busy. Do not switch cameras",
      "zh": "系统业务繁忙，禁止切换相机",
      "fr": ""
    },
    "0x1C002002" : {
      "en": "System not busy. Do not switch cameras",
      "zh": "业务繁忙解除，允许切换相机",
      "fr": ""
    },
    "0x1C002004" : {
      "en": "",
      "zh": "H20 相机图像传感器 芯片异常",
      "fr": ""
    },
    "0x1C002101" : {
      "en": "Camera receiving LiDAR data timed out. Restart aircraft and try again",
      "zh": "相机接收激光雷达数据超时，请尝试重启飞行器",
      "fr": ""
    },
    "0x1C002102" : {
      "en": "Point cloud data frames dropped. The ultimate point cloud model may not be complete. Restart aircraft",
      "zh": "点云数据丢帧，最终点云模型可能不完整，请重启飞行器",
      "fr": ""
    },
    "0x1C002103" : {
      "en": "LiDAR may be blocked or object out of measuring range",
      "zh": "激光雷达可能被遮挡，或者不在量程内",
      "fr": ""
    },
    "0x1C002104" : {
      "en": "RNG sampling failed. Try again later or restart aircraft",
      "zh": "激光测距采样失败，请稍后重试或重启飞行器",
      "fr": ""
    },
    "0x1C002105" : {
      "en": "",
      "zh": "相机温度过高，激光雷达电源暂时关闭",
      "fr": ""
    },
    "0x1C002106" : {
      "en": "",
      "zh": "相机温度过高，激光雷达功能暂时不可用",
      "fr": ""
    },
    "0x1C002107" : {
      "en": "",
      "zh": "相机温度过高，红外补光灯功能暂时不可用",
      "fr": ""
    },
    "0x1C002201" : {
      "en": "Previous media files exist in camera SSD. Back up files to avoid data loss",
      "zh": "相机SSD存在旧版本媒体文件，请及时备份避免丢失",
      "fr": ""
    },
    "0x1C002301" : {
      "en": "",
      "zh": "EIS的图像帧的vsync为0",
      "fr": ""
    },
    "0x1C002302" : {
      "en": "",
      "zh": "EIS图像帧的vsync顺序错误",
      "fr": ""
    },
    "0x1C002303" : {
      "en": "",
      "zh": "EIS获取不到IMU数据",
      "fr": ""
    },
    "0x1C002304" : {
      "en": "",
      "zh": "EIS获取IMU数据不足",
      "fr": ""
    },
    "0x1C002305" : {
      "en": "",
      "zh": "EIS获取IMU数据过多",
      "fr": ""
    },
    "0x1C002306" : {
      "en": "",
      "zh": "EIS获取IMU数据失败",
      "fr": ""
    },
    "0x1C002307" : {
      "en": "",
      "zh": "EIS获取到的IMU数据vsync顺序错误",
      "fr": ""
    },
    "0x1C002308" : {
      "en": "",
      "zh": "EIS的IMU target超出约束范围",
      "fr": ""
    },
    "0x1C002309" : {
      "en": "",
      "zh": "EIS迭代求解结果超出输入图像的边界",
      "fr": ""
    },
    "0x1C00230A" : {
      "en": "",
      "zh": "EIS的IMU对齐范围超出拿到的IMU数据的位置",
      "fr": ""
    },
    "0x1C00230B" : {
      "en": "",
      "zh": "EIS帧间时间间隔有问题，vsync不稳定",
      "fr": ""
    },
    "0x1C00230C" : {
      "en": "",
      "zh": "当前帧通过step模式匹配到了vsync信息",
      "fr": ""
    },
    "0x1C00230D" : {
      "en": "",
      "zh": "当前帧匹配到无效的vsync信息",
      "fr": ""
    },
    "0x1C00230E" : {
      "en": "",
      "zh": "当前帧匹配不到vsync信息",
      "fr": ""
    },
    "0x1C002501" : {
      "en": "",
      "zh": "相机超温预警，自动关闭镜头除雾、激光雷达、红外补光灯功能",
      "fr": ""
    },
    "0x1C002502" : {
      "en": "",
      "zh": "相机温度过高，自动关闭镜头除雾、激光雷达电源",
      "fr": ""
    },
    "0x1C002502_in_the_sky" : {
      "en": "",
      "zh": "相机温度过高，自动关闭红外补光灯（仅红外版），镜头除雾功能",
      "fr": ""
    },
    "0x1C002503" : {
      "en": "",
      "zh": "相机温度过高，镜头除雾功能暂时不可用",
      "fr": ""
    },
    "0x1C003001" : {
      "en": "",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C004001" : {
      "en": "Invalid memory card. Replace card",
      "zh": "无效存储卡，请更换存储卡",
      "fr": ""
    },
    "0x1C004002" : {
      "en": "Memory card speed low. Replace with faster card",
      "zh": "存储卡为慢速卡，请更换快速存储卡",
      "fr": ""
    },
    "0x1C004003" : {
      "en": "Memory card error. Replace card",
      "zh": "存储卡异常，请更换存储卡",
      "fr": ""
    },
    "0x1C004004" : {
      "en": "No memory card",
      "zh": "无存储卡",
      "fr": ""
    },
    "0x1C100001" : {
      "en": "Camera %component_index overheated. Wait for temperature to return to normal before use",
      "zh": "%component_index号云台相机过热，请等待降温后再使用",
      "fr": ""
    },
    "0x1C100101" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C100102" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C100103" : {
      "en": "Camera processor temperature high. Power off aircraft and wait for temperature to return to normal before use",
      "zh": "相机芯片温度高，请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C100103_in_the_sky" : {
      "en": "Camera processor temperature high. Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度高，请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C100104" : {
      "en": "Camera processor temperature too high. Power off aircraft and wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C100104_in_the_sky" : {
      "en": "Camera processor temperature too high. Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C100105" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C100201" : {
      "en": "H20 camera image transmission sensor processor error",
      "zh": "H20 相机图像传感器 芯片异常",
      "fr": ""
    },
    "0x1C100202" : {
      "en": "H20 camera image transmission sensor processor error",
      "zh": "H20 相机图像传感器 芯片异常",
      "fr": ""
    },
    "0x1C100203" : {
      "en": "Camera chip overheated. Power off aircraft and wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C100203_in_the_sky" : {
      "en": "Camera processor overheated. Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C100204" : {
      "en": "H20 camera image transmission sensor processor error",
      "zh": "H20 相机图像传感器 芯片异常",
      "fr": ""
    },
    "0x1C100205" : {
      "en": "FPV lens calibration error. Recalibrate lens and try again",
      "zh": "FPV镜头标定异常，请重新标定",
      "fr": ""
    },
    "0x1C100301" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C100302" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C100303" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C100304" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C100401" : {
      "en": "Invalid memory card. Replace card",
      "zh": "无效存储卡，请更换存储卡",
      "fr": ""
    },
    "0x1C100401_index_1" : {
      "en": "Invalid eMMC. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "无效EMMC，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C100402" : {
      "en": "Memory card speed low. Replace with faster card",
      "zh": "存储卡为慢速卡，请更换",
      "fr": ""
    },
    "0x1C100402_index_1" : {
      "en": "eMMC speed error. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "EMMC速度异常，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C100403" : {
      "en": "Memory card error. Replace card",
      "zh": "存储卡异常，请更换存储卡",
      "fr": ""
    },
    "0x1C100403_index_1" : {
      "en": "eMMC error. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "EMMC异常，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C100404" : {
      "en": "No memory card",
      "zh": "无存储卡",
      "fr": ""
    },
    "0x1C100404_index_1" : {
      "en": "eMMC identification error. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "EMMC识别异常，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1c100405" : {
      "en": "Confirm memory card read and write permissions",
      "zh": "请确认存储卡读写属性",
      "fr": ""
    },
    "0x1C100405" : {
      "en": "Confirm memory card read and write permissions",
      "zh": "请确认存储卡读写属性",
      "fr": ""
    },
    "0x1c100405_index_1" : {
      "en": "Confirm eMMC read and write properties",
      "zh": "请确认EMMC读写属性",
      "fr": ""
    },
    "0x1c100406" : {
      "en": "Memory card not formatted. Format card before use",
      "zh": "存储卡未格式化，请格式化后使用",
      "fr": ""
    },
    "0x1C100406" : {
      "en": "Memory card not formatted. Format card before use",
      "zh": "存储卡未格式化，请格式化后使用",
      "fr": ""
    },
    "0x1c100406_index_1" : {
      "en": "eMMC not formatted. Format before use",
      "zh": "EMMC未格式化，请格式化后使用",
      "fr": ""
    },
    "0x1c100407" : {
      "en": "Formatting memory card...",
      "zh": "存储卡正在格式化，请等待",
      "fr": ""
    },
    "0x1C100407" : {
      "en": "Formatting memory card...",
      "zh": "存储卡正在格式化，请等待",
      "fr": ""
    },
    "0x1c100407_index_1" : {
      "en": "eMMC formatting. Please wait",
      "zh": "EMMC正在格式化，请等待",
      "fr": ""
    },
    "0x1c100408" : {
      "en": "Memory card file system not supported. Format card before use",
      "zh": "不支持该存储卡文件系统，请格式化后使用",
      "fr": ""
    },
    "0x1C100408" : {
      "en": "Memory card file system not supported. Format card before use",
      "zh": "不支持该存储卡文件系统，请格式化后使用",
      "fr": ""
    },
    "0x1c100409" : {
      "en": "Refreshing memory card...",
      "zh": "存储卡正在刷新，请等待",
      "fr": ""
    },
    "0x1C100409" : {
      "en": "Refreshing memory card...",
      "zh": "存储卡正在刷新，请等待",
      "fr": ""
    },
    "0x1c100409_index_1" : {
      "en": "eMMC refreshing. Please wait",
      "zh": "EMMC正在刷新，请等待",
      "fr": ""
    },
    "0x1c10040a" : {
      "en": "Memory card full. Clear space",
      "zh": "存储卡已满，请清除内存",
      "fr": ""
    },
    "0x1C10040A" : {
      "en": "Memory card full. Clear space",
      "zh": "存储卡已满，请清除内存",
      "fr": ""
    },
    "0x1c10040a_index_1" : {
      "en": "eMMC full. Clear space",
      "zh": "EMMC已满，请清除内存",
      "fr": ""
    },
    "0x1c10040b" : {
      "en": "Max file index exceeded. Format SD card",
      "zh": "文件索引超出最大限制，请格式化SD卡",
      "fr": ""
    },
    "0x1c10040B" : {
      "en": "Max file index exceeded. Format SD card",
      "zh": "文件索引超出最大限制，请格式化SD卡",
      "fr": ""
    },
    "0x1C10040B" : {
      "en": "Max file index exceeded. Format SD card",
      "zh": "文件索引超出最大限制，请格式化SD卡",
      "fr": ""
    },
    "0x1c10040b_index_1" : {
      "en": "eMMC memory overflow. Format eMMC and restart camera",
      "zh": "EMMC内存溢出，请格式化EMMC并重启相机",
      "fr": ""
    },
    "0x1c10040c" : {
      "en": "Initializing memory card...",
      "zh": "存储卡正在初始化，请等待",
      "fr": ""
    },
    "0x1C10040C" : {
      "en": "Initializing memory card...",
      "zh": "存储卡正在初始化，请等待",
      "fr": ""
    },
    "0x1c10040c_index_1" : {
      "en": "eMMC initializing. Please wait",
      "zh": "EMMC正在初始化，请等待",
      "fr": ""
    },
    "0x1c10040d" : {
      "en": "Memory card error. Format card before use",
      "zh": "存储卡异常，请格式化存储卡后使用",
      "fr": ""
    },
    "0x1C10040D" : {
      "en": "Memory card error. Format card before use",
      "zh": "存储卡异常，请格式化存储卡后使用",
      "fr": ""
    },
    "0x1c10040d_index_1" : {
      "en": "eMMC error. Format before use",
      "zh": "EMMC异常，请格式化EMMC后使用",
      "fr": ""
    },
    "0x1c10040e" : {
      "en": "Fixing memory card...",
      "zh": "存储卡修复中，请等待",
      "fr": ""
    },
    "0x1C10040E" : {
      "en": "Fixing memory card...",
      "zh": "存储卡修复中，请等待",
      "fr": ""
    },
    "0x1c10040e_index_1" : {
      "en": "eMMC repair in progress. Please wait",
      "zh": "EMMC修复中，请等待",
      "fr": ""
    },
    "0x1c10040f" : {
      "en": "Memory card read and write speed low. Wait until process completes",
      "zh": "存储卡读写缓慢，请等待",
      "fr": ""
    },
    "0x1C10040F" : {
      "en": "Memory card read and write speed low. Wait until process completes",
      "zh": "存储卡读写缓慢，请等待",
      "fr": ""
    },
    "0x1c10040f_index_1" : {
      "en": "eMMC read and write speed low. Please wait",
      "zh": "EMMC读写缓慢，请等待",
      "fr": ""
    },
    "0x1C200001" : {
      "en": "Camera %component_index overheated. Wait for temperature to return to normal before use",
      "zh": "%component_index号云台相机过热，请等待降温后再使用",
      "fr": ""
    },
    "0x1C200101" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C200102" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C200103" : {
      "en": "Camera processor temperature too high. Power off aircraft and wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C200103_in_the_sky" : {
      "en": "Camera processor temperature high. Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度高，请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C200104" : {
      "en": "Camera processor temperature too high. Power off aircraft and wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C200104_in_the_sky" : {
      "en": "Camera processor temperature too high. Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C200105" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C200201" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C200202" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C200203" : {
      "en": "Camera chip overheated. Power off aircraft and wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C200203_in_the_sky" : {
      "en": "Camera processor overheated. Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C200204" : {
      "en": "H20 camera image transmission sensor processor error",
      "zh": "H20 相机图像传感器 芯片异常",
      "fr": ""
    },
    "0x1C200301" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C200302" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C200303" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C200304" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C200401" : {
      "en": "Invalid memory card. Replace card",
      "zh": "无效存储卡，请更换存储卡",
      "fr": ""
    },
    "0x1C200401_index_1" : {
      "en": "Invalid eMMC. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "无效EMMC，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C200402" : {
      "en": "Memory card speed low. Replace with faster card",
      "zh": "存储卡为慢速卡，请更换",
      "fr": ""
    },
    "0x1C200402_index_1" : {
      "en": "Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "EMMC速度异常，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C200403" : {
      "en": "Memory card error. Replace card",
      "zh": "存储卡异常，请更换存储卡",
      "fr": ""
    },
    "0x1C200403_index_1" : {
      "en": "eMMC error. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "EMMC异常，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C200404" : {
      "en": "No memory card",
      "zh": "无存储卡",
      "fr": ""
    },
    "0x1C200404_index_1" : {
      "en": "eMMC identification error. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "EMMC识别异常，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C200405" : {
      "en": "Confirm memory card read and write permissions",
      "zh": "请确认存储卡读写属性",
      "fr": ""
    },
    "0x1c200405_index_1" : {
      "en": "Confirm eMMC read and write properties",
      "zh": "请确认EMMC读写属性",
      "fr": ""
    },
    "0x1C200406" : {
      "en": "Memory card not formatted. Format card before use",
      "zh": "存储卡未格式化，请格式化后使用",
      "fr": ""
    },
    "0x1c200406_index_1" : {
      "en": "eMMC not formatted. Format before use",
      "zh": "EMMC未格式化，请格式化后使用",
      "fr": ""
    },
    "0x1C200407" : {
      "en": "Formatting memory card...",
      "zh": "存储卡正在格式化，请等待",
      "fr": ""
    },
    "0x1c200407_index_1" : {
      "en": "eMMC formatting. Please wait",
      "zh": "EMMC正在格式化，请等待",
      "fr": ""
    },
    "0x1C200408" : {
      "en": "Memory card file system not supported. Format card before use",
      "zh": "不支持该存储卡文件系统，请格式化后使用",
      "fr": ""
    },
    "0x1C200409" : {
      "en": "Refreshing memory card...",
      "zh": "存储卡正在刷新，请等待",
      "fr": ""
    },
    "0x1c200409_index_1" : {
      "en": "eMMC refreshing. Please wait",
      "zh": "EMMC正在刷新，请等待",
      "fr": ""
    },
    "0x1C20040A" : {
      "en": "Memory card full. Clear space",
      "zh": "存储卡已满，请清除内存",
      "fr": ""
    },
    "0x1c20040a_index_1" : {
      "en": "eMMC full. Clear space",
      "zh": "EMMC已满，请清除内存",
      "fr": ""
    },
    "0x1c20040b" : {
      "en": "Max file index exceeded. Format SD card",
      "zh": "文件索引超出最大限制，请格式化SD卡",
      "fr": ""
    },
    "0x1C20040B" : {
      "en": "Max file index exceeded. Format SD card",
      "zh": "文件索引超出最大限制，请格式化SD卡",
      "fr": ""
    },
    "0x1c20040b_index_1" : {
      "en": "eMMC memory overflow. Format eMMC and restart camera",
      "zh": "EMMC内存溢出，请格式化EMMC并重启相机",
      "fr": ""
    },
    "0x1C20040C" : {
      "en": "Initializing memory card...",
      "zh": "存储卡正在初始化，请等待",
      "fr": ""
    },
    "0x1c20040c_index_1" : {
      "en": "eMMC initializing. Please wait",
      "zh": "EMMC正在初始化，请等待",
      "fr": ""
    },
    "0x1C20040D" : {
      "en": "Memory card error. Format card before use",
      "zh": "存储卡异常，请格式化存储卡后使用",
      "fr": ""
    },
    "0x1c20040d_index_1" : {
      "en": "eMMC error. Format before use",
      "zh": "EMMC异常，请格式化EMMC后使用",
      "fr": ""
    },
    "0x1C20040E" : {
      "en": "Fixing memory card...",
      "zh": "存储卡修复中，请等待",
      "fr": ""
    },
    "0x1c20040e_index_1" : {
      "en": "eMMC repair in progress. Please wait",
      "zh": "EMMC修复中，请等待",
      "fr": ""
    },
    "0x1C20040F" : {
      "en": "Memory card read and write speed low. Wait until process completes",
      "zh": "存储卡读写缓慢，请等待",
      "fr": ""
    },
    "0x1c20040f_index_1" : {
      "en": "eMMC read and write speed low. Please wait",
      "zh": "EMMC读写缓慢，请等待",
      "fr": ""
    },
    "0x1c200410" : {
      "en": "Verification required before using memory card. Enter password to verify",
      "zh": "存储卡加密待验证，请输入密码验证后使用",
      "fr": ""
    },
    "0x1C200410" : {
      "en": "Verification required before using memory card. Enter password to verify",
      "zh": "存储卡加密待验证，请输入密码进行验证",
      "fr": ""
    },
    "0x1C300001" : {
      "en": "Camera %component_index overheated. Wait for temperature to return to normal before use",
      "zh": "%component_index号云台相机过热，请等待降温后再使用",
      "fr": ""
    },
    "0x1C300101" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C300102" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C300103" : {
      "en": "Camera processor temperature high. Power off aircraft and wait for temperature to return to normal before use",
      "zh": "相机芯片温度高，请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C300103_in_the_sky" : {
      "en": "Camera processor temperature high. Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度高，请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C300104" : {
      "en": "Camera processor temperature too high. Power off aircraft and wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请关闭飞机，等待冷却后再使用",
      "fr": ""
    },
    "0x1C300104_in_the_sky" : {
      "en": "Camera processor temperature too high. Return to home or land promptly. Wait for temperature to return to normal before use",
      "zh": "相机芯片温度过高，请尽快返航或降落，等待冷却后重启使用",
      "fr": ""
    },
    "0x1C300105" : {
      "en": "Camera %component_index error. Restart camera",
      "zh": "%component_index号云台相机异常，请重启相机",
      "fr": ""
    },
    "0x1C300301" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C300302" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C300303" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C300304" : {
      "en": "H20 camera lens error. Restart camera",
      "zh": "H20 镜头异常，请断电重启",
      "fr": ""
    },
    "0x1C300401" : {
      "en": "Invalid memory card. Replace card",
      "zh": "无效存储卡，请更换存储卡",
      "fr": ""
    },
    "0x1C300401_index_1" : {
      "en": "Invalid eMMC. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "无效EMMC，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C300402" : {
      "en": "Memory card speed low. Replace with faster card",
      "zh": "存储卡为慢速卡，请更换",
      "fr": ""
    },
    "0x1C300402_index_1" : {
      "en": "eMMC speed error. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "EMMC速度异常，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C300403" : {
      "en": "Memory card error. Replace card",
      "zh": "存储卡异常，请更换存储卡",
      "fr": ""
    },
    "0x1C300403_index_1" : {
      "en": "eMMC error. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "EMMC异常，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C300404" : {
      "en": "No memory card",
      "zh": "无存储卡",
      "fr": ""
    },
    "0x1C300404_index_1" : {
      "en": "eMMC identification error. Restart camera. If the issue persists, contact DJI Support for repairs",
      "zh": "EMMC识别异常，请重启相机，如问题还存在，请返厂维修",
      "fr": ""
    },
    "0x1C300405" : {
      "en": "Confirm memory card read and write permissions",
      "zh": "请确认存储卡读写属性",
      "fr": ""
    },
    "0x1c300405_index_1" : {
      "en": "Confirm eMMC read and write properties",
      "zh": "请确认EMMC读写属性",
      "fr": ""
    },
    "0x1C300406" : {
      "en": "Memory card not formatted. Format card before use",
      "zh": "存储卡未格式化，请格式化后使用",
      "fr": ""
    },
    "0x1c300406_index_1" : {
      "en": "eMMC not formatted. Format before use",
      "zh": "EMMC未格式化，请格式化后使用",
      "fr": ""
    },
    "0x1C300407" : {
      "en": "Formatting memory card...",
      "zh": "存储卡正在格式化，请等待",
      "fr": ""
    },
    "0x1c300407_index_1" : {
      "en": "eMMC formatting. Please wait",
      "zh": "EMMC正在格式化，请等待",
      "fr": ""
    },
    "0x1C300408" : {
      "en": "Memory card file system not supported. Format card before use",
      "zh": "不支持该存储卡文件系统，请格式化后使用",
      "fr": ""
    },
    "0x1C300409" : {
      "en": "Refreshing memory card...",
      "zh": "存储卡正在刷新，请等待",
      "fr": ""
    },
    "0x1c300409_index_1" : {
      "en": "eMMC refreshing. Please wait",
      "zh": "EMMC正在刷新，请等待",
      "fr": ""
    },
    "0x1C30040A" : {
      "en": "Memory card full. Clear space",
      "zh": "存储卡已满，请清除内存",
      "fr": ""
    },
    "0x1c30040a_index_1" : {
      "en": "eMMC full. Clear space",
      "zh": "EMMC已满，请清除内存",
      "fr": ""
    },
    "0x1c30040b" : {
      "en": "Max file index exceeded. Format SD card",
      "zh": "文件索引超出最大限制，请格式化SD卡",
      "fr": ""
    },
    "0x1C30040B" : {
      "en": "Max file index exceeded. Format SD card",
      "zh": "文件索引超出最大限制，请格式化SD卡",
      "fr": ""
    },
    "0x1c30040b_index_1" : {
      "en": "eMMC memory overflow. Format eMMC and restart camera",
      "zh": "EMMC内存溢出，请格式化EMMC并重启相机",
      "fr": ""
    },
    "0x1C30040C" : {
      "en": "Initializing memory card...",
      "zh": "存储卡正在初始化，请等待",
      "fr": ""
    },
    "0x1c30040c_index_1" : {
      "en": "eMMC initializing. Please wait",
      "zh": "EMMC正在初始化，请等待",
      "fr": ""
    },
    "0x1C30040D" : {
      "en": "Memory card error. Format card before use",
      "zh": "存储卡异常，请格式化存储卡后使用",
      "fr": ""
    },
    "0x1c30040d_index_1" : {
      "en": "eMMC error. Format before use",
      "zh": "EMMC异常，请格式化EMMC后使用",
      "fr": ""
    },
    "0x1C30040E" : {
      "en": "Fixing memory card...",
      "zh": "存储卡修复中，请等待",
      "fr": ""
    },
    "0x1c30040e_index_1" : {
      "en": "eMMC repair in progress. Please wait",
      "zh": "EMMC修复中，请等待",
      "fr": ""
    },
    "0x1C30040F" : {
      "en": "Memory card read and write speed low. Wait until process completes",
      "zh": "存储卡读写缓慢，请等待",
      "fr": ""
    },
    "0x1c30040f_index_1" : {
      "en": "eMMC read and write speed low. Please wait",
      "zh": "EMMC读写缓慢，请等待",
      "fr": ""
    },
    "0x1C300601" : {
      "en": "Temperature of current environment too low. Enable temperature measurement when temperature is within normal range",
      "zh": "环境温度过低，请在正常的工作温度范围内测温",
      "fr": ""
    },
    "0x1C300602" : {
      "en": "Temperature of current evironment too high. Only enable temperature measurement when temperature is within normal range",
      "zh": "环境温度过高，请在正常的工作温度范围内测温",
      "fr": ""
    },
    "0x1C300603" : {
      "en": "Zenmuse H20T infrared thermal camera switching modes...",
      "zh": "H20T相机红外镜头正在切换工作模式，请等待",
      "fr": ""
    },
    "0x1C300604" : {
      "en": "Zenmuse H20T infrared thermal camera calibration data missing",
      "zh": "H20T相机红外镜头标定数据缺失",
      "fr": ""
    },
    "0x1C300605" : {
      "en": "Zenmuse H20T infrared thermal camera initialization error. Restart camera",
      "zh": "H20T相机红外镜头初始化异常，请断电重启",
      "fr": ""
    },
    "0x1C300606" : {
      "en": "Temperature measurement failed. Adjust camera parameters and try again",
      "zh": "测温失败，请调整相机参数后测温",
      "fr": ""
    },
    "0x1C300607" : {
      "en": "Exceeded measuring range limit. Switch to Low Gain mode",
      "zh": "测温超出量程，请切换为低增益模式",
      "fr": ""
    },
    "0x1C300608" : {
      "en": "Exceeded measuring range limit. It is recommended to attach an infrared density filter",
      "zh": "测温超出量程，建议安装红外衰减镜",
      "fr": ""
    },
    "0x1C300609" : {
      "en": "Exceeded temperature measuring range limit",
      "zh": "测温超出量程",
      "fr": ""
    },
    "0x1C300701" : {
      "en": "Sun detected. Infrared shutter closed",
      "zh": "检测到太阳，红外快门关闭",
      "fr": ""
    },
    "0x1C300702" : {
      "en": "Sun detected. Rotate gimbal to avoid direct sunlight",
      "zh": "检测到太阳，请转动云台，避免太阳直射",
      "fr": ""
    },
    "0x1D001001" : {
      "en": "Gimbal unresponsive after power on",
      "zh": "云台上电后无力",
      "fr": ""
    },
    "0x1D001101" : {
      "en": "Gimbal unable to complete auto check",
      "zh": "云台无法完成自检",
      "fr": ""
    },
    "0x1D010001" : {
      "en": "Gimbal stuck",
      "zh": "云台被卡住",
      "fr": ""
    },
    "0x1D010002" : {
      "en": "Gimbal auto-check failed",
      "zh": "云台自检失败",
      "fr": ""
    },
    "0x1D010003" : {
      "en": "Gimbal motor overloaded",
      "zh": "云台电机过载",
      "fr": ""
    },
    "0x1D010C01" : {
      "en": "FPV gimbal stuck",
      "zh": "FPV云台被卡住",
      "fr": ""
    },
    "0x1D010C02" : {
      "en": "FPV gimbal auto-check failed",
      "zh": "FPV云台自检失败",
      "fr": ""
    },
    "0x1D010C03" : {
      "en": "FPV gimbal motor overloaded",
      "zh": "FPV云台电机过载",
      "fr": ""
    },
    "0x1D020001" : {
      "en": "Gimbal calibration error",
      "zh": "云台标定错误",
      "fr": ""
    },
    "0x1D020002" : {
      "en": "Gimbal IMU error. Restart aircraft and try again",
      "zh": "云台IMU数据异常，请尝试重启飞行器",
      "fr": ""
    },
    "0x1D020003" : {
      "en": "Gimbal calibration parameter error. Try gimbal Auto Calibration",
      "zh": "云台校准参数异常，请尝试云台自动校准",
      "fr": ""
    },
    "0x1D020C01" : {
      "en": "FPV gimbal calibration error",
      "zh": "FPV云台标定错误",
      "fr": ""
    },
    "0x1D030001" : {
      "en": "Gimbal unable to retrieve aircraft data",
      "zh": "云台无法获取飞行器信息",
      "fr": ""
    },
    "0x1D030002" : {
      "en": "",
      "zh": "飞行器与负载通讯链路中断，请检查负载连接情况",
      "fr": ""
    },
    "0x1D030002_in_the_sky" : {
      "en": "",
      "zh": "飞行器与负载通讯链路中断，请返航并检查负载连接情况",
      "fr": ""
    },
    "0x1D030C01" : {
      "en": "FPV gimbal unable to obtain aircraft data",
      "zh": "FPV云台无法获取飞行器信息",
      "fr": ""
    },
    "0x1D040001" : {
      "en": "Excessive gimbal vibration",
      "zh": "云台异常振动",
      "fr": ""
    },
    "0x1D040002" : {
      "en": "Gimbal sensor error",
      "zh": "云台传感器故障",
      "fr": ""
    },
    "0x1D040003" : {
      "en": "Gimbal ESC malfunctioned",
      "zh": "云台电调故障",
      "fr": ""
    },
    "0x1D040004" : {
      "en": "Gimbal ESC malfunctioned",
      "zh": "云台电调故障",
      "fr": ""
    },
    "0x1D040005" : {
      "en": "Gimbal ESC malfunctioned",
      "zh": "云台电调故障",
      "fr": ""
    },
    "0x1D040C01" : {
      "en": "Abnormal FPV gimbal vibration",
      "zh": "FPV云台异常振动",
      "fr": ""
    },
    "0x1D040C02" : {
      "en": "FPV gimbal sensor error",
      "zh": "FPV云台传感器故障",
      "fr": ""
    },
    "0x1D040C03" : {
      "en": "FPV gimbal ESC malfunction",
      "zh": "FPV云台电调故障",
      "fr": ""
    },
    "0x1D040C04" : {
      "en": "FPV gimbal ESC malfunction",
      "zh": "FPV云台电调故障",
      "fr": ""
    },
    "0x1D040C05" : {
      "en": "FPV gimbal ESC malfunction",
      "zh": "FPV云台电调故障",
      "fr": ""
    },
    "0x1D050001" : {
      "en": "Gimbal %component_index roll axis endpoint reached",
      "zh": "云台%component_index横滚已达限位",
      "fr": ""
    },
    "0x1D050002" : {
      "en": "Gimbal %component_index pitch axis endpoint reached",
      "zh": "云台%component_index俯仰已达限位",
      "fr": ""
    },
    "0x1D050003" : {
      "en": "Gimbal %component_index pan axis endpoint reached",
      "zh": "云台%component_index偏航已达限位",
      "fr": ""
    },
    "0x1D050004" : {
      "en": "Gimbal frozen due to low temperature. Return to dock and try unfreezing gimbal",
      "zh": "云台低温结冰，请返回机场并尝试解冻云台",
      "fr": ""
    },
    "0x1D050301" : {
      "en": "Gimbal operation retry attempts limit exceeded",
      "zh": "云台重试次数过多",
      "fr": ""
    },
    "0x1D050302" : {
      "en": "Camera exposure error",
      "zh": "相机曝光超时",
      "fr": ""
    },
    "0x1D05030F" : {
      "en": "Gimbal rotation count approaching max limit",
      "zh": "云台三轴转动次数接近使用寿命",
      "fr": ""
    },
    "0x1D050A01" : {
      "en": "Gimbal voltage too low",
      "zh": "云台电压过低",
      "fr": ""
    },
    "0x1D050A02" : {
      "en": "Gimbal time synchronization error",
      "zh": "云台时间同步功能异常",
      "fr": ""
    },
    "0x1D050C01" : {
      "en": "FPV gimbal limit reached",
      "zh": "FPV云台已达限位",
      "fr": ""
    },
    "0x1D050C02" : {
      "en": "FPV gimbal tilt limit reached",
      "zh": "FPV云台俯仰已达限位",
      "fr": ""
    },
    "0x1D050C03" : {
      "en": "FPV gimbal pan limit reached",
      "zh": "FPV云台偏航已达限位",
      "fr": ""
    },
    "0x1D0C0002" : {
      "en": "Gimbal IMU Error",
      "zh": "云台IMU异常",
      "fr": ""
    },
    "0x1D0C0003" : {
      "en": "Gimbal Initialization Error",
      "zh": "云台初始化异常",
      "fr": ""
    },
    "0x1D0C0004" : {
      "en": "Gimbal Initialization Error",
      "zh": "云台初始化异常",
      "fr": ""
    },
    "0x1D0C0005" : {
      "en": "Gimbal voltage error. Replace with DJI battery",
      "zh": "云台电源电压异常，请使用官方电池",
      "fr": ""
    },
    "0x1D0C000B" : {
      "en": "Gimbal Motor Temperature Too High",
      "zh": "云台电机温度过高",
      "fr": ""
    },
    "0x1D0C000E" : {
      "en": "Lens not firmly attached. Reattach lens and toggle lever to the locked position",
      "zh": "镜头未安装紧固，请取下重装，并拧紧扳扣",
      "fr": ""
    },
    "0x1D0C000F" : {
      "en": "Gimbal not balanced. Make sure lens protector/ND filter, hood, and balancing weight are properly installed",
      "zh": "云台未配平，请正确安装保护镜/ND镜、遮光罩以及配重",
      "fr": ""
    },
    "0x1D0C0C02" : {
      "en": "FPV gimbal IMU error",
      "zh": "FPV云台IMU异常",
      "fr": ""
    },
    "0x1D0C0C03" : {
      "en": "FPV gimbal initialization error",
      "zh": "FPV云台初始化异常",
      "fr": ""
    },
    "0x1D0C0C04" : {
      "en": "FPV gimbal initialization error",
      "zh": "FPV云台初始化异常",
      "fr": ""
    },
    "0x1D0C0C05" : {
      "en": "FPV gimbal voltage error. Replace with DJI battery",
      "zh": "FPV云台电源电压异常，请使用官方电池",
      "fr": ""
    },
    "0x1D0C0C0B" : {
      "en": "FPV gimbal motor overheated",
      "zh": "FPV云台电机温度过高",
      "fr": ""
    },
    "0x1D0E0001" : {
      "en": "Gimbal Initialization Error",
      "zh": "云台初始化异常",
      "fr": ""
    },
    "0x1D0E0C01" : {
      "en": "FPV gimbal initialization error",
      "zh": "FPV云台初始化异常",
      "fr": ""
    },
    "0x1D100002" : {
      "en": "Gimbal unresponsive after power on",
      "zh": "云台上电后无力",
      "fr": ""
    },
    "0x1D100006" : {
      "en": "Gimbal unresponsive after power on",
      "zh": "云台上电后无力",
      "fr": ""
    },
    "0x1D110002" : {
      "en": "Gimbal unable to complete auto check",
      "zh": "云台无法完成自检",
      "fr": ""
    },
    "0x1D110005" : {
      "en": "Gimbal unable to complete auto check",
      "zh": "云台无法完成自检",
      "fr": ""
    },
    "0x1D120001" : {
      "en": "Error detected during gimbal auto check",
      "zh": "云台自检后异常",
      "fr": ""
    },
    "0x1D120002" : {
      "en": "Error detected during gimbal auto check",
      "zh": "云台自检后异常",
      "fr": ""
    },
    "0x1D120004" : {
      "en": "Error detected during gimbal auto check",
      "zh": "云台自检后异常",
      "fr": ""
    },
    "0x1D120006" : {
      "en": "Error detected during gimbal auto check",
      "zh": "云台自检后异常",
      "fr": ""
    },
    "0x1D130003" : {
      "en": "Excessive gimbal vibration",
      "zh": "云台异常振动",
      "fr": ""
    },
    "0x1D130005" : {
      "en": "Excessive gimbal vibration",
      "zh": "云台异常振动",
      "fr": ""
    },
    "0x1D13000A" : {
      "en": "Excessive gimbal vibration",
      "zh": "云台异常振动",
      "fr": ""
    },
    "0x1D140001" : {
      "en": "Gimbal motor overloaded",
      "zh": "云台电机过载",
      "fr": ""
    },
    "0x1D150002" : {
      "en": "Gimbal drifting",
      "zh": "云台自动漂移",
      "fr": ""
    },
    "0x1D150003" : {
      "en": "Gimbal drifting",
      "zh": "云台自动漂移",
      "fr": ""
    },
    "0x1D150004" : {
      "en": "Gimbal drifting",
      "zh": "云台自动漂移",
      "fr": ""
    },
    "0x1D150005" : {
      "en": "Gimbal drifting",
      "zh": "云台自动漂移",
      "fr": ""
    },
    "0x1D160004" : {
      "en": "Camera tilted",
      "zh": "相机视频歪斜",
      "fr": ""
    },
    "0x1D170001" : {
      "en": "Gimbal error",
      "zh": "云台功能异常",
      "fr": ""
    },
    "0x1D180001" : {
      "en": "Gimbal calibration data error",
      "zh": "云台校准数据异常",
      "fr": ""
    },
    "0x1D190002" : {
      "en": "Gimbal update failed",
      "zh": "云台升级失败",
      "fr": ""
    },
    "0x1E00000" : {
      "en": "",
      "zh": "喊话器与机身发生共振，供电已断开，请等待自行恢复",
      "fr": ""
    },
    "0x1E000001" : {
      "en": "Payload %component_index startup error",
      "zh": "%component_index号负载启动异常",
      "fr": ""
    },
    "0x1E000002" : {
      "en": "Payload %component_index communication error",
      "zh": "%component_index号负载通讯异常",
      "fr": ""
    },
    "0x1E000003" : {
      "en": "Payload %component_index overheated",
      "zh": "%component_index号负载温度过高",
      "fr": ""
    },
    "0x1E000004" : {
      "en": "Payload %component_index hardware error",
      "zh": "%component_index号负载硬件异常",
      "fr": ""
    },
    "0x1E000006" : {
      "en": "Speaker resonates with the aircraft. Power supply disconnected. Wait for power supply to recover",
      "zh": "喊话器与机身发生共振，供电已断开，请等待自行恢复",
      "fr": ""
    },
    "0x1E000101" : {
      "en": "Aircraft returning to home. Spotlight disabled automatically",
      "zh": "飞行器正在返航，探照灯自动关闭",
      "fr": ""
    },
    "0x1E000102" : {
      "en": "Aircraft has not taken off. Spotlight max brightness level limited to 40%",
      "zh": "飞行器尚未起桨，探照灯最大亮度限制40%",
      "fr": ""
    },
    "0x1E000103" : {
      "en": "Spotlight power restricted. Max brightness level reduced",
      "zh": "探照灯功率受限，最大亮度降低",
      "fr": ""
    },
    "0x1E000104" : {
      "en": "Spotlight temperature too high. Brightness will be continuously reduced",
      "zh": "探照灯温度过高，亮度将持续降低",
      "fr": ""
    },
    "0x1E000105" : {
      "en": "Aircraft battery low. Spotlight disabled automatically",
      "zh": "飞行器电量低，探照灯自动关闭",
      "fr": ""
    },
    "0x1E000106" : {
      "en": "Aircraft landing near ground. Spotlight disabled automatically",
      "zh": "飞行器近地降落中，探照灯自动关闭",
      "fr": ""
    },
    "0x1E010001" : {
      "en": "Speaker overheats. Lower broadcast volume or wait until speaker cools down",
      "zh": "喊话器温度过高，请尝试降低音量或冷却后再使用",
      "fr": ""
    },
    "0x1E010002" : {
      "en": "Speaker hardware error. Contact DJI Support",
      "zh": "喊话器硬件异常，请联系售后服务",
      "fr": ""
    },
    "0x1E010003" : {
      "en": "Speaker overloaded. Restart aircraft",
      "zh": "喊话器过载，请重启飞行器",
      "fr": ""
    },
    "0x1E010004" : {
      "en": "Battery power limited. Speaker disabled",
      "zh": "电池功率限制，喊话器强制关闭",
      "fr": ""
    },
    "0x1E020001" : {
      "en": "Spotlight gimbal stuck",
      "zh": "探照灯云台被卡住",
      "fr": ""
    },
    "0x1E020002" : {
      "en": "Spotlight gimbal auto check failed",
      "zh": "探照灯云台自检失败",
      "fr": ""
    },
    "0x1E020003" : {
      "en": "Spotlight gimbal motor overloaded",
      "zh": "探照灯云台电机过载",
      "fr": ""
    },
    "0x1E030001" : {
      "en": "Spotlight gimbal calibration error",
      "zh": "探照灯云台标定错误",
      "fr": ""
    },
    "0x1E030003" : {
      "en": "Spotlight gimbal calibration parameter error",
      "zh": "探照灯云台校准参数异常",
      "fr": ""
    },
    "0x1E040001" : {
      "en": "Spotlight gimbal stuck",
      "zh": "探照灯云台被卡住",
      "fr": ""
    },
    "0x1E040002" : {
      "en": "Spotlight gimbal auto check failed",
      "zh": "探照灯云台自检失败",
      "fr": ""
    },
    "0x1E040003" : {
      "en": "Spotlight gimbal motor overloaded",
      "zh": "探照灯云台电机过载",
      "fr": ""
    },
    "0x1E050001" : {
      "en": "Spotlight gimbal calibration error",
      "zh": "探照灯云台标定错误",
      "fr": ""
    },
    "0x1E050002" : {
      "en": "Spotlight gimbal sensor error",
      "zh": "探照灯云台传感器故障",
      "fr": ""
    },
    "0x1E050003" : {
      "en": "Spotlight gimbal calibration parameter error",
      "zh": "探照灯云台校准参数异常",
      "fr": ""
    },
    "0x1E050004" : {
      "en": "Motor on right side of spotlight error. Try restarting spotlight",
      "zh": "探照灯右侧电机异常，请尝试重启探照灯",
      "fr": ""
    },
    "0x1E050005" : {
      "en": "Spotlight gimbal motor malfunction",
      "zh": "探照灯云台电机故障",
      "fr": ""
    },
    "0x1E060001" : {
      "en": "Spotlight unable to obtain aircraft information",
      "zh": "探照灯无法获取飞行器信息",
      "fr": ""
    },
    "0x1E070002" : {
      "en": "Spotlight gimbal sensor error",
      "zh": "探照灯云台传感器故障",
      "fr": ""
    },
    "0x1E070003" : {
      "en": "Motor on left side of spotlight error. Try restarting spotlight",
      "zh": "探照灯左侧电机异常，请尝试重启探照灯",
      "fr": ""
    },
    "0x1E070004" : {
      "en": "Motor on right side of spotlight error. Try restarting spotlight",
      "zh": "探照灯右侧电机异常，请尝试重启探照灯",
      "fr": ""
    },
    "0x1E070005" : {
      "en": "Spotlight gimbal motor malfunction",
      "zh": "探照灯云台电机故障",
      "fr": ""
    },
    "0x1E0D0001" : {
      "en": "Spotlight not activated",
      "zh": "探照灯未激活",
      "fr": ""
    },
    "0x1E0D0002" : {
      "en": "No IMU data for Spotlight",
      "zh": "探照灯无IMU数据",
      "fr": ""
    },
    "0x1E0D0003" : {
      "en": "Spotlight gimbal motor not initialized",
      "zh": "探照灯云台电机未初始化",
      "fr": ""
    },
    "0x1E0F0001" : {
      "en": "Spotlight not activated",
      "zh": "探照灯未激活",
      "fr": ""
    },
    "0x1E0F0002" : {
      "en": "No IMU data for Spotlight",
      "zh": "探照灯无IMU数据",
      "fr": ""
    },
    "0x1E0F0003" : {
      "en": "Spotlight gimbal motor not initialized",
      "zh": "探照灯云台电机未初始化",
      "fr": ""
    },
    "0x1E110001" : {
      "en": "Spotlight gimbal attitude initialization failed",
      "zh": "探照灯云台姿态初始化失败",
      "fr": ""
    },
    "0x1F010000" : {
      "en": "4G service: unable to obtain license. Contact DJI Support",
      "zh": "4G服务：License无法获取，请联系DJI售后服务",
      "fr": ""
    },
    "0x1F010001" : {
      "en": "4G service: license expired. Import valid license",
      "zh": "4G服务：License过期，请导入有效证书",
      "fr": ""
    },
    "0x1F010002" : {
      "en": "4G service: license verification failed. Contact DJI Support",
      "zh": "4G服务：License校验失败，请联系DJI售后服务",
      "fr": ""
    },
    "0x1F010003" : {
      "en": "4G service: device SN unauthorized. Authorize device SN",
      "zh": "4G服务：设备SN未授权，请授权设备SN",
      "fr": ""
    },
    "0x1F010004" : {
      "en": "4G service: device SN unauthorized. Purchase upgrade package",
      "zh": "4G服务：设备型号未授权，请购买扩容套餐",
      "fr": ""
    },
    "0x1F010005" : {
      "en": "4G service: the number of connected devices exceeds authorized number. Purchase upgrade package",
      "zh": "4G服务：设备连接数量超过授权，请购买扩容套餐",
      "fr": ""
    },
    "0x1F010006" : {
      "en": "4G service: device firmware version too early. Upgrade firmware",
      "zh": "4G服务：设备固件版本过低，请升级固件",
      "fr": ""
    },
    "0x1F010007" : {
      "en": "4G service: server version too early. Upgrade server",
      "zh": "4G服务：服务器版本过低，请升级服务器",
      "fr": ""
    },
    "0x1F010008" : {
      "en": "4G service: requested parameter error. Contact DJI Support",
      "zh": "4G服务：请求参数错误，请联系DJI售后服务",
      "fr": ""
    },
    "0x1F010009" : {
      "en": "4G service: server internal error. Contact DJI Support",
      "zh": "4G服务：服务器内部错误，请联系DJI售后服务",
      "fr": ""
    },
    "0x1F01000A" : {
      "en": "4G service: unable to obtain license. Contact DJI Support",
      "zh": "4G服务：证书无法读取，请联系DJI售后服务",
      "fr": ""
    },
    "0x1F01000B" : {
      "en": "4G service: license expired. Import valid license",
      "zh": "4G服务：证书过期，请导入有效证书",
      "fr": ""
    },
    "0x1F01000C" : {
      "en": "4G service: license verification failed. Contact DJI Support",
      "zh": "4G服务：证书校验失败，请联系DJI售后服务",
      "fr": ""
    },
    "0x1F01000D" : {
      "en": "System time error. Make sure device and server time are correct and try again",
      "zh": "系统时间错误，请确认设备和服务器时间正确后重试",
      "fr": ""
    },
    "0x1F01000E" : {
      "en": "Current area does not match area unlocked by license. Check unlocked area",
      "zh": "当前区域与证书区域不匹配，请检查证书适用区域",
      "fr": ""
    },
    "0x1F010063" : {
      "en": "4G service: system unknown error. Contact DJI Support",
      "zh": "4G服务：系统未知错误，请联系DJI售后服务",
      "fr": ""
    },
    "0x1F0B0001" : {
      "en": "Aircraft unable to use LTE Transmission. Network connection unstable or SIM card unable to connect to network",
      "zh": "飞机无法使用LTE链路，网络波动或SIM卡无法访问网络",
      "fr": ""
    },
    "0x1F0B0002" : {
      "en": "No network on DJI Cellular Dongle of remote controller",
      "zh": "遥控器DJI Cellular模块无法访问网络",
      "fr": ""
    },
    "0x1F0B0003" : {
      "en": "LTE Server and LTE Transmission unavailable",
      "zh": "LTE服务器不可用，LTE链路不可用",
      "fr": ""
    },
    "0x1F0B0004" : {
      "en": "LTE Server and LTE Transmission unavailable",
      "zh": "LTE服务器不可用，LTE链路不可用",
      "fr": ""
    },
    "0x1F0B0005" : {
      "en": "LTE Transmission unavailable. Check and ensure remote controller and aircraft are linked properly",
      "zh": "LTE链路不可用，请确认遥控器和飞机已成功对频",
      "fr": ""
    },
    "0x1F0B0006" : {
      "en": "LTE Transmission unavailable. Restart remote controller",
      "zh": "LTE链路不可用，请重启遥控器",
      "fr": ""
    },
    "0x1F0B0007" : {
      "en": "LTE Transmission unavailable. Check aircraft 4G Dongle network connectivity",
      "zh": "LTE链路不可用，请检查飞机4G dongle的网络能力",
      "fr": ""
    },
    "0x1F0B0008" : {
      "en": "LTE Transmission unavailable. Restart aircraft and remote controller",
      "zh": "LTE链路不可用，请重启飞机和遥控器",
      "fr": ""
    },
    "0x1F0B0009" : {
      "en": "LTE Transmission unavailable. Restart remote controller",
      "zh": "LTE链路不可用，请重启遥控器",
      "fr": ""
    },
    "0x1F0B0016" : {
      "en": "LTE Transmission unavailable. Check remote controller network connectivity",
      "zh": "LTE链路不可用，请检查遥控器的网络能力",
      "fr": ""
    },
    "0x1f0b0017" : {
      "en": "LTE Transmission unavailable. Check remote controller network connectivity",
      "zh": "LTE链路不可用，请检查遥控器的网络能力",
      "fr": ""
    },
    "0x1F0B0017" : {
      "en": "LTE Transmission unavailable. Check remote controller network connectivity",
      "zh": "LTE链路不可用，请检查遥控器的网络能力",
      "fr": ""
    },
    "0x1F0B0018" : {
      "en": "LTE Transmission unavailable. Restart aircraft and remote controller",
      "zh": "LTE链路不可用，请重启飞机和遥控器",
      "fr": ""
    },
    "0x1F0B001A" : {
      "en": "LTE Transmission unavailable. Check aircraft 4G Dongle network connectivity",
      "zh": "LTE链路不可用，请检查飞机4G dongle的网络能力",
      "fr": ""
    },
    "0x1F0B001B" : {
      "en": "LTE Transmission unavailable. Restart aircraft and remote controller",
      "zh": "LTE链路不可用，请重启飞机和遥控器",
      "fr": ""
    },
    "0x1F0B001c" : {
      "en": "LTE Transmission error. Aircraft authentication files missing. Contact your local dealer or DJI Support",
      "zh": "LTE链路异常，飞行器缺少认证文件，请联系大疆售后服务",
      "fr": ""
    },
    "0x1F0B001C" : {
      "en": "LTE Transmission error. Aircraft authentication files missing. Contact your local dealer or DJI Support",
      "zh": "LTE链路异常，飞行器缺少认证文件，请联系大疆售后服务",
      "fr": ""
    },
    "0x1F0B001d" : {
      "en": "LTE Transmission error. Remote controller authentication files missing. Contact your local dealer or DJI Support",
      "zh": "LTE链路异常，遥控器缺少认证文件，请联系大疆售后服务",
      "fr": ""
    },
    "0x1F0B0020" : {
      "en": "Update DJI Cellular Dongle of aircraft required",
      "zh": "飞行器 DJI Cellular 模块需要升级",
      "fr": ""
    },
    "0x1F0B0021" : {
      "en": "Update DJI Cellular Dongle of remote controller required",
      "zh": "遥控器 DJI Cellular 模块需升级",
      "fr": ""
    },
    "0x1F0B0022" : {
      "en": "Airplane mode enabled or Wi-Fi and mobile data disabled on mobile device. Unable to connect",
      "zh": "手机进入飞行模式或者关闭wifi及移动网络，无法发起移动网络通信",
      "fr": ""
    },
    "0x1F0B0023" : {
      "en": "LTE signal weak. Fly with caution",
      "zh": "LTE 信号弱，请谨慎飞行",
      "fr": ""
    },
    "0x1F0B0024" : {
      "en": "LTE signal weak. Fly with caution",
      "zh": "LTE 信号弱，请谨慎飞行",
      "fr": ""
    },
    "0x1F0B0025" : {
      "en": "LTE signal weak. Fly with caution",
      "zh": "LTE 信号弱，请谨慎飞行",
      "fr": ""
    },
    "0x1F0B0026" : {
      "en": "Insufficient data allowance on SIM card. Fly with caution",
      "zh": "SIM卡流量不足，请谨慎飞行",
      "fr": ""
    },
    "0x1F0B0027" : {
      "en": "Aircraft LTE certification update required. Contact your local dealer or DJI Support",
      "zh": "飞行器 LTE 证书需更新，请联系售后或代理商",
      "fr": ""
    },
    "0x1F0B0028" : {
      "en": "Remote controller LTE certification update required. Contact your local dealer or DJI Support",
      "zh": "遥控器 LTE 证书需更新，请联系售后或代理商",
      "fr": ""
    },
    "0x1F0B0029" : {
      "en": "License expired. Unable to establish communication",
      "zh": "证书过期，将无法正常建立通信链路",
      "fr": ""
    },
    "0x1F0B002A" : {
      "en": "Incompatible firmware versions. Return to home screen to update firmware",
      "zh": "固件版本不匹配，请返回首页进行升级",
      "fr": ""
    },
    "0x1F0B002B" : {
      "en": "Incompatible firmware versions. Return to home screen to update firmware",
      "zh": "固件版本不匹配，请返回首页进行升级",
      "fr": ""
    },
    "0x1F0B002C" : {
      "en": "Incompatible firmware versions. Go to home screen to update firmware",
      "zh": "固件版本不匹配，请在首页进行升级",
      "fr": ""
    },
    "0x1F0B002D" : {
      "en": "App update required",
      "zh": "App版本需要升级",
      "fr": ""
    },
    "0x1F0B002E" : {
      "en": "Weak network connection on remote controller. Fly with caution",
      "zh": "遥控器网络信号弱，请谨慎飞行",
      "fr": ""
    },
    "0x1F0B0030" : {
      "en": "Failed to connect to LTE server. Try again later",
      "zh": "LTE服务器暂时无法连接，请稍后再试",
      "fr": ""
    },
    "0x1F0B0031" : {
      "en": "Weak network signal on mobile device. Device may be unable to establish communication or connection may be unstable",
      "zh": "手机可网络信号弱，链路可能无法建立或者容易断开连接",
      "fr": ""
    },
    "0x1F0B0032" : {
      "en": "Service expired. Unable to use Enhanced Transmission. Firmware update required",
      "zh": "用户服务到期，不允许进入融合模式。固件版本需要升级",
      "fr": ""
    },
    "0x1F0B0035" : {
      "en": "Dongle firmware update required",
      "zh": "dongle固件版本需要升级",
      "fr": ""
    },
    "0x1F0B0036" : {
      "en": "Enhanced Transmission unavailable in current region",
      "zh": "当前地区无法使用增强图传功能",
      "fr": ""
    },
    "0x1F0B0037" : {
      "en": "No internet access on DJI Cellular Dongle of aircraft. Move or change network",
      "zh": "飞行器 DJI Cellular 模块无法访问网络，请更换至网络更好的地点或稍后重试",
      "fr": ""
    },
    "0x1F0B0038" : {
      "en": "No network on DJI Cellular Dongle of remote controller",
      "zh": "遥控器 DJI Cellular 模块无法访问网络",
      "fr": ""
    },
    "0x1F0B0039" : {
      "en": "Unable to establish network connection. Move to a different place or switch to a different SIM card from another service provider",
      "zh": "目前网络无法正常建立，可以尝试更换地点，或者换其他运营商的卡。",
      "fr": ""
    },
    "0x1F0B003A" : {
      "en": "No internet access on DJI Cellular Dongle of aircraft. Change network provider",
      "zh": "飞行器 DJI Cellular 模块无法访问网络，请尝试使用其他运营商网络",
      "fr": ""
    },
    "0x1F0B003B" : {
      "en": "No network on DJI Cellular Dongle of remote controller",
      "zh": "遥控器 DJI Cellular 模块无法访问网络",
      "fr": ""
    },
    "0x1F0B003C" : {
      "en": "Unable to establish network connection. Move to a different place or switch to a different SIM card from another service provider",
      "zh": "目前网络无法正常建立，可以尝试更换地点，或者换其他运营商的卡。",
      "fr": ""
    },
    "0x1F0B003D" : {
      "en": "No network connection",
      "zh": "无法访问网络",
      "fr": ""
    },
    "0x1F0B003E" : {
      "en": "No network on SIM card of DJI Cellular Dongle of remote controller. Check or replace SIM card",
      "zh": "遥控器 DJI Cellular SIM卡暂时无法获取网络服务，建议检查或更换SIM卡",
      "fr": ""
    },
    "0x1F0B0040" : {
      "en": "No network on remote controller",
      "zh": "遥控器无法访问网络",
      "fr": ""
    },
    "0x1F0B0040_in_the_sky" : {
      "en": "No internet on remote controller. Check DJI Cellular Dongle or Wi-Fi connection status",
      "zh": "遥控器无法访问网络，请检查DJI Cellular模块或Wi-Fi连接状态",
      "fr": ""
    },
    "0x1F0B0045" : {
      "en": "Enhanced link latency high. Fly with caution",
      "zh": "增强链路操控延时较大，请谨慎飞行",
      "fr": ""
    },
    "0x1F0B0045_in_the_sky" : {
      "en": "Enhanced link latency high. Fly with caution",
      "zh": "增强链路操控延时较大，请谨慎飞行",
      "fr": ""
    },
    "0x1F0B0046" : {
      "en": "SIM card not inserted in 4G Dongle of aircraft and eSIM card not activated",
      "zh": "飞机的4G Dongle未插入SIM卡且eSIM未激活",
      "fr": ""
    },
    "0x1F0B0047" : {
      "en": "SIM card inserted in 4G Dongle of aircraft. eSIM card selected but not activated",
      "zh": "飞机的4G Dongle已插入SIM卡，选择了eSIM且eSIM未激活",
      "fr": ""
    },
    "0x1F0B0048" : {
      "en": "SIM card not inserted in 4G Dongle of remote controller and eSIM card not activated",
      "zh": "遥控器的4G Dongle未插入SIM卡且eSIM未激活",
      "fr": ""
    },
    "0x1F0B0049" : {
      "en": "SIM card inserted in 4G Dongle of remote controller. eSIM card selected but not activated",
      "zh": "遥控器的4G Dongle已插入SIM卡，选择了eSIM且eSIM未激活",
      "fr": ""
    },
    "0x1F0B004A" : {
      "en": "",
      "zh": "飞机无法使用LTE链路，网络波动或SIM卡%lte_index无法访问网络",
      "fr": ""
    },
    "0x1F0B004B" : {
      "en": "",
      "zh": "飞行器 DJI Cellular 模块%lte_index无法访问网络，请更换至网络更好的地点或稍后重试",
      "fr": ""
    },
    "0x1F0B004C" : {
      "en": "",
      "zh": "飞行器 DJI Cellular 模块%lte_index无法访问网络，请尝试使用其他运营商网络",
      "fr": ""
    },
    "0x1F0B004D" : {
      "en": "",
      "zh": "无法访问网络",
      "fr": ""
    },
    "0x1F0B004E" : {
      "en": "",
      "zh": "飞机的Cellular 模块 %lte_index未插入SIM卡且eSIM未激活",
      "fr": ""
    },
    "0x1F0B004F" : {
      "en": "",
      "zh": "飞机的Cellular 模块 %lte_index已插入SIM卡，选择了eSIM且eSIM未激活",
      "fr": ""
    },
    "0x20010100" : {
      "en": "Remote controller %2$s obtained gimbal %1$s control",
      "zh": "云台%1$s的控制权已被%2$s控获取",
      "fr": ""
    },
    "0x20010200" : {
      "en": "Obtained control of current gimbal",
      "zh": "已成功获取该云台的控制权",
      "fr": ""
    },
    "0x20010301" : {
      "en": "Free-mode",
      "zh": "自由模式",
      "fr": ""
    },
    "0x20010302" : {
      "en": "Follow",
      "zh": "跟随模式",
      "fr": ""
    },
    "0x20010304" : {
      "en": "Failed to change gimbal mode, please try again.",
      "zh": "云台模式设置失败，请重试",
      "fr": ""
    },
    "0x20010400" : {
      "en": "Tip: Only the first camera can tap-zoom in dual gimbal control mode.",
      "zh": "提示：开启双云台同时控制模式时，只能使用1号云台指点变焦功能",
      "fr": ""
    },
    "0x20010501" : {
      "en": "Gimbal Recenter",
      "zh": "云台回中",
      "fr": ""
    },
    "0x20010502" : {
      "en": "Recenter Gimbal Pan",
      "zh": "云台偏航回中",
      "fr": ""
    },
    "0x20010503" : {
      "en": "Gimbal Pitch Up",
      "zh": "云台俯仰朝上",
      "fr": ""
    },
    "0x20010504" : {
      "en": "Gimbal Pitch Down",
      "zh": "云台俯仰朝下",
      "fr": ""
    },
    "0x20010505" : {
      "en": "Gimbal Up",
      "zh": "云台朝上",
      "fr": ""
    },
    "0x20010506" : {
      "en": "Gimbal down",
      "zh": "云台向下",
      "fr": ""
    },
    "0x20010507" : {
      "en": "Gimbal Pitch Recenter",
      "zh": "云台俯仰回中",
      "fr": ""
    },
    "0x20010508" : {
      "en": "Gimbal roll centered",
      "zh": "云台横滚回中",
      "fr": ""
    },
    "0x20010600" : {
      "en": "Vision stabilization on.",
      "zh": "云台增稳开启",
      "fr": ""
    },
    "0x20010601" : {
      "en": "Vision stabilization off.",
      "zh": "云台增稳关闭",
      "fr": ""
    },
    "0x20010700" : {
      "en": "Lost control of %1$s. Multi-Gimbal Connection disabled",
      "zh": "失去%1$s的控制权，联动取消",
      "fr": ""
    },
    "0x20010701" : {
      "en": "Lost control of %1$s. %2$s dropped from Multi-Gimbal Connection",
      "zh": "失去%1$s的控制权，%2$s脱离联动",
      "fr": ""
    },
    "0x20010800" : {
      "en": "Transmission interrupted. Gimbal control lost",
      "zh": "链路中断，您失去了对云台的控制权。",
      "fr": ""
    },
    "0x20010900" : {
      "en": "Remote controller %1$s transmission interrupted. Gained control of all gimbals",
      "zh": "%1$s控连接中断，您已经获得所有云台的控制权。",
      "fr": ""
    },
    "0x20020000" : {
      "en": "Obtained aircraft flight control. Current control stick mode: %1$s",
      "zh": "已成功获取飞行器的控制权，您当前的摇杆挡位为%1$s",
      "fr": ""
    },
    "0x20020001" : {
      "en": "Aircraft flight control unlocked",
      "zh": "控制权已解锁",
      "fr": ""
    },
    "0x20020002" : {
      "en": "Aircraft flight control locked",
      "zh": "控制权已锁定",
      "fr": ""
    },
    "0x20020003" : {
      "en": "Aircraft flight control obtained by remote controller %1$s",
      "zh": "飞行器的控制权已经被%1$s控获取",
      "fr": ""
    },
    "0x20020004" : {
      "en": "Unable to obtain current gimbal control",
      "zh": "当前状态下，不可夺取当前云台的控制权",
      "fr": ""
    },
    "0x20020005" : {
      "en": "Aircraft flight control locked by remote controller %1$s. Unable to obtain control",
      "zh": "飞行器的控制权已被%1$s控锁定，无法获取控制权",
      "fr": ""
    },
    "0x20020006" : {
      "en": "Unable to obtain aircraft flight control",
      "zh": "当前状态下，不可夺取飞行控制权",
      "fr": ""
    },
    "0x20020100" : {
      "en": "Tip: Aircraft reached maximum distance, please pay attention to flight safety.\\n",
      "zh": "提示：飞机已经达到最远距离， 请注意安全飞行",
      "fr": ""
    },
    "0x20020200" : {
      "en": "High Wind Velocity. Fly with caution.",
      "zh": "风速过大，谨慎飞行",
      "fr": ""
    },
    "0x20020201" : {
      "en": "High Wind Velocity. Fly with caution.",
      "zh": "风速过大，谨慎飞行",
      "fr": ""
    },
    "0x20020300" : {
      "en": "ATTI mode",
      "zh": "姿态模式",
      "fr": ""
    },
    "0x20020301" : {
      "en": "Cannot switch flight mode. Turn on \\\"Multiple Flight Modes\\\" to enable Atti and Sport Modes",
      "zh": "不允许切换飞行挡位，如需切到其他挡，请在飞控设置打开\\'允许切换飞行挡位\\'开关",
      "fr": ""
    },
    "0x20020302" : {
      "en": "Switched to S (Sport)-mode.",
      "zh": "已切换至S挡（运动）",
      "fr": ""
    },
    "0x20020303" : {
      "en": "Switched to P (Positioning)-mode.",
      "zh": "已切换至P挡（定位）",
      "fr": ""
    },
    "0x20020304" : {
      "en": "Switched to T (Tripod)-mode.",
      "zh": "已切换至T挡（三脚架）",
      "fr": ""
    },
    "0x20020305" : {
      "en": "Switched to A (Attitude)-mode.",
      "zh": "已切换至A挡（姿态）",
      "fr": ""
    },
    "0x20020306" : {
      "en": "To take off in non-P mode, toggle Flight Mode Switch to another mode and then toggle it back.",
      "zh": "如果要以非P挡起飞，请切换挡位至其他挡再切回当前挡以确认。",
      "fr": ""
    },
    "0x20020307" : {
      "en": "When winch mode is enabled, aircraft acceleration is limited and braking time is extended",
      "zh": "空吊模式下，加速度受限，刹停时间变长",
      "fr": ""
    },
    "0x20020308" : {
      "en": "Auto release payload successful",
      "zh": "空吊自动放货执行成功",
      "fr": ""
    },
    "0x20020309" : {
      "en": "Auto release payload failed",
      "zh": "空吊自动放货执行失败",
      "fr": ""
    },
    "0x20020400" : {
      "en": "The remaining battery is only enough for RTH. Return home now.",
      "zh": "当前电量仅够返回返航点，请尽快返航。",
      "fr": ""
    },
    "0x20020500" : {
      "en": "Home Point recorded. Return-to-Home Altitude:%1$.1f %2$s",
      "zh": "返航点已记录，返航高度：%1$.1f %2$s",
      "fr": ""
    },
    "0x20020600" : {
      "en": "Low power. Aircraft will return home.",
      "zh": "低电量，飞机开始返航",
      "fr": ""
    },
    "0x20020601" : {
      "en": "Critically low power. Aircraft is landing.",
      "zh": "严重低电量，系统强制降落，无法取消，您可以通过推油门减缓下降速度，调整摇杆方向避开危险",
      "fr": ""
    },
    "0x20020602" : {
      "en": "Low power. Returning home.",
      "zh": "系统计算您当前电量仅足够返回返航点，飞机开始返航",
      "fr": ""
    },
    "0x20020603" : {
      "en": "Critically low power. Aircraft is landing.",
      "zh": "当前电量仅够当前高度降落，系统将强制下降，无法取消",
      "fr": ""
    },
    "0x20020604" : {
      "en": "Critically low voltage. Aircraft is landing. Press the RTH button on the remote controller to stop.",
      "zh": "严重低电压，系统强制降落，短按遥控器上的返航按钮停止降落",
      "fr": ""
    },
    "0x20020605" : {
      "en": "Low voltage. Returning home now. Press the RTH button on the remote controller to stop.",
      "zh": "低电压报警，飞机开始返航，短按遥控器上的返航按钮停止返航",
      "fr": ""
    },
    "0x20020606" : {
      "en": "Aircraft is landing due to low voltage, which cannot be stopped. You can decelerate the descending speed and avoid obstacles using sticks.",
      "zh": "电池电压过低，系统强制降落，无法取消，您可以通过推油门减缓下降速度，调整摇杆方向避开危险",
      "fr": ""
    },
    "0x20020607" : {
      "en": "Aircraft is returning to the Home Point. Minimum RTH Altitude is %1$dm. You can reset the RTH Altitude in Remote Controller Settings after cancelling RTH if necessary.",
      "zh": "开始自动返航，最低返航高度%1$d米。如需调整返航高度，可在取消返航后到飞控设置中重新设置返航高度",
      "fr": ""
    },
    "0x20020608" : {
      "en": "Aircraft is returning to the Home Point. RTH Altitude is %1$dm. You can reset the RTH Altitude in Remote Controller Settings after cancelling RTH if necessary.",
      "zh": "开始自动返航，最低返航高度%1$d米。如需调整返航高度，可在取消返航后到飞控设置中重新设置返航高度",
      "fr": ""
    },
    "0x20020609" : {
      "en": "Aircraft signal lost. RTH started",
      "zh": "飞行器失联，开始返航",
      "fr": ""
    },
    "0x2002060A" : {
      "en": "You are in a No-Fly Zone. Auto landing initiated.",
      "zh": "飞行器在禁飞区内，开始自动降落",
      "fr": ""
    },
    "0x2002060B" : {
      "en": "Aircraft is close to the Home Point. Initiating Return to Home will now trigger Auto Landing.",
      "zh": "飞行器距离返航点太近，返航切换为自动降落",
      "fr": ""
    },
    "0x2002060C" : {
      "en": "Aircraft is too far from the Home Point. Initiating Return to Home will now trigger Auto Landing.",
      "zh": "飞行器距离返航点太远，返航切换为自动降落",
      "fr": ""
    },
    "0x2002060D" : {
      "en": "Landing",
      "zh": "开始自动降落",
      "fr": ""
    },
    "0x2002060E" : {
      "en": "Force Landing request from APP.",
      "zh": "App请求强制降落",
      "fr": ""
    },
    "0x20020610" : {
      "en": "Obstacle detected. Aircraft is landing",
      "zh": "返航时遇到障碍，正在降落",
      "fr": ""
    },
    "0x20020611" : {
      "en": "IMU error. Aircraft is returning home.",
      "zh": "IMU异常，正在返航",
      "fr": ""
    },
    "0x20020612" : {
      "en": "Aircraft is returning to the Home Point.",
      "zh": "开始智能高度返航",
      "fr": ""
    },
    "0x2002061F" : {
      "en": "Unofficial battery detected. Aircraft is landing.",
      "zh": "检测到非法电池，正在降落",
      "fr": ""
    },
    "0x20020700" : {
      "en": "Flight mode configuration: A/P/S. Current flight mode: %1$s.",
      "zh": "飞行挡位为A/P/S，且当前飞行挡位为%1$s挡",
      "fr": ""
    },
    "0x20020700_rc511" : {
      "en": "Flight mode configuration: A/N/S. Current flight mode: %1$s.",
      "zh": "飞行挡位为A/N/S，且当前飞行挡位为%1$s挡",
      "fr": ""
    },
    "0x20020800" : {
      "en": "Remote controller %1$s requesting aircraft flight control",
      "zh": "%1$s控请求获取飞行器的控制权",
      "fr": ""
    },
    "0x20020900" : {
      "en": "Mission interrupted. Fly aircraft manually",
      "zh": "任务已中断，可控制飞行器手动飞行",
      "fr": ""
    },
    "0x20020A00" : {
      "en": "ATTI mode",
      "zh": "姿态模式",
      "fr": ""
    },
    "0x20020b00" : {
      "en": "Taking off",
      "zh": "起飞",
      "fr": ""
    },
    "0x20020b01" : {
      "en": "Takeoff canceled",
      "zh": "取消起飞",
      "fr": ""
    },
    "0x20020C00" : {
      "en": "FlyTo location synced to current controller",
      "zh": "目标点已同步",
      "fr": ""
    },
    "0x20020C01" : {
      "en": "Severe flight controller error. Control aircraft manually and land promptly",
      "zh": "飞行系统发生严重异常，请立即手动降落!",
      "fr": ""
    },
    "0x20020D00" : {
      "en": "Rising landing gear. Obstacle avoidance unavailable",
      "zh": "起落架正在上升，避障失效",
      "fr": ""
    },
    "0x20020D01" : {
      "en": "Lowering landing gear. Obstacle avoidance unavailable",
      "zh": "起落架正在下降，避障失效",
      "fr": ""
    },
    "0x20020E01" : {
      "en": "Home Point update stopped. Remote controller disconnected. Pay attention to current Home Point location",
      "zh": "遥控器已断联，暂停刷新返航点，请留意返航位置",
      "fr": ""
    },
    "0x20020E02" : {
      "en": "Remote controller connected again. Updating Home Point...",
      "zh": "遥控器已连接，继续刷新返航点",
      "fr": ""
    },
    "0x20021000" : {
      "en": "Control sticks not centered. Unable to take off. Ensure control sticks are centered",
      "zh": "无法起飞：请确认摇杆在中位",
      "fr": ""
    },
    "0x20021001" : {
      "en": "RTH canceled",
      "zh": "取消返航",
      "fr": ""
    },
    "0x20021002" : {
      "en": "Landing canceled",
      "zh": "取消降落",
      "fr": ""
    },
    "0x20022001" : {
      "en": "QuickSpin started",
      "zh": "开始快速自旋",
      "fr": ""
    },
    "0x20022002" : {
      "en": "No GNSS signal. Flight area unknown. Flight altitude limited to %1$s",
      "zh": "无卫星定位信号，飞行区域未知，限高%1$s",
      "fr": ""
    },
    "0x20022003" : {
      "en": "No GNSS signal. Flight area unknown, and ambient light too low. Flight altitude limited to %1$s",
      "zh": "无卫星定位信号，飞行区域未知，环境光过暗，限高%1$s",
      "fr": ""
    },
    "0x20030000" : {
      "en": "Manned aircraft detected nearby. Fly with caution",
      "zh": "附近有载人飞行器，请谨慎飞行！",
      "fr": ""
    },
    "0x20040000" : {
      "en": "Flight speed too fast. Interval shooting may fail",
      "zh": "飞行速度过快，可能造成等距拍照失败",
      "fr": ""
    },
    "0x20040100" : {
      "en": "Manual exposure is enabled. Metering is disabled.",
      "zh": "当前曝光模式处于M档，无法测光",
      "fr": ""
    },
    "0x20040200" : {
      "en": "Object too close to laser rangefinder",
      "zh": "激光测距过近",
      "fr": ""
    },
    "0x20040201" : {
      "en": "Object too far for laser rangefinder",
      "zh": "激光测距过远",
      "fr": ""
    },
    "0x20040300" : {
      "en": "Capturing one-tap pano with visible light camera",
      "zh": "当前飞行器正在使用可见光相机进行一键全景拍摄",
      "fr": ""
    },
    "0x20040400" : {
      "en": "Zenmuse XT S not compatible with other infrared cameras",
      "zh": "Zenmuse XT S不兼容其它红外相机",
      "fr": ""
    },
    "0x20040500" : {
      "en": "Camera %component_index overheated. Shooting photos/videos may fail",
      "zh": "%component_index号云台相机过热，可能会无法拍照/录像",
      "fr": ""
    },
    "0x20040501" : {
      "en": "Camera %component_index overheated. Wait for temperature to return to normal before use",
      "zh": "%component_index号云台相机过热，请等待降温后再使用",
      "fr": ""
    },
    "0x20040600" : {
      "en": "SD card speed is slow, cannot record 4K video.",
      "zh": "SDCard速度慢，无法录制4K视频",
      "fr": ""
    },
    "0x20040700" : {
      "en": "Live stream video frame rate less than 9Hz. Fly with caution.",
      "zh": "当前画面流畅度过低，请注意飞行安全",
      "fr": ""
    },
    "0x20040800" : {
      "en": "Aircraft RTH or landing. Unable to enter Pano mode",
      "zh": "飞行器处于返航或降落状态下，无法进入全景拍照模式",
      "fr": ""
    },
    "0x20040801" : {
      "en": "Panorama taken successfully. View in Playback",
      "zh": "全景拍摄成功，可在回放中查看",
      "fr": ""
    },
    "0x20040802" : {
      "en": "Taking panorama failed",
      "zh": "全景拍摄失败",
      "fr": ""
    },
    "0x20040803" : {
      "en": "Panorama stopped",
      "zh": "全景拍摄终止",
      "fr": ""
    },
    "0x20040804" : {
      "en": "Aircraft not in flight. Unable to take panorama",
      "zh": "飞机未起飞，无法开始全景拍摄",
      "fr": ""
    },
    "0x20040805" : {
      "en": "Getting control failed. Panorama stopped",
      "zh": "控制权获取失败，全景拍摄终止",
      "fr": ""
    },
    "0x20040806" : {
      "en": "Unknown camera error. Unable to start panorama",
      "zh": "未知相机错误，无法开始全景拍摄",
      "fr": ""
    },
    "0x20040807" : {
      "en": "Camera response timed out. Panorama stopped",
      "zh": "相机超时，全景拍摄终止",
      "fr": ""
    },
    "0x20040808" : {
      "en": "Insufficient storage. Panorama stopped",
      "zh": "存储空间不足，全景拍摄终止",
      "fr": ""
    },
    "0x20040809" : {
      "en": "Aircraft moving. Unable to take panorama",
      "zh": "飞行器运动中，无法开始全景拍摄",
      "fr": ""
    },
    "0x2004080A" : {
      "en": "Gimbal moving. Unable to take panorama",
      "zh": "云台运动中，无法开始全景拍摄",
      "fr": ""
    },
    "0x2004080B" : {
      "en": "Control stick moved. Panorama stopped",
      "zh": "用户操作摇杆，全景拍摄终止",
      "fr": ""
    },
    "0x2004080C" : {
      "en": "Max altitude limit reached. Panorama stopped",
      "zh": "触碰到限飞高度，全景拍摄终止",
      "fr": ""
    },
    "0x2004080D" : {
      "en": "Max distance reached. Panorama stopped",
      "zh": "触发距离限制，全景拍摄终止",
      "fr": ""
    },
    "0x2004080E" : {
      "en": "Gimbal stuck. Panorama stopped",
      "zh": "云台受阻，全景拍摄终止",
      "fr": ""
    },
    "0x2004080F" : {
      "en": "Taking photo failed. Panorama stopped",
      "zh": "拍照失败，全景拍摄终止",
      "fr": ""
    },
    "0x20040810" : {
      "en": "Stitching panorama failed",
      "zh": "全景图片拼接失败",
      "fr": ""
    },
    "0x20040811" : {
      "en": "Loading calibration parameters failed. Panorama stopped",
      "zh": "加载标定参数失败，全景拍摄终止",
      "fr": ""
    },
    "0x20040812" : {
      "en": "Adjusting camera parameters failed. Panorama stopped",
      "zh": "调整相机参数失败，全景拍摄终止",
      "fr": ""
    },
    "0x20040813" : {
      "en": "Stitching panorama...",
      "zh": "全景图正在拼接合成，请耐心等待",
      "fr": ""
    },
    "0x20040900" : {
      "en": "Playback for Primary remote controller in progress. Disconnected from Liveview for Secondary remote controller",
      "zh": "主控已进入回放，辅控将断开图传",
      "fr": ""
    },
    "0x20040A00" : {
      "en": "Camera busy, cannot enter playback.",
      "zh": "相机正忙，无法进入回放",
      "fr": ""
    },
    "0x20040A01" : {
      "en": "No memory card",
      "zh": "无存储卡",
      "fr": ""
    },
    "0x20040B00" : {
      "en": "Install LiDAR on Gimbal I for optimal use",
      "zh": "为保证激光雷达负载使用效果，建议在I号云台安装",
      "fr": ""
    },
    "0x20040C00" : {
      "en": "Using Controller B. Unable to support LiDAR. Switch to Controller A",
      "zh": "当前控为B控，不支持激光雷达负载，请切换为A控",
      "fr": ""
    },
    "0x20040D00" : {
      "en": "Calibration failed. Check and try again",
      "zh": "标定失败，请尝试重新标定。",
      "fr": ""
    },
    "0x20040D01" : {
      "en": "Calibration failed. Contact DJI Support",
      "zh": "标定失败，请联系大疆售后服务。",
      "fr": ""
    },
    "0x20040E00" : {
      "en": "%1$s camera lens not calibrated. Focusing will be affected. Go to Settings > Calibrate Lens to calibrate.",
      "zh": "%s相机镜头未标定，会影响对焦效果，您可以通过相机设置中的『标定镜头』功能进行标定。",
      "fr": ""
    },
    "0x20040F00" : {
      "en": "Collecting point cloud data. Real-time data transfer unstable",
      "zh": "实时点云传输不稳定，点云数据正常采集中",
      "fr": ""
    },
    "0x20041000" : {
      "en": "Payload IMU warmed up",
      "zh": "负载惯导预热已完成",
      "fr": ""
    },
    "0x20041100" : {
      "en": "Point cloud model recording in progress. Unable to record video",
      "zh": "点云模型录制中，无法开始录像",
      "fr": ""
    },
    "0x20041200" : {
      "en": "Calibration Flight complete. Proceed ahead",
      "zh": "已完成标定飞行，请继续操作",
      "fr": ""
    },
    "0x20041300" : {
      "en": "Calibration Flight stopped manually. Check and try again",
      "zh": "标定飞行已被手动打断，请重新操作",
      "fr": ""
    },
    "0x20041400" : {
      "en": "Communication error between aircraft and payload",
      "zh": "负载与飞行器连接通信异常",
      "fr": ""
    },
    "0x20041500" : {
      "en": "IR Zoom Max",
      "zh": "红外变焦已达最大倍数",
      "fr": ""
    },
    "0x20041600" : {
      "en": "Switched successfully. A wider temperature measurement range available",
      "zh": "切换成功，该模式提供更大的测温区间",
      "fr": ""
    },
    "0x20041601" : {
      "en": "Switched successfully. A more precise temperature measurement available",
      "zh": "切换成功，该模式提供更精准的测温能力",
      "fr": ""
    },
    "0x20041602" : {
      "en": "Switched successfully. High-Res mode provides clearer infrared image. Temperature measurement not supported",
      "zh": "切换成功，红外超清模式提供更清晰的红外画面，不支持测温",
      "fr": ""
    },
    "0x20041700" : {
      "en": "Light sensor blocked. Multispectral data collection affected",
      "zh": "光照传感器被遮挡，影响多光谱数据采集",
      "fr": ""
    },
    "0x20041801" : {
      "en": "Incompatible camera parameters. Restart app and go to home screen to update",
      "zh": "摄像头参数不匹配，请重启APP进入首页更新参数",
      "fr": ""
    },
    "0x20050100" : {
      "en": "Nearby GEO Zone has temporary restrictions preparing to take effect in 1 hour",
      "zh": "附近有1小时后生效的临时限飞区",
      "fr": ""
    },
    "0x20050200" : {
      "en": "Nearby GEO Zone has temporary restrictions preparing to take effect (%1$d)",
      "zh": "附近有即将生效的临时限飞区（%1$d）",
      "fr": ""
    },
    "0x20050300" : {
      "en": "Aircraft will automatically descend in %1$s",
      "zh": "飞行器将在%1$s秒后自动下降",
      "fr": ""
    },
    "0x20050400" : {
      "en": "Aircraft leaving unlocked GEO zone. Fly with caution",
      "zh": "飞行器已触碰到解禁证书的区域边界，请注意飞行安全。",
      "fr": ""
    },
    "0x20050401" : {
      "en": "Aircraft at the boundary of a GEO Zone. RTH may be stopped. Fly away promptly",
      "zh": "飞行器已触碰到限飞区，返航可能中止。请尽快操控飞行器远离。",
      "fr": ""
    },
    "0x20050402" : {
      "en": "Aircraft at boundary of an Altitude Zone (%1$s ). Fly away or descend as soon as possible",
      "zh": "飞行器已触碰到限高区（限高 %1$s），当前飞行高度高于限飞高度，请操控飞行器远离或下降",
      "fr": ""
    },
    "0x20050403" : {
      "en": "Aircraft entered Altitude Zone (%1$s). Fly with caution",
      "zh": "飞行器进入限高区（限高 %1$s），请注意飞行安全",
      "fr": ""
    },
    "0x20050404" : {
      "en": "Aircraft at the boundary of a Restricted Zone. Fly away promptly",
      "zh": "飞行器已触碰到禁飞区，请尽快操控飞行器远离",
      "fr": ""
    },
    "0x20050405" : {
      "en": "GEO: You are in a Warning Zone (%1$s). Fly with caution.",
      "zh": "飞行器处于警告区(%1$s)内，请注意飞行安全。",
      "fr": ""
    },
    "0x20050406" : {
      "en": "Your aircraft is flying in an Altitude Zone (%1$s). Please fly with caution.",
      "zh": "飞行器在限高区（%1$s）下方，请注意飞行安全。",
      "fr": ""
    },
    "0x20050407" : {
      "en": "Aircraft in GEO Zone. Max flight altitude: %1$s",
      "zh": "当前在限飞区，限高%1$s。",
      "fr": ""
    },
    "0x20050408" : {
      "en": "Aircraft flying in an Altitude Zone (%s). Fly with caution",
      "zh": "飞行器在限高区（%s）下方，请注意飞行安全",
      "fr": ""
    },
    "0x20050500" : {
      "en": "Reaching maximum altitude...",
      "zh": "即将达到限飞高度",
      "fr": ""
    },
    "0x20050600" : {
      "en": "Multiple Enhanced Warning Zones near aircraft. Fly with caution",
      "zh": "飞行器附近区域有多个加强警示区，请注意飞行安全",
      "fr": ""
    },
    "0x20050601" : {
      "en": "Multiple Enhanced Warning Zones below aircraft. Fly with caution",
      "zh": "飞行器下方区域有多个加强警示区，请注意飞行安全",
      "fr": ""
    },
    "0x20050602" : {
      "en": "Multiple Enhanced Warning Zones above aircraft. Fly with caution",
      "zh": "飞行器上方区域有多个加强警示区，请注意飞行安全",
      "fr": ""
    },
    "0x20050603" : {
      "en": "Enhanced Warning Zone nearby (%s. Altitude range: %s m. Effective time: %s). Fly with caution",
      "zh": "飞行器附近有加强警示区（%s，高度区间：%s，生效时段：%s），请注意飞行安全",
      "fr": ""
    },
    "0x20050604" : {
      "en": "Enhanced Warning Zone below (%s. Altitude range: %s m. Effective time: %s). Fly with caution",
      "zh": "飞行器下方区域有加强警示区（%s，高度区间：%s，生效时段：%s），请注意飞行安全",
      "fr": ""
    },
    "0x20050605" : {
      "en": "Enhanced Warning Zone above (%s. Altitude range: %s m. Effective time: %s). Fly with caution",
      "zh": "飞行器上方区域有加强警示区（%s，高度区间：%s，生效时段：%s），请注意飞行安全",
      "fr": ""
    },
    "0x20050606" : {
      "en": "Aircraft in Enhanced Warning Zone (%s. Altitude range: %s. Effective time: %s). Fly with caution",
      "zh": "飞行器在加强警示区（%s，区间：%s，生效时段：%s）内，请注意飞行安全",
      "fr": ""
    },
    "0x20050607" : {
      "en": "Multiple Enhanced Warning Zones nearby. Fly with caution",
      "zh": "附近有多个加强警示区，请注意飞行安全",
      "fr": ""
    },
    "0x20050608" : {
      "en": "GNSS signal weak. Geo-awareness function degraded. Fly with caution",
      "zh": "卫星定位信号差，地理感知功能降级，请谨慎飞行",
      "fr": ""
    },
    "0x20060100" : {
      "en": "GNSS coordinates copied %s",
      "zh": "卫星定位坐标已复制 %s",
      "fr": ""
    },
    "0x20060200" : {
      "en": "RNG info copied. %s",
      "zh": "RNG信息已复制 %s",
      "fr": ""
    },
    "0x20070100" : {
      "en": "Aircraft propulsion system error. Forced landing. Manually control the aircraft and land in an open area",
      "zh": "飞行器动力异常，现已强制降落！请尽快打杆操作飞行器降落至空旷地区",
      "fr": ""
    },
    "0x20070101" : {
      "en": "Aircraft propulsion system error. Unable to take off",
      "zh": "飞行器动力异常，无法起飞!",
      "fr": ""
    },
    "0x20080100" : {
      "en": "Switched to OcuSync image transmission",
      "zh": "已切换为Ocusync图传",
      "fr": ""
    },
    "0x20080101" : {
      "en": "Switched to LTE Dual Link",
      "zh": "图传链路已切换至LTE增强链路",
      "fr": ""
    },
    "0x20080200" : {
      "en": "In dual control mode or current RC set as controller B. LTE Dual Link unavailable",
      "zh": "双控模式或当前控为B控，无法使用LTE增强链路",
      "fr": ""
    },
    "0x20080300" : {
      "en": "LTE network unstable. Fly with caution",
      "zh": "当前LTE网络质量差， 请谨慎飞行！",
      "fr": ""
    },
    "0x20080400" : {
      "en": "Image transmission signal weak. Adjust antennas and fly with caution",
      "zh": "图传信号微弱，请调整天线并谨慎打杆",
      "fr": ""
    },
    "0x20080500" : {
      "en": "Remote Controller Signal Weak",
      "zh": "遥控器信号微弱，请调整天线",
      "fr": ""
    },
    "0x20080600" : {
      "en": "Strong remote controller signal interference. Move away from other remote controllers or the source of interference",
      "zh": "遥控器侧干扰较强，请远离其他遥控器或干扰源",
      "fr": ""
    },
    "0x20080700" : {
      "en": "Strong aircraft signal interference. Return to home promptly or move away from the source of interference",
      "zh": "飞行器侧干扰较强，请尽快返航或飞离干扰源",
      "fr": ""
    },
    "0x20090000" : {
      "en": "Vision stabilization paused.",
      "zh": "视觉增稳功能已暂停",
      "fr": ""
    },
    "0x20090001" : {
      "en": "Vision stabilization resumed.",
      "zh": "视觉增稳功能已恢复",
      "fr": ""
    },
    "0x20090002" : {
      "en": "Vision stabilization paused.Reason: Features too few in current video.",
      "zh": "视觉增稳功能已暂停，原因：画面特征点过少",
      "fr": ""
    },
    "0x20090003" : {
      "en": "Vision stabilization resumed.Reason: Features too few in current video.",
      "zh": "视觉增稳功能已暂停，原因：相机参数已变更",
      "fr": ""
    },
    "0x20090004" : {
      "en": "Vision stabilization paused.Reason: Features too few in current video.Reason: Features too few in current video.",
      "zh": "视觉增稳功能已暂停，原因：当前处于跟踪模式",
      "fr": ""
    },
    "0x20090100" : {
      "en": "Pin Point Success",
      "zh": "打点成功",
      "fr": ""
    },
    "0x20090101" : {
      "en": "Unable to get laser rangefinder data. Recording location failed",
      "zh": "未获取到激光测距数据，打点失败",
      "fr": ""
    },
    "0x20090102" : {
      "en": "Insufficient satellites available. Recording location failed",
      "zh": "位置信息无效，打点失败",
      "fr": ""
    },
    "0x20090103" : {
      "en": "Aircraft location pinned successfully",
      "zh": "原地打点成功",
      "fr": ""
    },
    "0x20090200" : {
      "en": "Starting Smart Track",
      "zh": "开始智能跟踪",
      "fr": ""
    },
    "0x20090201" : {
      "en": "Smart Track Turn Off",
      "zh": "智能跟踪关闭",
      "fr": ""
    },
    "0x20090202" : {
      "en": "Unable to identify target. Drag-select target on screen",
      "zh": "未识别到目标，请在屏幕上手动框选",
      "fr": ""
    },
    "0x20100000" : {
      "en": "D-RTK Low Battery",
      "zh": "D-RTK低电量警报",
      "fr": ""
    },
    "0x20100100" : {
      "en": "RTK status error. Entering Maintain Positioning Accuracy mode. Aircraft will exit RTK if reconnection timed out",
      "zh": "RTK状态异常，将进入精度维持模式，超时将自动退出RTK",
      "fr": ""
    },
    "0x20100200" : {
      "en": "RTK base station not found. Check base station and search again",
      "zh": "未搜索到RTK基站，请检查RTK基站后重新搜索",
      "fr": ""
    },
    "0x2010D000" : {
      "en": "D-RTK  Low Battery",
      "zh": "D-RTK 低电量警报",
      "fr": ""
    },
    "0x20110000" : {
      "en": "Battery heating",
      "zh": "电池加热中",
      "fr": ""
    },
    "0x20120000" : {
      "en": "Failed to access GNSS positioning information of mobile device",
      "zh": "获取移动设备卫星定位失败",
      "fr": ""
    },
    "0x20120001" : {
      "en": "Failed to access GNSS positioning information of DJI device",
      "zh": "获取DJI设备卫星定位失败",
      "fr": ""
    },
    "0x20120200" : {
      "en": "Land aircraft before continuing to next step",
      "zh": "请先将飞机降落至地面，再进行下一步操作",
      "fr": ""
    },
    "0x20120300" : {
      "en": "Aircraft flying to editing start point",
      "zh": "飞行器自动飞至起始点，请耐心等待",
      "fr": ""
    },
    "0x20120301" : {
      "en": "Arrived at editing start point. Begin editing",
      "zh": "飞行器已到达起始点，请开始操作",
      "fr": ""
    },
    "0x20120302" : {
      "en": "Exit Flight Route Editing",
      "zh": "退出飞行编辑",
      "fr": ""
    },
    "0x20120400" : {
      "en": "Phone not bound. Altitude and distance limited. Bind phone before taking off.",
      "zh": "未绑定手机，已限高限远。请完成绑定手机再起飞。",
      "fr": ""
    },
    "0x20120500" : {
      "en": "Media files will be uploaded through current remote controller",
      "zh": "媒体资源将从当前控上传云端",
      "fr": ""
    },
    "0x20120501" : {
      "en": "Media files will be uploaded through another remote controller",
      "zh": "媒体资源将从另一个控上传云端",
      "fr": ""
    },
    "0x20120502" : {
      "en": "Aircraft cloud control enabled",
      "zh": "飞行器已接受云端命令控制",
      "fr": ""
    },
    "0x20120503" : {
      "en": "Aircraft bound to other team. Cloud service unavailable",
      "zh": "飞行器跨团队，云服务不可用",
      "fr": ""
    },
    "0x20120600" : {
      "en": "Removed from project. Unable to view project details",
      "zh": "您已被当前项目移除，将无法查看该项目内容",
      "fr": ""
    },
    "0x20120700" : {
      "en": "Project archived. Unable to view project details",
      "zh": "您所在项目已归档，将无法查看该项目内容",
      "fr": ""
    },
    "0x20120800" : {
      "en": "Project team disbanded. Unable to view project details",
      "zh": "您所在项目已解散，将无法查看该项目内容",
      "fr": ""
    },
    "0x20120900" : {
      "en": "Real-time mapping stopped",
      "zh": "实时建图停止",
      "fr": ""
    },
    "0x20120A00" : {
      "en": "Livestream started",
      "zh": "已开启直播",
      "fr": ""
    },
    "0x20120B00" : {
      "en": "Flight route mission paused manually",
      "zh": "您已手动暂停航线任务",
      "fr": ""
    },
    "0x20120B01" : {
      "en": "RTK signal weak. Flight route mission paused",
      "zh": "RTK信号差，航线任务已暂停",
      "fr": ""
    },
    "0x20120B02" : {
      "en": "Max flight altitude reached. Flight route mission paused",
      "zh": "飞行器已达到飞行最大高度，航线任务已暂停",
      "fr": ""
    },
    "0x20120B03" : {
      "en": "Max flight distance reached. Flight route mission paused",
      "zh": "飞行器已达到飞行最远距离，航线任务已暂停",
      "fr": ""
    },
    "0x20120B04" : {
      "en": "Task paused. Obstacle detected",
      "zh": "航线任务暂停，飞行器检测到障碍物",
      "fr": ""
    },
    "0x20120B05" : {
      "en": "Approaching GEO Zone. Task paused",
      "zh": "飞行器接近限飞区，航线任务已暂停",
      "fr": ""
    },
    "0x20120B06" : {
      "en": "Min flight altitude reached. Task paused",
      "zh": "飞行器已达到飞行最低高度，航线任务已暂停",
      "fr": ""
    },
    "0x20120B07" : {
      "en": "Unknown error. Task paused",
      "zh": "未知原因，航线任务已暂停",
      "fr": ""
    },
    "0x20120B08" : {
      "en": "Max flight altitude of airport Altitude Zone reached",
      "zh": "超过机场限高区限高",
      "fr": ""
    },
    "0x20120B09" : {
      "en": "Emergency brake triggered. Flight task paused",
      "zh": "触发紧急刹停，航线任务已暂停",
      "fr": ""
    },
    "0x20120B0A" : {
      "en": "Ambient light is too bright or too dark",
      "zh": "环境光过亮或过暗",
      "fr": ""
    },
    "0x20120B0B" : {
      "en": "GNSS signal weak. Task paused",
      "zh": "卫星定位信号差，航线任务已暂停",
      "fr": ""
    },
    "0x20120B0C" : {
      "en": "Home Point not updated. Flight task paused",
      "zh": "返航点未刷新，航线任务已暂停",
      "fr": ""
    },
    "0x20120B0D" : {
      "en": "Remote controller disconnected. Smart RTH in progress",
      "zh": "遥控器断连，正在执行智能返航",
      "fr": ""
    },
    "0x20120B0E" : {
      "en": "Auto takeoff failed. Try uploading flight route again",
      "zh": "自动起飞失败，请尝试重新上传航线",
      "fr": ""
    },
    "0x20120B0F" : {
      "en": "Approaching boundary of custom flight area. Flight task paused",
      "zh": "接近自定义飞行区，航线任务已暂停",
      "fr": ""
    },
    "0x20120B10" : {
      "en": "Terrain Follow altitude error (greater than 200 m or less than 30 m). Modify parameter",
      "zh": "仿地高度异常（大于200m或小于30m），请修改参数",
      "fr": ""
    },
    "0x20120B11" : {
      "en": "Wind speed too high. Flight task paused",
      "zh": "风速过大，航线任务已暂停",
      "fr": ""
    },
    "0x20120B12" : {
      "en": "Aircraft at the boundary of an Altitude Zone or aircraft altitude too low. Flight task paused",
      "zh": "触碰到限高区或飞行器高度过低，航线任务已中断",
      "fr": ""
    },
    "0x20120B13" : {
      "en": "PSDK on blocklist. Remove device before takeoff",
      "zh": "该PSDK负载处于黑名单中，请移除后起飞",
      "fr": ""
    },
    "0x20120BA0" : {
      "en": "Aircraft verification in progress...",
      "zh": "飞行器校验中",
      "fr": ""
    },
    "0x20120C00" : {
      "en": "Disable Vision Positioning",
      "zh": "禁用视觉定位",
      "fr": ""
    },
    "0x20120C01" : {
      "en": "Enable Vision Positioning",
      "zh": "启用视觉定位",
      "fr": ""
    },
    "0x20120C02" : {
      "en": "Cloud control from DJI DeliveryHub enabled",
      "zh": "已允许大疆司运指令",
      "fr": ""
    },
    "0x20120C03" : {
      "en": "Pausing flight through cloud control",
      "zh": "执行云端急停指令",
      "fr": ""
    },
    "0x20120C04" : {
      "en": "Aircraft landing through cloud control",
      "zh": "执行云端降落指令",
      "fr": ""
    },
    "0x20120C05" : {
      "en": "Aircraft returning to home through cloud control",
      "zh": "执行云端返航指令",
      "fr": ""
    },
    "0x20120C06" : {
      "en": "Operating winch system through cloud control",
      "zh": "执行云端空吊指令",
      "fr": ""
    },
    "0x20120C07" : {
      "en": "Operating FPV gimbal camera through cloud control",
      "zh": "执行云端FPV指令",
      "fr": ""
    },
    "0x20120C08" : {
      "en": "Performing flight task through cloud control",
      "zh": "执行云端航线指令",
      "fr": ""
    },
    "0x20120C09" : {
      "en": "Cloud control from DJI DeliveryHub disabled",
      "zh": "已撤销云端指令许可",
      "fr": ""
    },
    "0x20120C0A" : {
      "en": "RTH canceled by cloud control",
      "zh": "云端已取消返航",
      "fr": ""
    },
    "0x20120C0B" : {
      "en": "Aircraft locked",
      "zh": "飞行器已锁定",
      "fr": ""
    },
    "0x20120C0C" : {
      "en": "Aircraft unlocked",
      "zh": "飞行器已解锁",
      "fr": ""
    },
    "0x20120D01" : {
      "en": "Obstacle sensing of all directions disabled. Fly with caution",
      "zh": "全部避障已关闭，请安全飞行",
      "fr": ""
    },
    "0x20120D02" : {
      "en": "Horizontal obstacle sensing disabled. Fly with caution",
      "zh": "水平避障已关闭，请安全飞行",
      "fr": ""
    },
    "0x20120D03" : {
      "en": "Upward obstacle sensing disabled. Fly with caution",
      "zh": "上避障已关闭，请安全飞行",
      "fr": ""
    },
    "0x20120D04" : {
      "en": "Downward obstacle sensing disabled. Fly with caution",
      "zh": "下避障已关闭，请安全飞行",
      "fr": ""
    },
    "0x20120D05" : {
      "en": "Obstacle sensing of all directions enabled",
      "zh": "全部避障已开启",
      "fr": ""
    },
    "0x20120D06" : {
      "en": "Horizontal obstacle sensing enabled",
      "zh": "水平避障已开启",
      "fr": ""
    },
    "0x20120D07" : {
      "en": "Upward obstacle sensing enabled",
      "zh": "上避障已开启",
      "fr": ""
    },
    "0x20120D08" : {
      "en": "Downward obstacle sensing enabled",
      "zh": "下避障已开启",
      "fr": ""
    },
    "0x20120E00" : {
      "en": "High ionospheric activity in current area. Positioning accuracy may be affected",
      "zh": "当前地区电离层开始活跃，可能影响定位精度",
      "fr": ""
    },
    "0x20120E01" : {
      "en": "Aircraft and remote controller firmware versions do not match. Update firmware to latest version",
      "zh": "飞行器与遥控器固件不匹配，请升级最新固件",
      "fr": ""
    },
    "0x20120F00" : {
      "en": "Account not logged in. Flight altitude and distance restricted to 30 m and 50 m respectively. Login required",
      "zh": "未检测到账号，已限高30m，限远50m，请登录",
      "fr": ""
    },
    312014 : {
      "dje_id": 312014,
      "en": "Updating device firmware. Wait until update completed",
      "zh": "设备升级中，请勿重复操作",
      "fr": ""
    },
    312015 : {
      "dje_id": 312015,
      "en": "Unable to update device firmware. Dock ({dock_org_name}) busy. Try again when dock is idle",
      "zh": "机场：{dock_org_name} 业务繁忙无法进行设备升级，请等待机场处于空闲中后再试",
      "fr": ""
    },
    312016 : {
      "dje_id": 312016,
      "en": "Update failed. Dock and aircraft transmission error. Restart dock and aircraft and try again",
      "zh": "升级失败，机场和飞行器图传链路异常，请重启机场和飞行器后重试",
      "fr": ""
    },
    312022 : {
      "dje_id": 312022,
      "en": "Failed to power on aircraft, or aircraft not connected. Check if aircraft is inside dock, battery installed, and dock and aircraft linked",
      "zh": "飞行器开机失败或未连接，请检查飞行器是否在舱内，是否安装电池，机场和飞行器是否已对频",
      "fr": ""
    },
    312023 : {
      "dje_id": 312023,
      "en": "Failed to push driving rods back into place. Unable to update aircraft firmware. Check if emergency stop button is pressed down or driving rods are stuck",
      "zh": "推杆闭合失败无法升级飞行器，请检查急停按钮是否被按下，推杆是否有异物卡住",
      "fr": ""
    },
    312027 : {
      "dje_id": 312027,
      "en": "Failed to update firmware. Aircraft not detected inside dock",
      "zh": "升级失败，机场未检测到飞行器",
      "fr": ""
    },
    312028 : {
      "dje_id": 312028,
      "en": "Failed to update firmware. Device restarted during update",
      "zh": "升级失败，设备升级过程中设备被重启",
      "fr": ""
    },
    312029 : {
      "dje_id": 312029,
      "en": "Restarting device. Unable to update firmware. Wait until restart completed",
      "zh": "设备重启中无法进行设备升级，请等待设备重启完成后重试",
      "fr": ""
    },
    312030 : {
      "dje_id": 312030,
      "en": "Aircraft enhanced transmission enabled. Failed to update firmware. Disable enhanced transmission and try again",
      "zh": "升级失败，飞行器增强图传开启后无法升级，请关闭飞行器增强图传后重试",
      "fr": ""
    },
    312704 : {
      "dje_id": 312704,
      "en": "Device battery level too low. Wait until device is charged to above 20% and try again",
      "zh": "设备电量过低，请充电至20%以上后重试",
      "fr": ""
    },
    314000 : {
      "dje_id": 314000,
      "en": "Operation not supported. Check device status",
      "zh": "设备当前无法支持该操作，建议检查设备当前工作状态",
      "fr": ""
    },
    314001 : {
      "dje_id": 314001,
      "en": "Failed to distribute task. Try again later",
      "zh": "飞行任务下发失败，请稍后重试",
      "fr": ""
    },
    314002 : {
      "dje_id": 314002,
      "en": "Failed to distribute task. Try again later",
      "zh": "飞行任务下发失败，请稍后重试",
      "fr": ""
    },
    314003 : {
      "dje_id": 314003,
      "en": "Flight route file format not supported. Check file",
      "zh": "航线文件格式不兼容，请检查航线文件是否正确",
      "fr": ""
    },
    314005 : {
      "dje_id": 314005,
      "en": "Failed to distribute task. Try again later or restart dock and try again",
      "zh": "飞行任务下发失败，请稍后重试或重启机场后重试",
      "fr": ""
    },
    314006 : {
      "dje_id": 314006,
      "en": "Failed to initiate aircraft. Restart dock and try again",
      "zh": "飞行器初始化失败，请重启机场后重试",
      "fr": ""
    },
    314007 : {
      "dje_id": 314007,
      "en": "Failed to distribute flight route file from dock to aircraft. Restart dock and try again",
      "zh": "机场传输航线至飞行器失败，请重启机场后重试",
      "fr": ""
    },
    314008 : {
      "dje_id": 314008,
      "en": "Aircraft task preparation timed out. Restart dock and try again",
      "zh": "飞行器起飞前准备超时，请重启机场后重试",
      "fr": ""
    },
    314009 : {
      "dje_id": 314009,
      "en": "Failed to initiate aircraft. Restart dock and try again",
      "zh": "飞行器初始化失败，请重启机场后重试",
      "fr": ""
    },
    314010 : {
      "dje_id": 314010,
      "en": "Unable to perform task. Restart dock and try again",
      "zh": "航线执行失败，请重启机场后重试",
      "fr": ""
    },
    314011 : {
      "dje_id": 314011,
      "en": "Dock system error. Unable to obtain task result",
      "zh": "机场系统异常，无法获取飞行任务执行结果",
      "fr": ""
    },
    314012 : {
      "dje_id": 314012,
      "en": "Aircraft task preparation failed. Unable to perform task. Restart dock and try again",
      "zh": "飞行器起飞前准备失败，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    314013 : {
      "dje_id": 314013,
      "en": "Failed to distribute task. Dock unable to obtain flight route file and perform task. Try again later",
      "zh": "飞行任务下发失败，机场无法获取到本次飞行任务的航线，无法执行飞行任务，请稍后重试",
      "fr": ""
    },
    314014 : {
      "dje_id": 314014,
      "en": "Dock system error. Failed to perform task. Try again later",
      "zh": "机场系统异常，飞行任务执行失败，请稍后重试",
      "fr": ""
    },
    314015 : {
      "dje_id": 314015,
      "en": "Failed to distribute AI-Spot Check flight route from dock to aircraft. Unable to perform task. Try again later or restart dock and try again",
      "zh": "机场传输精准复拍航线至飞行器失败，无法执行飞行任务，请稍后重试或重启机场后重试",
      "fr": ""
    },
    314016 : {
      "dje_id": 314016,
      "en": "Failed to process flight route file. Unable to perform task. Check file",
      "zh": "航线文件解析失败，无法执行飞行任务，请检查航线文件",
      "fr": ""
    },
    314017 : {
      "dje_id": 314017,
      "en": "Dock system error. Failed to perform task. Try again later",
      "zh": "机场系统异常，飞行任务执行失败，请稍后重试",
      "fr": ""
    },
    314018 : {
      "dje_id": 314018,
      "en": "Aircraft RTK positioning error. Unable to perform task. Try again later or restart dock and try again",
      "zh": "飞行器 RTK 定位异常，无法执行飞行任务，请稍后重试或重启机场后重试",
      "fr": ""
    },
    314019 : {
      "dje_id": 314019,
      "en": "Failed to converge aircraft RTK data. Unable to perform task. Try again later or restart dock and try again",
      "zh": "飞行器 RTK 收敛失败，无法执行飞行任务，请稍后重试或重启机场后重试",
      "fr": ""
    },
    314020 : {
      "dje_id": 314020,
      "en": "Aircraft not in the middle of landing pad or aircraft heading incorrect. Unable to perform task. Check aircraft position and heading",
      "zh": "飞行器不在停机坪正中间或飞行器朝向不正确，无法执行飞行任务，请检查飞行器位置和朝向",
      "fr": ""
    },
    314021 : {
      "dje_id": 314021,
      "en": "Aircraft RTK positioning error. Unable to perform task. Try again later or restart dock and try again",
      "zh": "飞行器 RTK 定位异常，无法执行飞行任务，请稍后重试或重启机场后重试",
      "fr": ""
    },
    314024 : {
      "dje_id": 314024,
      "en": "Failed to distribute entry/exit route. Try again later or restart dock and try again",
      "zh": "进离场航线下发失败，请稍后重试或重启机场后重试",
      "fr": ""
    },
    314025 : {
      "dje_id": 314025,
      "en": "RTK convergence timed out. Cancel task manually",
      "zh": "RTK收敛超时，用户手动取消任务",
      "fr": ""
    },
    314200 : {
      "dje_id": 314200,
      "en": "Task failed. Dock network disconnected. Aircraft automatically returned to home. Make sure network is connected and try again",
      "zh": "任务失败，由于机场网络断开，飞行器已自动返航，请确保机场已连接网络后再试",
      "fr": ""
    },
    315000 : {
      "dje_id": 315000,
      "en": "Dock communication error. Restart dock and try again",
      "zh": "机场通信异常，请重启机场后重试",
      "fr": ""
    },
    315001 : {
      "dje_id": 315001,
      "en": "Dock communication error. Power on aircraft remotely and wait for 1 min before distributing task again",
      "zh": "机场通信异常，请远程开启飞机并等待 1min 后，再次下发任务重试",
      "fr": ""
    },
    315002 : {
      "dje_id": 315002,
      "en": "Dock communication error. Restart dock and try again",
      "zh": "机场通信异常，请重启机场后重试",
      "fr": ""
    },
    315003 : {
      "dje_id": 315003,
      "en": "Dock communication error. Restart dock and try again",
      "zh": "机场通信异常，请重启机场后重试",
      "fr": ""
    },
    315004 : {
      "dje_id": 315004,
      "en": "Task failed. Wait until both docks are in idle status and distribute task again",
      "zh": "任务失败，请等待两个机场都空闲后，再次下发任务重试",
      "fr": ""
    },
    315005 : {
      "dje_id": 315005,
      "en": "Dock communication error. Restart dock and try again",
      "zh": "机场通信异常，请重启机场后重试",
      "fr": ""
    },
    315006 : {
      "dje_id": 315006,
      "en": "Dock communication error. Restart dock and try again",
      "zh": "机场通信异常，请重启机场后重试",
      "fr": ""
    },
    315007 : {
      "dje_id": 315007,
      "en": "Dock communication error. Update dock firmware to latest version or restart dock and try again",
      "zh": "机场通信异常，请将机场升级到最新版本或重启机场后重试",
      "fr": ""
    },
    315008 : {
      "dje_id": 315008,
      "en": "RTK calibration method inconsistent between docks for takeoff and landing. Make sure the same calibration method is used and connection is stable",
      "zh": "降落机场和起飞机场标定信息不一致，请确认两个机场均链路通畅且使用了相同的网络信息标定",
      "fr": ""
    },
    315009 : {
      "dje_id": 315009,
      "en": "Dock communication error. Restart dock and try again",
      "zh": "机场通信异常，请重启机场后重试",
      "fr": ""
    },
    315010 : {
      "dje_id": 315010,
      "en": "Unable to stop task. Try again later. Contact DJI Support if issue persists",
      "zh": "无法停止飞行任务，请稍后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315011 : {
      "dje_id": 315011,
      "en": "Unable to stop task. Try again later. Contact DJI Support if issue persists",
      "zh": "无法停止飞行任务，请稍后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315012 : {
      "dje_id": 315012,
      "en": "Unable to stop task. Try again later. Contact DJI Support if issue persists",
      "zh": "无法停止飞行任务，请稍后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315013 : {
      "dje_id": 315013,
      "en": "Failed to distribute task. Try again later. Contact DJI Support if issue persists",
      "zh": "飞行任务下发失败，请稍后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315014 : {
      "dje_id": 315014,
      "en": "Unable to set Home Point for current task type",
      "zh": "当前任务类型不支持设置返航点",
      "fr": ""
    },
    315015 : {
      "dje_id": 315015,
      "en": "Failed to set Home Point. Try again later. Contact DJI Support if issue persists",
      "zh": "返航点设置失败，请稍后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315016 : {
      "dje_id": 315016,
      "en": "Failed to distribute task. Try again later. Contact DJI Support if issue persists",
      "zh": "飞行任务下发失败，请稍后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315017 : {
      "dje_id": 315017,
      "en": "Failed to distribute task. Try again later. Contact DJI Support if issue persists",
      "zh": "飞行任务下发失败，请稍后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315018 : {
      "dje_id": 315018,
      "en": "Task failed. Wait until both docks are in idle status and distribute task again",
      "zh": "任务失败，请等待两个机场都空闲后，再次下发任务重试",
      "fr": ""
    },
    315019 : {
      "dje_id": 315019,
      "en": "Unable to perform multi-dock task due to suboptimal deployment location. Select another dock and try again",
      "zh": "设备部署位置不佳，无法执行蛙跳任务，请选择其它机场再试",
      "fr": ""
    },
    315050 : {
      "dje_id": 315050,
      "en": "Dock system error. Restart dock and try again",
      "zh": "机场系统异常，请重启机场后重试",
      "fr": ""
    },
    315051 : {
      "dje_id": 315051,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315052 : {
      "dje_id": 315052,
      "en": "RTK data not converged. Dock location not calibrated. Wait and try again",
      "zh": "机场位置未收敛，请等待一段时间后重试",
      "fr": ""
    },
    315053 : {
      "dje_id": 315053,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315054 : {
      "dje_id": 315054,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315055 : {
      "dje_id": 315055,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315056 : {
      "dje_id": 315056,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315057 : {
      "dje_id": 315057,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315058 : {
      "dje_id": 315058,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315059 : {
      "dje_id": 315059,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315060 : {
      "dje_id": 315060,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315061 : {
      "dje_id": 315061,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315062 : {
      "dje_id": 315062,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315063 : {
      "dje_id": 315063,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315064 : {
      "dje_id": 315064,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    315065 : {
      "dje_id": 315065,
      "en": "Task failed. Restart dock and distribute task again. Contact DJI Support if issue persists",
      "zh": "任务失败，请重启机场并再次下发任务后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    316001 : {
      "dje_id": 316001,
      "en": "Failed to configure aircraft parameters. Restart dock and try again",
      "zh": "飞行器参数配置失败，请重启机场后重试",
      "fr": ""
    },
    316002 : {
      "dje_id": 316002,
      "en": "Failed to configure aircraft parameters. Restart dock and try again",
      "zh": "飞行器参数配置失败，请重启机场后重试",
      "fr": ""
    },
    316003 : {
      "dje_id": 316003,
      "en": "Failed to configure aircraft parameters. Restart dock and try again",
      "zh": "飞行器参数配置失败，请重启机场后重试",
      "fr": ""
    },
    316004 : {
      "dje_id": 316004,
      "en": "Failed to configure aircraft parameters. Restart dock and try again",
      "zh": "飞行器参数配置失败，请重启机场后重试",
      "fr": ""
    },
    316005 : {
      "dje_id": 316005,
      "en": "Failed to converge aircraft RTK data. Unable to perform task. Restart dock and try again",
      "zh": "飞行器 RTK 收敛失败，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    316006 : {
      "dje_id": 316006,
      "en": "Task timed out. Aircraft lost or unable to land on dock because dock cover closed or driving rods pulled back. Check aircraft status on-site",
      "zh": "任务超时，飞行器已丢失或降落时机场未开启舱盖或展开推杆，飞行器无法降落回机场，请尽快至机场部署现场检查飞行器状况",
      "fr": ""
    },
    316007 : {
      "dje_id": 316007,
      "en": "Failed to initiate aircraft. Restart dock and try again",
      "zh": "飞行器初始化失败，请重启机场后重试",
      "fr": ""
    },
    316008 : {
      "dje_id": 316008,
      "en": "Dock failed to obtain aircraft flight control. Unable to perform task. Make sure flight control not locked by remote controller",
      "zh": "机场获取飞行器控制权失败，无法执行飞行任务，请确认遥控器未锁定控制权",
      "fr": ""
    },
    316009 : {
      "dje_id": 316009,
      "en": "Aircraft battery level lower than 30%. Unable to perform task. It is recommended to charged battery up to 50% before trying again",
      "zh": "飞行器电量低于30%，无法执行飞行任务，请充电后重试（建议电量≥50%）",
      "fr": ""
    },
    316010 : {
      "dje_id": 316010,
      "en": "Aircraft not detected. Unable to perform task. Check if aircraft is inside dock and linked to dock, or restart dock and try again",
      "zh": "机场未检测到飞行器，无法执行飞行任务，请检查舱内是否有飞行器，机场与飞行器是否已对频，或重启机场后重试",
      "fr": ""
    },
    316011 : {
      "dje_id": 316011,
      "en": "Aircraft landed on incorrect location. Check if aircraft should be manually placed on dock deployment site",
      "zh": "飞行器降落位置偏移过大，请检查飞行器是否需要现场摆正",
      "fr": ""
    },
    316012 : {
      "dje_id": 316012,
      "en": "Aircraft task preparation failed. Unable to perform task. Restart dock and try again",
      "zh": "飞行器起飞前准备失败，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    316013 : {
      "dje_id": 316013,
      "en": "Aircraft task preparation failed. Unable to perform task. Restart dock and try again",
      "zh": "飞行器起飞前准备失败，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    316014 : {
      "dje_id": 316014,
      "en": "Aircraft task preparation failed. Unable to perform task. Restart dock and try again",
      "zh": "飞行器起飞前准备失败，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    316015 : {
      "dje_id": 316015,
      "en": "Aircraft location calibrated by RTK device is far from dock. Unable to perform task. Restart dock and try again",
      "zh": "飞行器 RTK 收敛位置距离机场过远，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    316016 : {
      "dje_id": 316016,
      "en": "Aircraft landing on dock timed out. Aircraft and dock may be disconnected. Check livestream view to see if aircraft landed on dock",
      "zh": "飞行器降落至机场超时，可能是机场与飞行器断连导致，请通过直播查看飞行器是否降落至舱内",
      "fr": ""
    },
    316017 : {
      "dje_id": 316017,
      "en": "Obtaining number of aircraft media files timed out. Aircraft and dock may be disconnected. Check livestream view to see if aircraft landed on dock",
      "zh": "获取飞行器媒体数量超时，可能是机场与飞行器断连导致，请通过直播查看飞行器是否降落至舱内",
      "fr": ""
    },
    316018 : {
      "dje_id": 316018,
      "en": "Task performance timed out. Aircraft and dock may be disconnected. Check livestream view to see if aircraft landed on dock",
      "zh": "飞行任务执行超时，可能是机场与飞行器断连导致，请通过直播查看飞行器是否降落至舱内",
      "fr": ""
    },
    316019 : {
      "dje_id": 316019,
      "en": "Dock system error. Unable to perform task. Try again later",
      "zh": "机场系统错误，无法执行飞行任务，请稍后重试",
      "fr": ""
    },
    316020 : {
      "dje_id": 316020,
      "en": "Aircraft RTK signal source error. Try again later",
      "zh": "飞行器使用的 RTK 信号源错误，请稍后重试",
      "fr": ""
    },
    316021 : {
      "dje_id": 316021,
      "en": "Checking aircraft RTK signal source timed out. Try again later",
      "zh": "飞行器 RTK 信号源检查超时，请稍后重试",
      "fr": ""
    },
    316022 : {
      "dje_id": 316022,
      "en": "Aircraft unable to return to home. Check if aircraft is powered on, aircraft and dock are connected, and try again",
      "zh": "飞行器无法执行返航指令，请检查飞行器是否已开机，机场与飞行器是否已断连，请确认无以上问题后重试",
      "fr": ""
    },
    316023 : {
      "dje_id": 316023,
      "en": "Aircraft controlled by Controller B and unable to return to home. Control aircraft from Controller B or power off remote controller and try again",
      "zh": "飞行器无法执行返航指令，飞行器已被 B 控接管，请在 B 控操控飞行器，或关闭 B 控后重试",
      "fr": ""
    },
    316024 : {
      "dje_id": 316024,
      "en": "Aircraft failed to return to home. Check if aircraft has taken off and try again",
      "zh": "飞行器执行返航指令失败，请检查飞行器是否已起飞，确认飞行器已起飞后请重试",
      "fr": ""
    },
    316025 : {
      "dje_id": 316025,
      "en": "Failed to configure aircraft parameters. Try again later or restart dock and try again",
      "zh": "飞行器参数配置失败，请稍后重试或重启机场后重试",
      "fr": ""
    },
    316026 : {
      "dje_id": 316026,
      "en": "Dock emergency stop button pressed down. Unable to perform task. Release button and try again",
      "zh": "机场急停按钮被按下，无法执行飞行任务，请释放急停按钮后重试",
      "fr": ""
    },
    316027 : {
      "dje_id": 316027,
      "en": "Setting aircraft parameters timed out. Try again later or restart dock and try again",
      "zh": "飞行器参数配置超时，请稍后重试或重启机场后重试",
      "fr": ""
    },
    316029 : {
      "dje_id": 316029,
      "en": "Dock emergency stop button pressed down. Aircraft flying to alternate landing site. Make sure aircraft has safely landed and place aircraft inside dock",
      "zh": "机场急停按钮被按下，飞行器将飞往备降点降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场",
      "fr": ""
    },
    316032 : {
      "dje_id": 316032,
      "en": "Obtaining battery data timed out. Try again later or restart aircraft and try again",
      "zh": "获取电池数据超时，请稍后重试或重启飞行器后重试",
      "fr": ""
    },
    316033 : {
      "dje_id": 316033,
      "en": "Battery approaching cycle count limit. Task stopped to ensure flight safety. Changing battery recommended",
      "zh": "飞行器电池循环次数过高，为保证飞行安全，已自动终止任务，建议更换该电池",
      "fr": ""
    },
    316034 : {
      "dje_id": 316034,
      "en": "Unable to take off. Aircraft and dock firmware versions do not match. Update firmware and try again",
      "zh": "无法起飞，飞行器固件版本与机场固件版本不匹配，为保证飞行安全请升级固件后再试",
      "fr": ""
    },
    316035 : {
      "dje_id": 316035,
      "en": "Failed to distribute entry/exit route. Make sure firmware is up to date and distribute task again. Contact DJI support if issue persists",
      "zh": "进离场航线下发失败，请确保设备固件为最新版本后重新下发任务，如果持续报错，请联系大疆售后。",
      "fr": ""
    },
    316050 : {
      "dje_id": 316050,
      "en": "Aircraft landed outside of dock because of low battery level. Make sure aircraft has landed safely and place aircraft inside dock",
      "zh": "飞行器因电量过低在舱外降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场",
      "fr": ""
    },
    316051 : {
      "dje_id": 316051,
      "en": "Task error. Aircraft landed outside of dock. Make sure aircraft has safely landed and place aircraft inside dock",
      "zh": "飞行任务异常，飞行器在舱外降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场",
      "fr": ""
    },
    316052 : {
      "dje_id": 316052,
      "en": "Task error. Aircraft flying to alternate landing site. Make sure aircraft safely lands on-site and place aircraft inside dock",
      "zh": "飞行任务异常，飞行器将飞往备降点降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场",
      "fr": ""
    },
    316053 : {
      "dje_id": 316053,
      "en": "Aircraft has been manually landed by pilot. Make sure aircraft has safely landed and place aircraft inside dock",
      "zh": "用户已操控飞行器降落，请立即检查飞行器是否已安全降落并将飞行器放回至机场",
      "fr": ""
    },
    316100 : {
      "dje_id": 316100,
      "en": "Failed to obtain camera info. Try again",
      "zh": "获取相机概要信息失败，请重试",
      "fr": ""
    },
    316101 : {
      "dje_id": 316101,
      "en": "Failed to switch to Single Shot mode. Try again",
      "zh": "设置相机为单拍模式失败，请重试",
      "fr": ""
    },
    316102 : {
      "dje_id": 316102,
      "en": "Failed to disable watermark. Try again",
      "zh": "关闭相机水印失败，请重试",
      "fr": ""
    },
    316103 : {
      "dje_id": 316103,
      "en": "Failed to switch to average metering mode. Try again",
      "zh": "设置测光模式到平均测光失败，请重试",
      "fr": ""
    },
    316104 : {
      "dje_id": 316104,
      "en": "Failed to switch to wide-angle camera. Try again",
      "zh": "切换镜头到广角镜头失败，请重试",
      "fr": ""
    },
    316105 : {
      "dje_id": 316105,
      "en": "Failed to save photo storage settings. Try again",
      "zh": "设置相机存储照片失败，请重试",
      "fr": ""
    },
    316106 : {
      "dje_id": 316106,
      "en": "Failed to set infrared camera zoom ratio. Try again",
      "zh": "红外变焦倍数设置失败，请重试",
      "fr": ""
    },
    316107 : {
      "dje_id": 316107,
      "en": "Failed to set photo resolution to 4K. Try again",
      "zh": "照片尺寸设置4k失败，请重试",
      "fr": ""
    },
    316108 : {
      "dje_id": 316108,
      "en": "Failed to set photo format as JPEG. Try again",
      "zh": "设置照片存储格式为jpeg格式失败，请重试",
      "fr": ""
    },
    316109 : {
      "dje_id": 316109,
      "en": "Failed to disable dewarp. Try again",
      "zh": "关闭相机畸变矫正失败，请重试",
      "fr": ""
    },
    316110 : {
      "dje_id": 316110,
      "en": "Failed to open mechanical shutter. Try again",
      "zh": "打开相机机械快门失败，请重试",
      "fr": ""
    },
    316111 : {
      "dje_id": 316111,
      "en": "Failed to set focus mode. Try again",
      "zh": "设置对焦模式失败，请重试",
      "fr": ""
    },
    317001 : {
      "dje_id": 317001,
      "en": "Failed to obtain number of aircraft media files. Restart dock and try again",
      "zh": "获取飞行器媒体文件数量失败，请重启机场后重试",
      "fr": ""
    },
    317002 : {
      "dje_id": 317002,
      "en": "Failed to format aircraft storage. Make sure aircraft is powered on and connected to dock and camera can be detected. Or restart aircraft and try again",
      "zh": "飞行器存储格式化失败，飞行器未开机、未连接或未检测到相机，请确认无以上问题后重试，或重启飞行器后重试",
      "fr": ""
    },
    317003 : {
      "dje_id": 317003,
      "en": "Failed to format aircraft storage. Restart aircraft and try again",
      "zh": "飞行器存储格式化失败，请重启飞行器后重试",
      "fr": ""
    },
    317004 : {
      "dje_id": 317004,
      "en": "Failed to format media files. Try again later or restart dock and try again",
      "zh": "机场媒体文件格式化失败，请稍后重试或重启机场后重试",
      "fr": ""
    },
    317005 : {
      "dje_id": 317005,
      "en": "Aircraft video recording terminated unsuccessfully, media files for this flight mission may not be able to be uploaded",
      "zh": "飞行器结束录像失败，本次飞行任务的媒体文件可能无法上传",
      "fr": ""
    },
    317006 : {
      "dje_id": 317006,
      "en": "Unable to format. Wait until media files are downloaded and try again",
      "zh": "无法格式化，请等待当前飞行器媒体文件下载完成后再试",
      "fr": ""
    },
    317007 : {
      "dje_id": 317007,
      "en": "Failed to obtain number of media files. Try again later. If there are media files collected by current flight but issue persists, contact DJI Support",
      "zh": "获取媒体文件数量失败，请稍后重试，如本架次任务有媒体文件且持续报错可联系大疆售后",
      "fr": ""
    },
    319001 : {
      "dje_id": 319001,
      "en": "Unable to perform task. Dock is performing task or uploading issue logs. Wait until task is complete or logs uploaded and try again",
      "zh": "机场作业中或设备异常反馈上传日志中，无法执行飞行任务，请等待当前飞行任务或操作执行完成后重试",
      "fr": ""
    },
    319002 : {
      "dje_id": 319002,
      "en": "Dock system error. Restart dock and try again",
      "zh": "机场系统运行异常，请重启机场后重试",
      "fr": ""
    },
    319003 : {
      "dje_id": 319003,
      "en": "Dock system error. Distribute task again",
      "zh": "机场系统运行异常，请重新下发任务",
      "fr": ""
    },
    319004 : {
      "dje_id": 319004,
      "en": "Performing task timed out. Task automatically stopped",
      "zh": "飞行任务执行超时，已自动终止本次飞行任务",
      "fr": ""
    },
    319005 : {
      "dje_id": 319005,
      "en": "Communication error between cloud and dock. Unable to perform task",
      "zh": "云端与机场通信异常，无法执行飞行任务",
      "fr": ""
    },
    319006 : {
      "dje_id": 319006,
      "en": "Failed to cancel task. Task in progress",
      "zh": "取消飞行任务失败，飞行任务已经在执行中",
      "fr": ""
    },
    319007 : {
      "dje_id": 319007,
      "en": "Failed to edit task. Task in progress",
      "zh": "修改飞行任务失败，飞行任务已经在执行中",
      "fr": ""
    },
    319008 : {
      "dje_id": 319008,
      "en": "Dock and cloud time not synced. Dock unable to perform task",
      "zh": "机场时间与云端时间不同步，机场无法执行飞行任务",
      "fr": ""
    },
    319009 : {
      "dje_id": 319009,
      "en": "Failed to distribute task. Try again later or restart dock and try again",
      "zh": "飞行任务下发失败，请稍后重试或重启机场后重试",
      "fr": ""
    },
    319010 : {
      "dje_id": 319010,
      "en": "Dock firmware version too early. Unable to perform task. Update dock to latest version and try again",
      "zh": "机场固件版本过低，无法执行飞行任务，请升级机场固件为最新版本后重试",
      "fr": ""
    },
    319015 : {
      "dje_id": 319015,
      "en": "Initializing dock. Unable to perform task. Wait until initialization is complete",
      "zh": "机场正在初始化中，无法执行飞行任务，请等待机场初始化完成后重试",
      "fr": ""
    },
    319016 : {
      "dje_id": 319016,
      "en": "Dock performing other task. Unable to perform current task",
      "zh": "机场正在执行其他飞行任务，无法执行本次飞行任务",
      "fr": ""
    },
    319017 : {
      "dje_id": 319017,
      "en": "Dock processing media files captured in last task. Unable to perform current task. Try again later",
      "zh": "机场正在处理上次飞行任务媒体文件，无法执行本次飞行任务，请稍后重试",
      "fr": ""
    },
    319018 : {
      "dje_id": 319018,
      "en": "Unable to perform task. Dock uploading issue logs. Try again later",
      "zh": "机场正在自动导出日志中（设备异常反馈），无法执行飞行任务，请稍后重试",
      "fr": ""
    },
    319019 : {
      "dje_id": 319019,
      "en": "Unable to perform task. Dock obtaining issue logs. Try again later",
      "zh": "机场正在拉取日志中（设备异常反馈），无法执行飞行任务，请稍后重试",
      "fr": ""
    },
    319020 : {
      "dje_id": 319020,
      "en": "Failed to pause flight task. Try again later",
      "zh": "航线中断失败，请稍后重试",
      "fr": ""
    },
    319021 : {
      "dje_id": 319021,
      "en": "Failed to disable Live Flight Controls. Try again later",
      "zh": "退出远程控制失败，请稍后重试",
      "fr": ""
    },
    319022 : {
      "dje_id": 319022,
      "en": "FlyTo task failed. Try again later",
      "zh": "指点飞行失败，请稍后重试",
      "fr": ""
    },
    319023 : {
      "dje_id": 319023,
      "en": "Failed to stop FlyTo task. Try again later",
      "zh": "指点飞行停止失败，请稍后重试",
      "fr": ""
    },
    319024 : {
      "dje_id": 319024,
      "en": "Takeoff failed. Try again later",
      "zh": "一键起飞失败，请稍后重试",
      "fr": ""
    },
    319025 : {
      "dje_id": 319025,
      "en": "Task in preparation. Dock unable to perform task distributed from cloud. Try again later",
      "zh": "机场未准备完成，无法执行云端下发的飞行任务，请稍后重试",
      "fr": ""
    },
    319026 : {
      "dje_id": 319026,
      "en": "Aircraft battery level lower than set value. Unable to perform task. Wait until charging completes and try again",
      "zh": "飞行器电池电量低于用户设置的任务开始执行的电量，请等待充电完成后再执行飞行任务",
      "fr": ""
    },
    319027 : {
      "dje_id": 319027,
      "en": "Insufficient storage on dock or aircraft. Unable to perform task. Wait until media files are uploaded to cloud and try again",
      "zh": "机场或飞行器剩余存储容量过低，无法执行飞行任务，请等待媒体文件上传，机场和飞行器存储容量释放后再执行飞行任务",
      "fr": ""
    },
    319028 : {
      "dje_id": 319028,
      "en": "Updating custom flight area...",
      "zh": "正在更新自定义飞行区",
      "fr": ""
    },
    319029 : {
      "dje_id": 319029,
      "en": "Updating offline maps...",
      "zh": "正在更新离线地图",
      "fr": ""
    },
    319030 : {
      "dje_id": 319030,
      "en": "Operation failed. No aircraft control",
      "zh": "操作失败，无飞行器控制权",
      "fr": ""
    },
    319031 : {
      "dje_id": 319031,
      "en": "Flight control error. Refresh page and try again",
      "zh": "控制权异常，请刷新重试",
      "fr": ""
    },
    319032 : {
      "dje_id": 319032,
      "en": "FlyTo task failed. Try again later",
      "zh": "指点飞行失败，请稍后重试",
      "fr": ""
    },
    319033 : {
      "dje_id": 319033,
      "en": "Keyboard commands failed. Try again later",
      "zh": "虚拟摇杆操作失败，请稍后重试",
      "fr": ""
    },
    319034 : {
      "dje_id": 319034,
      "en": "Keyboard commands failed. Try again later",
      "zh": "虚拟摇杆操作失败，请稍后重试",
      "fr": ""
    },
    319035 : {
      "dje_id": 319035,
      "en": "Failed to pause. Try again later",
      "zh": "急停失败，请稍后重试",
      "fr": ""
    },
    319036 : {
      "dje_id": 319036,
      "en": "Device in remote debugging mode. Try again later",
      "zh": "设备远程调试中，请稍后重试",
      "fr": ""
    },
    319037 : {
      "dje_id": 319037,
      "en": "Device in on-site debugging mode. Try again later",
      "zh": "设备本地调试中，请稍后重试",
      "fr": ""
    },
    319038 : {
      "dje_id": 319038,
      "en": "Updating device. Try again later",
      "zh": "设备正在升级，请稍后重试",
      "fr": ""
    },
    319042 : {
      "dje_id": 319042,
      "en": "Failed to resume flight. Try again later",
      "zh": "航线恢复失败，请稍后重试",
      "fr": ""
    },
    319043 : {
      "dje_id": 319043,
      "en": "Failed to cancel RTH. Try again later",
      "zh": "取消返航失败，请稍后重试",
      "fr": ""
    },
    319044 : {
      "dje_id": 319044,
      "en": "Task completed. Unable to resume",
      "zh": "航线任务已结束，无法恢复",
      "fr": ""
    },
    319045 : {
      "dje_id": 319045,
      "en": "Aircraft paused. Operate aircraft by keyboard commands",
      "zh": "急停成功，请重新按键操作",
      "fr": ""
    },
    319046 : {
      "dje_id": 319046,
      "en": "Task completed or paused. Unable to pause",
      "zh": "无法暂停航线，飞行器尚未进入航线或已退出航线",
      "fr": ""
    },
    319999 : {
      "dje_id": 319999,
      "en": "Dock system error. Restart dock and try again",
      "zh": "机场系统运行异常，请重启机场后重试",
      "fr": ""
    },
    321000 : {
      "dje_id": 321000,
      "en": "Task error. Try again later or restart dock and try again",
      "zh": "航线执行异常，请稍后重试或重启机场后重试",
      "fr": ""
    },
    321004 : {
      "dje_id": 321004,
      "en": "Failed to process flight route file. Unable to perform task. Check file",
      "zh": "航线文件解析失败，无法执行飞行任务，请检查航线文件",
      "fr": ""
    },
    321005 : {
      "dje_id": 321005,
      "en": "Missing breakpoint info in flight route. Dock unable to perform task",
      "zh": "航线缺少断点信息，机场无法执行飞行任务",
      "fr": ""
    },
    321257 : {
      "dje_id": 321257,
      "en": "Task in progress. Failed to start task again",
      "zh": "飞行任务已在执行中，请勿重复执行",
      "fr": ""
    },
    321258 : {
      "dje_id": 321258,
      "en": "Unable to stop task. Check aircraft status",
      "zh": "飞行任务无法终止，请检查飞行器状态",
      "fr": ""
    },
    321259 : {
      "dje_id": 321259,
      "en": "Task not started. Unable to stop task",
      "zh": "飞行任务未开始执行，无法终止飞行任务",
      "fr": ""
    },
    321260 : {
      "dje_id": 321260,
      "en": "Task not started. Unable to pause task",
      "zh": "飞行任务未开始执行，无法中断飞行任务",
      "fr": ""
    },
    321513 : {
      "dje_id": 321513,
      "en": "Unable to perform task. Flight route altitude greater than aircraft max flight altitude",
      "zh": "航线规划高度已超过飞行器限高，机场无法执行飞行任务",
      "fr": ""
    },
    321514 : {
      "dje_id": 321514,
      "en": "Failed to perform task. Flight route start or end point in buffer zone or exceeds distance limit",
      "zh": "任务失败，起点或终点位于限远区域的缓冲区内或超过了限远距离",
      "fr": ""
    },
    321515 : {
      "dje_id": 321515,
      "en": "Unable to perform task. Aircraft will fly across GEO Zone",
      "zh": "航线穿过限飞区，机场无法执行飞行任务",
      "fr": ""
    },
    321516 : {
      "dje_id": 321516,
      "en": "Flight altitude too low. Task stopped",
      "zh": "飞行器飞行高度过低，飞行任务执行被终止",
      "fr": ""
    },
    321517 : {
      "dje_id": 321517,
      "en": "Obstacle detected. Task stopped. To ensure flight safety, do not resume task from breakpoint",
      "zh": "飞行器触发避障，飞行任务执行被终止。为保证飞行安全，请勿用当前航线执行断点续飞任务",
      "fr": ""
    },
    321519 : {
      "dje_id": 321519,
      "en": "Aircraft approached GEO Zone or reached max distance and automatically returned to home. Unable to complete task",
      "zh": "飞行器接近限飞区或限远距离自动返航，无法完成航线飞行",
      "fr": ""
    },
    321523 : {
      "dje_id": 321523,
      "en": "Failed to take off. Try again later. Contact DJI Support if issue persists",
      "zh": "飞行器起飞失败，请稍后重试，如果仍报错请联系大疆售后。",
      "fr": ""
    },
    321524 : {
      "dje_id": 321524,
      "en": "The preparation before takeoff of the aircraft has failed, possibly due to the aircraft's inability to locate or gear error. Please check the status of the aircraft",
      "zh": "飞行器起飞前准备失败，可能是飞行器无法定位或档位错误导致，请检查飞行器状态",
      "fr": ""
    },
    321528 : {
      "dje_id": 321528,
      "en": "Approaching boundary of custom flight area. Flight task paused",
      "zh": "触碰自定义飞行区边界，航线任务已暂停",
      "fr": ""
    },
    321529 : {
      "dje_id": 321529,
      "en": "Unable to reach FlyTo destination. Task paused. FlyTo destination inside Restricted Zone or obstacle area. Adjust route and try again",
      "zh": "目标点位于禁飞区域或者障碍物内，无法到达，航线任务已暂停，请重新规划后再试",
      "fr": ""
    },
    321530 : {
      "dje_id": 321530,
      "en": "Task paused. Failed to plan flight route",
      "zh": "飞行器飞行航线过程中轨迹规划失败，航线任务已暂停",
      "fr": ""
    },
    321531 : {
      "dje_id": 321531,
      "en": "Failed to execute entry/exit route. Contact DJI support",
      "zh": "进离场航线执行失败，请联系大疆售后。",
      "fr": ""
    },
    321532 : {
      "dje_id": 321532,
      "en": "Failed to execute entry/exit route. Contact DJI support",
      "zh": "进离场航线执行失败，请联系大疆售后。",
      "fr": ""
    },
    321533 : {
      "dje_id": 321533,
      "en": "Failed to execute entry/exit route. Contact DJI support",
      "zh": "进离场航线执行失败，请联系大疆售后。",
      "fr": ""
    },
    321769 : {
      "dje_id": 321769,
      "en": "Aircraft satellite positioning signal weak. Unable to perform task. Restart dock and try again",
      "zh": "飞行器卫星定位信号差，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    321770 : {
      "dje_id": 321770,
      "en": "Aircraft flight mode error. Unable to perform task. Restart dock and try again",
      "zh": "飞行器挡位错误，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    321771 : {
      "dje_id": 321771,
      "en": "Aircraft Home Point not set. Unable to perform task. Restart dock and try again",
      "zh": "飞行器返航点未设置，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    321772 : {
      "dje_id": 321772,
      "en": "Aircraft battery level lower than 30%. Unable to perform task. It is recommended to charged battery up to 50% before trying again",
      "zh": "飞行器电量低于30%，无法执行飞行任务，请充电后重试（建议电量≥50%）",
      "fr": ""
    },
    321773 : {
      "dje_id": 321773,
      "en": "Aircraft battery level low and returned to home. Unable to complete task",
      "zh": "飞行器执行飞行任务过程中低电量返航，无法完成航线飞行",
      "fr": ""
    },
    321775 : {
      "dje_id": 321775,
      "en": "Aircraft signal lost when performing task. Failed to complete task",
      "zh": "飞行器航线飞行过程中失联，无法完成航线飞行",
      "fr": ""
    },
    321776 : {
      "dje_id": 321776,
      "en": "Failed to converge aircraft RTK data. Unable to perform task. Restart dock and try again",
      "zh": "飞行器 RTK 收敛失败，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    321777 : {
      "dje_id": 321777,
      "en": "Aircraft not hovering. Unable to start task",
      "zh": "飞行器未悬停，无法开始执行飞行任务",
      "fr": ""
    },
    321778 : {
      "dje_id": 321778,
      "en": "Unable to perform task. Aircraft controlled by Controller B, and propellers started",
      "zh": "用户使用 B 控操控飞行器起桨，机场无法执行飞行任务",
      "fr": ""
    },
    321784 : {
      "dje_id": 321784,
      "en": "Aircraft returned to home during task due to strong wind",
      "zh": "任务过程中遇到大风紧急返航",
      "fr": ""
    },
    322281 : {
      "dje_id": 322281,
      "en": "Task failed. Task stopped manually or abnormally during flight",
      "zh": "任务失败，机场执行飞行任务过程被手动打断或异常终止",
      "fr": ""
    },
    322282 : {
      "dje_id": 322282,
      "en": "Task stopped. Aircraft control obtained by cloud user or remote controller",
      "zh": "机场执行飞行任务过程中被中断，飞行器被云端用户或遥控器接管",
      "fr": ""
    },
    322283 : {
      "dje_id": 322283,
      "en": "RTH command sent by user. Aircraft unable to complete task",
      "zh": "机场执行飞行任务过程中被用户触发返航，无法完成航线飞行",
      "fr": ""
    },
    322539 : {
      "dje_id": 322539,
      "en": "Breakpoint info error. Dock unable to perform task",
      "zh": "航线的断点信息错误，机场无法执行飞行任务",
      "fr": ""
    },
    322563 : {
      "dje_id": 322563,
      "en": "Failed to generate flight route. Check if vision sensor is stained or restart aircraft and try again. Contact DJI Support if issue persists",
      "zh": "航线轨迹生成失败，请检查飞行器视觉镜头是否存在脏污或重启飞行器后再试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    324012 : {
      "dje_id": 324012,
      "en": "Compressing logs timed out. Too many logs selected. Unselect some logs and try again",
      "zh": "日志压缩过程超时，所选日志过多，请减少选择的日志后重试",
      "fr": ""
    },
    324013 : {
      "dje_id": 324013,
      "en": "Failed to obtain device log list. Try again later",
      "zh": "设备日志列表获取失败，请稍后重试",
      "fr": ""
    },
    324014 : {
      "dje_id": 324014,
      "en": "Device log list is empty. Refresh page or restart dock and try again",
      "zh": "设备日志列表为空，请刷新页面或重启机场后重试",
      "fr": ""
    },
    324015 : {
      "dje_id": 324015,
      "en": "Aircraft powered off or not connected. Unable to obtain log list. Make sure aircraft is inside dock. Remotely power on aircraft and try again",
      "zh": "飞行器已关机或未连接，无法获取日志列表，请确认飞行器在舱内，通过远程调试将飞行器开机后重试",
      "fr": ""
    },
    324016 : {
      "dje_id": 324016,
      "en": "Insufficient dock storage space. Failed to compress logs. Clear space or try again later",
      "zh": "机场存储空间不足，日志压缩失败，请清理机场存储空间或稍后重试",
      "fr": ""
    },
    324017 : {
      "dje_id": 324017,
      "en": "Failed to compress logs. Unable to obtain logs of selected aircraft. Refresh page or restart dock and try again",
      "zh": "日志压缩失败，无法获取所选飞行器日志，请刷新页面或重启机场后重试",
      "fr": ""
    },
    324018 : {
      "dje_id": 324018,
      "en": "Failed to obtaining logs and submit issue report. Try again later or restart dock and try again",
      "zh": "日志文件拉取失败，导致本次设备异常反馈上传失败，请稍后重试或重启机场后重试",
      "fr": ""
    },
    324019 : {
      "dje_id": 324019,
      "en": "Due to network anomalies at the airport, the log upload has failed. Please retry later. If this issue persists, please contact your agent or DJI Support for network troubleshooting.",
      "zh": "因机场网络异常，日志上传失败，请稍后重试。如果连续多次出现该问题，请联系代理商或大疆售后进行网络排障",
      "fr": ""
    },
    324021 : {
      "dje_id": 324021,
      "en": "Failed to export log. Dock power supply off or restarted. Try again later",
      "zh": "因机场断电或重启导致日志导出中断，日志导出失败，请稍后重试",
      "fr": ""
    },
    324030 : {
      "dje_id": 324030,
      "en": "Failed to upload media files due to reasons such as dock network or aircraft image transmission error",
      "zh": "因机场网络异常、飞行器图传链路异常等原因，媒体文件暂时无法上传或文件已上传但云端读取失败",
      "fr": ""
    },
    325001 : {
      "dje_id": 325001,
      "en": "Cloud command parameter error. Device unable to execute command",
      "zh": "云端下发命令不符合格式要求，设备无法执行",
      "fr": ""
    },
    325003 : {
      "dje_id": 325003,
      "en": "Command failed. Try again",
      "zh": "指令响应失败，请重试",
      "fr": ""
    },
    325004 : {
      "dje_id": 325004,
      "en": "Device command request timed out. Try again",
      "zh": "设备端命令请求已超时，请重试",
      "fr": ""
    },
    325005 : {
      "dje_id": 325005,
      "en": "Dock unable to respond to current task. Try again later",
      "zh": "当前机场无法响应任务，请稍后重试",
      "fr": ""
    },
    325006 : {
      "dje_id": 325006,
      "en": "Dock in task preparation status. Try again later",
      "zh": "当前机场启动检查中，请稍后重试",
      "fr": ""
    },
    325007 : {
      "dje_id": 325007,
      "en": "Dock is performing task. Try again later",
      "zh": "当前机场执行作业任务中，请稍后重试",
      "fr": ""
    },
    325008 : {
      "dje_id": 325008,
      "en": "Dock is processing task output. Try again later",
      "zh": "当前机场处理作业任务结果中，请稍后重试",
      "fr": ""
    },
    325009 : {
      "dje_id": 325009,
      "en": "Dock is exporting logs to cloud. Try again later",
      "zh": "当前机场执行远程日志导出中，请稍后重试",
      "fr": ""
    },
    325010 : {
      "dje_id": 325010,
      "en": "Dock is updating custom flight area. Try again later",
      "zh": "当前机场更新自定义飞行区中，请稍后重试",
      "fr": ""
    },
    325011 : {
      "dje_id": 325011,
      "en": "Dock is updating offline map. Try again later",
      "zh": "当前机场更新离线地图中，请稍后重试",
      "fr": ""
    },
    325012 : {
      "dje_id": 325012,
      "en": "Aircraft not connected. Try again later",
      "zh": "当前飞机未连接，请稍后重试",
      "fr": ""
    },
    326002 : {
      "dje_id": 326002,
      "en": "No DJI Cellular Dongle on aircraft",
      "zh": "飞行器未安装 DJI Cellualr 模块",
      "fr": ""
    },
    326003 : {
      "dje_id": 326003,
      "en": "No SIM card in DJI Cellular Dongle of aircraft",
      "zh": "飞行器 DJI Cellualr 模块中未安装 SIM 卡",
      "fr": ""
    },
    326004 : {
      "dje_id": 326004,
      "en": "Updating DJI Cellular Dongle of aircraft required. Otherwise, features will be unavailable",
      "zh": "飞行器 DJI Cellualr 模块需要强制升级，否则无法使用",
      "fr": ""
    },
    326005 : {
      "dje_id": 326005,
      "en": "Operation failed. Check 4G signal or contact network provider to check data allowance and APN settings",
      "zh": "操作失败，增强图传无法建立连接，请检查 4G 信号强度，或咨询运营商查询套餐流量和 APN 设置",
      "fr": ""
    },
    326006 : {
      "dje_id": 326006,
      "en": "Failed to change enhanced transmission status. Try again later",
      "zh": "增强图传开关切换失败，请稍后重试",
      "fr": ""
    },
    326008 : {
      "dje_id": 326008,
      "en": "No DJI Cellular Dongle in dock",
      "zh": "机场未安装 DJI Cellualr 模块",
      "fr": ""
    },
    326009 : {
      "dje_id": 326009,
      "en": "No SIM card in DJI Cellular Dongle of dock",
      "zh": "机场 DJI Cellualr 模块中未安装 SIM 卡",
      "fr": ""
    },
    326010 : {
      "dje_id": 326010,
      "en": "Updating DJI Cellular Dongle of dock required. Otherwise, features will be unavailable",
      "zh": "机场 DJI Cellualr 模块需要强制升级，否则无法使用",
      "fr": ""
    },
    326103 : {
      "dje_id": 326103,
      "en": "Activating eSIM. Try again later",
      "zh": "当前 eSIM 正在激活中，请稍后再试",
      "fr": ""
    },
    326104 : {
      "dje_id": 326104,
      "en": "Switching network provider. Try again later",
      "zh": "当前 eSIM 正在切换运营商中，请稍后再试",
      "fr": ""
    },
    326105 : {
      "dje_id": 326105,
      "en": "Switching DJI Cellular Dongle mode. Try again later",
      "zh": "DJI 增强图传模块正在切换模式中，请稍后再试",
      "fr": ""
    },
    326106 : {
      "dje_id": 326106,
      "en": "DJI Cellular Dongle error. Restart device and try again. Contact DJI Support if issue persists",
      "zh": "DJI 增强图传模块异常，请重启设备后再试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    326107 : {
      "dje_id": 326107,
      "en": "Click Devices > Dock > Device Maintenance to activate eSIM of DJI Cellular Dongle or insert SIM card and try again",
      "zh": "请在设备管理 > 机场 > 设备运维中激活DJI增强图传模块的 eSIM 或插入 SIM 卡后再试",
      "fr": ""
    },
    327000 : {
      "dje_id": 327000,
      "en": "Failed to set parameters. Try again later",
      "zh": "参数设置失败，请稍后重试",
      "fr": ""
    },
    327001 : {
      "dje_id": 327001,
      "en": "Failed to set parameters. Try again later",
      "zh": "参数设置失败，请稍后重试",
      "fr": ""
    },
    327002 : {
      "dje_id": 327002,
      "en": "Failed to obtain control. Try again later",
      "zh": "获取控制权失败，请稍后重试",
      "fr": ""
    },
    327003 : {
      "dje_id": 327003,
      "en": "Failed to obtain control. Try again later",
      "zh": "获取控制权失败，请稍后重试",
      "fr": ""
    },
    327004 : {
      "dje_id": 327004,
      "en": "Failed to drag livestream view. Try again later",
      "zh": "画面拖动失败，请重试",
      "fr": ""
    },
    327005 : {
      "dje_id": 327005,
      "en": "Failed to center livestream view around clicked point",
      "zh": "双击画面归中失败",
      "fr": ""
    },
    327006 : {
      "dje_id": 327006,
      "en": "Failed to take photo",
      "zh": "拍照失败",
      "fr": ""
    },
    327007 : {
      "dje_id": 327007,
      "en": "Failed to start recording",
      "zh": "开始录像失败",
      "fr": ""
    },
    327008 : {
      "dje_id": 327008,
      "en": "Failed to stop recording",
      "zh": "停止录像失败",
      "fr": ""
    },
    327009 : {
      "dje_id": 327009,
      "en": "Failed to switch camera modes",
      "zh": "切换相机模式失败",
      "fr": ""
    },
    327010 : {
      "dje_id": 327010,
      "en": "Failed to zoom in/out with zoom camera",
      "zh": "ZOOM相机变焦失败",
      "fr": ""
    },
    327011 : {
      "dje_id": 327011,
      "en": "Failed to zoom in/out with IR camera",
      "zh": "IR相机变焦失败",
      "fr": ""
    },
    327012 : {
      "dje_id": 327012,
      "en": "Failed to obtain control. Try again later",
      "zh": "获取控制权失败，请稍后重试",
      "fr": ""
    },
    327013 : {
      "dje_id": 327013,
      "en": "Failed to set parameters. Try again later",
      "zh": "参数设置失败，请稍后重试",
      "fr": ""
    },
    327014 : {
      "dje_id": 327014,
      "en": "Gimbal reached movement limit",
      "zh": "云台已达限位",
      "fr": ""
    },
    327015 : {
      "dje_id": 327015,
      "en": "Failed to start livestream. Refresh livestream view or reopen device status window",
      "zh": "直播启动失败，建议刷新直播或重新打开设备小窗",
      "fr": ""
    },
    327016 : {
      "dje_id": 327016,
      "en": "Failed to set signal lost action. Try again",
      "zh": "失联动作设置失败，请重试",
      "fr": ""
    },
    327017 : {
      "dje_id": 327017,
      "en": "Failed to set FlyTo altitude. Try again",
      "zh": "指点飞行高度设置失败，请重试",
      "fr": ""
    },
    327018 : {
      "dje_id": 327018,
      "en": "Failed to change FlyTo mode. Try again",
      "zh": "指点飞行模式切换失败，请重试",
      "fr": ""
    },
    327019 : {
      "dje_id": 327019,
      "en": "Failed to face PinPoint in current status",
      "zh": "当前状态无法看向标注点",
      "fr": ""
    },
    327020 : {
      "dje_id": 327020,
      "en": "Panorama stopp failedï¼Command timed out",
      "zh": "全景拍照停止命令超时",
      "fr": ""
    },
    327050 : {
      "dje_id": 327050,
      "en": "Broadcast not supported in current device status",
      "zh": "当前设备状态不支持播放音频",
      "fr": ""
    },
    327051 : {
      "dje_id": 327051,
      "en": "Failed to download audio file",
      "zh": "下载音频文件失败",
      "fr": ""
    },
    327052 : {
      "dje_id": 327052,
      "en": "Failed to switch operating modes of speaker",
      "zh": "喊话器处理模式切换失败",
      "fr": ""
    },
    327053 : {
      "dje_id": 327053,
      "en": "Failed to upload audio file",
      "zh": "上传音频文件失败",
      "fr": ""
    },
    327054 : {
      "dje_id": 327054,
      "en": "Failed to play audio",
      "zh": "播放音频失败",
      "fr": ""
    },
    327055 : {
      "dje_id": 327055,
      "en": "Failed to set work mode",
      "zh": "设置工作模式失败",
      "fr": ""
    },
    327056 : {
      "dje_id": 327056,
      "en": "Failed to upload text",
      "zh": "上传文本失败",
      "fr": ""
    },
    327057 : {
      "dje_id": 327057,
      "en": "Failed to stop playing",
      "zh": "停止播放失败",
      "fr": ""
    },
    327058 : {
      "dje_id": 327058,
      "en": "Failed to set play mode",
      "zh": "设置播放模式失败",
      "fr": ""
    },
    327059 : {
      "dje_id": 327059,
      "en": "Failed to set volume",
      "zh": "设置音量失败",
      "fr": ""
    },
    327060 : {
      "dje_id": 327060,
      "en": "Failed to set widget value",
      "zh": "设置控件值失败",
      "fr": ""
    },
    327061 : {
      "dje_id": 327061,
      "en": "Failed to send text value",
      "zh": "发送文本值失败",
      "fr": ""
    },
    327062 : {
      "dje_id": 327062,
      "en": "Failed to switch system languages",
      "zh": "切换系统语言失败",
      "fr": ""
    },
    327063 : {
      "dje_id": 327063,
      "en": "Failed to obtain device function list",
      "zh": "获取设备功能列表失败",
      "fr": ""
    },
    327064 : {
      "dje_id": 327064,
      "en": "Failed to obtain device configuration file",
      "zh": "获取设备配置文件失败",
      "fr": ""
    },
    327065 : {
      "dje_id": 327065,
      "en": "Failed to obtain device photos",
      "zh": "获取设备图片文件失败",
      "fr": ""
    },
    327066 : {
      "dje_id": 327066,
      "en": "Failed to compress device file",
      "zh": "设备文件压缩失败",
      "fr": ""
    },
    327067 : {
      "dje_id": 327067,
      "en": "Failed to upload device file",
      "zh": "设备文件上传失败",
      "fr": ""
    },
    327068 : {
      "dje_id": 327068,
      "en": "Failed to upload audio file. MD5 checksum error",
      "zh": "上传音频文件失败，md5校验失败",
      "fr": ""
    },
    327069 : {
      "dje_id": 327069,
      "en": "Failed to upload audio file",
      "zh": "上传音频文件失败",
      "fr": ""
    },
    327070 : {
      "dje_id": 327070,
      "en": "Failed to upload audio file. Abnormal termination",
      "zh": "上传音频文件失败，异常终止",
      "fr": ""
    },
    327071 : {
      "dje_id": 327071,
      "en": "Failed to upload TTS file. MD5 checksum error",
      "zh": "上传TTS文本失败，md5校验失败",
      "fr": ""
    },
    327072 : {
      "dje_id": 327072,
      "en": "Failed to upload TTS file",
      "zh": "上传TTS文本失败",
      "fr": ""
    },
    327073 : {
      "dje_id": 327073,
      "en": "Failed to upload TTS file. Abnormal termination",
      "zh": "上传TTS文本失败，异常终止",
      "fr": ""
    },
    327074 : {
      "dje_id": 327074,
      "en": "Replay failed",
      "zh": "喊话器重播失败",
      "fr": ""
    },
    327075 : {
      "dje_id": 327075,
      "en": "Speaker encoding failed",
      "zh": "喊话器编码失败",
      "fr": ""
    },
    327201 : {
      "dje_id": 327201,
      "en": "Taking panorama failed",
      "zh": "全景拍照失败",
      "fr": ""
    },
    327202 : {
      "dje_id": 327202,
      "en": "Panorama stopped",
      "zh": "全景拍摄终止",
      "fr": ""
    },
    327203 : {
      "dje_id": 327203,
      "en": "Panorama not supported on current device",
      "zh": "当前设备不支持全景拍照",
      "fr": ""
    },
    327204 : {
      "dje_id": 327204,
      "en": "System busy.Panorama not allowed",
      "zh": "系统繁忙，无法全景拍照",
      "fr": ""
    },
    327205 : {
      "dje_id": 327205,
      "en": "Request failed.Panorama not allowed",
      "zh": "请求失败，无法全景拍照",
      "fr": ""
    },
    327206 : {
      "dje_id": 327206,
      "en": "Aircraft not in flight. Unable to take panorama",
      "zh": "飞机未起飞，无法开始全景拍摄",
      "fr": ""
    },
    327207 : {
      "dje_id": 327207,
      "en": "Getting control failed. Panorama stopped",
      "zh": "控制权获取失败，全景拍摄终止",
      "fr": ""
    },
    327208 : {
      "dje_id": 327208,
      "en": "Unknown camera error. Unable to start panorama",
      "zh": "未知相机错误，无法开始全景拍摄",
      "fr": ""
    },
    327209 : {
      "dje_id": 327209,
      "en": "Camera response timed out. Panorama stopped",
      "zh": "相机超时，全景拍摄终止",
      "fr": ""
    },
    327210 : {
      "dje_id": 327210,
      "en": "Panorama not allowed",
      "zh": "无法全景拍照",
      "fr": ""
    },
    327211 : {
      "dje_id": 327211,
      "en": "Insufficient storage. Panorama stopped",
      "zh": "存储空间不足，全景拍摄终止",
      "fr": ""
    },
    327212 : {
      "dje_id": 327212,
      "en": "Aircraft moving. Unable to take panorama",
      "zh": "飞机运动中，无法开始全景拍摄",
      "fr": ""
    },
    327213 : {
      "dje_id": 327213,
      "en": "Gimbal moving. Unable to take panorama",
      "zh": "云台运动中，无法开始全景拍摄",
      "fr": ""
    },
    327214 : {
      "dje_id": 327214,
      "en": "Control stick moved. Panorama stopped",
      "zh": "用户操作摇杆，全景拍摄终止",
      "fr": ""
    },
    327215 : {
      "dje_id": 327215,
      "en": "Max altitude limit reached. Panorama stopped",
      "zh": "碰到限飞区，全景拍摄终止",
      "fr": ""
    },
    327216 : {
      "dje_id": 327216,
      "en": "Max distance reached. Panorama stopped",
      "zh": "触发距离限制，全景拍摄终止",
      "fr": ""
    },
    327217 : {
      "dje_id": 327217,
      "en": "Gimbal stuck. Panorama stopped",
      "zh": "云台受阻，全景拍摄终止",
      "fr": ""
    },
    327218 : {
      "dje_id": 327218,
      "en": "Taking photo failed. Panorama stopped",
      "zh": "拍照失败，全景拍摄终止",
      "fr": ""
    },
    327219 : {
      "dje_id": 327219,
      "en": "Stitching panorama failed",
      "zh": "全景图片拼接失败",
      "fr": ""
    },
    327220 : {
      "dje_id": 327220,
      "en": "Loading calibration parameters failed. Panorama stopped",
      "zh": "加载标定参数失败，全景拍摄终止",
      "fr": ""
    },
    327221 : {
      "dje_id": 327221,
      "en": "Adjusting camera parameters failed. Panorama stopped",
      "zh": "调整相机参数失败，全景拍摄终止",
      "fr": ""
    },
    327500 : {
      "dje_id": 327500,
      "en": "Failed to defog lens. Try again later",
      "zh": "飞行器镜头除雾失败，请稍后重试",
      "fr": ""
    },
    328051 : {
      "dje_id": 328051,
      "en": "CAAC registration is not completed. Connect to remote controller and complete registration based on instructions before flight",
      "zh": "飞机未完成实名登记，请连接遥控器，按照指引完成、实名登记后飞行",
      "fr": ""
    },
    328052 : {
      "dje_id": 328052,
      "en": "CAAC registration is canceled. Connect to remote controller and complete registration based on instructions before flight",
      "zh": "飞机实名登记状态已注销，请连接遥控器，按照指引完成实名登记后飞行",
      "fr": ""
    },
    336000 : {
      "dje_id": 336000,
      "en": "Failed to send FlyTo command. Try again",
      "zh": "指点飞行命令发送失败，请重试",
      "fr": ""
    },
    336001 : {
      "dje_id": 336001,
      "en": "Aircraft data error. Unable to respond to command",
      "zh": "飞行器数据异常，无法响应指令",
      "fr": ""
    },
    336002 : {
      "dje_id": 336002,
      "en": "Aircraft GPS signal weak",
      "zh": "飞行器GPS信号差",
      "fr": ""
    },
    336003 : {
      "dje_id": 336003,
      "en": "Aircraft positioning error. Unable to respond to command",
      "zh": "飞行器定位失效，无法响应指令",
      "fr": ""
    },
    336004 : {
      "dje_id": 336004,
      "en": "Failed to plan FlyTo task",
      "zh": "指点飞行自主规划失败",
      "fr": ""
    },
    336005 : {
      "dje_id": 336005,
      "en": "Home Point not updated",
      "zh": "飞行器返航点未更新",
      "fr": ""
    },
    336006 : {
      "dje_id": 336006,
      "en": "Aircraft signal lost. FlyTo task exited",
      "zh": "飞行器已失联，已退出指点飞行",
      "fr": ""
    },
    336017 : {
      "dje_id": 336017,
      "en": "Unable to complete task with current aircraft battery level",
      "zh": "飞行器电量不足以完成当前任务",
      "fr": ""
    },
    336018 : {
      "dje_id": 336018,
      "en": "FlyTo mode changed",
      "zh": "已切换飞行器规划模式",
      "fr": ""
    },
    336019 : {
      "dje_id": 336019,
      "en": "FlyTo altitude exceeds limit. Altitude automatically adjusted",
      "zh": "指点飞行因限高自动调整飞行高度",
      "fr": ""
    },
    336513 : {
      "dje_id": 336513,
      "en": "FlyTo destination in Restricted Zone",
      "zh": "目标点在禁飞区内",
      "fr": ""
    },
    336514 : {
      "dje_id": 336514,
      "en": "FlyTo destination exceeds max flight distance",
      "zh": "目标点超出飞行器限远",
      "fr": ""
    },
    336515 : {
      "dje_id": 336515,
      "en": "FlyTo destination in Restricted Zone",
      "zh": "目标点在禁飞区内",
      "fr": ""
    },
    336516 : {
      "dje_id": 336516,
      "en": "FlyTo destination exceeds max flight altitude",
      "zh": "目标点超出飞行器限高",
      "fr": ""
    },
    336517 : {
      "dje_id": 336517,
      "en": "FlyTo destination is below min flight altitude",
      "zh": "目标点超出飞行器限低",
      "fr": ""
    },
    337025 : {
      "dje_id": 337025,
      "en": "Unable to take off",
      "zh": "飞行器无法起飞",
      "fr": ""
    },
    337026 : {
      "dje_id": 337026,
      "en": "FlyTo destination error. Try again",
      "zh": "目标点异常，请重试",
      "fr": ""
    },
    337027 : {
      "dje_id": 337027,
      "en": "Aircraft speed setting error. Try again",
      "zh": "飞行器速度设置异常，请重试",
      "fr": ""
    },
    337028 : {
      "dje_id": 337028,
      "en": "Aircraft version error. Check aircraft version",
      "zh": "飞行器版本异常，请检查飞行器版本",
      "fr": ""
    },
    337029 : {
      "dje_id": 337029,
      "en": "Aircraft unable to respond to current task. Try again later",
      "zh": "飞行器无法响应当前任务，请稍后重试",
      "fr": ""
    },
    337030 : {
      "dje_id": 337030,
      "en": "Clearance altitude for FlyTo task is too low",
      "zh": "指令飞行安全离场高过低",
      "fr": ""
    },
    337537 : {
      "dje_id": 337537,
      "en": "Reached Restricted Zone",
      "zh": "已触碰禁飞区",
      "fr": ""
    },
    337538 : {
      "dje_id": 337538,
      "en": "Reached aircraft max flight distance",
      "zh": "已触碰飞行器限远",
      "fr": ""
    },
    337539 : {
      "dje_id": 337539,
      "en": "Reached Restricted Zone",
      "zh": "已触碰禁飞区",
      "fr": ""
    },
    337540 : {
      "dje_id": 337540,
      "en": "Aircraft reached max flight altitude or altitude limit in Altitude Zone",
      "zh": "已触碰飞行器限高或限高区",
      "fr": ""
    },
    337541 : {
      "dje_id": 337541,
      "en": "Reached aircraft min flight altitude",
      "zh": "已触碰飞行器限低",
      "fr": ""
    },
    337542 : {
      "dje_id": 337542,
      "en": "Failed to take off. Try again",
      "zh": "飞行器起飞失败，请重试",
      "fr": ""
    },
    337543 : {
      "dje_id": 337543,
      "en": "FlyTo destination may be within obstacle area. Check surrounding environment",
      "zh": "目标点可能在障碍物内，请检查周边环境",
      "fr": ""
    },
    337544 : {
      "dje_id": 337544,
      "en": "Obstacle detected. Check surrounding environment",
      "zh": "检测到障碍物，请检查周边环境",
      "fr": ""
    },
    337545 : {
      "dje_id": 337545,
      "en": "FlyTo task planning error. Try again",
      "zh": "飞行器规划异常，请重试",
      "fr": ""
    },
    337546 : {
      "dje_id": 337546,
      "en": "Reached custom flight area boundary",
      "zh": "已触碰自定义飞行区边界",
      "fr": ""
    },
    338001 : {
      "dje_id": 338001,
      "en": "Unable to perform task. Aircraft communication error. Restart aircraft and dock and try again",
      "zh": "飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试",
      "fr": ""
    },
    338002 : {
      "dje_id": 338002,
      "en": "Unable to perform task. Aircraft communication error. Restart aircraft and dock and try again",
      "zh": "飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试",
      "fr": ""
    },
    338003 : {
      "dje_id": 338003,
      "en": "Unable to perform task. Aircraft communication error. Restart aircraft and dock and try again",
      "zh": "飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试",
      "fr": ""
    },
    338004 : {
      "dje_id": 338004,
      "en": "Unable to perform task. Aircraft communication error. Restart aircraft and dock and try again",
      "zh": "飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试",
      "fr": ""
    },
    338005 : {
      "dje_id": 338005,
      "en": "Unable to perform task. Distance between docks must not exceed 15 km",
      "zh": "起飞机场与降落机场部署距离超出限制，无法执行飞行任务，请选择两个部署距离不超过 15km 的机场执行任务",
      "fr": ""
    },
    338006 : {
      "dje_id": 338006,
      "en": "Unable to perform task. Make sure unlocking license is applied for the area where aircraft lands and dock is not in custom Restricted Zone or outside custom flight area",
      "zh": "无法执行飞行任务，请检查降落机场是否已申请解禁证书、是否位于自定义禁飞区或是否位于自定义飞行区外",
      "fr": ""
    },
    338007 : {
      "dje_id": 338007,
      "en": "Unable to perform task. Dock altitude higher than altitude limit in Altitude Zone. Aircraft will not be able to land on dock. Apply for unlocking license and try again",
      "zh": "目标降落机场部署突破限高区限高，无法执行任务，请申请解禁证书后再试",
      "fr": ""
    },
    338008 : {
      "dje_id": 338008,
      "en": "Unable to perform task. Dock altitude higher than max flight altitude. Aircraft unable to land on dock. Adjust flight altitude limit and try again",
      "zh": "目标降落机场部署突破飞行器设置的限高，无法执行任务，请调整限高后重试",
      "fr": ""
    },
    338009 : {
      "dje_id": 338009,
      "en": "Unable to perform task. GPS signal weak. Restart aircraft and try again",
      "zh": "飞行器 GPS 定位信号差，无法执行任务，请重启飞行器后重试",
      "fr": ""
    },
    338010 : {
      "dje_id": 338010,
      "en": "Unable to perform task. Aircraft positioning error. Restart aircraft and try again",
      "zh": "飞行器定位失效，无法执行任务，请重启飞行器后重试",
      "fr": ""
    },
    338011 : {
      "dje_id": 338011,
      "en": "Task failed. Dock for landing is outside of flight geography volume. Plan task and try again",
      "zh": "任务失败，目标机场处于地理鸟笼作业区域外，请重新规划任务后再试",
      "fr": ""
    },
    338017 : {
      "dje_id": 338017,
      "en": "Unable to perform task. Aircraft data update error. Restart aircraft and try again",
      "zh": "飞行器数据更新失败，无法执行任务，请重启飞行器后重试",
      "fr": ""
    },
    338018 : {
      "dje_id": 338018,
      "en": "Unable to perform task. Failed to update aircraft data. Restart aircraft and try again",
      "zh": "飞行器数据更新失败，无法执行任务，请重启飞行器后重试",
      "fr": ""
    },
    338019 : {
      "dje_id": 338019,
      "en": "Unable to perform task. Planning RTH route to selected dock. Restart aircraft and try again",
      "zh": "飞行器到目标机场的返航路线正在规划中，无法执行任务，请重启飞行器后重试",
      "fr": ""
    },
    338020 : {
      "dje_id": 338020,
      "en": "Unable to perform task. Aircraft unable to land on selected dock based on planned route. Select another dock and try again",
      "zh": "飞行器无法根据规划的路径到达目标降落机场，无法执行任务，请重新选择降落机场后再试",
      "fr": ""
    },
    338021 : {
      "dje_id": 338021,
      "en": "Unable to perform task. Battery level insufficient for aircraft to land on selected dock. Charge aircraft and try again",
      "zh": "飞行器当前电量不足以到达目标降落机场，无法执行任务，请给飞行器充电后重试",
      "fr": ""
    },
    338049 : {
      "dje_id": 338049,
      "en": "Control stick moved. FlyTo task exited",
      "zh": "响应遥控器杆量，已退出指点飞行",
      "fr": ""
    },
    338050 : {
      "dje_id": 338050,
      "en": "Aircraft responds to command to end task. FlyTo task exited",
      "zh": "响应终止指令，已退出指点飞行",
      "fr": ""
    },
    338051 : {
      "dje_id": 338051,
      "en": "Aircraft battery level low and returning to home. FlyTo task exited",
      "zh": "飞行器低电量返航，已退出指点飞行",
      "fr": ""
    },
    338052 : {
      "dje_id": 338052,
      "en": "Aircraft battery level low. Aircraft landing. FlyTo task exited",
      "zh": "飞行器低电量降落，已退出指点飞行",
      "fr": ""
    },
    338053 : {
      "dje_id": 338053,
      "en": "Crewed aircraft nearby. FlyTo task exited",
      "zh": "附近有载人机，已退出指点飞行",
      "fr": ""
    },
    338054 : {
      "dje_id": 338054,
      "en": "Aircraft responds to task with higher priority. FlyTo task exited",
      "zh": "响应其他高优先级任务，已退出指点飞行",
      "fr": ""
    },
    338255 : {
      "dje_id": 338255,
      "en": "Unable to perform task. Aircraft communication error. Restart aircraft and dock and try again",
      "zh": "飞行器通信异常，无法执行飞行任务，请重启飞行器与机场后重试",
      "fr": ""
    },
    386535 : {
      "dje_id": 386535,
      "en": "Task error. Try again later or restart dock and try again",
      "zh": "航线执行异常，请稍后重试或重启机场后重试",
      "fr": ""
    },
    513002 : {
      "dje_id": 513002,
      "en": "Livestream failed. Camera does not exist or camera type error",
      "zh": "直播失败，相机不存在或相机类型错误",
      "fr": ""
    },
    513003 : {
      "dje_id": 513003,
      "en": "Camera livestream in progress. Do not start livestream again",
      "zh": "相机已经在直播中，请勿重复开启直播",
      "fr": ""
    },
    513005 : {
      "dje_id": 513005,
      "en": "Livestream failed. Livestream definition setting error",
      "zh": "直播失败，直播参数（清晰度）设置错误",
      "fr": ""
    },
    513006 : {
      "dje_id": 513006,
      "en": "Failed to start livestream. Refresh and try again",
      "zh": "直播启动失败，请刷新重试",
      "fr": ""
    },
    513008 : {
      "dje_id": 513008,
      "en": "Livestream failed. Image transmission data on device is abnormal",
      "zh": "直播失败，设备端图传数据异常",
      "fr": ""
    },
    513010 : {
      "dje_id": 513010,
      "en": "Livestream failed. Device unable to connect to network",
      "zh": "直播失败，设备无法联网",
      "fr": ""
    },
    513011 : {
      "dje_id": 513011,
      "en": "Operation failed. Livestream not enabled",
      "zh": "操作失败，设备未开启直播",
      "fr": ""
    },
    513012 : {
      "dje_id": 513012,
      "en": "Livestream failed. Device livestream in progress. Switching lens not supported",
      "zh": "操作失败，设备已在直播中，不支持切换镜头",
      "fr": ""
    },
    513013 : {
      "dje_id": 513013,
      "en": "Livestream failed. Video transmission protocol not supported",
      "zh": "直播失败，直播使用的视频传输协议不支持",
      "fr": ""
    },
    513014 : {
      "dje_id": 513014,
      "en": "Livestream failed. Livestream parameter error or incomplete",
      "zh": "直播失败，直播参数错误或者不完整",
      "fr": ""
    },
    513015 : {
      "dje_id": 513015,
      "en": "Livestream error. Network lags. Please refresh and retry",
      "zh": "直播异常，网络卡顿, 请刷新后重试",
      "fr": ""
    },
    513016 : {
      "dje_id": 513016,
      "en": "Livestream error. Video decoding failed",
      "zh": "直播异常，视频解码失败",
      "fr": ""
    },
    513017 : {
      "dje_id": 513017,
      "en": "Livestream paused. Wait until aircraft file download is completed",
      "zh": "直播已暂停，请等待当前飞行器媒体文件下载完成后再试",
      "fr": ""
    },
    513099 : {
      "dje_id": 513099,
      "en": "Livestream failed. Try again later",
      "zh": "直播失败，请稍后重试",
      "fr": ""
    },
    514100 : {
      "dje_id": 514100,
      "en": "Dock error. Restart dock and try again",
      "zh": "机场运行异常，请重启机场后重试",
      "fr": ""
    },
    514101 : {
      "dje_id": 514101,
      "en": "Failed to push driving rods into place. Make sure landing pad is clear of obstacles and aircraft heading is the same as arrow direction, or restart dock and try again",
      "zh": "推杆闭合失败，请检查停机坪上是否存在异物，飞行器方向是否放反，或重启机场后重试",
      "fr": ""
    },
    514102 : {
      "dje_id": 514102,
      "en": "Failed to pull driving rods back. Make sure landing pad is clear of obstacles or restart dock and try again",
      "zh": "推杆展开失败，请检查停机坪上是否存在异物，或重启机场后重试",
      "fr": ""
    },
    514103 : {
      "dje_id": 514103,
      "en": "Aircraft battery level lower than 30%. Unable to perform task. It is recommended to charged battery up to 50% before trying again",
      "zh": "飞行器电量低于30%，无法执行飞行任务，请充电后重试（建议电量≥50%）",
      "fr": ""
    },
    514104 : {
      "dje_id": 514104,
      "en": "Failed to charge battery. Restart dock and try again",
      "zh": "飞行器电池开始充电失败，请重启机场后重试",
      "fr": ""
    },
    514105 : {
      "dje_id": 514105,
      "en": "Failed to stop charging battery. Restart dock and try again",
      "zh": "飞行器电池停止充电失败，请重启机场后重试",
      "fr": ""
    },
    514106 : {
      "dje_id": 514106,
      "en": "Aircraft battery error. Restart dock and try again",
      "zh": "飞行器电源控制异常，请重启机场后重试",
      "fr": ""
    },
    514107 : {
      "dje_id": 514107,
      "en": "Failed to open dock cover. Make sure dock cover is clear of obstacles or restart dock and try again",
      "zh": "舱盖开启失败，请检查舱盖周围是否存在异物，或重启机场后重试",
      "fr": ""
    },
    514108 : {
      "dje_id": 514108,
      "en": "Failed to close dock cover. Make sure dock cover is clear of obstacles or restart dock and try again",
      "zh": "舱盖关闭失败，请检查舱盖周围是否存在异物，或重启机场后重试",
      "fr": ""
    },
    514109 : {
      "dje_id": 514109,
      "en": "Failed to power on aircraft. Check if aircraft is inside dock, aircraft battery level is sufficient. Restart dock and try again",
      "zh": "飞行器开机失败，请检查飞行器是否在舱和飞机电量是否正常，或重启机场后重试",
      "fr": ""
    },
    514110 : {
      "dje_id": 514110,
      "en": "Failed to power off aircraft. Restart dock and try again",
      "zh": "飞行器关机失败，请重启机场后重试",
      "fr": ""
    },
    514111 : {
      "dje_id": 514111,
      "en": "Propeller error in slow motion mode. Restart dock and try again",
      "zh": "飞行器慢转收桨控制异常，请重启机场后重试",
      "fr": ""
    },
    514112 : {
      "dje_id": 514112,
      "en": "Propeller error in slow motion mode. Restart dock and try again",
      "zh": "飞行器慢转收桨控制异常，请重启机场后重试",
      "fr": ""
    },
    514113 : {
      "dje_id": 514113,
      "en": "Connection error between driving rod and aircraft. Check if aircraft is inside dock, driving rods are stuck, or charging connector is stained or damaged",
      "zh": "机场推杆与飞行器无法连接，请检查飞行器是否在舱内，推杆闭合时是否被卡住，充电连接器是否脏污或损坏",
      "fr": ""
    },
    514114 : {
      "dje_id": 514114,
      "en": "Failed to obtain aircraft battery status. Restart dock and try again",
      "zh": "获取飞行器电源状态失败，请重启机场后重试",
      "fr": ""
    },
    514116 : {
      "dje_id": 514116,
      "en": "Unable to perform operation. Dock is executing other command. Try again later",
      "zh": "无法执行当前操作，机场正在执行其他控制指令，请稍后重试",
      "fr": ""
    },
    514117 : {
      "dje_id": 514117,
      "en": "Dock cover is open or not fully closed. Restart dock and try again",
      "zh": "舱盖开启或关闭未到位，请重启机场后重试",
      "fr": ""
    },
    514118 : {
      "dje_id": 514118,
      "en": "Driving rods pulled back or not pushed into place. Restart dock and try again",
      "zh": "推杆展开或闭合未到位，请重启机场后重试",
      "fr": ""
    },
    514120 : {
      "dje_id": 514120,
      "en": "Dock and aircraft disconnected. Restart dock and try again or relink dock and aircraft",
      "zh": "机场与飞行器断连，请重启机场后重试或重新对频",
      "fr": ""
    },
    514121 : {
      "dje_id": 514121,
      "en": "Emergency stop button pressed down. Release button",
      "zh": "机场急停按钮被按下，请释放急停按钮",
      "fr": ""
    },
    514122 : {
      "dje_id": 514122,
      "en": "Failed to obtain aircraft charging status. Restart dock and try again",
      "zh": "获取飞行器充电状态失败，请重启机场后重试",
      "fr": ""
    },
    514123 : {
      "dje_id": 514123,
      "en": "Aircraft battery level too low. Unable to power on aircraft",
      "zh": "飞行器电池电量过低无法开机",
      "fr": ""
    },
    514124 : {
      "dje_id": 514124,
      "en": "Failed to obtain aircraft battery information. Unable to perform task. Restart dock and try again",
      "zh": "获取飞行器电池信息失败，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    514125 : {
      "dje_id": 514125,
      "en": "Aircraft battery level almost full. Unable to start charging. Charge battery when battery level is lower than 95%",
      "zh": "飞行器电池电量已接近满电状态，无法开始充电，请使用至95%以下再进行充电",
      "fr": ""
    },
    514134 : {
      "dje_id": 514134,
      "en": "Heavy rainfall. Unable to perform task. Try again later",
      "zh": "雨量过大，机场无法执行飞行任务，请稍后重试",
      "fr": ""
    },
    514135 : {
      "dje_id": 514135,
      "en": "Unable to perform task. Wind speed too high. Try again later",
      "zh": "风速过大，机场无法执行飞行任务，请稍后重试",
      "fr": ""
    },
    514136 : {
      "dje_id": 514136,
      "en": "Dock power supply error. Unable to perform task. Resume power supply and try again",
      "zh": "机场供电断开，机场无法执行飞行任务，请恢复机场供电后重试",
      "fr": ""
    },
    514137 : {
      "dje_id": 514137,
      "en": "Environment temperature lower than -20Â° C (-4Â°F). Unable to perform task. Try again later",
      "zh": "环境温度过低于-20℃ (-4°F)，机场无法执行飞行任务，请稍后重试",
      "fr": ""
    },
    514138 : {
      "dje_id": 514138,
      "en": "Maintaining aircraft battery. Unable to perform task. Wait until maintenance is complete",
      "zh": "飞行器电池正在保养中，机场无法执行飞行任务，请等待保养结束后重试",
      "fr": ""
    },
    514139 : {
      "dje_id": 514139,
      "en": "Failed to maintain aircraft battery. No maintenance required",
      "zh": "飞行器电池无法执行保养指令，飞行器电池无需保养",
      "fr": ""
    },
    514140 : {
      "dje_id": 514140,
      "en": "Failed to maintain aircraft battery. No maintenance required",
      "zh": "飞行器电池无法执行保养指令，飞行器电池无需保养",
      "fr": ""
    },
    514141 : {
      "dje_id": 514141,
      "en": "Dock system error. Restart dock and try again",
      "zh": "机场系统运行异常，请重启机场后重试",
      "fr": ""
    },
    514142 : {
      "dje_id": 514142,
      "en": "Connection error between driving rod and aircraft before takeoff. Check if aircraft is inside dock, driving rods are stuck, or charging connector is stained or damaged",
      "zh": "飞行器起飞前，机场推杆与飞行器无法连接，请检查飞行器是否在舱内，推杆闭合时是否被卡住，充电连接器是否脏污或损坏",
      "fr": ""
    },
    514143 : {
      "dje_id": 514143,
      "en": "Driving rods pulled back or not pushed into place. Try again later or restart dock and try again",
      "zh": "推杆未闭合或闭合不到位，请稍后重试或重启机场后重试",
      "fr": ""
    },
    514144 : {
      "dje_id": 514144,
      "en": "Dock cover is open or not fully closed. Try again later or restart dock and try again",
      "zh": "舱盖未关闭或关闭不到位，请稍后重试或重启机场后重试",
      "fr": ""
    },
    514145 : {
      "dje_id": 514145,
      "en": "Dock in on-site debugging mode. Unable to perform current operation or task. Disconnect dock from remote controller and try again",
      "zh": "机场处于现场调试中，无法执行当前操作或执行飞行任务，请断开遥控器和机场的数据线连接后重试",
      "fr": ""
    },
    514146 : {
      "dje_id": 514146,
      "en": "Dock in remote debugging mode. Unable to perform task. Exit debugging mode and try again",
      "zh": "机场处于远程调试中，无法执行飞行任务，请退出远程调试后重试",
      "fr": ""
    },
    514147 : {
      "dje_id": 514147,
      "en": "Unable to start remote debugging or perform task. Updating device firmware. Wait until update is complete",
      "zh": "设备升级中，无法进行远程调试或执行飞行任务，请等待升级完成后重试",
      "fr": ""
    },
    514148 : {
      "dje_id": 514148,
      "en": "Task in progress. Dock unable to enter remote debugging mode or perform task again. Wait until current task is complete and try again",
      "zh": "机场已经在作业中，无法进行远程调试或再次执行飞行任务，请等待当前任务执行完成后重试",
      "fr": ""
    },
    514149 : {
      "dje_id": 514149,
      "en": "Dock system error. Unable to perform task. Restart dock and try again",
      "zh": "机场系统运行异常，无法执行飞行任务，请重启机场后重试",
      "fr": ""
    },
    514150 : {
      "dje_id": 514150,
      "en": "Restarting device. Unable to perform task. Wait until restart is complete",
      "zh": "设备重启中，无法执行飞行任务，请等待重启完成后重试",
      "fr": ""
    },
    514151 : {
      "dje_id": 514151,
      "en": "Updating device firmware. Unable to restart device. Wait until update is complete",
      "zh": "设备升级中，无法执行设备重启指令，请等待升级完成后重试",
      "fr": ""
    },
    514153 : {
      "dje_id": 514153,
      "en": "Dock exited remote debugging mode. Unable to perform current operation",
      "zh": "机场已退出远程调试模式，无法执行当前操作",
      "fr": ""
    },
    514154 : {
      "dje_id": 514154,
      "en": "Failed to obtain internal circulation supply vent temperature. Try again later",
      "zh": "获取内循环出风口温度失败，请稍后再试",
      "fr": ""
    },
    514156 : {
      "dje_id": 514156,
      "en": "Aircraft is outside of dock. Make sure aircraft has safely landed and place aircraft inside dock",
      "zh": "飞机不在舱内，请立即检查飞行器是否已安全降落并将飞行器放回至机场",
      "fr": ""
    },
    514157 : {
      "dje_id": 514157,
      "en": "Failed to power on. Wireless charging module busy. Restart dock and try again",
      "zh": "执行开机失败，无线充电线圈业务繁忙，请重启机场后再试复",
      "fr": ""
    },
    514158 : {
      "dje_id": 514158,
      "en": "Unable to take off. Dock RTK error. Restart dock and try again",
      "zh": "无法起飞，机场 RTK 业务异常，请重启机场后再试",
      "fr": ""
    },
    514159 : {
      "dje_id": 514159,
      "en": "Task failed. Aircraft detected in dock for landing. Make sure there is no aircraft inside the dock and try again",
      "zh": "任务失败，降落机场检测到飞行器，请确保降落机场没有飞行器后再试",
      "fr": ""
    },
    514162 : {
      "dje_id": 514162,
      "en": "Failed to connect aircraft and dock. Close dock cover or restart dock and try again",
      "zh": "飞行器和机场连接失败，请关闭机场舱盖或重启机场后再试",
      "fr": ""
    },
    514163 : {
      "dje_id": 514163,
      "en": "Battery error. Make sure battery is inserted properly or restart aircraft and try again",
      "zh": "电池功能异常，请确保飞行器电池插入到位或重启飞行器后再试",
      "fr": ""
    },
    514164 : {
      "dje_id": 514164,
      "en": "Failed to restart device. Try again later. Contact DJI Support if issue persists",
      "zh": "设备重启失败，请稍后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    514165 : {
      "dje_id": 514165,
      "en": "Failed to restart device. Try again later. Contact DJI Support if issue persists",
      "zh": "设备重启失败，请稍后重试，如果仍报错请联系大疆售后",
      "fr": ""
    },
    514170 : {
      "dje_id": 514170,
      "en": "Initializing dock. Unable to perform operation. Wait until initialization completes",
      "zh": "机场系统初始化中，无法执行当前操作或指令，请等待机场系统初始化完成后重试",
      "fr": ""
    },
    514171 : {
      "dje_id": 514171,
      "en": "Cloud command parameter error. Dock unable to execute command",
      "zh": "云端下发给机场的命令不符合格式要求，机场无法执行",
      "fr": ""
    },
    514172 : {
      "dje_id": 514172,
      "en": "Unable to power off aircraft. Bluetooth disconnected. Restart aircraft and dock remotely or reconnect on-site and try again",
      "zh": "飞行器无法关机，蓝牙连接状态为未连接，请尝试重启飞行器和机场，或去现场重新对频飞行器与机场后再试",
      "fr": ""
    },
    514173 : {
      "dje_id": 514173,
      "en": "Unable to perform task. Ambient temperature lower than 5Â° C and rainfall intensity is moderate rain or heavier, which may result in propellers being frozen",
      "zh": "由于天气原因（环境温度低于5度并且降雨大于等于中雨），可能导致桨叶结冰影响作业安全，暂无法执行任务",
      "fr": ""
    },
    514174 : {
      "dje_id": 514174,
      "en": "Failed to charge aircraft. Dock cover open or not properly closed. Close dock cover and try again",
      "zh": "飞行器充电失败，机场舱盖开启或关闭未到位，请关闭舱盖后再试",
      "fr": ""
    },
    514180 : {
      "dje_id": 514180,
      "en": "Failed to disable AC cooling or heating. Try again later",
      "zh": "停止空调制冷或停止空调制热失败，请稍后重试",
      "fr": ""
    },
    514181 : {
      "dje_id": 514181,
      "en": "Failed to enable AC cooling. Try again later",
      "zh": "开启空调制冷失败，请稍后重试",
      "fr": ""
    },
    514182 : {
      "dje_id": 514182,
      "en": "Failed to enable AC heating. Try again later",
      "zh": "开启空调制热失败，请稍后重试",
      "fr": ""
    },
    514183 : {
      "dje_id": 514183,
      "en": "Failed to enable AC dehumidifying. Try again later",
      "zh": "开启空调除湿失败，请稍后重试",
      "fr": ""
    },
    514184 : {
      "dje_id": 514184,
      "en": "Ambient temperature below 0Â° C (32Â°F). Unable to enable AC cooling",
      "zh": "当前温度低于 0 ℃（32°F），无法开启空调制冷",
      "fr": ""
    },
    514185 : {
      "dje_id": 514185,
      "en": "Ambient temperature above 45Â° C (115Â°F). Unable to enable AC heating",
      "zh": "当前温度高于 45 ℃（115°F），无法开启空调制热",
      "fr": ""
    },
    514300 : {
      "dje_id": 514300,
      "en": "Gateway error.",
      "zh": "网关异常",
      "fr": ""
    },
    514301 : {
      "dje_id": 514301,
      "en": "Request timed out. Disconnected.",
      "zh": "请求超时，连接断开",
      "fr": ""
    },
    514302 : {
      "dje_id": 514302,
      "en": "Network certificate error. Connection failed.",
      "zh": "网络证书异常，连接失败",
      "fr": ""
    },
    514303 : {
      "dje_id": 514303,
      "en": "Network error. Disconnected.",
      "zh": "网络异常，连接断开",
      "fr": ""
    },
    514304 : {
      "dje_id": 514304,
      "en": "Request rejected. Connection failed.",
      "zh": "请求被拒，连接失败",
      "fr": ""
    },
    800100 : {
      "dje_id": 800100,
      "en": "Timeout global sur la commande",
      "zh": "NULL",
      "fr": ""
    },
    800101 : {
      "dje_id": 800101,
      "en": "Timeout de la télécommande",
      "zh": "NULL",
      "fr": ""
    },
    800102 : {
      "dje_id": 800102,
      "en": "Timeout du récepteur",
      "zh": "NULL",
      "fr": ""
    },
    800103 : {
      "dje_id": 800103,
      "en": "Commande déjà en cours de traitement",
      "zh": "NULL",
      "fr": ""
    },
    800104 : {
      "dje_id": 800104,
      "en": "API est occupé et ne peut pas traiter la commande",
      "zh": "NULL",
      "fr": ""
    },
    800200 : {
      "dje_id": 800200,
      "en": "Progression du chargement de la fence de 0%",
      "zh": "NULL",
      "fr": ""
    },
    800201 : {
      "dje_id": 800201,
      "en": "Progression du chargement de la fence de 1%",
      "zh": "NULL",
      "fr": ""
    },
    800202 : {
      "dje_id": 800202,
      "en": "Progression du chargement de la fence de 2%",
      "zh": "NULL",
      "fr": ""
    },
    800203 : {
      "dje_id": 800203,
      "en": "Progression du chargement de la fence de 3%",
      "zh": "NULL",
      "fr": ""
    },
    800204 : {
      "dje_id": 800204,
      "en": "Progression du chargement de la fence de 4%",
      "zh": "NULL",
      "fr": ""
    },
    800205 : {
      "dje_id": 800205,
      "en": "Progression du chargement de la fence de 5%",
      "zh": "NULL",
      "fr": ""
    },
    800206 : {
      "dje_id": 800206,
      "en": "Progression du chargement de la fence de 6%",
      "zh": "NULL",
      "fr": ""
    },
    800207 : {
      "dje_id": 800207,
      "en": "Progression du chargement de la fence de 7%",
      "zh": "NULL",
      "fr": ""
    },
    800208 : {
      "dje_id": 800208,
      "en": "Progression du chargement de la fence de 8%",
      "zh": "NULL",
      "fr": ""
    },
    800209 : {
      "dje_id": 800209,
      "en": "Progression du chargement de la fence de 9%",
      "zh": "NULL",
      "fr": ""
    },
    800210 : {
      "dje_id": 800210,
      "en": "Progression du chargement de la fence de 10%",
      "zh": "NULL",
      "fr": ""
    },
    800211 : {
      "dje_id": 800211,
      "en": "Progression du chargement de la fence de 11%",
      "zh": "NULL",
      "fr": ""
    },
    800212 : {
      "dje_id": 800212,
      "en": "Progression du chargement de la fence de 12%",
      "zh": "NULL",
      "fr": ""
    },
    800213 : {
      "dje_id": 800213,
      "en": "Progression du chargement de la fence de 13%",
      "zh": "NULL",
      "fr": ""
    },
    800214 : {
      "dje_id": 800214,
      "en": "Progression du chargement de la fence de 14%",
      "zh": "NULL",
      "fr": ""
    },
    800215 : {
      "dje_id": 800215,
      "en": "Progression du chargement de la fence de 15%",
      "zh": "NULL",
      "fr": ""
    },
    800216 : {
      "dje_id": 800216,
      "en": "Progression du chargement de la fence de 16%",
      "zh": "NULL",
      "fr": ""
    },
    800217 : {
      "dje_id": 800217,
      "en": "Progression du chargement de la fence de 17%",
      "zh": "NULL",
      "fr": ""
    },
    800218 : {
      "dje_id": 800218,
      "en": "Progression du chargement de la fence de 18%",
      "zh": "NULL",
      "fr": ""
    },
    800219 : {
      "dje_id": 800219,
      "en": "Progression du chargement de la fence de 19%",
      "zh": "NULL",
      "fr": ""
    },
    800220 : {
      "dje_id": 800220,
      "en": "Progression du chargement de la fence de 20%",
      "zh": "NULL",
      "fr": ""
    },
    800221 : {
      "dje_id": 800221,
      "en": "Progression du chargement de la fence de 21%",
      "zh": "NULL",
      "fr": ""
    },
    800222 : {
      "dje_id": 800222,
      "en": "Progression du chargement de la fence de 22%",
      "zh": "NULL",
      "fr": ""
    },
    800223 : {
      "dje_id": 800223,
      "en": "Progression du chargement de la fence de 23%",
      "zh": "NULL",
      "fr": ""
    },
    800224 : {
      "dje_id": 800224,
      "en": "Progression du chargement de la fence de 24%",
      "zh": "NULL",
      "fr": ""
    },
    800225 : {
      "dje_id": 800225,
      "en": "Progression du chargement de la fence de 25%",
      "zh": "NULL",
      "fr": ""
    },
    800226 : {
      "dje_id": 800226,
      "en": "Progression du chargement de la fence de 26%",
      "zh": "NULL",
      "fr": ""
    },
    800227 : {
      "dje_id": 800227,
      "en": "Progression du chargement de la fence de 27%",
      "zh": "NULL",
      "fr": ""
    },
    800228 : {
      "dje_id": 800228,
      "en": "Progression du chargement de la fence de 28%",
      "zh": "NULL",
      "fr": ""
    },
    800229 : {
      "dje_id": 800229,
      "en": "Progression du chargement de la fence de 29%",
      "zh": "NULL",
      "fr": ""
    },
    800230 : {
      "dje_id": 800230,
      "en": "Progression du chargement de la fence de 30%",
      "zh": "NULL",
      "fr": ""
    },
    800231 : {
      "dje_id": 800231,
      "en": "Progression du chargement de la fence de 31%",
      "zh": "NULL",
      "fr": ""
    },
    800232 : {
      "dje_id": 800232,
      "en": "Progression du chargement de la fence de 32%",
      "zh": "NULL",
      "fr": ""
    },
    800233 : {
      "dje_id": 800233,
      "en": "Progression du chargement de la fence de 33%",
      "zh": "NULL",
      "fr": ""
    },
    800234 : {
      "dje_id": 800234,
      "en": "Progression du chargement de la fence de 34%",
      "zh": "NULL",
      "fr": ""
    },
    800235 : {
      "dje_id": 800235,
      "en": "Progression du chargement de la fence de 35%",
      "zh": "NULL",
      "fr": ""
    },
    800236 : {
      "dje_id": 800236,
      "en": "Progression du chargement de la fence de 36%",
      "zh": "NULL",
      "fr": ""
    },
    800237 : {
      "dje_id": 800237,
      "en": "Progression du chargement de la fence de 37%",
      "zh": "NULL",
      "fr": ""
    },
    800238 : {
      "dje_id": 800238,
      "en": "Progression du chargement de la fence de 38%",
      "zh": "NULL",
      "fr": ""
    },
    800239 : {
      "dje_id": 800239,
      "en": "Progression du chargement de la fence de 39%",
      "zh": "NULL",
      "fr": ""
    },
    800240 : {
      "dje_id": 800240,
      "en": "Progression du chargement de la fence de 40%",
      "zh": "NULL",
      "fr": ""
    },
    800241 : {
      "dje_id": 800241,
      "en": "Progression du chargement de la fence de 41%",
      "zh": "NULL",
      "fr": ""
    },
    800242 : {
      "dje_id": 800242,
      "en": "Progression du chargement de la fence de 42%",
      "zh": "NULL",
      "fr": ""
    },
    800243 : {
      "dje_id": 800243,
      "en": "Progression du chargement de la fence de 43%",
      "zh": "NULL",
      "fr": ""
    },
    800244 : {
      "dje_id": 800244,
      "en": "Progression du chargement de la fence de 44%",
      "zh": "NULL",
      "fr": ""
    },
    800245 : {
      "dje_id": 800245,
      "en": "Progression du chargement de la fence de 45%",
      "zh": "NULL",
      "fr": ""
    },
    800246 : {
      "dje_id": 800246,
      "en": "Progression du chargement de la fence de 46%",
      "zh": "NULL",
      "fr": ""
    },
    800247 : {
      "dje_id": 800247,
      "en": "Progression du chargement de la fence de 47%",
      "zh": "NULL",
      "fr": ""
    },
    800248 : {
      "dje_id": 800248,
      "en": "Progression du chargement de la fence de 48%",
      "zh": "NULL",
      "fr": ""
    },
    800249 : {
      "dje_id": 800249,
      "en": "Progression du chargement de la fence de 49%",
      "zh": "NULL",
      "fr": ""
    },
    800250 : {
      "dje_id": 800250,
      "en": "Progression du chargement de la fence de 50%",
      "zh": "NULL",
      "fr": ""
    },
    800251 : {
      "dje_id": 800251,
      "en": "Progression du chargement de la fence de 51%",
      "zh": "NULL",
      "fr": ""
    },
    800252 : {
      "dje_id": 800252,
      "en": "Progression du chargement de la fence de 52%",
      "zh": "NULL",
      "fr": ""
    },
    800253 : {
      "dje_id": 800253,
      "en": "Progression du chargement de la fence de 53%",
      "zh": "NULL",
      "fr": ""
    },
    800254 : {
      "dje_id": 800254,
      "en": "Progression du chargement de la fence de 54%",
      "zh": "NULL",
      "fr": ""
    },
    800255 : {
      "dje_id": 800255,
      "en": "Progression du chargement de la fence de 55%",
      "zh": "NULL",
      "fr": ""
    },
    800256 : {
      "dje_id": 800256,
      "en": "Progression du chargement de la fence de 56%",
      "zh": "NULL",
      "fr": ""
    },
    800257 : {
      "dje_id": 800257,
      "en": "Progression du chargement de la fence de 57%",
      "zh": "NULL",
      "fr": ""
    },
    800258 : {
      "dje_id": 800258,
      "en": "Progression du chargement de la fence de 58%",
      "zh": "NULL",
      "fr": ""
    },
    800259 : {
      "dje_id": 800259,
      "en": "Progression du chargement de la fence de 59%",
      "zh": "NULL",
      "fr": ""
    },
    800260 : {
      "dje_id": 800260,
      "en": "Progression du chargement de la fence de 60%",
      "zh": "NULL",
      "fr": ""
    },
    800261 : {
      "dje_id": 800261,
      "en": "Progression du chargement de la fence de 61%",
      "zh": "NULL",
      "fr": ""
    },
    800262 : {
      "dje_id": 800262,
      "en": "Progression du chargement de la fence de 62%",
      "zh": "NULL",
      "fr": ""
    },
    800263 : {
      "dje_id": 800263,
      "en": "Progression du chargement de la fence de 63%",
      "zh": "NULL",
      "fr": ""
    },
    800264 : {
      "dje_id": 800264,
      "en": "Progression du chargement de la fence de 64%",
      "zh": "NULL",
      "fr": ""
    },
    800265 : {
      "dje_id": 800265,
      "en": "Progression du chargement de la fence de 65%",
      "zh": "NULL",
      "fr": ""
    },
    800266 : {
      "dje_id": 800266,
      "en": "Progression du chargement de la fence de 66%",
      "zh": "NULL",
      "fr": ""
    },
    800267 : {
      "dje_id": 800267,
      "en": "Progression du chargement de la fence de 67%",
      "zh": "NULL",
      "fr": ""
    },
    800268 : {
      "dje_id": 800268,
      "en": "Progression du chargement de la fence de 68%",
      "zh": "NULL",
      "fr": ""
    },
    800269 : {
      "dje_id": 800269,
      "en": "Progression du chargement de la fence de 69%",
      "zh": "NULL",
      "fr": ""
    },
    800270 : {
      "dje_id": 800270,
      "en": "Progression du chargement de la fence de 70%",
      "zh": "NULL",
      "fr": ""
    },
    800271 : {
      "dje_id": 800271,
      "en": "Progression du chargement de la fence de 71%",
      "zh": "NULL",
      "fr": ""
    },
    800272 : {
      "dje_id": 800272,
      "en": "Progression du chargement de la fence de 72%",
      "zh": "NULL",
      "fr": ""
    },
    800273 : {
      "dje_id": 800273,
      "en": "Progression du chargement de la fence de 73%",
      "zh": "NULL",
      "fr": ""
    },
    800274 : {
      "dje_id": 800274,
      "en": "Progression du chargement de la fence de 74%",
      "zh": "NULL",
      "fr": ""
    },
    800275 : {
      "dje_id": 800275,
      "en": "Progression du chargement de la fence de 75%",
      "zh": "NULL",
      "fr": ""
    },
    800276 : {
      "dje_id": 800276,
      "en": "Progression du chargement de la fence de 76%",
      "zh": "NULL",
      "fr": ""
    },
    800277 : {
      "dje_id": 800277,
      "en": "Progression du chargement de la fence de 77%",
      "zh": "NULL",
      "fr": ""
    },
    800278 : {
      "dje_id": 800278,
      "en": "Progression du chargement de la fence de 78%",
      "zh": "NULL",
      "fr": ""
    },
    800279 : {
      "dje_id": 800279,
      "en": "Progression du chargement de la fence de 79%",
      "zh": "NULL",
      "fr": ""
    },
    800280 : {
      "dje_id": 800280,
      "en": "Progression du chargement de la fence de 80%",
      "zh": "NULL",
      "fr": ""
    },
    800281 : {
      "dje_id": 800281,
      "en": "Progression du chargement de la fence de 81%",
      "zh": "NULL",
      "fr": ""
    },
    800282 : {
      "dje_id": 800282,
      "en": "Progression du chargement de la fence de 82%",
      "zh": "NULL",
      "fr": ""
    },
    800283 : {
      "dje_id": 800283,
      "en": "Progression du chargement de la fence de 83%",
      "zh": "NULL",
      "fr": ""
    },
    800284 : {
      "dje_id": 800284,
      "en": "Progression du chargement de la fence de 84%",
      "zh": "NULL",
      "fr": ""
    },
    800285 : {
      "dje_id": 800285,
      "en": "Progression du chargement de la fence de 85%",
      "zh": "NULL",
      "fr": ""
    },
    800286 : {
      "dje_id": 800286,
      "en": "Progression du chargement de la fence de 86%",
      "zh": "NULL",
      "fr": ""
    },
    800287 : {
      "dje_id": 800287,
      "en": "Progression du chargement de la fence de 87%",
      "zh": "NULL",
      "fr": ""
    },
    800288 : {
      "dje_id": 800288,
      "en": "Progression du chargement de la fence de 88%",
      "zh": "NULL",
      "fr": ""
    },
    800289 : {
      "dje_id": 800289,
      "en": "Progression du chargement de la fence de 89%",
      "zh": "NULL",
      "fr": ""
    },
    800290 : {
      "dje_id": 800290,
      "en": "Progression du chargement de la fence de 90%",
      "zh": "NULL",
      "fr": ""
    },
    800291 : {
      "dje_id": 800291,
      "en": "Progression du chargement de la fence de 91%",
      "zh": "NULL",
      "fr": ""
    },
    800292 : {
      "dje_id": 800292,
      "en": "Progression du chargement de la fence de 92%",
      "zh": "NULL",
      "fr": ""
    },
    800293 : {
      "dje_id": 800293,
      "en": "Progression du chargement de la fence de 93%",
      "zh": "NULL",
      "fr": ""
    },
    800294 : {
      "dje_id": 800294,
      "en": "Progression du chargement de la fence de 94%",
      "zh": "NULL",
      "fr": ""
    },
    800295 : {
      "dje_id": 800295,
      "en": "Progression du chargement de la fence de 95%",
      "zh": "NULL",
      "fr": ""
    },
    800296 : {
      "dje_id": 800296,
      "en": "Progression du chargement de la fence de 96%",
      "zh": "NULL",
      "fr": ""
    },
    800297 : {
      "dje_id": 800297,
      "en": "Progression du chargement de la fence de 97%",
      "zh": "NULL",
      "fr": ""
    },
    800298 : {
      "dje_id": 800298,
      "en": "Progression du chargement de la fence de 98%",
      "zh": "NULL",
      "fr": ""
    },
    800299 : {
      "dje_id": 800299,
      "en": "Progression du chargement de la fence de 99%",
      "zh": "NULL",
      "fr": ""
    },
    800500 : {
      "dje_id": 800500,
      "en": "Échec de la commande, une valeur erronée a été retournée à l’API",
      "zh": "NULL",
      "fr": ""
    }
  }

  static get(){
    return {
      dji_error: this.dji_error
    }
  }
}
